(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

module.exports = function AboutProfiles($elm) {
  var _window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;

  var doc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;

  _classCallCheck(this, AboutProfiles);

  if (!$elm) {
    return;
  }

  this.$elm = $elm;
  this.window = _window;
  this.doc = doc;

  this.$elm.classList.add('grid-listing');
  this.$elm.classList.add('clearfix'); // IE doesn't support multiple arguments
  [].forEach.call(this.$elm.querySelectorAll('li'), function (item) {
    item.classList.add('grid-listing-item');
  });
};

},{}],2:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var utils = require('../libs/elife-utils')();

module.exports = function () {
  function AnnotationTeaser($elm) {
    var _window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;

    var doc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;

    _classCallCheck(this, AnnotationTeaser);

    if (!$elm) {
      return;
    }

    this.$elm = $elm;
    this.window = _window;
    this.doc = doc;

    this.createLink(this.$elm.dataset.inContextUri);
    if (this.$elm.dataset.isReply) {
      this.showAsReply('View the full conversation');
    }
  }

  _createClass(AnnotationTeaser, [{
    key: 'createLink',
    value: function createLink(uri) {
      if (!uri || typeof uri !== 'string') {
        return;
      }

      var $a = utils.buildElement('a', ['annotation-teaser__link']);
      var rootChildren = [].slice.call(this.$elm.childNodes);
      [].forEach.call(rootChildren, function (node) {
        $a.appendChild(node);
      });

      $a.setAttribute('href', uri);
      this.$elm.appendChild($a);
    }
  }, {
    key: 'showAsReply',
    value: function showAsReply(text) {
      if (!text || typeof text !== 'string') {
        return;
      }

      var $parent = this.$elm.querySelector('.annotation-teaser__reply');
      utils.buildElement('span', ['annotation-teaser__reply_cta'], text, $parent);
    }
  }]);

  return AnnotationTeaser;
}();

},{"../libs/elife-utils":35}],3:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var utils = require('../libs/elife-utils')();

module.exports = function () {

  // Passing window and document separately allows for independent mocking of window in order
  // to test feature support fallbacks etc.
  function ArticleDownloadLinksList($elm) {
    var _window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;

    var doc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;

    _classCallCheck(this, ArticleDownloadLinksList);

    if (!$elm) {
      return;
    }

    this.window = _window;
    this.doc = doc;
    this.$elm = $elm;

    this.$contentHeader = this.doc.querySelector('.content-header');
    if (!this.$contentHeader) {
      return;
    }

    this.$contentHeaderDownloadLink = this.$contentHeader.querySelector('.content-header__download_link');
    if (!this.$contentHeaderDownloadLink) {
      return;
    }

    // One statement per class name because IE doesn't support multiple strings, comma separated.
    this.$elm.classList.add('article-download-links-list--js');
    this.$elm.classList.add('visuallyhidden');
    this.$elm.setAttribute('aria-expanded', 'false');
    this.moveList();
    this.$toggler = this.doc.querySelector('.content-header__download_link');
    this.$toggler.addEventListener('click', this.toggle.bind(this));
  }

  /**
   * Moves the download links list to be by the icon this.$toggler
   */


  _createClass(ArticleDownloadLinksList, [{
    key: 'moveList',
    value: function moveList() {
      var $followingSibling = this.$contentHeaderDownloadLink.nextElementSibling;
      this.$elm.parentNode.parentNode.classList.add('visuallyhidden');
      this.$contentHeader.insertBefore(this.$elm, $followingSibling);
    }

    /**
     * Toggles the download links list display.
     *
     * @param e The event triggering the display toggle
     */

  }, {
    key: 'toggle',
    value: function toggle(e) {
      e.preventDefault();
      e.stopPropagation();
      if (this.isOpen()) {
        this.close();
      } else {
        this.open();
      }
    }

    /**
     * Returns whether links list is currently viewable.
     *
     * @returns {boolean} Whether links list is currently viewable
     */

  }, {
    key: 'isOpen',
    value: function isOpen() {
      return !this.$elm.classList.contains('visuallyhidden');
    }

    /**
     * Make viewable.
     */

  }, {
    key: 'open',
    value: function open() {
      this.$elm.classList.remove('visuallyhidden');
      this.$elm.setAttribute('aria-expanded', 'true');
      this.window.addEventListener('click', this.checkForClose.bind(this));
    }

    /**
     * Checks whether a click occurred outside this, and close this if it did.
     *
     * @param e The click event to evaluate the target of
     */

  }, {
    key: 'checkForClose',
    value: function checkForClose(e) {
      if (!utils.areElementsNested(this.$elm, e.target)) {
        this.close();
      }
    }

    /**
     * Make unviewable.
     */

  }, {
    key: 'close',
    value: function close() {
      this.$elm.classList.add('visuallyhidden');
      this.$elm.setAttribute('aria-expanded', 'false');
      this.window.removeEventListener('click', this.checkForClose.bind(this));
    }
  }]);

  return ArticleDownloadLinksList;
}();

},{"../libs/elife-utils":35}],4:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var utils = require('../libs/elife-utils')();

module.exports = function () {
  function ArticleSection($elm) {
    var _window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;

    var doc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;

    _classCallCheck(this, ArticleSection);

    if ($elm.classList.contains('article-section--first')) {
      return;
    }

    this.$elm = $elm;
    this.window = _window;
    this.doc = doc;

    this.thresholdWidth = 600;
    this.initialise(this.$elm, doc);
  }

  _createClass(ArticleSection, [{
    key: 'initialise',
    value: function initialise($elm, doc) {
      this.$elm.classList.add('article-section--js');
      this.$headerLink = this.createHeaderLink($elm, doc);
      this.$body = $elm.querySelector('.article-section__body');
      this.setInitialState($elm, this.$headerLink, this.$body);
      this.$elm.addEventListener('expandsection', this.expand.bind(this));
      this.$elm.addEventListener('collapsesection', this.collapse.bind(this));
    }
  }, {
    key: 'createHeaderLink',
    value: function createHeaderLink($elm, doc) {
      var $header = $elm.querySelector('.article-section__header');
      var $link = doc.createElement('A');
      $link.setAttribute('href', '#');
      $link.classList.add('article-section__header_link');
      $link.appendChild($header.firstElementChild);
      $header.appendChild($link);
      $link.addEventListener('click', this.toggleState.bind(this));
      return $link;
    }
  }, {
    key: 'setInitialState',
    value: function setInitialState($elm, $headerLink, $body) {
      var hash = '';
      if (this.window.location && this.window.location.hash) {
        hash = this.window.location.hash.substring(1);
      }

      if (this.window.navigator.userAgent && this.window.navigator.userAgent.indexOf('Googlebot/') !== -1) {
        // Google Scholar requires article sections to be open to improve indexing
        $elm.dataset.initialState = 'opened';
      } else if (this.doc.referrer && this.doc.referrer.indexOf('.google.') !== -1) {
        // Google requires referrals to visually match the indexed version
        $elm.dataset.initialState = 'opened';
      } else if (hash && utils.isIdOfOrWithinSection(hash, $elm, this.doc)) {
        // Force open if the fragment is here.
        $elm.dataset.initialState = 'opened';
      } else if (this.viewportNoWiderThan(this.thresholdWidth)) {
        // Force closed on small screens.
        $elm.dataset.initialState = 'closed';
      }

      if ($elm.dataset.initialState === 'closed') {
        $elm.classList.add('article-section--collapsed');
        $headerLink.classList.add('article-section__header_link--closed');
        $body.classList.add('visuallyhidden');
      } else {
        // Defensive: remove classes if they turn up here when they shouldn't
        $headerLink.classList.remove('article-section__header_link--closed');
        $body.classList.remove('visuallyhidden');
      }
    }
  }, {
    key: 'viewportNoWiderThan',
    value: function viewportNoWiderThan(thresholdInPx) {
      return this.window.matchMedia('(max-width: ' + thresholdInPx + 'px)').matches;
    }
  }, {
    key: 'toggleState',
    value: function toggleState(e) {
      e.preventDefault();
      if (this.$headerLink.classList.contains('article-section__header_link--closed')) {
        this.$elm.dispatchEvent(utils.eventCreator('expandsection'));
      } else {
        this.$elm.dispatchEvent(utils.eventCreator('collapsesection'));
      }
    }
  }, {
    key: 'collapse',
    value: function collapse() {
      this.$headerLink.classList.add('article-section__header_link--closed');
      this.$elm.classList.add('article-section--collapsed');
      this.$body.classList.add('visuallyhidden');
    }
  }, {
    key: 'expand',
    value: function expand(e) {
      this.$headerLink.classList.remove('article-section__header_link--closed');
      this.$elm.classList.remove('article-section--collapsed');
      this.$body.classList.remove('visuallyhidden');
      if (!!this.window.MathJax && !!this.window.MathJax.Hub) {
        this.window.MathJax.Hub.Queue(['Rerender', this.window.MathJax.Hub, this.$elm.id]);
      }

      try {
        if (e.detail.search(/https?:\/\//) !== 0) {
          var $descendentEl = this.doc.getElementById(e.detail);
          if (!!$descendentEl) {
            $descendentEl.scrollIntoView();
          }
        }
      } catch (err) {
        // The event may not have detail
      }
    }
  }]);

  return ArticleSection;
}();

},{"../libs/elife-utils":35}],5:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var utils = require('../libs/elife-utils')();

module.exports = function () {
  function AssetNavigation($elm) {
    var _this = this;

    var _window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;

    var doc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;

    _classCallCheck(this, AssetNavigation);

    this.$elm = $elm;
    this.window = _window;
    this.doc = doc;
    this.assetItems = [];

    var promise = void 0;

    var $seeAll = this.$elm.querySelector('.asset-viewer-inline__header_link');
    if ($seeAll) {
      promise = utils.remoteDoc($seeAll.href, this.window).then(function (doc) {
        var $newAsset = doc.querySelector('#' + _this.$elm.id); // No getElementById() as this might be a remote doc.
        if (!$newAsset) {
          return [_this.$elm];
        }

        var $newSupplements = doc.querySelectorAll('[data-parent-asset-id="' + _this.$elm.id + '"]');

        // Avoid circular behaviour.
        var dataset = $newAsset.dataset.behaviour.trim().split(' ');
        var index = dataset.indexOf('AssetNavigation');
        dataset.splice(index, 1);
        $newAsset.dataset.behaviour = dataset.join(' ');

        _this.$elm.parentNode.replaceChild($newAsset, _this.$elm);
        _this.$elm = $newAsset;
        var assetItems = [_this.$elm];

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = $newSupplements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var supplement = _step.value;

            assetItems.push(supplement);
            _this.$elm.parentNode.insertBefore(supplement, _this.$elm.nextSibling);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return assetItems;
      });
    } else {
      promise = Promise.resolve().then(function () {
        return [_this.$elm].concat(_toConsumableArray(_this.findSupplements()));
      });
    }

    promise = promise.then(function (assetItems) {
      _this.assetItems = assetItems;
      if (_this.assetItems.length > 1) {
        (function () {
          var hash = _this.window.location.hash.substring(1);
          var show = 0;
          [].forEach.call(_this.assetItems, function (assetItem, i) {
            var navigation = utils.buildElement('div', ['asset-viewer-inline__header_navigation'], '', assetItem.querySelector('.asset-viewer-inline__header_panel'), '.asset-viewer-inline__header_text');

            if (assetItem.id === hash) {
              show = i;
            }

            _this.addPreviousButton(i, navigation);
            _this.addNextButton(i, navigation);

            assetItem.addEventListener('assetViewerFocus', function () {
              return _this.show(i);
            });
          });

          _this.show(show);

          _this.window.addEventListener('hashchange', _this.hashChange.bind(_this));
        })();
      }
    });
  }

  _createClass(AssetNavigation, [{
    key: 'addPreviousButton',
    value: function addPreviousButton(i, navigation) {
      var _this2 = this;

      var previous = utils.buildElement('span', ['asset-viewer-inline__previous'], '', navigation);
      if (i > 0) {
        previous.addEventListener('click', function () {
          _this2.window.history.pushState(null, '', '#' + _this2.assetItems[i - 1].id);
          _this2.show(i - 1);
        });
        previous.classList.add('asset-viewer-inline__previous--active');
      }
    }
  }, {
    key: 'addNextButton',
    value: function addNextButton(i, navigation) {
      var _this3 = this;

      var next = utils.buildElement('span', ['asset-viewer-inline__next'], '', navigation);
      if (i < this.assetItems.length - 1) {
        next.addEventListener('click', function () {
          _this3.window.history.pushState(null, '', '#' + _this3.assetItems[i + 1].id);
          _this3.show(i + 1);
        });
        next.classList.add('asset-viewer-inline__next--active');
      }
    }
  }, {
    key: 'hideAll',
    value: function hideAll() {
      [].forEach.call(this.assetItems, function (assetItem) {
        return assetItem.classList.add('visuallyhidden');
      });
    }
  }, {
    key: 'show',
    value: function show(i) {
      this.hideAll();
      this.assetItems[i].classList.remove('visuallyhidden');
    }
  }, {
    key: 'findSupplements',
    value: function findSupplements() {
      return this.doc.querySelectorAll('[data-parent-asset-id="' + this.$elm.id + '"]');
    }
  }, {
    key: 'hashChange',
    value: function hashChange(e) {
      var _this4 = this;

      var hash = '';

      // event was hashChange
      if (!!e.newURL) {
        hash = e.newURL.substring(e.newURL.indexOf('#') + 1);
      } else {
        hash = this.window.location.hash.substring(1);
      }

      if (!hash) {
        return false;
      }

      [].forEach.call(this.assetItems, function (assetItem, i) {
        if (assetItem.id === hash) {
          _this4.show(i);
          assetItem.scrollIntoView();
        }
      });
    }
  }]);

  return AssetNavigation;
}();

},{"../libs/elife-utils":35}],6:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var utils = require('../libs/elife-utils')();

module.exports = function () {
  function AssetViewer($elm) {
    var _window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;

    var doc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;

    _classCallCheck(this, AssetViewer);

    this.$elm = $elm;
    this.window = _window;
    this.doc = doc;

    if (this.$elm.querySelector('.asset-viewer-inline__open_link')) {
      this.setup(doc);
    }
  }

  _createClass(AssetViewer, [{
    key: 'handleClick',
    value: function handleClick(e) {
      var _this = this;

      e.preventDefault();

      var items = [];
      var index = 0;

      var assets = this.findAssets();
      [].forEach.call(assets, function (asset, i) {
        var caption = asset.querySelector('.caption-text__heading');

        var item = {
          src: asset.dataset.assetViewerUri,
          w: asset.dataset.assetViewerWidth,
          h: asset.dataset.assetViewerHeight
        };

        if (caption) {
          item.title = caption.innerHTML;
        }

        items.push(item);

        if (asset.id === _this.$elm.id) {
          index = i;
        }
      });

      var options = {
        index: index,
        history: false,
        shareEl: false
      };

      // jscs:disable requireCamelCaseOrUpperCaseIdentifiers
      var gallery = new PhotoSwipe(document.querySelector('.pswp'), PhotoSwipeUI_Default, items, options); // jshint ignore:line

      // jscs:enable

      gallery.init();

      gallery.listen('beforeChange', function () {
        var asset = _this.findAssets()[gallery.getCurrentIndex()];
        var event = utils.eventCreator('assetViewerFocus');

        asset.dispatchEvent(event);
      });
    }
  }, {
    key: 'findAssets',
    value: function findAssets() {
      return this.doc.querySelectorAll('[data-asset-viewer-group="' + this.$elm.dataset.assetViewerGroup + '"]');
    }
  }, {
    key: 'setup',
    value: function setup(doc) {
      var _this2 = this;

      AssetViewer.load(doc).then(function () {
        var assetLink = _this2.$elm.querySelector('.captioned-asset__link');
        var openLink = _this2.$elm.querySelector('.asset-viewer-inline__open_link');

        if (assetLink) {
          assetLink.addEventListener('click', _this2.handleClick.bind(_this2));
        }

        if (openLink) {
          openLink.addEventListener('click', _this2.handleClick.bind(_this2));
        }
      });
    }
  }], [{
    key: 'load',
    value: function load(doc) {
      if (!this.loader) {
        this.loader = Promise.all([utils.loadJavaScript('https://cdnjs.cloudflare.com/ajax/libs/photoswipe/4.1.2/photoswipe.min.js', 'sha384-QELNnmcmU8IR9ZAykt67vGr9/rZJdHbiWi64V88fCPaOohUlHCqUD/unNN0BXSqy'), utils.loadJavaScript('https://cdnjs.cloudflare.com/ajax/libs/photoswipe/4.1.2/photoswipe-ui-default.min.js', 'sha384-m67o7SkQ1ALzKZIFh4CiTA8tmadaujiTa9Vu+nqPSwDOqHrDmxLezTdFln8077+q'), utils.loadStyleSheet('https://cdnjs.cloudflare.com/ajax/libs/photoswipe/4.1.2/photoswipe.min.css', 'sha384-h/L2W9KefUClHWaty3SLE5F/qvc4djlyR4qY3NUV5HGQBBW7stbcfff1+I/vmsHh'), utils.loadStyleSheet('https://cdnjs.cloudflare.com/ajax/libs/photoswipe/4.1.2/default-skin/default-skin.min.css', 'sha384-iD0dNku6PYSIQLyfTOpB06F2KCZJAKLOThS5HRe8b3ibhdEQ6eKsFf/EeFxdOt5R')]);

        var div = document.createElement('div');
        div.className = 'pswp';
        div.tabIndex = '-1';
        div.setAttribute('role', 'dialog');
        div.setAttribute('aria-hidden', 'true');
        div.innerHTML = '\n<div class="pswp__bg"></div>\n<div class="pswp__scroll-wrap">\n    <div class="pswp__container">\n        <div class="pswp__item"></div>\n        <div class="pswp__item"></div>\n        <div class="pswp__item"></div>\n    </div>\n    <div class="pswp__ui pswp__ui--hidden">\n        <div class="pswp__top-bar">\n            <div class="pswp__counter"></div>\n            <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>\n            <button class="pswp__button pswp__button--share" title="Share"></button>\n            <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>\n            <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>\n            <div class="pswp__preloader">\n                <div class="pswp__preloader__icn">\n                  <div class="pswp__preloader__cut">\n                    <div class="pswp__preloader__donut"></div>\n                  </div>\n                </div>\n            </div>\n        </div>\n        <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">\n            <div class="pswp__share-tooltip"></div>\n        </div>\n        <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)"></button>\n        <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)"></button>\n        <div class="pswp__caption">\n            <div class="pswp__caption__center"></div>\n        </div>\n    </div>\n</div>\n';
        doc.body.appendChild(div);
      }

      return this.loader;
    }
  }]);

  return AssetViewer;
}();

},{"../libs/elife-utils":35}],7:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var utils = require('../libs/elife-utils')();
module.exports = function () {
  function AudioPlayer($elm) {
    var _this = this;

    var _window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;

    var doc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;

    _classCallCheck(this, AudioPlayer);

    if (!$elm) {
      console.warn('No element provided');
      return;
    }

    this.window = _window;
    if (!this.window.HTMLAudioElement) {
      console.warn('Audio element not supported');
      return;
    }

    console.log('Initialising Audio Player...');

    this.$elm = $elm;
    this.$audioElement = this.$elm.querySelector('audio');
    if (!this.$audioElement) {
      console.warn('No audio element found');
      return;
    }

    this.uniqueId = utils.uniqueIds.get('audio', doc);
    this.$elm.id = this.uniqueId;
    this.$playButton = AudioPlayer.buildPlayButton(this);

    // $title must be prepared before buildProgressIndicator is called
    this.$title = this.prepare$title(this.$elm.querySelector('.audio-player__header'), doc);
    this.$progressTrack = AudioPlayer.buildProgressIndicator(this);
    this.$progressBar = this.$progressTrack.querySelector('[class*="progress_bar"]');
    this.$timeIndicators = AudioPlayer.buildTimeIndicators(this);
    this.$currentTime = this.$timeIndicators.querySelector('[class*="current_time"]');
    this.$duration = this.$timeIndicators.querySelector('[class*="duration"]');

    // state
    this.duration = null;
    this.isPlaying = false;

    this.$elm.classList.add('audio-player--js');

    this.$playButton.classList.add('loading');

    this.isPlayerReady = false;
    this.$audioElement.addEventListener('loadedmetadata', function () {
      _this.playerReady(_this);
    });

    if (this.$audioElement.readyState >= 2) {
      this.playerReady(this);
    }

    this.usingMetadata = false; // set to true in loadMetadata if no errors thrown
    this.loadMetadata(this.$elm.dataset.episodeNumber);
  }

  _createClass(AudioPlayer, [{
    key: 'playerReady',
    value: function playerReady(player) {
      if (this.isPlayerReady) {
        return;
      }

      this.isPlayerReady = true;
      player.duration = player.$audioElement.duration;
      player.$duration.innerHTML = AudioPlayer.secondsToMinutes(player.duration);
      player.$playButton.addEventListener('click', function () {
        player.togglePlay(player.$audioElement, player.$playButton);
      }, false);
      player.$audioElement.addEventListener('timeupdate', player.update.bind(player));
      player.window.addEventListener('hashchange', player.seekNewTime.bind(player));
      player.window.addEventListener('load', player.seekNewTime.bind(player));
      this.$playButton.classList.remove('loading');

      var playerReady = void 0;
      try {
        playerReady = new CustomEvent('playerReady', { detail: this.uniqueId });
      } catch (e) {
        // CustomEvent not supported, do it the old fashioned way
        playerReady = document.createEvent('playerReady');
        playerReady.initCustomEvent('playerReady', true, true, { detail: this.uniqueId });
      }

      player.window.dispatchEvent(playerReady);
    }
  }, {
    key: 'prepare$title',
    value: function prepare$title(parent, doc) {
      var span = doc.createElement('span');
      try {
        span.innerHTML = parent.innerHTML;
      } catch (e) {
        return;
      }

      span.classList.add('audio-player__title');
      parent.innerHTML = '';
      parent.appendChild(span);

      var link = span.querySelector('.audio-player__header-link');

      if (link) {
        this.$titleLink = link;

        return link;
      }

      return span;
    }

    /**
     * Converts seconds to a display of minutes & seconds.
     *
     * @param {Number} seconds The time to convert, in seconds
     * @returns {string} The time in a [m]m:ss string
     */

  }, {
    key: 'togglePlay',


    //noinspection JSValidateJSDoc
    /**
     * Toggles play/pause state of media file.
     *
     * @param {HTMLAudioElement} $audioElement The audio element to toggle the play state of
     * @param {HTMLButtonElement} $togglePlayButton The button controlling the playback
     */
    value: function togglePlay($audioElement, $togglePlayButton) {
      if (this.isPlaying) {
        this.pause($audioElement, $togglePlayButton);
      } else {
        this.play($audioElement, $togglePlayButton);
      }
    }
  }, {
    key: 'play',
    value: function play($audioElement, $togglePlayButton) {
      $audioElement.play();
      $togglePlayButton.classList.add('audio-player__toggle_play--pauseable');
      $togglePlayButton.classList.remove('audio-player__toggle_play--playable');
      $togglePlayButton.innerHTML = 'Pause';
      this.isPlaying = true;
    }
  }, {
    key: 'pause',
    value: function pause($audioElement, $togglePlayButton) {
      $audioElement.pause();
      $togglePlayButton.classList.add('audio-player__toggle_play--playable');
      $togglePlayButton.classList.remove('audio-player__toggle_play--pauseable');
      $togglePlayButton.innerHTML = 'Play';
      this.isPlaying = false;
    }

    /**
     * Update the progress bar and elapsed time indicator based on track's current time.
     */

  }, {
    key: 'update',
    value: function update() {
      var currentTime = Math.floor(this.$audioElement.currentTime);
      var pc = currentTime / this.duration * 100;
      var currentTime2Dis = AudioPlayer.secondsToMinutes(currentTime);
      this.$progressBar.style.width = pc + '%';
      this.$currentTime.innerHTML = currentTime2Dis;

      if (this.$titleLink) {
        this.$titleLink.hash = currentTime;
      }

      if (this.usingMetadata) {
        var chapterNumberOnLastUpdate = this.getCurrentChapterNumber();
        this.setCurrentChapterMetadata(this.getChapterMetadataAtTime(currentTime, this.chapterMetadata));
        if (this.getCurrentChapterMetadata().number !== chapterNumberOnLastUpdate) {
          this.changeChapter(this.getCurrentChapterNumber(), this.getCurrentChapterMetadata().title, this.$elm);
        }
      }

      if (this.$audioElement.ended) {
        this.$playButton.classList.add('audio-player__toggle_play--playable');
        this.$playButton.classList.remove('audio-player__toggle_play--pauseable');
        this.$playButton.innerHTML = 'Play';
        this.isPlaying = false;
      }
    }

    /**
     * Updates player title with chapter number & name, and dispatches chapterChanged event.
     *
     * @param {int} number New chapter number Used as value of detail property of
     * @param {String} title new chapter title
     * @param {HTMLElement} $elm Element from which to dispatch the event
     */

  }, {
    key: 'changeChapter',
    value: function changeChapter(number, title, $elm) {
      this.setTitle(this.episodeTitle, title);
      var chapterChanged = void 0;
      try {
        chapterChanged = new CustomEvent('chapterChanged', { detail: number });
      } catch (e) {
        // CustomEvent not supported, do it the old fashioned way
        chapterChanged = document.createEvent('chapterChanged');
        chapterChanged.initCustomEvent('chapterChanged', true, true, { detail: number });
      }

      $elm.dispatchEvent(chapterChanged);
    }
  }, {
    key: 'seekNewTime',
    value: function seekNewTime(e) {
      var hash;
      var shouldPlay = false;
      try {
        hash = e.newURL.substring(e.newURL.indexOf('#') + 1);

        // Should play when chapter changed within the page, but not autoplay on page load :-)
        shouldPlay = true;
      } catch (e) {
        // newURL only available on hashchange event, but load event may also invoke this handler
        hash = this.window.location.hash.substring(1);
        shouldPlay = false;
      }

      if (!isNaN(hash) && hash >= 0) {
        this.seek(hash, this.$audioElement);
        if (!this.isPlaying && shouldPlay) {
          this.play(this.$audioElement, this.$playButton);
        }
      }
    }

    /**
     * Event handler to determine track seek time in response to user interaction.
     *
     * @param e The user-generated click event
     * @param {AudioPlayer} player The audio player object that the new element belongs to
     */

  }, {
    key: 'handleSeek',
    value: function handleSeek(e, player) {
      var newSeekPosition = parseInt(e.offsetX, 10);
      var availableWidth = player.$progressTrack.clientWidth;
      var durationProportionToSeek = newSeekPosition / parseInt(availableWidth, 10);
      this.seek(durationProportionToSeek * player.duration, player.$audioElement);
    }

    //noinspection JSValidateJSDoc
    /**
     * Seeks a particular time in the media file.
     *
     * @param {Number} time The time to seek
     * @param {HTMLAudioElement} $audioElement The audio element to toggle the play state of
     */

  }, {
    key: 'seek',
    value: function seek(time, $audioElement) {
      $audioElement.currentTime = time;
      this.update();
    }

    /**
     * Builds the progress indicator.
     *
     * @param {AudioPlayer} player The audio player object that the new element belongs to
     * @returns {Element} The progress indicator
     */

  }, {
    key: 'setTitle',


    /**
     * Set the title based on both episode and chapter titles
     * @param episodeTitle
     * @param chapterTitle
     */
    value: function setTitle(episodeTitle, chapterTitle) {
      this.title = episodeTitle;
      if (!!chapterTitle) {
        this.title += ': ' + chapterTitle;
      }

      this.$title.innerHTML = this.title;
    }
  }, {
    key: 'getCurrentChapterMetadata',
    value: function getCurrentChapterMetadata() {
      return this.currentChapterMetadata;
    }
  }, {
    key: 'setCurrentChapterMetadata',
    value: function setCurrentChapterMetadata(metadata) {
      this.currentChapterMetadata = metadata;
    }
  }, {
    key: 'getCurrentChapterNumber',
    value: function getCurrentChapterNumber() {
      return this.getCurrentChapterMetadata().number || 0;
    }

    /**
     * Returns a chapter's title and number, based on the playback position
     * @param time
     * @param {Array} chapterMetadata
     * An array of objects that must contain as a minimum
     * @returns {*}
     */

  }, {
    key: 'getChapterMetadataAtTime',
    value: function getChapterMetadataAtTime(time, chapterMetadata) {
      if (!chapterMetadata) {
        return '';
      }

      var chapterTitle = '';
      var chapterNumber = 0;
      chapterMetadata.forEach(function (chapter, i, chapters) {
        var chapterStartTime = parseInt(chapter.time, 10);
        var nextChapterStartTime = i < chapters.length - 1 ? chapters[i + 1].time : null;
        if (time >= chapterStartTime) {
          if (!nextChapterStartTime || time < nextChapterStartTime) {
            chapterTitle = chapter.title;
            chapterNumber = chapter.number;
          }
        }
      });

      return {
        title: chapterTitle,
        number: chapterNumber
      };
    }

    /**
     * Sets episode title and respective chapter information from metadata
     * @param metadata
     */

  }, {
    key: 'processMetadata',
    value: function processMetadata(metadata) {
      this.episodeTitle = 'Episode ' + metadata.number;
      this.setTitle(this.episodeTitle);

      this.chapterMetadata = this.prepareChapterMetadata(metadata);
      this.currentChapterMetadata = { number: 0, title: '' };
    }

    /**
     * Returns array of objects describing respective chapter information
     * @param metadata
     * @returns {Array} of objects containing time, number and title properties
     */

  }, {
    key: 'prepareChapterMetadata',
    value: function prepareChapterMetadata(metadata) {
      var chapterMetadata = [];
      metadata.chapters.forEach(function (chapter) {
        chapterMetadata.push({
          time: chapter.time,
          number: chapter.number,
          title: chapter.number + '. ' + chapter.title
        });
      });

      return chapterMetadata;
    }

    /**
     * Metadata is expected in the data-metadata attribute of $elm as a JSON-like string with single-
     * quoted instead of double-quoted values.
     */

  }, {
    key: 'loadMetadata',
    value: function loadMetadata() {
      try {
        this.processMetadata(JSON.parse(this.$elm.dataset.metadata.replace(/'/g, '"')));
        this.usingMetadata = true;
      } catch (e) {
        console.error(e);
        this.usingMetadata = false;
      }
    }
  }], [{
    key: 'secondsToMinutes',
    value: function secondsToMinutes(seconds) {
      var _seconds = parseInt(seconds, 10);
      var mins = Math.floor(_seconds / 60);
      var secs = _seconds % 60;
      if (secs <= 9) {
        secs = '0' + secs;
      }

      return mins + ':' + secs;
    }
  }, {
    key: 'buildProgressIndicator',
    value: function buildProgressIndicator(player) {
      var $barWrapper = utils.buildElement('div', ['audio-player__progress'], '', '#' + player.uniqueId + ' [class*="audio-player__container"]');

      utils.buildElement('div', ['audio-player__progress_bar'], '', $barWrapper);

      $barWrapper.addEventListener('click', function (e) {
        player.handleSeek(e, player);
      }, false);

      return $barWrapper;
    }

    /**
     * Builds the play button.
     *
     * @param {AudioPlayer} player The audio player object that the new element belongs to
     * @returns {Element} The play/pause button
     */

  }, {
    key: 'buildPlayButton',
    value: function buildPlayButton(player) {
      return utils.buildElement('button', ['audio-player__toggle_play'], 'Play', '#' + player.uniqueId + ' [class*="audio-player"]', true);
    }

    /**
     * Builds the current time and duration indicators.
     *
     * @param {AudioPlayer} player The audio player object that the new element belongs to
     * @returns {Element} An element containing the current time and duration indicators.
     */

  }, {
    key: 'buildTimeIndicators',
    value: function buildTimeIndicators(player) {
      var playerId = player.uniqueId;
      var $container = utils.buildElement('div', ['audio-player__times'], '', '#' + playerId + ' [class*=audio-player__header]', true);

      utils.buildElement('span', ['audio-player__current_time'], '0:00', $container);
      utils.buildElement('span', ['audio-player__duration'], '0:00', $container);
      return $container;
    }
  }]);

  return AudioPlayer;
}();

},{"../libs/elife-utils":35}],8:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Highcharts = require('highcharts');

var MONTHLY_TICK = 3600 * 1000 * 24 * 30;
var WEEKLY_TICK = 3600 * 1000 * 24 * 7;

var defaultOptions = {
  chart: { type: 'column' },
  credits: { enabled: false },
  title: { text: 'Downloads' },
  subtitle: { text: '(Monthly)' },
  exporting: false,
  xAxis: {
    type: 'datetime',
    dateTimeLabelFormats: { month: '%m/%y' },
    tickInterval: MONTHLY_TICK,
    gridLineWidth: 1,
    labels: {
      style: { fontWeight: 'bold' }
    }
  },
  yAxis: {
    min: 0,
    title: { text: null },
    labels: {
      step: 2,
      style: { fontWeight: 'bold' }
    },
    plotLines: [{
      value: 0,
      width: 1,
      color: '#808080'
    }]
  },
  legend: { enabled: false },
  tooltip: {
    shared: true,
    crosshairs: true,
    backgroundColor: '#000000',
    borderColor: '#000000',
    borderRadius: 5,
    useHTML: true,
    formatter: function formatter() {
      return '\n            <div class="chart-tooltip">\n              <div class="chart-tooltip__header">\n                ' + this.y + ' ' + this.points[0].series.chart.options.title.text + '\n              </div>\n              <div class="chart-tooltip__content">\n                ' + Highcharts.dateFormat('%b %d, %Y', new Date(this.x)) + '\n              </div>\n            </div>\n          ';
    }
  },
  plotOptions: {
    column: {
      states: {
        hover: { color: '#0088cd' }
      }
    }
  },
  series: [{
    name: null,
    data: [],
    color: '#000000',
    lineColor: '#cccccc'
  }]
};

var BarChart = function () {
  function BarChart(id) {
    _classCallCheck(this, BarChart);

    this.target = id;
    this.chart = Highcharts.chart(id, defaultOptions);
  }

  _createClass(BarChart, [{
    key: 'update',
    value: function update(data, dateTimeLabelFormats, tickInterval, text, label) {
      var config = {
        title: { text: label },
        subtitle: { text: text },
        xAxis: { tickInterval: tickInterval, dateTimeLabelFormats: dateTimeLabelFormats },
        series: [{
          name: null,
          data: data.periods
        }]
      };

      this.chart.redraw();
      this.chart.reflow();
      this.chart.update(config);
    }
  }, {
    key: 'getDateRange',
    value: function getDateRange(range) {
      return {
        dateRange: _defineProperty({}, range === 'monthly' ? 'week' : 'day', '%d/%m/%y'),
        tick: range === 'monthly' ? MONTHLY_TICK : WEEKLY_TICK
      };
    }
  }, {
    key: 'updateFromJson',
    value: function updateFromJson(_ref) {
      var data = _ref.data,
          label = _ref.label,
          range = _ref.range,
          title = _ref.title;

      var _getDateRange = this.getDateRange(range),
          dateRange = _getDateRange.dateRange,
          tick = _getDateRange.tick;

      this.update(data, dateRange, tick, title, label);
    }
  }]);

  return BarChart;
}();

module.exports = BarChart;

},{"highcharts":128}],9:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var utils = require('../libs/elife-utils')();

module.exports = function () {
  function Carousel($elm) {
    var _window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;

    var doc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;

    _classCallCheck(this, Carousel);

    if (!$elm) {
      return;
    }

    this.window = _window;
    this.doc = doc;
    this.$elm = $elm;

    this.moveableStage = this.$elm.querySelector('.carousel__items');
    this.originalSlideWrappers = this.moveableStage.querySelectorAll('.carousel-item');
    this.originalSlideCount = this.originalSlideWrappers.length;
    this.currentSlideCount = this.originalSlideCount;

    [].forEach.call(this.originalSlideWrappers, function (slide) {
      slide.insertAdjacentHTML('afterbegin', slide.dataset.image);
    });

    if (this.originalSlideCount < 2) {
      return;
    }

    this.init();
  }

  _createClass(Carousel, [{
    key: 'init',
    value: function init() {
      var _this = this;

      this.currentSlide = 1;
      this.timerInterval = 10000;

      this.updateButtonAppearance();
      this.$elm.appendChild(this.buildVisibleControls());
      this.$toggler = this.buildControl$toggle();
      this.$elm.insertBefore(this.$toggler, this.$elm.querySelector('.carousel__items'));
      this.updateWidth();
      this.updateControlPanel(this.currentSlide);
      this.togglePlay(this.$toggler);

      this.window.addEventListener('keydown', this.handleKey.bind(this));
      this.window.addEventListener('blur', this.cancelTimer.bind(this));
      this.window.addEventListener('focus', this.setupTimer.bind(this));
      this.window.addEventListener('resize', function () {
        _this.updateWidth();
        _this.adjustTranslateForResize();
      });
      this.makeSingleSlideATVisible(this.currentSlide);
    }
  }, {
    key: 'updateButtonAppearance',
    value: function updateButtonAppearance() {
      var buttons = this.$elm.querySelectorAll('.carousel-item__cta .button');
      [].forEach.call(buttons, function (button) {
        button.classList.add('button--reversed');
      });
    }
  }, {
    key: 'atHide',
    value: function atHide($node) {
      $node.setAttribute('tabindex', -1);
      $node.setAttribute('aria-hidden', true);
    }
  }, {
    key: 'atShow',
    value: function atShow($node) {
      $node.removeAttribute('tabindex', -1);
      $node.removeAttribute('aria-hidden', true);
    }
  }, {
    key: 'setATVisibility',
    value: function setATVisibility($root, show) {
      var _this2 = this;

      var action = void 0;
      if (show) {
        action = this.atShow;
      } else {
        action = this.atHide;
      }

      action.call(this, $root);
      [].forEach.call($root.childNodes, function ($descendant) {
        if ($descendant.nodeType === $descendant.ELEMENT_NODE) {
          action.call(_this2, $descendant);
          if ($descendant.hasChildNodes()) {
            _this2.setATVisibility($descendant, show);
          }
        }
      });
    }
  }, {
    key: 'makeSingleSlideATVisible',
    value: function makeSingleSlideATVisible(slideNumber) {
      var _this3 = this;

      [].forEach.call(this.moveableStage.querySelectorAll('.carousel-item'), function ($el) {
        _this3.setATVisibility($el, false);
      });
      var _slideNumber = slideNumber || 1;
      var slide = this.$elm.querySelectorAll('.carousel-item')[_slideNumber - 1];
      this.setATVisibility(slide, true);
    }

    /**
     * Builds and returns all controls for the carousel
     *
     * @returns {Element} The control panel
     */

  }, {
    key: 'buildVisibleControls',
    value: function buildVisibleControls() {
      var $previousButton = this.buildControl$traverser('previous');
      var $nextButton = this.buildControl$traverser('next');

      this.buttons = {
        previous: $previousButton,
        next: $nextButton
      };

      // switches are the circular buttons for depicting/going to a slide
      this.switches = this.buildControl$switches(this.originalSlideCount);

      var $controlPanel = utils.buildElement('div', ['carousel__control_panel']);
      var visibleControls = [$previousButton, this.switches, $nextButton];
      visibleControls.forEach(function (control) {
        $controlPanel.appendChild(control);
      });

      return $controlPanel;
    }

    /**
     * Returns a div-wrapped button for a next or previous control, with event listener
     *
     * @param {String} direction 'previous' | 'next'
     * @returns {Element} A div-wrapped button
     */

  }, {
    key: 'buildControl$traverser',
    value: function buildControl$traverser(direction) {
      var _this4 = this;

      var _direction = direction === 'previous' ? 'previous' : 'next';
      var text = direction + ' item';
      var $button = utils.buildElement('button', ['carousel__control', 'carousel__control--traverse', 'carousel__control--' + _direction]);
      $button.addEventListener('click', function () {
        _this4.userInitiatedProgression(_this4[_direction]);
      });

      utils.buildElement('span', ['visuallyhidden'], text, $button);
      return $button;
    }

    /**
     * Builds and returns a visually hidden play/pause toggle (button & label), with event listener
     *
     * @returns {Element} The toggler
     */

  }, {
    key: 'buildControl$toggle',
    value: function buildControl$toggle() {
      var _this5 = this;

      var $button = utils.buildElement('button', ['carousel__control--toggler', 'visuallyhidden'], 'Play carousel');
      $button.setAttribute('aria-label', 'The carousel is now paused. Play carousel');
      $button.addEventListener('click', function () {
        _this5.togglePlay($button);
      });
      return $button;
    }

    /**
     * Builds and returns a list of switches, with event listener attached
     *
     * @param quantity The number of switches to build
     * @returns {Element} The list of switches
     */

  }, {
    key: 'buildControl$switches',
    value: function buildControl$switches(quantity) {
      var $switches = utils.buildElement('ol', ['carousel__control_switches']);
      for (var i = 1; i <= quantity; i += 1) {
        $switches.appendChild(this.buildControl$switch('Go to item ' + i + ' of ' + this.originalSlideCount, i));
      }

      $switches.addEventListener('click', this.activateSwitch.bind(this));
      return $switches;
    }

    /**
     * Builds and returns a switch
     * @param text The next for the switch (visually hidden)
     * @returns {Element} The switch
     */

  }, {
    key: 'buildControl$switch',
    value: function buildControl$switch(text, index) {
      var $item = utils.buildElement('li', ['carousel__control--switch-item']);
      var $button = utils.buildElement('button', ['carousel__control', 'carousel__control--switch'], '', $item);
      var $switch = utils.buildElement('span', ['visuallyhidden'], '' + index, $button);
      $switch.setAttribute('aria-label', text);
      return $item;
    }

    /**
     * Toggles the play/pause state of the carousel based on the current value of the toggle button.
     *
     * @param $button The toggler
     */

  }, {
    key: 'togglePlay',
    value: function togglePlay($button) {
      var currentButtonState = $button.innerHTML;
      if (currentButtonState === 'Pause carousel') {
        $button.innerHTML = 'Play carousel';
        $button.setAttribute('aria-label', 'The carousel is now paused. Play carousel');
        this.timerStopped = true;
        this.cancelTimer();
      } else {
        $button.innerHTML = 'Pause carousel';
        $button.setAttribute('aria-label', 'The carousel is now playing. Pause carousel');
        this.timerStopped = false;
        this.setupTimer();
      }
    }
  }, {
    key: 'cancelTimer',
    value: function cancelTimer() {
      this.window.clearInterval(this.timer);
    }
  }, {
    key: 'setupTimer',
    value: function setupTimer() {
      var _this6 = this;

      // make sure old timer stopped before starting a new one
      this.cancelTimer();

      // Indicates whether timer should run at all on this carousel (hard stop, not pause).
      this.timerStopped = false;
      this.timer = this.startNewAdvancementTimer(this.timerInterval);

      // mousing over the carousel cancels the timer
      this.$elm.addEventListener('mouseenter', this.cancelTimer.bind(this));

      // mouse out from the carousel resets the timer
      this.$elm.addEventListener('mouseleave', function () {
        _this6.cancelTimer();
        if (!_this6.timerStopped) {
          _this6.timer = _this6.startNewAdvancementTimer(_this6.timerInterval);
        }
      });
    }
  }, {
    key: 'startNewAdvancementTimer',
    value: function startNewAdvancementTimer(intervalInMs) {
      var _this7 = this;

      return this.window.setInterval(function () {
        if (!_this7.timerStopped) {
          _this7.next();
        }
      }, intervalInMs);
    }
  }, {
    key: 'handleKey',
    value: function handleKey(e) {
      var code = e.keyCode || e.charCode;
      if (code === 37 /*left arrow*/ || code === 39 /*right arrow*/) {
          this.timerStopped = true;
          if (code === 37) {
            this.userInitiatedProgression(this.previous);
          } else {
            this.userInitiatedProgression(this.next);
          }
        }
    }
  }, {
    key: 'userInitiatedProgression',
    value: function userInitiatedProgression(callback) {
      // Any user-activation of a control permanently stops the timer
      this.timerStopped = true;
      if (!!callback && typeof callback === 'function') {
        callback.call(this, true);
      }
    }
  }, {
    key: 'next',
    value: function next() {
      if ((this.currentSlide + 1) % this.originalSlideCount === 0) {
        this.extendStage();
      }

      this.updateSlide();
      this.updateControlPanel(this.currentSlide);
    }
  }, {
    key: 'previous',
    value: function previous() {
      if (this.currentSlide > 1) {
        this.updateSlide('previous');
        this.updateControlPanel(this.currentSlide);
      }
    }
  }, {
    key: 'extendStage',
    value: function extendStage() {
      var _this8 = this;

      // Make room for another slide set
      this.currentSlideCount += this.originalSlideCount;
      this.updateWidth();

      // Clone in the new slide set
      [].forEach.call(this.originalSlideWrappers, function (slide) {
        _this8.moveableStage.appendChild(slide.cloneNode(true));
      });
    }

    /**
     * Translates moveableStage 1 slide's width in the appropriate direction
     * @param {String} [direction] 'previous' means translate left to right
     */

  }, {
    key: 'updateSlide',
    value: function updateSlide(direction) {
      var currentOffset = this.getCurrentOffset();
      var newOffset = void 0;
      if (direction === 'previous') {
        this.currentSlide -= 1;
        newOffset = currentOffset + Math.round(this.calcOffset());
      } else {
        this.currentSlide += 1;
        newOffset = currentOffset - Math.round(this.calcOffset());
      }

      utils.updateElementTranslate(this.moveableStage, [newOffset + 'px', 0]);
    }

    /**
     * Calculates offset for translating a carousel item, taking vertical scrollbar width into account
     *
     * @return {number} Pixel offset with which to translate the carousel item
     */

  }, {
    key: 'calcOffset',
    value: function calcOffset() {
      var maxCarouselWidth = 1114;
      var windowCanFitFullWidthCarousel = window.innerWidth >= maxCarouselWidth + utils.calcScrollbarWidth();
      if (windowCanFitFullWidthCarousel) {
        return this.$elm.getBoundingClientRect().width;
      }

      return window.innerWidth;
    }

    /**
     * Returns the current numerical value of moveableStage's X translation in px
     *
     * @returns {number} Numerical value of the X translation of moveableStage
     */

  }, {
    key: 'getCurrentOffset',
    value: function getCurrentOffset() {
      var offsetStringMatch = this.moveableStage.style.transform.match(/translate\((.*)px,[^)]+\)/);
      if (!offsetStringMatch) {
        return 0;
      }

      return this.window.parseInt(offsetStringMatch[1], 10);
    }
  }, {
    key: 'updateControlPanel',
    value: function updateControlPanel(currentSlide) {
      this.hideInvalidButtonChoice(currentSlide);
      this.updateActiveSwitch(currentSlide);
    }

    /**
     * Hides previous button if on first slide.
     *
     * @param {number} currentSlide The number of the current slide
     */

  }, {
    key: 'hideInvalidButtonChoice',
    value: function hideInvalidButtonChoice(currentSlide) {
      this.buttons.previous.classList.remove('hidden');
      this.buttons.next.classList.remove('hidden');
      var logicalSlideNumber = this.getLogicalSlideNumber(currentSlide);
      if (logicalSlideNumber === 1) {
        this.buttons.previous.classList.add('hidden');
      } else if (logicalSlideNumber === this.originalSlideCount) {
        this.buttons.next.classList.add('hidden');
      }
    }

    /**
     * Activate the switch indicating the current logical slide
     *
     * @param {number} currentSlide The number of the current slide
     */

  }, {
    key: 'updateActiveSwitch',
    value: function updateActiveSwitch(currentSlide) {
      var currentLogicalSlide = this.getLogicalSlideNumber(currentSlide);
      [].forEach.call(this.switches.querySelectorAll('.carousel__control--switch'), function (aSwitch, i) {
        if (i === currentLogicalSlide - 1) {
          aSwitch.classList.add('active');
        } else {
          aSwitch.classList.remove('active');
        }
      });
    }

    /**
     * Returns the number of the side within its set.
     *
     * E.g. where there's 3 slides in a set, and the actualSlideNumber is 8, this indicates that it's
     * the 2nd slide in the 3rd slide set, so its logical number is 2.
     * (A slide set is a clone of the starting slides to facilitate perpetual scroll.)
     *
     * @param {number} actualSlideNumber Number of the slide to evaluate
     * @returns {number}
     */

  }, {
    key: 'getLogicalSlideNumber',
    value: function getLogicalSlideNumber(actualSlideNumber) {
      var setSize = this.originalSlideCount;
      var slideSetOfSlide = Math.ceil(actualSlideNumber / setSize);
      var firstSlideOfSet = setSize * slideSetOfSlide - (setSize - 1);
      return actualSlideNumber - firstSlideOfSet + 1;
    }

    /**
     * Move to the closest slide with the same logical number as the activated switch
     *
     * @param {Event} e The event
     */

  }, {
    key: 'activateSwitch',
    value: function activateSwitch(e) {
      var logicalSlideRequested = this.window.parseInt(e.target.querySelector('span').innerHTML, 10);
      var logicalSlideCurrent = this.getLogicalSlideNumber(this.currentSlide);
      var slideOffset = logicalSlideRequested - logicalSlideCurrent;

      if (logicalSlideRequested === logicalSlideCurrent) {
        return;
      }

      var callback = slideOffset < 0 ? this.previous : this.next;

      for (var i = 0; i < Math.abs(slideOffset); i += 1) {
        this.userInitiatedProgression(callback);
      }
    }
  }, {
    key: 'adjustTranslateForResize',
    value: function adjustTranslateForResize() {
      var carouselWidth = Math.round(window.getComputedStyle(this.$elm).width.match(/([0-9.]+)px/)[1]);
      var currentSlide = this.currentSlide;
      var expectedOffset = (currentSlide - 1) * carouselWidth * -1;
      this.moveableStage.style.transform = 'translate(' + expectedOffset + 'px, 0)';
    }
  }, {
    key: 'updateWidth',
    value: function updateWidth() {
      this.moveableStage.style.width = utils.adjustPxString(this.window.getComputedStyle(this.$elm).width, this.currentSlideCount, 'multiply');
    }
  }]);

  return Carousel;
}();

},{"../libs/elife-utils":35}],10:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var utils = require('../libs/elife-utils')();

module.exports = function () {

  // Passing window and document separately allows for independent mocking of window in order
  // to test feature support fallbacks etc.
  function ContentHeader($elm) {
    var _window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;

    var doc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;

    _classCallCheck(this, ContentHeader);

    if (!$elm) {
      return;
    }

    this.window = _window;
    this.doc = doc;
    this.$elm = $elm;
    this.$elm.classList.add('content-header--js');

    this.authors = $elm.querySelectorAll('.content-header__author_list_item');
    this.institutions = $elm.querySelectorAll('.content-header__institution_list_item');

    if (this.authors.length > 0) {
      this.authors[this.authors.length - 1].classList.add('content-header__author_list_item--last');
    }

    if (this.institutions.length > 0) {
      this.institutions[this.institutions.length - 1].classList.add('content-header__institution_list_item--last');
    }

    this.hasToggleAuthor = false;
    this.hasToggleInstitution = false;
    this.hideAllExcessItems();
    this.setupResizeHandler();
  }

  _createClass(ContentHeader, [{
    key: 'setupResizeHandler',
    value: function setupResizeHandler() {
      var _this = this;

      this.currentClientWidth = document.body.clientWidth;
      this.window.addEventListener('resize', utils.debounce(function () {
        return _this.handleResize();
      }, 30));
    }
  }, {
    key: 'handleResize',
    value: function handleResize() {
      // Android (at least), may fire resize on initial scroll as url bar moves off the top of the
      // screen, and the height of the browser window increases until the top edge is at the top of
      // the screen.
      if (this.currentClientWidth === document.body.clientWidth) {
        return;
      }

      this.currentClientWidth = document.body.clientWidth;
      if (!this.$elm.querySelector('.content-header__author_list--expanded')) {
        this.hideAllExcessItems();
      }

      var toggles = this.$elm.querySelectorAll('.content-header__item_toggle .content-header__author_link_highlight');
      var updateToggleText = this.getUpdatedToggleText.bind(this);
      [].forEach.call(toggles, function ($toggle) {
        $toggle.innerHTML = updateToggleText();
      });
    }

    /**
     * Determine excess by itemType from items supplied and hides those.
     *
     * @param {string} itemType 'author' or 'institution'
     * @param {DOMTokenList} items List of items to identify the excess within, and hide those
     */

  }, {
    key: 'hideExcessItems',
    value: function hideExcessItems(itemType, items) {
      this.clearExcessMark(items);
      this.markAsExcess(this.getExcessItems(itemType, items));
      this.toggleExcessItems(items);
      this.addTrailingText(itemType, items);
    }

    /**
     *
     * @returns {number} Number of item to display by default
     */

  }, {
    key: 'getMaxItems',
    value: function getMaxItems() {
      if (this.window.matchMedia('(min-width: 730px)').matches) {
        return 9;
      }

      if (this.authors.length === 2) {
        return 2;
      }

      return 1;
    }

    /**
     * Returns array of elements in excess of the default max items, or null if itemType invalid.
     *
     * The returned array is a subset of the list supplied, or empty if there are no excess items.
     *
     * @param {string} itemType 'author' or 'institution'
     * @param {DOMTokenList} items List of items from which to identify the excess
     * @returns {Array|null} Items in excess of the default maximum for the current screen width
     */

  }, {
    key: 'getExcessItems',
    value: function getExcessItems(itemType, items) {
      if (itemType !== 'author' && itemType !== 'institution') {
        return null;
      }

      var maxItems = this.getMaxItems();
      if (items.length > maxItems) {
        return [].slice.call(items, maxItems);
      }

      return [];
    }

    /**
     * Marks supplied list elements as excess.
     *
     * @param {Array} els The elements to mark as excess
     */

  }, {
    key: 'markAsExcess',
    value: function markAsExcess(els) {
      els.forEach(function ($el) {
        $el.classList.add('excess-item');
      });
    }

    /**
     * Clears any excess mark from all elements in the supplied list.
     *
     * @param {DOMTokenList} els The elements to clear the excess mark from
     */

  }, {
    key: 'clearExcessMark',
    value: function clearExcessMark(els) {
      [].forEach.call(els, function ($el) {
        $el.classList.remove('excess-item');
      });
    }

    /**
     * Toggles the display of any excess items found in the supplied list of elements.
      * @param {DOMTokenList} items The elements to inspect for excess items, and to toggle those found
     */

  }, {
    key: 'toggleExcessItems',
    value: function toggleExcessItems(items) {
      [].forEach.call(items, function (item) {
        if (item.classList.contains('excess-item')) {
          item.classList.add('visuallyhidden');
        } else {
          item.classList.remove('visuallyhidden');
        }
      });
    }

    /**
     * Marks the last shown non-excess item with particlular class (so not if showing last in list).
     *
     * @param {string} itemType 'author' or 'institution'
     * @param {DOMTokenList} items List of items to act upon
     */

  }, {
    key: 'markLastNonExcessItem',
    value: function markLastNonExcessItem(itemType, items) {
      var lastShownIndex = null;
      var foundLastShown = false;
      [].forEach.call(items, function (item, i) {

        // Clear old any obsolete determination of what's the last non-excess item.
        if (item.querySelector('.content-header__' + itemType)) {
          item.querySelector('.content-header__' + itemType).classList.remove('content-header__' + itemType + '--last-non-excess');
          if (item.classList.contains('excess-item') && !foundLastShown) {
            lastShownIndex = i - 1;
            foundLastShown = true;
          }
        }
      });

      if (lastShownIndex !== null && lastShownIndex > -1) {
        var lastShown = items[lastShownIndex].querySelector('.content-header__' + itemType);
        if (lastShown) {
          lastShown.classList.add('content-header__' + itemType + '--last-non-excess');
        }
      }
    }

    /**
     * Adds trailing text to the visible end of truncated author & institution lists & builds toggle.
     *
     * @param {string} itemType The type of items supplied
     * @param {DOMTokenList} items The items to which to add the trailing text
     */

  }, {
    key: 'addTrailingText',
    value: function addTrailingText(itemType, items) {
      if (itemType === 'author' && items.length > this.getMaxItems()) {
        if (!this.hasToggleAuthor) {
          this.buildSeeMoreLessToggle('author');
          this.hasToggleAuthor = true;
        }
      }

      if (itemType === 'institution' && items.length > this.getMaxItems()) {
        if (!this.hasToggleInstitution) {
          this.buildSeeMoreLessToggle('institution');
          this.hasToggleInstitution = true;
        }
      }

      this.markLastNonExcessItem(itemType, items);
    }
  }, {
    key: 'getToggleCollapsedText',
    value: function getToggleCollapsedText() {
      var baseText = '<span class="visuallyhidden"> expand author list</span>';
      if (this.window.matchMedia('(min-width: 730px)').matches) {
        return baseText + '<span aria-hidden="true">see&nbsp;all</span>';
      }

      return 'et al.' + baseText;
    }
  }, {
    key: 'getToggleExpandedText',
    value: function getToggleExpandedText() {
      var baseText = '<span class="visuallyhidden"> collapse author list</span>';
      if (this.window.matchMedia('(min-width: 730px)').matches) {
        return baseText + '<span aria-hidden="true">see&nbsp;less</span>';
      }

      return baseText + '<span aria-hidden="true" class="content-header__item_toggle_cta">&#171;</span>';
    }
  }, {
    key: 'getUpdatedToggleText',
    value: function getUpdatedToggleText(newState) {
      if (newState === 'expanded') {
        return this.getToggleExpandedText();
      }

      if (newState === 'collapsed') {
        return this.getToggleCollapsedText();
      }

      // This has been invoked because of a resize, not a state change
      if (this.$elm.querySelector('.content-header__item_toggle--expanded')) {
        return this.getToggleExpandedText();
      }

      if (this.$elm.querySelector('.content-header__item_toggle--collapsed')) {
        return this.getToggleCollapsedText();
      }
    }
  }, {
    key: 'updateToggleState',
    value: function updateToggleState(newState, toggles) {
      var _this2 = this;

      if (newState !== 'expanded' && newState !== 'collapsed') {
        return;
      }

      [].forEach.call(toggles, function ($toggle) {
        $toggle.innerHTML = _this2.getUpdatedToggleText(newState);
        $toggle.parentNode.classList.toggle('content-header__item_toggle--expanded');
        $toggle.parentNode.classList.toggle('content-header__item_toggle--collapsed');
      });

      if (newState === 'expanded') {
        this.$elm.querySelector('.content-header__author_list').classList.add('content-header__author_list--expanded');
        this.$elm.querySelector('.content-header__institution_list').classList.add('content-header__institution_list--expanded');
      } else {
        this.$elm.querySelector('.content-header__author_list').classList.remove('content-header__author_list--expanded');
        this.$elm.querySelector('.content-header__institution_list').classList.remove('content-header__institution_list--expanded');
      }
    }

    /**
     * Builds the show/hide toggle for excess authors & institutions.
     */

  }, {
    key: 'buildSeeMoreLessToggle',
    value: function buildSeeMoreLessToggle(itemType) {
      var _this3 = this;

      var $toggleWrapper = utils.buildElement('li', ['content-header__item_toggle', 'content-header__author_list_item', 'content-header__item_toggle--collapsed', 'content-header__item_toggle--' + itemType], '', this.$elm.querySelector('.content-header__' + itemType + '_list'));
      $toggleWrapper.setAttribute('aria-hidden', 'true');

      var $toggle = utils.buildElement('button', ['content-header__author_link_highlight'], this.getUpdatedToggleText('collapsed'), $toggleWrapper);

      var handleSeeMoreLessPress = function handleSeeMoreLessPress(e) {
        e.preventDefault();
        var $toggleWrapper = e.currentTarget.parentNode;
        var newState = void 0;
        if ($toggleWrapper.classList.contains('content-header__item_toggle--collapsed')) {
          _this3.showAllItems();
          newState = 'expanded';
        } else {
          _this3.hideAllExcessItems();
          newState = 'collapsed';
        }

        _this3.updateToggleState(newState, _this3.$elm.querySelectorAll('.content-header__item_toggle .content-header__author_link_highlight'), itemType);
      };

      $toggle.addEventListener('click', handleSeeMoreLessPress);
    }
  }, {
    key: 'showAllItems',
    value: function showAllItems() {
      this.clearExcessMark(this.authors);
      this.clearExcessMark(this.institutions);
      this.toggleExcessItems(this.authors);
      this.toggleExcessItems(this.institutions);
    }
  }, {
    key: 'hideAllExcessItems',
    value: function hideAllExcessItems() {
      this.markLastNonExcessItem('author', this.authors);
      this.markLastNonExcessItem('institution', this.institutions);
      this.hideExcessItems('author', this.authors);
      this.hideExcessItems('institution', this.institutions);
    }
  }]);

  return ContentHeader;
}();

},{"../libs/elife-utils":35}],11:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var utils = require('../libs/elife-utils')();

module.exports = function () {
  function CookieOverlay($elm) {
    var _window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;

    var doc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;

    _classCallCheck(this, CookieOverlay);

    if (!$elm) {
      return;
    }

    this.$elm = $elm;
    this.window = _window;
    this.doc = doc;
    var defaultDomain = 'elifesciences.org';
    try {
      this.domain = this.window.elifeConfig.domain || defaultDomain;
    } catch (e) {
      this.domain = defaultDomain;
      utils.logError(this.window, e, 'Domain configuration failed');
    }

    this.cookieString = null;

    if (this.previouslyAccepted()) {
      return;
    }

    var message = 'This site uses cookies to deliver its services and analyse traffic. By using ' + 'this site, you agree to its use of cookies. ' + '<a href="https://elifesciences.org/privacy">Learn&nbsp;more</a>.';
    this.$overlay = this.buildDOM(message);
    this.doc.querySelector('body').appendChild(this.$overlay);
  }

  _createClass(CookieOverlay, [{
    key: 'previouslyAccepted',
    value: function previouslyAccepted() {
      return !!utils.getCookieValue('cookieNotificationAccepted', this.doc.cookie);
    }
  }, {
    key: 'accept',
    value: function accept() {
      this.$overlay.parentNode.removeChild(this.$overlay);
      var expiryDate = 'Tue, 19 January 2038 03:14:07 UTC';
      this.cookieString = 'cookieNotificationAccepted=true; expires=' + expiryDate + '; path=/; domain=' + this.domain + ';';
      this.doc.cookie = this.cookieString;
    }
  }, {
    key: 'buildDOM',
    value: function buildDOM(message) {
      var _this = this;

      var $root = utils.buildElement('div', ['opt-in-message-bar']);
      utils.buildElement('div', ['opt-in-message-bar__message'], message, $root);

      var $buttonWrapper = utils.buildElement('div', ['opt-in-message-bar__button_wrapper'], '', $root);
      var $button = utils.buildElement('button', ['button', 'button--default', 'button--small'], 'Got it', $buttonWrapper);

      $button.addEventListener('click', function () {
        _this.accept();
      });

      return $root;
    }
  }]);

  return CookieOverlay;
}();

},{"../libs/elife-utils":35}],12:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

module.exports = function () {
  _createClass(DelegateBehaviour, null, [{
    key: 'setInitialiseComponent',
    value: function setInitialiseComponent(initialiseComponent) {
      DelegateBehaviour.initialiseComponent = initialiseComponent;
    }
  }]);

  function DelegateBehaviour($elm) {
    _classCallCheck(this, DelegateBehaviour);

    var behaviour = $elm.getAttribute('data-delegate-behaviour');
    var targets = $elm.querySelectorAll($elm.getAttribute('data-selector'));
    var classToApply = $elm.getAttribute('data-delegate-behaviour-class');
    [].forEach.call(targets, function (target) {
      DelegateBehaviour.initialiseComponent(target, behaviour);
      if (classToApply) {
        target.classList.add(classToApply);
      }
    });
  }

  return DelegateBehaviour;
}();

},{}],13:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

module.exports = function () {
  function FilterPanel($elm) {
    var _window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;

    var doc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;

    _classCallCheck(this, FilterPanel);

    if (!$elm) {
      return;
    }

    this.$elm = $elm;
    this.window = _window;
    this.doc = doc;

    this.$button = $elm.querySelector('button');

    if (!this.$button.form) {
      return;
    }

    this.$button.classList.add('visuallyhidden');
    FilterPanel.setupEventListeners(FilterPanel.findFilters(this.$elm));
  }

  _createClass(FilterPanel, null, [{
    key: 'setupEventListeners',
    value: function setupEventListeners(filters) {
      [].forEach.call(filters, function ($filter) {
        if (!$filter.form) {
          return;
        }

        $filter.addEventListener('change', function () {
          return $filter.form.submit();
        });
      });
    }
  }, {
    key: 'findFilters',
    value: function findFilters($elm) {
      return $elm.querySelectorAll('input[type="checkbox"]');
    }
  }]);

  return FilterPanel;
}();

},{}],14:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var utils = require('../libs/elife-utils')();

/**
 * FragmentHandler mediates how the hash controls the opening of article sections.
 * It has no dedicated pattern template and its data-behaviour may live on any element, but note
 * that because it's a singleton only one will be instansiated.
 * @type {FragmentHandler}
 */
module.exports = function () {
  function FragmentHandler($elm) {
    var _window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;

    var doc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;

    _classCallCheck(this, FragmentHandler);

    this.$elm = $elm;
    this.window = _window;
    this.doc = doc;
    this.isSingleton = true;

    this.window.addEventListener('load', this.handleSectionOpeningViaHash.bind(this));
    this.window.addEventListener('hashchange', this.handleSectionOpeningViaHash.bind(this));
  }

  /**
   * Returns the id of the collapsed section containing the html element with idToFind, or null.
   *
   * @param {String} idToFind The id to search for
   * @param {HTMLDocument} doc
   * @returns {String} The id of the collapsed section containing idToFind, or null
   */


  _createClass(FragmentHandler, [{
    key: 'getIdOfCollapsedSection',
    value: function getIdOfCollapsedSection(idToFind, doc) {
      var collapsedSections = doc.querySelectorAll('.article-section--collapsed');
      if (!collapsedSections.length) {
        return null;
      }

      var $collapsedSectionContainingFrag = void 0;
      [].forEach.call(collapsedSections, function ($collapsedSection) {
        if (!$collapsedSectionContainingFrag) {
          if (utils.isIdOfOrWithinSection(idToFind, $collapsedSection, doc)) {
            $collapsedSectionContainingFrag = $collapsedSection;
          }
        }
      });

      if (!!$collapsedSectionContainingFrag) {
        return $collapsedSectionContainingFrag.id;
      }

      return null;
    }

    /**
     * Fires a custom expandsection event on the collapsed article section containing id from hash.
     *
     * @param e
     * @returns {boolean} False if no hash found
     */

  }, {
    key: 'handleSectionOpeningViaHash',
    value: function handleSectionOpeningViaHash(e) {

      // TODO: Code similar to that in Audioplayer.seekNewTime(), refactor out into common
      var hash = '';

      // event was hashChange
      if (!!e.newURL) {
        hash = e.newURL.substring(e.newURL.indexOf('#') + 1);
      } else {
        hash = this.window.location.hash.substring(1);
      }

      if (!hash) {
        return false;
      }

      var idOfCollapsedSection = this.getIdOfCollapsedSection(hash, this.doc);
      if (!!idOfCollapsedSection) {
        this.doc.getElementById(idOfCollapsedSection).dispatchEvent(utils.eventCreator('expandsection', hash));
      }
    }
  }]);

  return FragmentHandler;
}();

},{"../libs/elife-utils":35}],15:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var utils = require('../libs/elife-utils')();

module.exports = function () {
  function Highlights($elm) {
    var _this = this;

    var _window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;

    var doc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;

    _classCallCheck(this, Highlights);

    if (!($elm instanceof HTMLElement)) {
      return;
    }

    this.window = _window;
    this.$elm = $elm;
    this.doc = doc;
    this.tabletWidth = 900;
    this.desktopWidth = 1200;
    this.setCurrentSlide(1);
    this.timerInterval = 10000;
    this.$prevBtn = $elm.querySelector('.highlights__control--prev');
    this.$nextBtn = $elm.querySelector('.highlights__control--next');
    this.$prevBtn.addEventListener('click', this.previousButton.bind(this));
    this.$nextBtn.addEventListener('click', this.nextButton.bind(this));
    this.moveableStage = this.$elm.querySelector('.listing-list--highlights');
    this.originalSlideWrappers = this.moveableStage.querySelectorAll('.listing-list__item');
    this.numSlides = this.originalSlideWrappers.length;
    this.switchBreakpoint();
    this.window.addEventListener('resize', utils.debounce(function () {
      return _this.switchBreakpoint();
    }, 150));
    this.margin = this.calculateMargin() * 2;

    this.$elm.addEventListener('keyup', this.checkTabPress.bind(this));
  }

  _createClass(Highlights, [{
    key: 'calculateMargin',
    value: function calculateMargin() {
      var element = this.originalSlideWrappers[0];
      var style = element.currentStyle || window.getComputedStyle(element);

      return parseInt(style.marginLeft, 10);
    }
  }, {
    key: 'setCurrentSlide',
    value: function setCurrentSlide(num) {
      this.currentSlide = num > this.maxOffset ? this.maxOffset : num;
    }
  }, {
    key: 'checkTabPress',
    value: function checkTabPress(e) {

      // Key code 9 is tab key.
      if (e && e.keyCode === 9) {

        // Closest list item.
        var parentNode = utils.closest(document.activeElement, '.listing-list__item');

        // If we found that list item
        if (parentNode) {

          // The current slide is the nth list item (-1) taking into account the a tag at the top.
          this.setCurrentSlide(utils.getOrdinalAmongstSiblingElements(parentNode) - 1);

          // Render the view again.
          this.renderCurrent();
        }
      }
    }
  }, {
    key: 'isFirstSlide',
    value: function isFirstSlide() {
      return this.currentSlide === 1;
    }
  }, {
    key: 'isLastSlide',
    value: function isLastSlide() {
      return this.currentSlide === this.maxOffset;
    }
  }, {
    key: 'previousButton',
    value: function previousButton(e) {
      e.preventDefault();

      // Nope out early.
      if (this.isFirstSlide()) {
        return null;
      }

      this.setCurrentSlide(this.currentSlide - 1);
      this.renderCurrent();
    }
  }, {
    key: 'nextButton',
    value: function nextButton(e) {
      e.preventDefault();

      // Nope out early.
      if (this.isLastSlide()) {
        return null;
      }

      this.setCurrentSlide(this.currentSlide + 1);
      this.renderCurrent();
    }
  }, {
    key: 'viewportNoWiderThan',
    value: function viewportNoWiderThan(thresholdInPx) {
      return this.window.matchMedia('(max-width: ' + thresholdInPx + 'px)').matches;
    }
  }, {
    key: 'onMobile',
    value: function onMobile() {
      return this.viewportNoWiderThan(this.tabletWidth);
    }
  }, {
    key: 'onTabletOrMobile',
    value: function onTabletOrMobile() {
      return this.viewportNoWiderThan(this.desktopWidth);
    }
  }, {
    key: 'switchBreakpoint',
    value: function switchBreakpoint() {
      if (this.onMobile()) {
        this.inView = 1;
      } else if (this.onTabletOrMobile()) {
        this.inView = 2;
      } else {
        this.inView = 3;
      }

      // Which page is the last page?
      this.maxOffset = this.numSlides - (this.inView - 1);

      // Recalculate margin.
      this.margin = this.calculateMargin() * 2;

      // Update some things.
      this.carouselWidth = window.getComputedStyle(this.$elm).width.match(/([0-9\.]+)px/)[1];
      this.setCurrentSlide(this.currentSlide);

      // Render view.
      this.renderCurrent();

      // Equalise heights.
      [].forEach.call(this.originalSlideWrappers, function (slideWrapper) {
        slideWrapper.style.height = '106px';
      });
    }
  }, {
    key: 'renderCurrent',
    value: function renderCurrent() {
      this.render(this.$elm, this.$nextBtn, this.$prevBtn, this.currentSlide, this.carouselWidth, this.inView);
    }
  }, {
    key: 'render',
    value: function render($el, $nextButton, $prevButton, thisSlide, carouselWidth, inView) {
      if (this.isFirstSlide()) {
        $prevButton.classList.add('hidden');
      } else {
        $prevButton.classList.remove('hidden');
      }

      if (this.isLastSlide()) {
        $nextButton.classList.add('hidden');
      } else {
        $nextButton.classList.remove('hidden');
      }

      var numOfMargins = inView - 1;
      var totalMargins = numOfMargins * this.margin;

      // Slide width = Carousel width - margins / number in view
      var slideWidth = (carouselWidth - totalMargins) / inView;

      // Slide offset = Slide width plus margin
      var slideOffset = slideWidth + this.margin;

      // Negative offset of 'x' slide offsets
      var nudge = slideOffset * (thisSlide - 1) * -1;

      // Transform
      utils.updateElementTranslate(this.moveableStage, [nudge, 0]);

      // Reset any scroll lefts
      $el.scrollLeft = 0;
    }
  }]);

  return Highlights;
}();

},{"../libs/elife-utils":35}],16:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var utils = require('../libs/elife-utils')();

module.exports = function () {
  function HypothesisLoader($elm) {
    var _this = this;

    var _window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;

    var doc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;

    _classCallCheck(this, HypothesisLoader);

    if (!$elm) {
      return;
    }

    this.$elm = $elm;
    this.window = _window;
    this.doc = doc;

    this.isSingleton = true;

    try {
      this.window.hypothesisConfig = HypothesisLoader.assembleHypothesisConfig(this.window);
    } catch (e) {
      this.window.console.error(e);
      if (_typeof(this.window.newrelic) === 'object') {
        this.window.newrelic.noticeError(e);
      }

      return;
    }

    this.$embedder = this.doc.createElement('script');
    this.$embedder.id = 'hypothesisEmbedder';
    this.$embedder.addEventListener('load', function () {
      _this.setUpAssetViewerFocus(_this.doc);
    });
    this.$embedder.addEventListener('error', function () {
      _this.handleLoadError(_this.$embedder);
    });
    this.doc.querySelector('head').appendChild(this.$embedder);
    this.$embedder.src = 'https://hypothes.is/embed.js';
  }

  _createClass(HypothesisLoader, [{
    key: 'setUpAssetViewerFocus',
    value: function setUpAssetViewerFocus(document) {
      document.addEventListener('scrolltorange', function (event) {
        if (!event.detail.startContainer) {
          return;
        }

        var $assetViewer = event.detail.startContainer.closest('.asset-viewer-inline');

        if ($assetViewer) {
          $assetViewer.dispatchEvent(utils.eventCreator('assetViewerFocus'));
        }
      });
    }
  }, {
    key: 'handleLoadError',
    value: function handleLoadError($loader) {
      $loader.dataset.hypothesisEmbedLoadStatus = 'failed';
      $loader.dispatchEvent(new this.window.ErrorEvent('loaderror', { message: 'Hypothesis embed load failed' }));
    }
  }], [{
    key: 'assembleHypothesisConfig',
    value: function assembleHypothesisConfig(window) {
      var externalConfig = window.elifeConfig.hypothesis;
      HypothesisLoader.validateConfig(externalConfig);

      var uiConfig = {
        branding: {
          accentColor: '#0288D1',
          appBackgroundColor: 'white',
          ctaBackgroundColor: '#0288D1',
          ctaTextColor: 'white',
          selectionFontFamily: 'Georgia, Times, serif',
          annotationFontFamily: 'Georgia, Times, serif'
        },
        openSidebar: window.location.hash === '#annotations',
        disableToolbarCloseBtn: false,
        disableToolbarMinimizeBtn: true,
        disableToolbarHighlightsBtn: true,
        disableToolbarNewNoteBtn: true,
        disableBucketBar: true,
        enableSidebarDropShadow: true,
        enableExperimentalNewNoteButton: true,
        enableCleanOnboardingTheme: true,
        theme: 'clean',
        showHighlights: true,
        onLayoutChange: function onLayoutChange(layout) {
          if (!!layout.expanded) {
            utils.expandCollapsedSections(document);
          }
        }
      };

      return function () {
        return Object.assign({}, uiConfig, externalConfig);
      };
    }
  }, {
    key: 'validateConfig',
    value: function validateConfig(externalConfig) {

      var services = externalConfig.services[0];

      HypothesisLoader.validateAsUrl('usernameUrl', externalConfig.usernameUrl);
      HypothesisLoader.validateAsUrl('apiUrl', services.apiUrl);
      HypothesisLoader.validateAsUrl('icon', services.icon);
      HypothesisLoader.validateAsPopulatedString('authority', services.authority);

      if (services.onLoginRequest && services.onLogoutRequest || !(services.onLoginRequest || services.onLogoutRequest)) {
        throw new Error('Hypothesis config generation failed: couldn\'t find exactly one of the properties ' + '"onLoginRequest" and "onLogoutRequest"');
      }

      if (services.onLoginRequest && services.onProfileRequest) {
        throw new Error('Hypothesis config generation failed: found both mutually exclusive properties "onLoginRequest" ' + 'and "onProfileRequest"');
      }

      if (services.onLoginRequest && !services.onSignupRequest) {
        HypothesisLoader.failValidationMissingProperty('onSignupRequest');
      }

      if (services.onLoginRequest && services.grantToken !== null) {
        throw new Error('Hypothesis config generation failed: expected the property "grantToken" to be null, but it was not null');
      }

      if (services.onLogoutRequest && !services.onProfileRequest) {
        HypothesisLoader.failValidationMissingProperty('onProfileRequest');
      }

      if (services.onLogoutRequest && services.onSignupRequest) {
        throw new Error('Hypothesis config generation failed: found both mutually exclusive properties "onLogoutRequest" ' + 'and "onSignupRequest"');
      }

      if (services.onLogoutRequest) {
        HypothesisLoader.validateAsPopulatedString('grantToken', services.grantToken);
      }
    }
  }, {
    key: 'validateAsUrl',
    value: function validateAsUrl(name, value) {
      if (!HypothesisLoader.isProbablyUrl(value)) {
        HypothesisLoader.failValidationMissingProperty(name);
      }
    }
  }, {
    key: 'isProbablyUrl',
    value: function isProbablyUrl(candidate) {
      return typeof candidate === 'string' && candidate.match(/^https?:\/\/.*$/);
    }
  }, {
    key: 'validateAsPopulatedString',
    value: function validateAsPopulatedString(name, value) {
      if (typeof value !== 'string' || !value.length) {
        HypothesisLoader.failValidationMissingProperty(name);
      }
    }
  }, {
    key: 'failValidationMissingProperty',
    value: function failValidationMissingProperty(propertyName) {
      throw new Error('Hypothesis config generation failed: couldn\'t find a valid property with the name "' + propertyName + '"');
    }
  }]);

  return HypothesisLoader;
}();

},{"../libs/elife-utils":35}],17:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var utils = require('../libs/elife-utils')();
var SpeechBubble = require('./SpeechBubble');

module.exports = function () {
  function HypothesisOpener($elm) {
    var _window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;

    var doc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;

    _classCallCheck(this, HypothesisOpener);

    if (!$elm) {
      return;
    }

    this.$elm = $elm;
    this.window = _window;
    this.doc = doc;

    this.isWithinContextualData = utils.areElementsNested(this.doc.querySelector('.contextual-data'), this.$elm);
    this.speechBubble = this.setupSpeechBubble(this.isWithinContextualData);
    this.setupPlacementAndStyles(this.isWithinContextualData);

    var maxWaitTimer = null;
    var $loader = null;
    try {
      $loader = HypothesisOpener.get$hypothesisLoader(this.doc);
      maxWaitTimer = this.setupPreReadyIndicatorsWithTimer($loader);
    } catch (e) {
      this.window.console.error(e);
      if (!!$loader && $loader instanceof HTMLElement) {
        $loader.parentNode.removeChild($loader);
      }

      if (_typeof(this.window.newrelic) === 'object') {
        this.window.newrelic.noticeError(e);
      }

      return;
    }

    var visibleCountSelector = '[data-visible-annotation-count]';
    this.hookUpDataProvider(this.$elm, this.isWithinContextualData, visibleCountSelector, maxWaitTimer);

    // Declare this.$elm to be a trigger to open the Hypothesis client (click handled by Hypothesis)
    this.$elm.dataset.hypothesisTrigger = '';
  }

  // It is an error for any of:
  //  - the load has already failed
  //  - the loaderror event fires before Hypothesis is ready
  //  - the maxWaitTimer expires


  _createClass(HypothesisOpener, [{
    key: 'setupPreReadyIndicatorsWithTimer',
    value: function setupPreReadyIndicatorsWithTimer($loader) {
      var _this = this;

      if (HypothesisOpener.hasLoadAlreadyFailed($loader)) {
        // Already-failed loading should already have thrown an error, so don't throw again.
        this.handleInitFail(null, this.window, false);
        return;
      }

      var maxWaitTime = 120000;

      var maxWaitTimer = this.window.setTimeout(this.handleTimerExpired.bind(this), maxWaitTime);

      $loader.addEventListener('loaderror', function (e) {
        _this.handleInitFail(maxWaitTimer, _this.window, e);
      });

      return maxWaitTimer;
    }
  }, {
    key: 'handleInitFail',
    value: function handleInitFail(timer, win, err) {
      this.removeHypothesisUI();
      this.speechBubble.showFailureState(this.isWithinContextualData);
      var window = win || this.window;
      window.clearTimeout(timer);

      // Do not log the error (use when error will already have been logged elsewhere).
      if (err === false) {
        return;
      }

      var errorMsg = void 0;
      if (err && typeof err.message === 'string') {
        errorMsg = err.message;
      } else {
        errorMsg = 'Problem loading or interacting with Hypothesis client.';
      }

      // Needs to be explicitly thrown to get a stack trace from Safari.
      // https://docs.newrelic.com/docs/browser/new-relic-browser/browser-agent-spa-api/notice-error
      try {
        throw new Error(errorMsg);
      } catch (e) {
        this.window.console.error(e);
        if (_typeof(this.window.newrelic) === 'object') {
          this.window.newrelic.noticeError(e);
        }
      }
    }
  }, {
    key: 'handleTimerExpired',
    value: function handleTimerExpired() {
      this.handleInitFail(null, this.window, new Error('Hypothesis loading timed out'));
    }
  }, {
    key: 'removeHypothesisUICounters',
    value: function removeHypothesisUICounters() {
      var counters = this.doc.querySelectorAll('[data-visible-annotation-count]');
      if (counters) {
        [].forEach.call(counters, function (counter) {
          var visuallyHiddenCounter = counter.parentNode.parentNode.querySelector('.visuallyhidden');
          visuallyHiddenCounter.innerHTML = '';
          delete counter.dataset.visibleAnnotationCount;
        });
      }
    }
  }, {
    key: 'removeHypothesisUISidebar',
    value: function removeHypothesisUISidebar() {
      var sidebar = this.doc.querySelector('.annotator-frame');
      if (sidebar) {
        sidebar.parentElement.removeChild(sidebar);
      }
    }
  }, {
    key: 'removeHypothesisUITriggers',
    value: function removeHypothesisUITriggers() {
      var triggers = this.doc.querySelectorAll('[data-hypothesis-trigger]');
      if (triggers) {
        [].forEach.call(triggers, function ($trigger) {
          delete $trigger.dataset.hypothesisTrigger;
        });
      }
    }
  }, {
    key: 'removeHypothesisUIPopupOnSelect',
    value: function removeHypothesisUIPopupOnSelect() {
      var _this2 = this;

      var obs = void 0;
      var remove$hypothesisAdder = function remove$hypothesisAdder(addedNode) {
        if (addedNode.nodeName === 'HYPOTHESIS-ADDER') {
          var adder = _this2.doc.querySelector('hypothesis-adder');
          if (adder && _typeof(adder.parentElement)) {
            adder.parentElement.removeChild(adder);
            obs.disconnect();
          }
        }
      };

      var observerCallback = function observerCallback(mutationsList) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = mutationsList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var mutation = _step.value;

            if (mutation.type === 'childList' && mutation.addedNodes.length) {
              [].forEach.call(mutation.addedNodes, remove$hypothesisAdder);
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      };

      var popup = this.doc.querySelector('hypothesis-adder');
      if (popup) {
        popup.parentElement.removeChild(popup);
      } else {
        obs = new MutationObserver(observerCallback);
        obs.observe(this.doc.querySelector('body'), { childList: true });
      }
    }
  }, {
    key: 'removeHypothesisUI',
    value: function removeHypothesisUI() {
      this.removeHypothesisUICounters();
      this.removeHypothesisUISidebar();
      this.removeHypothesisUITriggers();
      this.removeHypothesisUIPopupOnSelect();
    }
  }, {
    key: 'setupSpeechBubble',
    value: function setupSpeechBubble(isContextualData) {
      var speechBubble = new SpeechBubble(this.findElementWithClass('speech-bubble'));

      if (isContextualData) {
        speechBubble.showLoadingIndicator();
      }

      return speechBubble;
    }
  }, {
    key: 'setupPlacementAndStyles',
    value: function setupPlacementAndStyles(isContextualData) {
      HypothesisOpener.applyStyleInitial(this.$elm);
      if (!isContextualData) {
        HypothesisOpener.applyStyleArticleBody(this.$elm);
        this.setInitialDomLocation(this.$elm, utils.getItemType(this.doc.querySelector('body')));
      }
    }
  }, {
    key: 'findElementWithClass',
    value: function findElementWithClass(className) {
      if (this.$elm.querySelector('.' + className)) {
        return this.$elm.querySelector('.' + className);
      }

      if (this.$elm.classList.contains(className)) {
        return this.$elm;
      }

      return null;
    }
  }, {
    key: 'hookUpDataProvider',
    value: function hookUpDataProvider($elm, isWithinContextualData, visibleCountSelector, timer) {
      var _this3 = this;

      // Updated by the hypothesis client
      var $dataProvider = $elm.querySelector('[data-hypothesis-annotation-count]');
      if (!$dataProvider) {
        this.handleInitFail(timer, this.window);
        return;
      }

      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          try {
            if (!mutation.addedNodes[0]) {
              return;
            }

            _this3.updateVisibleCount(mutation.addedNodes[0].data, visibleCountSelector, isWithinContextualData);
            _this3.speechBubble.removeLoadingIndicator();
            _this3.window.clearTimeout(timer);
          } catch (error) {
            _this3.handleInitFail(timer, _this3.window, error);
          }
        });
      });

      observer.observe($dataProvider, { childList: true });
    }
  }, {
    key: 'updateVisibleCount',
    value: function updateVisibleCount(value, selector, isContextualData) {
      var count = parseInt(value);
      if (isNaN(count) || count < 0) {
        return;
      }

      if (isContextualData) {
        this.$elm.querySelector(selector).innerHTML = '' + count;
      } else {
        this.updateVisibleCountArticleBody(count, selector);
      }
    }
  }, {
    key: 'updateVisibleCountArticleBody',
    value: function updateVisibleCountArticleBody(count, selector) {
      if (count) {
        this.speechBubble.update(count, selector);
      } else {
        this.speechBubble.showPlaceholder(selector);
      }
    }
  }, {
    key: 'setInitialDomLocation',
    value: function setInitialDomLocation($elm, articleType) {
      if (!articleType) {
        return;
      }

      try {
        HypothesisOpener.findPositioningMethod(articleType).call(null, $elm, this.doc.querySelector('.content-container'));
      } catch (e) {
        this.window.console.error(e);
      }
    }
  }], [{
    key: 'hasLoadAlreadyFailed',
    value: function hasLoadAlreadyFailed($loader) {
      return $loader.dataset.hypothesisEmbedLoadStatus === 'failed';
    }
  }, {
    key: 'get$hypothesisLoader',
    value: function get$hypothesisLoader($ancestor) {
      var $loader = $ancestor.querySelector('#hypothesisEmbedder');
      if ($loader) {
        return $loader;
      }

      throw new Error('No Hypothesis loading code found');
    }
  }, {
    key: 'applyStyleInitial',
    value: function applyStyleInitial($elm) {
      $elm.classList.add('hypothesis-opener');
      $elm.style.display = 'inline-block';
      $elm.style.cursor = 'pointer';
    }
  }, {
    key: 'applyStyleArticleBody',
    value: function applyStyleArticleBody($elm) {
      $elm.style.display = 'block';
      $elm.style.float = 'right';
      $elm.style.marginBottom = '48px';
    }
  }, {
    key: 'positionCentrallyInline',
    value: function positionCentrallyInline($elm, $contentContainer) {
      var paragraphs = $contentContainer.querySelectorAll('p');

      if (!paragraphs.length) {
        $contentContainer.appendChild($elm);
        return;
      }

      $elm.classList.add('speech-bubble--inline');
      var $target = paragraphs[Math.floor((paragraphs.length - 1) / 2)];
      $target.insertBefore($elm, $target.firstChild);
    }
  }, {
    key: 'positionBySecondSection',
    value: function positionBySecondSection($elm, $contentContainer) {
      var $firstSection = $contentContainer.querySelector('.article-section--first');
      if ($firstSection) {
        $firstSection.nextElementSibling.querySelector('.article-section__body').appendChild($elm);
        return;
      }

      throw new Error('Trying to position hypothesis opener in second section, but ' + 'can\'t find element with the css class article-section--first.');
    }
  }, {
    key: 'positionByFirstSection',
    value: function positionByFirstSection($elm, $contentContainer) {
      var $firstSection = $contentContainer.querySelector('.article-section--first');
      if ($firstSection) {
        $firstSection.appendChild($elm);
        return;
      }

      throw new Error('Trying to position hypothesis opener by first section but can\'t find element' + ' with the css class article-section--first.');
    }
  }, {
    key: 'positionEnd',
    value: function positionEnd($elm, $contentContainer) {
      $contentContainer.appendChild($elm);
    }
  }, {
    key: 'findPositioningMethod',
    value: function findPositioningMethod(articleType) {
      var positioners = {
        'blog-article': HypothesisOpener.positionCentrallyInline,
        interview: HypothesisOpener.positionCentrallyInline,
        'press-package': HypothesisOpener.positionCentrallyInline,
        'labs-post': HypothesisOpener.positionCentrallyInline,

        digest: HypothesisOpener.positionEnd,

        insight: HypothesisOpener.positionBySecondSection,
        feature: HypothesisOpener.positionBySecondSection,
        editorial: HypothesisOpener.positionBySecondSection,

        default: HypothesisOpener.positionByFirstSection
      };

      return positioners[articleType] || positioners.default;
    }
  }]);

  return HypothesisOpener;
}();

},{"../libs/elife-utils":35,"./SpeechBubble":31}],18:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var utils = require('../libs/elife-utils')();

module.exports = function () {
  function LoginControl($elm) {
    var _window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;

    var doc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;

    _classCallCheck(this, LoginControl);

    this.$elm = $elm;
    this.window = _window;
    this.doc = doc;

    this.extraLinksToBuild = null;

    try {
      var linkFieldRoots = this.$elm.dataset.linkFieldRoots;
      var dataAttributeRoots = void 0;
      if (linkFieldRoots) {
        dataAttributeRoots = LoginControl.deriveDataAttributeRoots(this.$elm.dataset.linkFieldRoots, this.$elm);
      }

      this.setPropertiesFromDataAttributes(dataAttributeRoots, this.$elm);
      if (this.extraLinksToBuild) {
        this.$control = this.buildControl(this.extraLinksToBuild, this.$elm, utils.buildElement);
        this.$elm.appendChild(this.$control);
      }
    } catch (e) {
      // TODO: When removing, Log to NR instead?
      this.window.console.log(e);
    }
  }

  /**
   * Returns an array of expected data attribute roots, based on the supplied comma-delimited string
   *
   * Each item in rootsList describes the root name of a set of two data attributes that will
   * together describe the text and uri of a link that is to be included in the control.
   *
   * For example:
   *
   * If rootsList were to have the value "profile-manage-link, logout", this would specify that
   * there are two links described, and that the the data attributes that define them are:
   *
   *  - data-profile-manage-link-text: defines the display text of the profile manage link
   *  - data-profile-manage-link-uri: defines the uri of the profile manage link
   *
   *  - data-logout-text: defines the display text of the logout link
   *  - data-logout-uri: defines the uri of the logout link
   *
   *  In this case the return value would be the array:
   *
   *    ['profile-manage-link-text', 'profile-manage-link-uri', 'logout-text', 'logout-uri']
   *
   * If any of the data attributes implied by rootsList are missing or empty, it is an error.
   *
   * @param {String} rootsList comma-delimited list of data attribute root names
   * @param {HTMLElement} $elm HTML element that the data attributes belong to
   *
   * @throws {SyntaxError} if rootsList is invalid
   * @throws {ReferenceError} if required data attributes are missing
   *
   * @returns {Array.<String>} list of expected data attribute roots, will be empty if none found
   *
   */


  _createClass(LoginControl, [{
    key: 'setPropertiesFromDataAttributes',


    /**
     * Set object properties based on discovered HTML element data attributes, based on supplied roots
     *
     * @param {Array.<String>} dataAttributeRoots list of data attribute roots
     * @param {HTMLElement} $elm element containing the data attributes
     */
    value: function setPropertiesFromDataAttributes(dataAttributeRoots, $elm) {
      this.displayName = $elm.dataset.displayName;
      this.defaultUri = $elm.dataset.defaultUri;
      if (dataAttributeRoots) {
        this.extraLinksToBuild = LoginControl.deriveLinksToBuild(dataAttributeRoots, $elm);
      }
    }

    /**
     * Returns array of objects describing the text & uris for the links to put into the menu control
     **
     * @param {Array.<String>} dataAttributeRoots list of data attribute root names to process
     * @param {HTMLElement} $elm element containing the data attributes
     * @return {Array.<{text: String, uri: String}>}
     */

  }, {
    key: 'buildControl',


    /**
     * Build the control
     *
     * This is the top level entry point for building the required DOM elements.
     *
     * @param {Array.<{text: String, uri: String}>} extraLinksToBuild data defining the links to build
     * @param {HTMLElement} $elm pattern-root element
     * @param {Function} buildElement Function used to build an element (elife-utils.buildElement)
     * @return {HTMLElement} The resulting control element
     */
    value: function buildControl(extraLinksToBuild, $elm, buildElement) {
      var $nav = buildElement.call(null, 'nav');
      this.insertToggle($nav, $elm, buildElement);
      this.$menu = this.buildMenu(extraLinksToBuild, $elm, buildElement);
      $nav.appendChild(this.$menu);

      return $nav;
    }

    /**
     * Build and insert the menu toggle into the supplied container
     *
     * @param {HTMLElement} $container The required parent of the toggle
     * @param {HTMLElement} $elm the element containing the data attribute with the icon definition
     * @param {Function} buildElement Function used to build an element (elife-utils.buildElement)
     */

  }, {
    key: 'insertToggle',
    value: function insertToggle($container, $elm, buildElement) {
      var $toggle = buildElement.call(null, 'a', ['login-control__controls_toggle'], '', $container);
      $toggle.setAttribute('href', this.defaultUri);
      var iconAsString = $elm.dataset.icon;
      if (typeof iconAsString === 'string' && iconAsString.length) {
        $toggle.innerHTML = iconAsString;
      }

      $toggle.addEventListener('click', this.toggle.bind(this));
    }

    /**
     * Build the menu
     *
     * @param {Array.<{text: String, uri: String}>} extraLinksToBuild data defining the links to build
     * @param {HTMLElement} $elm element contaning any subsidiary text data attribute
     * @param {Function} buildElement Function used to build an element (elife-utils.buildElement)
     * @return {HTMLElement} The menu that has been built
     */

  }, {
    key: 'buildMenu',
    value: function buildMenu(extraLinksToBuild, $elm, buildElement) {
      var $list = buildElement.call(null, 'ul', ['login-control__controls', 'hidden']);
      this.insertDefaultLink($list, $elm, buildElement);
      if (extraLinksToBuild) {
        this.insertExtraLinks(extraLinksToBuild, $list, buildElement);
      }

      return $list;
    }

    /**
     * Build and insert the default link into the supplied container
     *
     * @param {HTMLElement} $container The required parent of the default link
     * @param {HTMLElement} $elm element contaning any subsidiary text data attribute
     * @param {Function} buildElement Function used to build an element (elife-utils.buildElement)
     * @return {*}
     */

  }, {
    key: 'insertDefaultLink',
    value: function insertDefaultLink($container, $elm, buildElement) {
      var $li = buildElement.call(null, 'li', ['login-control__control'], '', $container);
      var $a = buildElement.call(null, 'a', ['login-control__link'], '', $li);
      $a.setAttribute('href', this.defaultUri);
      buildElement.call(null, 'div', ['login-control__display_name'], this.displayName, $a);

      var subsidiaryText = $elm.dataset.subsidiaryText;
      if (subsidiaryText) {
        buildElement.call(null, 'div', ['login-control__subsidiary_text'], subsidiaryText, $a);
      }

      return $li;
    }

    /**
     * Build and insert the links defined by the arbitrary data attributes
     *
     * @param {Array.<{text: String, uri: String}>} extraLinksData data defining the links to build
     * @param {HTMLElement} $container The required parent of all the links
     * @param {Function} buildElement Function used to build an element (elife-utils.buildElement)
     */

  }, {
    key: 'insertExtraLinks',
    value: function insertExtraLinks(extraLinksData, $container, buildElement) {
      if (!Array.isArray(extraLinksData) || !extraLinksData.length) {
        throw new Error('Unable to build extra links, no data supplied');
      }

      extraLinksData.forEach(function (extraLinkData) {
        LoginControl.insertLink(extraLinkData, $container, buildElement);
      });
    }

    /**
     * Build and insert a link defined by a pair of arbitrary data attributes
     *
     * @param linkData {{text: String, uri: String}} data from which to create the link
     * @param {HTMLElement} $container The required parent of the link
     * @param {Function} buildElement Function used to build an element (elife-utils.buildElement)
     */

  }, {
    key: 'toggle',


    /**
     * Toggles the download links list display.
     *
     * @param e The event triggering the display toggle
     */
    value: function toggle(e) {
      e.preventDefault();
      e.stopPropagation();
      if (this.isOpen()) {
        this.close();
      } else {
        this.open();
      }
    }

    /**
     * Returns whether links list is currently viewable.
     *
     * @returns {boolean} Whether links list is currently viewable
     */

  }, {
    key: 'isOpen',
    value: function isOpen() {
      return !this.$menu.classList.contains('hidden');
    }

    /**
     * Make viewable.
     */

  }, {
    key: 'open',
    value: function open() {
      this.$menu.classList.remove('hidden');
      this.window.addEventListener('click', this.checkForClose.bind(this));
    }

    /**
     * Checks whether a click occurred outside this, and close this if it did.
     *
     * @param e The click event to evaluate the target of
     */

  }, {
    key: 'checkForClose',
    value: function checkForClose(e) {
      if (!utils.areElementsNested(this.$menu, e.target)) {
        this.close();
      }
    }

    /**
     * Make unviewable.
     */

  }, {
    key: 'close',
    value: function close() {
      this.$menu.classList.add('hidden');
      this.window.removeEventListener('click', this.checkForClose.bind(this));
    }
  }], [{
    key: 'deriveDataAttributeRoots',
    value: function deriveDataAttributeRoots(rootsList, $elm) {
      if (!LoginControl.validateDataAttributeRootsList(rootsList)) {
        throw new SyntaxError('invalid roots list supplied');
      }

      var dataAttributeRoots = rootsList.split(',').map(function (root) {
        return root.trim();
      });
      if (!dataAttributeRoots[0].length) {
        return [];
      }

      if (!LoginControl.areAllImpliedDataAttributesPresent(dataAttributeRoots, $elm)) {
        throw new ReferenceError('One or more required data attributes implied by data-link-field-roots are missing');
      }

      return dataAttributeRoots;
    }

    /**
     * Returns false if not all data attributes implied by dataAttributeRoots are present
     *
     * @param {Array.<String>} dataAttributeRoots list of expected data attribute roots
     * @param {HTMLElement} $elm HTML element that the data attributes belong to
     * @return {boolean} false if not all data attributes implied by dataAttributeRoots are present
     */

  }, {
    key: 'areAllImpliedDataAttributesPresent',
    value: function areAllImpliedDataAttributesPresent(dataAttributeRoots, $elm) {
      var areAllPresent = true;
      dataAttributeRoots.forEach(function (root) {
        if (!$elm.dataset[LoginControl.convertKebabCaseToCamelCase(root + '-uri')] || !$elm.dataset[LoginControl.convertKebabCaseToCamelCase(root + '-text')]) {
          areAllPresent = false;
        }
      });

      return areAllPresent;
    }

    /**
     * Indicates validity of list of data attribute roots supplied
     *
     * The regex determining validity:
     *  - allows lower case js name characters, plus space, hyphen and commma
     *  - allows leading/trailing space
     *  - allows other space only when adjacent to a comma
     *  - disallows leading/trailing commas and hyphens on the string
     *  - disallows leading or trailing hyphens on a word
     *
     * @param {String} rootsList comma-delimited list of data attribute root names
     * @returns {boolean} whether the roots list string is valid
     */

  }, {
    key: 'validateDataAttributeRootsList',
    value: function validateDataAttributeRootsList(rootsList) {
      return typeof rootsList === 'string' && rootsList.search(/^[ \t]*[a-z][a-z-$_]*[^-,][ \t]*(,[ \t]*[a-z][a-z-$_]*[^-,][ \t]*)*$/) > -1;
    }
  }, {
    key: 'deriveLinksToBuild',
    value: function deriveLinksToBuild(dataAttributeRoots, $elm) {
      var linksToBuild = [];
      dataAttributeRoots.forEach(function (dataAttributeRoot) {
        var textDataAttribute = dataAttributeRoot + '-text';
        var textProperty = LoginControl.convertKebabCaseToCamelCase(textDataAttribute);
        var text = $elm.dataset[textProperty];

        var uriDataAttribute = dataAttributeRoot + '-uri';
        var uriProperty = LoginControl.convertKebabCaseToCamelCase(uriDataAttribute);
        var uri = $elm.dataset[uriProperty];

        if (text && uri) {
          linksToBuild.push({ text: text, uri: uri });
        }
      });

      return linksToBuild;
    }

    /**
     * Derive a camelCased word from a kebab-cased word
     *
     * @param kebabCase the kebab-cased word (which is a data-attribute-name)
     * @returns {(String|null)}
     */

  }, {
    key: 'convertKebabCaseToCamelCase',
    value: function convertKebabCaseToCamelCase() {
      var kebabCase = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      if (!kebabCase || typeof kebabCase !== 'string') {
        return null;
      }

      return kebabCase.replace(/\-([a-z])/g, function (x) {
        return x.substring(1).toUpperCase();
      });
    }
  }, {
    key: 'insertLink',
    value: function insertLink(linkData, $container, buildElement) {
      var $li = buildElement.call(null, 'li', ['login-control__control'], '', $container);
      var $a = buildElement.call(null, 'a', ['login-control__link'], linkData.text, $li);
      $a.setAttribute('href', linkData.uri);
    }
  }]);

  return LoginControl;
}();

},{"../libs/elife-utils":35}],19:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Overlay = require('./Overlay');
var utils = require('../libs/elife-utils')();

module.exports = function () {

  // Passing window and document separately allows for independent mocking of window in order
  // to test feature support fallbacks etc.
  function MainMenu($elm) {
    var _window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;

    var doc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;

    _classCallCheck(this, MainMenu);

    if (!$elm) {
      return;
    }

    this.window = _window;
    this.doc = doc;
    this.$elm = $elm;
    this.pageOverlay = new Overlay('body', null, 'overlayMainMenu', 30);
    this.closeFn = this.close.bind(this);
    this.$elm.setAttribute('aria-expanded', 'false');
    this.buildCloseControl();
  }

  /**
   * Moves main menu from default non-js DOM position into position required by js implementation.
   */


  _createClass(MainMenu, [{
    key: 'moveWithinDom',
    value: function moveWithinDom() {
      this.$elm.classList.add('main-menu--js');
      var $siteHeaderWrapper = this.doc.querySelector('.wrapper--site-header');
      if (!!$siteHeaderWrapper) {
        $siteHeaderWrapper.insertBefore(this.$elm, $siteHeaderWrapper.insertAfter);
      }
    }

    /**
     * Indicates whether the main menu is currently open.
     *
     * @returns {boolean} true if the main menu is currently open
     */

  }, {
    key: 'isOpen',
    value: function isOpen() {
      return this.$elm.classList.contains('main-menu--shown');
    }

    /**
     * Closes the main menu
     */

  }, {
    key: 'close',
    value: function close() {
      this.$elm.classList.remove('main-menu--shown');
      this.$elm.setAttribute('aria-expanded', 'false');
      this.pageOverlay.hide();
      this.pageOverlay.get$elm().removeEventListener('click', this.closeFn);
    }

    /**
     * Opens the main menu
     */

  }, {
    key: 'open',
    value: function open() {
      this.$elm.classList.add('main-menu--shown');
      this.$elm.setAttribute('aria-expanded', 'true');
      this.$elm.focus();
      this.pageOverlay.get$elm().addEventListener('click', this.closeFn);
      this.pageOverlay.show();
    }
  }, {
    key: 'buildCloseControl',
    value: function buildCloseControl() {
      var $close = void 0;
      if (!this.$elm.querySelector('#mainMenuCloseControl')) {
        var $parent = this.$elm.querySelector('.main-menu__container');
        $close = utils.buildElement('button', ['main-menu__close_control'], 'Close', $parent, $parent.firstElementChild);
        $close.id = 'mainMenuCloseControl';
        $close.addEventListener('click', this.close.bind(this));
      }
    }
  }]);

  return MainMenu;
}();

},{"../libs/elife-utils":35,"./Overlay":23}],20:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

module.exports = function () {
  function Math($elm) {
    var _window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;

    var doc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;

    _classCallCheck(this, Math);

    this.window = _window;
    this.isSingleton = true;

    Math.init(doc);
  }

  _createClass(Math, null, [{
    key: 'init',
    value: function init(doc) {
      Math.loadDependencies(doc);
      if ('MutationObserver' in window) {
        if (!Math.dependenciesAlreadySetup(doc)) {
          var observer = new MutationObserver(function (mutations, observer) {
            Math.loadDependencies(doc);
            if (Math.dependenciesAlreadySetup(doc)) {
              observer.disconnect();
            }
          });
          observer.observe(doc.body, { childList: true, subtree: true });
        }
      }
    }
  }, {
    key: 'loadDependencies',
    value: function loadDependencies(doc) {
      if (doc.querySelector('math')) {
        Math.setupProperties();
        Math.load(doc);
      }
    }
  }, {
    key: 'dependenciesAlreadySetup',
    value: function dependenciesAlreadySetup(doc) {
      return !!doc.querySelector('script[src*="mathjax"]');
    }
  }, {
    key: 'setupProperties',
    value: function setupProperties() {
      window.MathJax = {
        CommonHTML: {
          linebreaks: { automatic: true, width: '75% container' }
        },
        'fast-preview': { disabled: true },
        'HTML-CSS': {
          linebreaks: { automatic: true, width: '75% container' }
        },
        SVG: {
          linebreaks: { automatic: true, width: '75% container' }
        }
      };
    }
  }, {
    key: 'setupResizeHandler',
    value: function setupResizeHandler() {
      window.MathJax.Hub.Config({
        'HTML-CSS': {
          linebreaks: { automatic: true, width: '75% container' },

          // Required when using Noto Serif as body font, for other fonts YMMV.
          scale: function () {

            // Noto Serif's ex height is marginally larger than the font it replaces. The slight
            // down scaling of the maths set in basicScaling (90%) tries to keep the equation size similar
            // to how it was with the previous font, in case line breaks within equations are significant.
            var basicScaling = 90;

            // Work around for a bug causing inconsistent maths sizing between browsers:
            // Some browsers display the maths legibly with the basic scaling, other browsers
            // require it to be scaled up.
            var upScaling = basicScaling * 2;

            function shouldBeScaledUp(Browser) {

              // Required because maths scales differently between iOS & Android platforms in Chrome
              // and Safari, and the MathJax API doesn't have a way of distinguishing the mobile OS.
              // Deliberately not made available as a utility: we don't want to encourage this!
              var isProbablyIOS = function isProbablyIOS() {
                return !!navigator.userAgent.match(/iPad|iPhone/);
              };

              // Don't scale up if any the following applies:
              return !(

              // IE
              Browser.isMSIE ||

              // Safari or Chrome on a Mac
              Browser.isMac && (Browser.isSafari || Browser.isChrome) ||

              // Safari or Chrome on iOS
              isProbablyIOS() && Browser.isSafari ||

              // Aiming to target Firefox on Linux & mobile
              Browser.isFirefox && !(Browser.isMac || Browser.isPC) ||

              // Some smaller browsers e.g. Brave are identified as "Unknown" . (Although both
              // Brave and Yandex browsers are based on Chromium and use Blink rendering, Yandex
              // identifies as "Chrome".)
              Browser.toString() === 'Unknown');
            }

            return shouldBeScaledUp(window.MathJax.Hub.Browser) ? upScaling : basicScaling;
          }()
        }
      });
      this.currentClientWidth = document.body.clientWidth;
      var resizeTimeout = void 0;
      var resizeThrottler = function resizeThrottler() {
        if (!resizeTimeout) {
          resizeTimeout = setTimeout(function () {
            resizeTimeout = null;

            if (!!this.window.MathJax && this.currentClientWidth !== document.body.clientWidth) {
              this.currentClientWidth = document.body.clientWidth;
              this.window.MathJax.Hub.Queue(['Rerender', this.window.MathJax.Hub]);
            }
          }, 300);
        }
      };

      window.addEventListener('resize', resizeThrottler);
    }
  }, {
    key: 'load',
    value: function load(doc) {
      var script = doc.createElement('script');
      script.type = 'text/javascript';
      script.addEventListener('load', Math.setupResizeHandler);
      script.src = 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.1/MathJax.js?config=MML_HTMLorMML';
      script.integrity = 'sha384-Ra6zh6uYMmH5ydwCqqMoykyf1T/+ZcnOQfFPhDrp2kI4OIxadnhsvvA2vv9A7xYv';
      script.crossOrigin = 'anonymous';
      doc.querySelector('body').appendChild(script);
    }
  }]);

  return Math;
}();

},{}],21:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

module.exports = function () {
  function MediaChapterListingItem($elm) {
    var _window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;

    var doc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;

    _classCallCheck(this, MediaChapterListingItem);

    if (!$elm) {
      console.warn('No element provided');
      return;
    }

    console.log('Initialising Chapter listing item...');

    this.$elm = $elm;
    this.startTime = $elm.dataset.startTime;
    if (!this.startTime || isNaN(this.startTime) || this.startTime < 0) {
      return;
    }

    this.window = _window;
    this.document = doc;

    // When ready, AudioPlayer dispatches a custom event 'playerReady' on window, that supplies that
    // player's html element id.
    _window.addEventListener('playerReady', this.listenForChapterChange.bind(this));
    this.$link = this.createLink(doc, this.$elm, this.startTime);
    this.setupEventHandlers(this.$link);
  }

  _createClass(MediaChapterListingItem, [{
    key: 'listenForChapterChange',
    value: function listenForChapterChange(e) {
      var $player = this.document.getElementById(e.detail);
      if (!!$player) {
        $player.addEventListener('chapterChanged', this.indicateChapterChanged.bind(this));
      }
    }
  }, {
    key: 'createLink',
    value: function createLink(document, $rootElm, startTime) {
      var $title = $rootElm.querySelector('.media-chapter-listing-item__header_text');
      if (!$title) {
        return;
      }

      var titleText = void 0;
      var $existingLink = void 0;
      try {
        $existingLink = $title.querySelector('.media-chapter-listing-item__header_text_link');
        titleText = $existingLink.innerHTML;
        $existingLink.parentNode.removeChild($existingLink);
      } catch (e) {
        titleText = $title.innerHTML;
      }

      var $link = document.createElement('a');
      $link.innerHTML = titleText;
      $link.setAttribute('href', '#' + startTime);
      $link.classList.add('media-chapter-listing-item__header_text_link');
      $title.innerHTML = '';
      $title.appendChild($link);
      return $link;
    }
  }, {
    key: 'indicateChapterChanged',
    value: function indicateChapterChanged(e) {
      var currentChapterNumber = e.detail;
      if (currentChapterNumber === this.window.parseInt(this.$elm.dataset.chapterNumber)) {
        this.$elm.classList.add('current-chapter');
      } else {
        this.$elm.classList.remove('current-chapter');
      }
    }
  }, {
    key: 'setupEventHandlers',
    value: function setupEventHandlers($link) {
      $link.addEventListener('chapterChanged', this.indicateChapterChanged);
    }
  }]);

  return MediaChapterListingItem;
}();

},{}],22:[function(require,module,exports){
'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var utils = require('../libs/elife-utils')();
var BarChart = require('./BarChart');

var Metrics = function () {
  function Metrics($el) {
    var _this = this;

    _classCallCheck(this, Metrics);

    this.$el = $el;

    var $charts = utils.buildElement('div', ['charts'], '', this.$el);

    var container = utils.buildElement('div', [], 'Loading...', $charts);
    container.id = this.$el.dataset.containerId;
    var p = utils.buildElement('p', [], '', $charts);

    // TODO: not sure who uses this?
    utils.buildElement('span', ['visuallyhidden'], 'Toggle charts', p);

    // TODO: extract
    // The data flows from left to right, but clicking the left arrow takes
    // you to the next page, which is the previous month, the comments below
    // provide the best description of the UI.
    this.$next = this.trigger('prev', 'Left', p); // "->" arrow
    this.$prev = this.trigger('next', 'Right', p); // "<-" arrow

    var $grouping = utils.buildElement('ol', ['button-collection', 'button-collection--centered', 'button-collection--compact'], '', this.$el);
    this.$dailyButton = this.groupingButton($grouping, 'Daily');
    this.$monthlyButton = this.groupingButton($grouping, 'Monthly');

    // We need get these from the DOM, I would prefer a script with JSON.
    this.endpoint = $el.dataset.apiEndpoint;
    this.id = $el.dataset.id;
    this.type = $el.dataset.type || 'article';
    this.selected = $el.dataset.metric || 'downloads';
    this.period = $el.dataset.period || 'month';

    var parent = utils.closest(this.$el, '.article-section');
    if (parent) {
      parent.addEventListener('expandsection', function () {
        // This catches cases where the data may be loading, which breaks.
        if (_this.getSelectedMetric().page !== 0) {
          _this.renderView($el, _this.getSelectedMetric());
        }
      });
    }

    // The data flows from left to right, but clicking the left arrow takes
    // you to the next page, which is the previous month, the comments below
    // provide the best description of the UI.
    this.availableCharts = ['page-views', 'downloads'];
    this.availablePeriods = ['day', 'month'];
    this.currentChart = this.availableCharts.indexOf(this.selected);

    // Set the correct button initially.
    if (this.period === 'month') {
      this.$monthlyButton.classList.add('button--default');
      this.$monthlyButton.classList.remove('button--outline');
      this.$dailyButton.classList.add('button--outline');
      this.$dailyButton.classList.remove('button--default');
    } else {
      this.$monthlyButton.classList.add('button--outline');
      this.$monthlyButton.classList.remove('button--default');
      this.$dailyButton.classList.add('button--default');
      this.$dailyButton.classList.remove('button--outline');
    }

    // Name each chart in format like "downloads-by-day"
    var availableMetrics = utils.flatten(this.availableCharts.map(function (chart) {
      return _this.availablePeriods.map(function (period) {
        return chart + '-by-' + period;
      });
    }));

    this.loadMore = this.loadMore.bind(this);
    this.barChart = new BarChart($el.dataset.containerId);
    this.metrics = availableMetrics.map(function (metric) {
      return {
        name: metric,
        page: 0,
        viewPage: 1,
        firstMonth: null,
        remaining: 1,
        periods: [],
        selected: false,
        loaded: false,
        reverse: -1
      };
    });

    // data-daily-id
    this.$prev.addEventListener('click', this.prevButton.bind(this));
    this.$next.addEventListener('click', this.nextButton.bind(this));
    if (this.$dailyButton) {
      this.$dailyButton.addEventListener('click', this.changePeriod('day').bind(this));
    }

    if (this.$monthlyButton) {
      this.$monthlyButton.addEventListener('click', this.changePeriod('month').bind(this));
    }

    // Select the current metric.
    this.updateSelectedMetric(function (m) {
      return Object.assign(m, { selected: true });
    });

    // Register event to call this method.
    this.loadMore().then(function () {
      return this.renderView($el, this.getSelectedMetric());
    }.bind(this));
  }

  _createClass(Metrics, [{
    key: 'trigger',
    value: function trigger(temporalDirection, side, p) {
      var a = utils.buildElement('a', ['trigger', 'trigger--' + temporalDirection], this.chevron(side), p);
      a.href = '#';
      return a;
    }
  }, {
    key: 'chevron',
    value: function chevron(side) {
      var svg = 'chevron' + side + 'Svg';
      var srcset = 'chevron' + side + 'Srcset';
      var src = 'chevron' + side + 'Src';
      return '<picture>' + '<source srcset="' + this.$el.dataset[svg] + '" type="image/svg+xml">' + '<img srcset="' + this.$el.dataset[srcset] + '" src="' + this.$el.dataset[src] + '" alt="Navigate ' + side.toLowerCase() + ' icon">' + '</picture>';
    }
  }, {
    key: 'groupingButton',
    value: function groupingButton($grouping, label) {
      var $item = utils.buildElement('li', ['button-collection__item'], null, $grouping);
      var button = utils.buildElement('a', ['button', 'button--outline', 'button--small'], label, $item);
      button.href = '#';
      return button;
    }
  }, {
    key: 'changePeriod',
    value: function changePeriod(period) {
      var _this2 = this;

      return function (e) {
        e.preventDefault();

        // Change button style.
        var $current = _this2.$el.querySelector('.button--default');
        $current.classList.add('button--outline');
        $current.classList.remove('button--default');

        e.currentTarget.classList.add('button--default');
        e.currentTarget.classList.remove('button--outline');
        _this2.log('changed period to ' + period);

        // Change metric and reload.
        return _this2.changeMetric(_this2.selected, period).then(function () {
          _this2.renderView(_this2.$el, _this2.getSelectedMetric());
        });
      };
    }
  }, {
    key: 'isFirstPage',
    value: function isFirstPage() {
      return this.currentChart <= 0;
    }
  }, {
    key: 'isLastPage',
    value: function isLastPage() {
      return this.currentChart >= this.availableCharts.length - 1;
    }
  }, {
    key: 'nextButton',
    value: function nextButton(e) {
      var _this3 = this;

      e.preventDefault();
      this.$el.classList.add('charts--loading');
      this.loadMore().then(function () {
        _this3.$el.classList.remove('charts--loading');
        _this3.updateSelectedMetric(function (m) {
          return Object.assign(m, { viewPage: m.viewPage + 1 });
        });
        _this3.renderView(_this3.$el, _this3.getSelectedMetric());
      });
    }
  }, {
    key: 'prevButton',
    value: function prevButton(e) {
      e.preventDefault();
      this.updateSelectedMetric(function (m) {
        return Object.assign(m, { viewPage: m.viewPage - 1 });
      });
      this.renderView(this.$el, this.getSelectedMetric());
    }
  }, {
    key: 'nextChart',
    value: function nextChart() {
      var _this4 = this;

      if (this.isLastPage()) {
        return null;
      }

      this.currentChart = this.currentChart + 1;
      this.changeMetric(this.availableCharts[this.currentChart], this.period).then(function () {
        _this4.renderView(_this4.$el, _this4.getSelectedMetric());
      });
    }
  }, {
    key: 'previousChart',
    value: function previousChart() {
      var _this5 = this;

      if (this.isFirstPage()) {
        return null;
      }

      this.currentChart = this.currentChart - 1;
      this.changeMetric(this.availableCharts[this.currentChart], this.period).then(function () {
        _this5.renderView(_this5.$el, _this5.getSelectedMetric());
      });
    }
  }, {
    key: 'changeMetric',
    value: function changeMetric(metric, period) {
      var _this6 = this;

      this.$el.classList.add('charts--loading');
      if (this.isLocked) {
        this.log('Finishing in progress requests first');
        return this.lock.then(function () {
          return _this6.changeMetric(metric, period);
        });
      }

      // Select the current metric.
      this.updateSelectedMetric(function (m) {
        return Object.assign(m, { selected: false });
      });

      this.selected = metric;
      this.period = period;
      var isLoaded = void 0;

      // Select the current metric.
      this.updateSelectedMetric(function (m) {
        isLoaded = m.loaded;
        return Object.assign(m, { selected: true });
      });

      this.log('Changed metric to ', metric, period, ', loaded: ', isLoaded);
      return Promise.resolve(isLoaded ? null : this.loadMore());
    }
  }, {
    key: 'getSelectedName',
    value: function getSelectedName() {
      this.log('selected name: ', this.selected + '-by-' + this.period);
      return this.selected + '-by-' + this.period;
    }
  }, {
    key: 'getEndpoint',
    value: function getEndpoint(url, type, id, metric, by, perPage, page) {
      return url + '/metrics/' + type + '/' + id + '/' + metric + '?by=' + by + '&per-page=' + perPage + '&page=' + page;
    }
  }, {
    key: 'getSelectedMetric',
    value: function getSelectedMetric() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.metrics[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var metric = _step.value;

          if (metric.name === this.getSelectedName()) {
            return metric;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: 'getNthPage',
    value: function getNthPage(n, firstMonth, firstMonthYear, direction) {
      var month = firstMonth;
      var year = firstMonthYear;

      month = month + (n - 1) * direction;
      while (month > 12) {
        month = month - 12;
        year += 1;
      }

      return { month: parseInt(month, 10), year: parseInt(year, 10) };
    }
  }, {
    key: 'getJsonPage',
    value: function getJsonPage(page, perView) {
      return utils.loadData(this.getEndpoint(this.endpoint, this.type, this.id, this.selected, this.period, perView, page));
    }
  }, {
    key: 'updateSelectedMetric',
    value: function updateSelectedMetric(fn) {
      var _this7 = this;

      this.metrics = this.metrics.map(function (m) {
        return m.name === _this7.getSelectedName() ? fn(m) : m;
      });
    }
  }, {
    key: 'saveResults',
    value: function saveResults(data, page, remaining) {
      this.log('saving results', data);

      // Add the results to the metrics store.
      this.updateSelectedMetric(function (m) {
        m.periods = m.periods.concat(this.transformPeriods(data.periods));
        m.page = page;
        m.loaded = true;
        m.remaining = remaining;
        if (page === 1) {
          m.firstMonth = [parseInt(m.periods[0].month), parseInt(m.periods[0].year)];
        }

        if (m.periods.length >= 2) {
          if (this.periodToTimestamp(m.periods[0]) < this.periodToTimestamp(m.periods[1])) {
            m.reverse = 1;
          }
        }

        return m;
      }.bind(this));
    }
  }, {
    key: 'periodToTimestamp',
    value: function periodToTimestamp(entry) {
      return Date.UTC(parseInt(entry.year, 10), parseInt(entry.month - 1, 10), parseInt(entry.day ? entry.day : 1, 10));
    }
  }, {
    key: 'transformPeriods',
    value: function transformPeriods(periods) {
      this.log(periods);

      // Converts 2015-11-01 to { year: 2015, month: 11, day: 1 }
      return periods.map(function (_ref) {
        var value = _ref.value,
            period = _ref.period;

        var p = period.split('-');
        var year = p[0];
        var month = p[1];

        var minimum = { year: year, month: month, value: value };
        if (p[2]) {
          minimum.day = p[2];
        }

        // const [year, month, day] = period.split('-');
        return minimum;
      });
    }
  }, {
    key: 'log',
    value: function log() /* ...args */{

      // console.info('—>', ...args);
    }
  }, {
    key: 'filterPeriod',
    value: function filterPeriod(month, year) {
      return function (d) {
        return parseInt(d.month, 10) === month && parseInt(d.year, 10) === year;
      };
    }
  }, {
    key: 'filterYearPeriod',
    value: function filterYearPeriod(year) {
      return function (d) {
        return parseInt(d.year, 10) === year;
      };
    }
  }, {
    key: 'filterMonthPeriod',
    value: function filterMonthPeriod(firstMonth, firstMonthYear, viewPage) {
      return function (d) {
        if (parseInt(d.month, 10) >= firstMonth && parseInt(d.year, 10) === firstMonthYear + (viewPage - 1)) {
          return true;
        }

        return parseInt(d.month, 10) <= firstMonth && parseInt(d.year, 10) === firstMonthYear + viewPage;
      };
    }
  }, {
    key: 'renderView',
    value: function renderView($el, data) {
      var _this8 = this;

      var periods = void 0;
      var hasNextPage = void 0;

      var _data$firstMonth = _slicedToArray(data.firstMonth, 2),
          firstMonth = _data$firstMonth[0],
          firstMonthYear = _data$firstMonth[1];

      var current = this.getNthPage(data.viewPage, firstMonth, firstMonthYear, data.reverse);
      var next = this.getNthPage(data.viewPage + 1, firstMonth, firstMonthYear, data.reverse);

      // Current page of results.
      var currentFilter = this.period === 'day' ? this.filterPeriod(current.month, current.year) : this.filterYearPeriod(firstMonthYear + (data.viewPage - 1) * data.reverse);

      // Next page of results.
      var nextFilter = this.period === 'day' ? this.filterPeriod(next.month, next.year) : this.filterYearPeriod(firstMonthYear + data.viewPage * data.reverse);

      // Filter by each.
      periods = data.periods.filter(currentFilter);
      hasNextPage = data.periods.filter(nextFilter).length > 0;

      // Reverse if needed.
      if (data.reverse === -1) {
        periods = periods.reverse();
      }

      // Start working on UI.
      this.$el.classList.remove('charts--loading');
      this.barChart.updateFromJson({
        data: {
          totalPeriods: data.totalPeriods,
          totalValue: data.totalValue,
          periods: periods.map(function (entry) {
            return [_this8.periodToTimestamp(entry), entry.value];
          })
        },
        range: this.period === 'month' ? 'monthly' : 'daily',
        title: this.period === 'month' ? '(Monthly)' : '(Daily)',
        label: this.selected === 'downloads' ? 'Downloads' : 'Page Views'
      });

      if (!hasNextPage) {
        this.$next.classList.add('hidden');
      } else {
        this.$next.classList.remove('hidden');
      }

      if (data.viewPage === 1) {
        this.$prev.classList.add('hidden');
      } else {
        this.$prev.classList.remove('hidden');
      }

      this.log('Rendering view', $el, data);
    }
  }, {
    key: 'loadMore',
    value: function loadMore() {
      var _this9 = this;

      var currentMetric = this.getSelectedMetric();
      if (currentMetric.remaining < 1) {
        this.log('No more pages, skipping');
        return Promise.resolve(null);
      }

      if (this.isLocked) {
        this.log('Request already in progress');
        this.lock = this.lock.then(function () {
          this.loadMore();
        }.bind(this));
        return this.lock;
      }

      var deferred = utils.defer();
      this.isLocked = true;
      this.lock = deferred.promise;
      var page = currentMetric.page + 1;

      // Over fetch so we know that there is a next month to load.
      var perView = this.period === 'day' ? 32 : 13;

      // The next XHR
      this.currentRrequest = this.getJsonPage(page, perView);

      return this.currentRrequest.then(function (j) {
        return JSON.parse(j);
      }).then(function (json) {
        _this9.total = json.totalPeriods || 0;
        _this9.log('parse page ', page);
        var remaining = _this9.total - perView * page;
        var remainingPages = Math.ceil(remaining / perView);
        _this9.saveResults(json, page, remainingPages);
        _this9.isLocked = false;
        deferred.resolve();
        _this9.log('resolved,', 'total', _this9.total, 'remaining requests:', remainingPages);
        return json;
      });
    }
  }]);

  return Metrics;
}();

module.exports = Metrics;

},{"../libs/elife-utils":35,"./BarChart":8}],23:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var utils = require('../libs/elife-utils')();

/**
 * Creates a new visual overlay of 20% transparent black.
 *
 * Not attachable with a data-behaviour attribute, must be directly invoked by the using component
 * @type {Overlay}
 */
module.exports = function () {

  /**
   *
   * @param $parent the parent element to attach the overlay to
   * @param $followingSibling sibling to attach the overlay before
   * @param id the id to give the overlay
   * @param z the CSS z-index value to give the overlay
   * @param _window window
   * @param doc document
   */
  function Overlay($parent, $followingSibling, id, z) {
    var _window = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : window;

    var doc = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : document;

    _classCallCheck(this, Overlay);

    this.window = _window;
    this.doc = doc;

    this.$parent = this.find$parent($parent);
    if (!this.$parent) {
      return;
    }

    this.$elm = utils.create$pageOverlay(this.$parent, $followingSibling, id);
    if (this.$elm) {
      this.assignZIndex(z);
    }
  }

  _createClass(Overlay, [{
    key: 'hide',
    value: function hide() {
      this.$elm.classList.add('hidden');
    }
  }, {
    key: 'show',
    value: function show() {
      this.$elm.style.height = this.$parent.getBoundingClientRect().height + 'px';
      this.$elm.classList.remove('hidden');
    }
  }, {
    key: 'assignZIndex',
    value: function assignZIndex(z) {
      if (!isNaN(z)) {
        if (!this.$elm.style) {
          this.$elm.style = { zIndex: z };
        } else {
          this.$elm.style.zIndex = z;
        }
      }
    }
  }, {
    key: 'assignTop',
    value: function assignTop(top) {
      if (!isNaN(top)) {
        if (!this.$elm.style) {
          this.$elm.style = { top: top + 'px' };
        } else {
          this.$elm.style.top = top + 'px';
        }
      }
    }
  }, {
    key: 'find$parent',
    value: function find$parent(parentCandidate) {
      if (parentCandidate instanceof HTMLElement) {
        return parentCandidate;
      }

      return this.doc.querySelector(parentCandidate);
    }
  }, {
    key: 'get$elm',
    value: function get$elm() {
      return this.$elm;
    }
  }]);

  return Overlay;
}();

},{"../libs/elife-utils":35}],24:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var utils = require('../libs/elife-utils')();

module.exports = function () {
  function Pager($elm) {
    var _window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;

    var doc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;

    _classCallCheck(this, Pager);

    if (!$elm) {
      return;
    }

    this.$elm = $elm;
    this.window = _window;
    this.doc = doc;

    this.$targetEl = this.find$targetEl();
    this.$loader = this.find$Loader();
    if (!(this.$loader && this.$targetEl)) {
      return;
    }

    this.isCurrentlyLoading = false;
    this.timeoutThresholdInMs = 10000;
    this.loaderLink = this.$loader.getAttribute('href');
    this.$loader.addEventListener('click', this.handleLoadRequest.bind(this));
  }

  _createClass(Pager, [{
    key: 'createDocFragFromString',
    value: function createDocFragFromString(str) {
      if (typeof str !== 'string') {
        return;
      }

      var frag = this.doc.createDocumentFragment();
      var $temp = this.doc.createElement('div');
      $temp.innerHTML = str;
      while ($temp.firstElementChild) {
        var child = $temp.firstElementChild;
        frag.appendChild(child);
      }

      return frag;
    }
  }, {
    key: 'injectNewData',
    value: function injectNewData(newData) {
      var normalisedData = Pager.normaliseData(newData);
      this.setLoaderLinkFromData(normalisedData);
      var regex = /.*<ol[^>]*class="[^"]*(grid-listing|listing-list)[^"]*"[^>]*>(<li>?.*<\/li>)<\/ol>.*/;
      var match = normalisedData.match(regex);

      if (!(match && match[2])) {
        throw new SyntaxError('Loaded data doesn\'t match required format');
      }

      this.$targetEl.appendChild(this.createDocFragFromString(match[2]));
    }
  }, {
    key: 'redirectToFullResultsPage',
    value: function redirectToFullResultsPage() {
      var loaderLink = this.getLoaderLink();
      if (loaderLink) {
        this.window.location.search = loaderLink;
      }
    }
  }, {
    key: 'handleError',
    value: function handleError() {
      this.redirectToFullResultsPage();
    }
  }, {
    key: 'getLoaderLink',
    value: function getLoaderLink() {
      return this.loaderLink;
    }

    /**
     * Sets the link for the next page onto the $loader, if it can find it in the supplied data
     *
     * @param normalisedData HTML as string with leading space and line breaks removed
     *
     */

  }, {
    key: 'setLoaderLinkFromData',
    value: function setLoaderLinkFromData(normalisedData) {
      var regex = /.*(<div[^>]*class="[^"]*pager[^"]*"[^>]*>.*<\/div>).*/;
      var $docFragOfPagerFoundInData = this.createDocFragFromString(normalisedData.match(regex)[1]);
      if (!$docFragOfPagerFoundInData) {
        this.loaderLink = '#';
        return;
      }

      var nextPageButton = $docFragOfPagerFoundInData.querySelector('.button:nth-child(2)');
      if (!nextPageButton) {
        this.loaderLink = '#';
        return;
      }

      var nextPageButtonLink = nextPageButton.href;
      var location = this.window.location;
      this.loaderLink = nextPageButtonLink.replace(location.protocol + '//' + location.host, '');
      this.$loader.setAttribute('href', this.loaderLink);
    }
  }, {
    key: 'setLoadingState',
    value: function setLoadingState() {
      var _this = this;

      this.isCurrentlyLoading = true;
      this.$loader.classList.add('button--inactive');
      var $pagerTextWrapper = this.$loader.querySelector('.pager__text_wrapper');
      if ($pagerTextWrapper) {
        $pagerTextWrapper.innerHTML = 'Loading...';
        $pagerTextWrapper.classList.add('loading');
      }

      // If the loading takes longer than timeoutThresholdInMs, try to go to the full results page.
      this.loadingTimer = this.window.setTimeout(function () {
        _this.redirectToFullResultsPage();
      }, this.timeoutThresholdInMs);
    }
  }, {
    key: 'clearLoadingState',
    value: function clearLoadingState() {
      this.window.clearTimeout(this.loadingTimer);
      this.isCurrentlyLoading = false;
      var $pagerTextWrapper = this.$loader.querySelector('.pager__text_wrapper');
      if ($pagerTextWrapper) {
        $pagerTextWrapper.classList.remove('loading');
        $pagerTextWrapper.innerHTML = !!this.$loader.originalText ? this.$loader.originalText : 'Load more';
      }

      this.$loader.classList.remove('button--inactive');
    }
  }, {
    key: 'updatePager',
    value: function updatePager(normalisedData) {
      if (Pager.isLastPage(normalisedData)) {
        this.$loader.parentNode.removeChild(this.$loader);
      } else {
        this.setLoaderLinkFromData(normalisedData);
      }
    }
  }, {
    key: 'updateUrl',
    value: function updateUrl(loaderLink) {
      if (loaderLink) {
        this.window.history.pushState(null, '', loaderLink);
      }
    }
  }, {
    key: 'handleLoad',
    value: function handleLoad(data) {
      var loaderLink = this.loaderLink;
      var normalisedData = void 0;
      try {
        normalisedData = Pager.normaliseData(data);
        this.injectNewData(normalisedData);
      } catch (e) {
        this.handleError(e);
        return;
      }

      this.clearLoadingState();
      this.updateUrl(loaderLink);
      this.updatePager(normalisedData);
    }
  }, {
    key: 'handleLoadRequest',
    value: function handleLoadRequest(e) {
      e.preventDefault();

      if (this.isCurrentlyLoading) {
        return null;
      }

      this.loadData(this.getLoaderLink(), this.window.XMLHttpRequest).then(this.handleLoad.bind(this), this.handleError.bind(this));
      this.setLoadingState();
    }
  }, {
    key: 'loadData',
    value: function loadData(url, XMLHttpRequest) {

      return new Promise(function resolver(resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.addEventListener('load', function () {
          resolve(xhr.responseText);
        });
        xhr.addEventListener('error', reject);
        xhr.open('GET', url);
        xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        xhr.send();
      });
    }
  }, {
    key: 'find$Loader',
    value: function find$Loader() {
      var $loader = this.$elm.querySelector('.button--full:first-child.button--full:last-child');
      if (!$loader) {
        return;
      }

      $loader.id = utils.uniqueIds.get('pager', this.doc);
      $loader.originalText = $loader.innerHTML;
      var $loaderTextWrapper = this.doc.createElement('span');
      $loaderTextWrapper.classList.add('pager__text_wrapper');
      $loaderTextWrapper.innerHTML = $loader.originalText;
      $loader.replaceChild($loaderTextWrapper, $loader.firstChild);

      return $loader;
    }
  }, {
    key: 'find$targetEl',
    value: function find$targetEl() {
      return this.doc.getElementById(this.$elm.dataset.targetid);
    }
  }], [{
    key: 'normaliseData',
    value: function normaliseData(data) {
      var dataNoLeadingWhitespace = data.replace(/^\s+([^\s])/gm, '$1');
      return dataNoLeadingWhitespace.replace(/\n/g, '');
    }
  }, {
    key: 'isLastPage',
    value: function isLastPage(data) {
      return !data.match(/class="pager".*button--default.*button--default/g);
    }
  }]);

  return Pager;
}();

},{"../libs/elife-utils":35}],25:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var utils = require('../libs/elife-utils')();

module.exports = function () {
  function Popup($elm) {
    var _this = this;

    var _window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;

    var doc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;

    _classCallCheck(this, Popup);

    var $link = void 0;

    if ($elm.dataset.popupWrapper) {
      $link = utils.buildElement('a');
      $link.classList.add('popup__wrapper');
      $link.href = '#';
      $elm.parentNode.insertBefore($link, $elm);
      $link.appendChild($elm);
    } else {
      $link = $elm;
    }

    if (!$elm.dataset.popupSelf) {
      if (!$link.hash || $link.host !== _window.location.host || !$link.hash.match(/^#[a-z]/i)) {
        return;
      }
    }

    this.$link = $link;
    this.$elm = $elm;
    this.isOpen = false;
    this.resolver = null;
    this.window = _window;
    this.doc = doc;
    this.bodyContents = null;
    this.thresholdWidth = 730;
    this.$link.addEventListener('click', function (e) {
      return _this.handleLinkClick(e);
    });

    doc.addEventListener('click', function (e) {
      return _this.handleDocumentClick(e);
    });
  }

  _createClass(Popup, [{
    key: 'handleLinkClick',
    value: function handleLinkClick(e) {
      var _this2 = this;

      // If the viewport is too narrow, we don't.
      if (!this.window.matchMedia('(min-width: ' + this.thresholdWidth + 'px)').matches) {
        if (e.currentTarget.href.match(/.*#$/)) {
          e.stopPropagation();
          e.preventDefault();
        }

        return;
      }

      if (!this.$link) {
        return true;
      }

      e.preventDefault();

      this.isOpen = !this.isOpen;
      this.render(e).then(function () {
        if (_this2.isEmpty) {
          var link = _this2.$link;
          _this2.$link = null;
          link.click();
        }
      });
    }
  }, {
    key: 'handleDocumentClick',
    value: function handleDocumentClick(e) {

      // If the viewport is too narrow, we don't.
      if (!this.window.matchMedia('(min-width: ' + this.thresholdWidth + 'px)').matches) {
        return;
      }

      if (utils.closest(e.target, 'a') === this.$link) {
        return;
      }

      var closestPopup = utils.closest(e.target, '.popup');
      if (closestPopup && closestPopup === this.popupHitBox) {
        return;
      }

      if (this.isOpen) {
        this.isOpen = false;
        this.render(e);
      }
    }
  }, {
    key: 'getResolver',
    value: function getResolver(link) {
      if (this.resolver) {
        return this.resolver;
      }

      // If there's no hash, there's no point in going on.
      if (!link.hash) {
        this.resolver = Promise.resolve(null);
      } else {
        this.resolver = utils.remoteDoc(link.href, this.window);
      }

      return this.resolver;
    }
  }, {
    key: 'getBodyContentsFromNode',
    value: function getBodyContentsFromNode(node) {
      if (!node) {
        return this.emptyResponse();
      }

      if (!node.getAttribute('data-popup-contents')) {

        // Mark empty.
        return this.emptyResponse();
      }

      if (node.getAttribute('data-popup-label')) {

        // Set label for jump link.
        this.label = node.getAttribute('data-popup-label');
      }

      if (node.getAttribute('data-popup-contents') === node.id) {

        // Return node if it points to itself.
        return node.cloneNode(true);
      }

      var target = node.getElementById(node.getAttribute('data-popup-contents'));
      if (!target) {

        // Also mark empty.
        return this.emptyResponse();
      }

      // Return the target.
      return target.cloneNode(true);
    }
  }, {
    key: 'emptyResponse',
    value: function emptyResponse() {
      this.isEmpty = true;
      return null;
    }
  }, {
    key: 'requestContents',
    value: function requestContents(e) {
      var _this3 = this;

      if (this.$elm.dataset.popupSelf) {
        this.bodyContents = this.$elm.cloneNode(true);
        return Promise.resolve(this.render(e));
      }

      // We await on the contents, which might be XHR.
      return this.getResolver(this.$link).then(function (r) {

        // If there is contents the come back we add it to our object.
        if (r) {
          _this3.bodyContents = _this3.getBodyContentsFromNode(r.querySelector(_this3.$link.hash));
          return _this3.render(e);

          // If not, we set this and ignore.
        } else {
          _this3.emptyResponse();
        }

        return Promise.resolve(_this3.$link);
      });
    }
  }, {
    key: 'createBottomBar',
    value: function createBottomBar(label, link) {
      var $bottomBar = utils.buildElement('div', ['popup__actions', 'clearfix']);

      var $seeInReferences = utils.buildElement('a', ['popup__button', 'popup__button--right'], label, $bottomBar);
      $seeInReferences.href = link;

      return $bottomBar;
    }
  }, {
    key: 'createPopupBox',
    value: function createPopupBox() {
      // Get the content
      var $content = void 0;

      for (var _len = arguments.length, children = Array(_len), _key = 0; _key < _len; _key++) {
        children[_key] = arguments[_key];
      }

      [].forEach.call(children, function (child) {
        if (child.classList.contains('popup__content')) {
          $content = child;
        }
      });

      // wrap ancillary content in an ancillary block
      if ($content instanceof HTMLElement) {
        (function () {
          var $ancillary = utils.buildElement('div', ['popup__content__ancillary']);
          var exclusions = ['reference__title', 'reference__authors_list', 'reference__authors_list_suffix', 'author-details__name', 'about-profile__name', 'about-profile__role'];
          var ancillaries = [];

          // If an immediate child of content does not have an excluded class, it's ancillary
          // Ancillary elements are added to a new ancillary block
          [].forEach.call($content.children, function ($contentChild) {
            var isAncillary = false;
            [].forEach.call($contentChild.classList, function (cssClass) {
              if (!isAncillary && exclusions.indexOf(cssClass) === -1) {
                ancillaries.push($contentChild);
                isAncillary = true;
              }
            });
          });

          ancillaries.forEach(function ($ancillaryChild) {
            $ancillary.appendChild($ancillaryChild);
          });

          $content.appendChild($ancillary);
        })();
      }

      return utils.wrapElements(children, 'div', 'popup__window');
    }
  }, {
    key: 'createPopupHitBox',
    value: function createPopupHitBox() {
      for (var _len2 = arguments.length, children = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        children[_key2] = arguments[_key2];
      }

      return utils.wrapElements(children, 'div', 'popup');
    }
  }, {
    key: 'calcInitialPosition',
    value: function calcInitialPosition(e, width) {
      // Triggered by a pointer
      if (e.pageX || e.pageY) {
        return {
          left: e.pageX - width / 2,
          top: e.pageY + 20
        };
      }

      // Triggered by keyboard
      var rect = e.currentTarget.getBoundingClientRect();
      return {
        left: rect.left + this.window.scrollX,
        top: rect.bottom - /*three baseline grid measures*/72 + this.window.scrollY
      };
    }
  }, {
    key: 'positionPopupHitBox',
    value: function positionPopupHitBox(e) {
      this.popupHitBox.style.display = '';

      var width = this.popupHitBox.offsetWidth;
      var height = this.popupHitBox.offsetHeight;

      var initialPosition = this.calcInitialPosition(e, width);
      var left = initialPosition.left;
      var top = initialPosition.top;

      // If off the left.
      if (left < 10) {
        left = 10;
      }

      // If off the right.
      if (left + width + 10 > this.window.innerWidth) {
        left = this.window.innerWidth - width - 10;
      }

      // See if can be placed completely above.
      var topIfAbove = e.pageY - height - 20;
      if (top + height + 10 > this.window.pageYOffset + this.window.innerHeight && topIfAbove >= this.window.pageYOffset + 10) {
        top = topIfAbove;
      }

      this.popupHitBox.style.left = left + 'px';
      this.popupHitBox.style.top = top + 'px';
    }
  }, {
    key: 'render',
    value: function render(e) {
      var _this4 = this;

      // If there's nothing to render.. we don't.
      if (this.isEmpty) {
        return Promise.resolve(this.$link);
      }

      // If there's no body to show, we request it.
      if (!this.bodyContents) {
        return this.requestContents(e);
      }

      // If there's no popup element yet, we create it.
      if (!this.popupHitBox) {
        this.bodyContents.id = utils.uniqueIds.get('popupFragment', this.doc);
        this.bodyContents.classList.add('popup__content');

        var _children = [this.bodyContents];
        if (this.label) {
          _children.push(this.createBottomBar(this.label, this.$link.href));
        }

        // Create elements.
        this.popupHitBox = this.createPopupHitBox(this.createPopupBox.apply(this, _children));

        Popup.setLinksClasses(this.popupHitBox);

        // Add to DOM.
        this.doc.body.appendChild(this.popupHitBox);

        this.window.addEventListener('resize', utils.debounce(function () {
          // If the viewport is too narrow, we don't.
          if (!_this4.window.matchMedia('(min-width: ' + _this4.thresholdWidth + 'px)').matches) {
            return;
          }

          _this4.isOpen = false;
          _this4.render(e);
        }, 150));
      }

      // Changing the state depending on the other properties of the object.
      if (this.isOpen) {
        this.positionPopupHitBox(e);
      } else {
        this.popupHitBox.style.display = 'none';
      }

      return Promise.resolve(this.$link);
    }
  }], [{
    key: 'setLinksClasses',
    value: function setLinksClasses($root) {
      if ($root instanceof HTMLElement) {
        [].slice.call($root.querySelectorAll('a')).forEach(function ($link) {
          $link.classList.add('popup__link');
        });
      }
    }
  }]);

  return Popup;
}();

},{"../libs/elife-utils":35}],26:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

module.exports = function () {

  // Injecting window and document to allow easier mocking
  function SearchBox($elm) {
    var _window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;

    var doc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;

    _classCallCheck(this, SearchBox);

    try {
      this.$elm = $elm;
      this.$input = this.$elm.querySelector('input[type="search"]');
    } catch (e) {
      return;
    }

    this.window = _window;
    this.doc = doc;
    this.$container = $elm.querySelector('fieldset');
    this.$resetButton = $elm.querySelector('button[type="reset"]');

    this.$elm.classList.add('search-box--js');

    // events
    this.$resetButton.addEventListener('click', this.reset.bind(this));
    this.$input.addEventListener('keyup', this.handleInput.bind(this));
    this.$input.addEventListener('paste', this.handleInput.bind(this));
  }

  /**
   * Handles the reset button being pressed.
   */


  _createClass(SearchBox, [{
    key: 'reset',
    value: function reset() {
      this.hideResetButton();
      if (this.$output) {
        this.$output.innerHTML = '';
      }

      this.$input.focus();
    }

    /**
     * Hides the reset button.
     */

  }, {
    key: 'hideResetButton',
    value: function hideResetButton() {
      this.$elm.classList.remove('search-box--populated');
    }

    /**
     * Shows the reset button.
     */

  }, {
    key: 'showResetButton',
    value: function showResetButton() {
      this.$elm.classList.add('search-box--populated');
    }

    /**
     * Show/hide reset button, depending on whether there's text to clear or not.
     */

  }, {
    key: 'handleInput',
    value: function handleInput(e) {
      if (e.keyCode === /*Tab*/9) {
        return;
      }

      if (this.$input.value.length > 0) {
        this.showResetButton();
      } else {
        this.hideResetButton();
      }
    }
  }]);

  return SearchBox;
}();

},{}],27:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var utils = require('../libs/elife-utils')();

module.exports = function () {
  function SectionListingLink($elm) {
    var _window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;

    var doc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;

    _classCallCheck(this, SectionListingLink);

    try {
      if (!($elm instanceof HTMLElement && $elm.href.length && $elm.href.indexOf('#') > -1)) {
        return;
      }
    } catch (e) {
      return;
    }

    this.window = _window;
    this.doc = doc;
    this.$elm = $elm;
    this.href = this.$elm.href;
    this.$listing = this.doc.getElementById(this.href.substring(this.href.indexOf('#') + 1));
    if (this.$listing) {
      this.init();
    } else {
      this.$elm.classList.add('hidden');
    }
  }

  _createClass(SectionListingLink, [{
    key: 'init',
    value: function init() {
      var _this = this;

      this.$defaultListParent = this.$listing.parentNode;
      this.$wideViewListParent = this.$elm.parentNode;
      this.breakpoint = 1200;

      this.handleWidth();
      this.window.addEventListener('resize', utils.debounce(function () {
        return _this.handleWidth();
      }, 10));
    }
  }, {
    key: 'handleWidth',
    value: function handleWidth() {
      this.updateView(this.$listing, this.$defaultListParent, this.$wideViewListParent, this.breakpoint);
    }
  }, {
    key: 'updateView',
    value: function updateView($list, $defaultListParent, $wideViewListParent, thresholdWidthInPx) {
      if (this.window.matchMedia('(min-width: ' + thresholdWidthInPx + 'px)').matches) {
        this.showWideView($list, $wideViewListParent);
      } else {
        this.restoreDefaultView($list, $defaultListParent);
      }
    }
  }, {
    key: 'showWideView',
    value: function showWideView($list, $wideViewListParent) {
      if ($list.parentNode !== $wideViewListParent) {
        $wideViewListParent.appendChild($list);
        this.$elm.classList.add('hidden');
      }
    }
  }, {
    key: 'restoreDefaultView',
    value: function restoreDefaultView($list, $defaultListParent) {
      if ($list.parentNode !== $defaultListParent) {
        $defaultListParent.appendChild($list);
        this.$elm.classList.remove('hidden');
      }
    }
  }]);

  return SectionListingLink;
}();

},{"../libs/elife-utils":35}],28:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

module.exports = function () {
  function SelectNav($elm) {
    _classCallCheck(this, SelectNav);

    if (!$elm) {
      return;
    }

    this.$elm = $elm;
    this.$elm.classList.add('select-nav--js');
    this.$elm.querySelector('select').addEventListener('change', this.triggerSubmit.bind(this));
  }

  _createClass(SelectNav, [{
    key: 'triggerSubmit',
    value: function triggerSubmit() {
      this.$elm.submit();
    }
  }]);

  return SelectNav;
}();

},{}],29:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var utils = require('../libs/elife-utils')();

module.exports = function () {
  function SideBySideView($elm, src, $header) {
    var _this = this;

    var _window = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : window;

    var doc = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : document;

    _classCallCheck(this, SideBySideView);

    if (!$elm) {
      return;
    }

    this.window = _window;
    this.doc = doc;
    this.$global = $elm;

    this.$header = $header;
    this.eachButHeader = function (callback) {

      [].forEach.call(_this.$global.childNodes, function (node) {

        // skip text nodes
        if (!node.tagName) {
          return;
        }

        if (utils.areElementsNested(node, _this.$header)) {
          return;
        }

        callback(node);
      });
    };

    this.src = src;
  }

  _createClass(SideBySideView, [{
    key: 'open',
    value: function open() {

      this.saveScrollingPosition();

      this.$iframe = this.doc.querySelector('.side-by-side-view__iframe');
      if (!this.$iframe) {
        this.$iframe = SideBySideView.createIframe(this.src);
        this.doc.body.appendChild(this.$iframe);
      } else {
        this.$iframe.classList.remove('hidden');
      }

      this.$closeBar = this.doc.querySelector('.side-by-side-view__bar');
      if (!this.$closeBar) {
        this.$closeBar = this.createCloseBar();
        this.doc.body.appendChild(this.$closeBar);
      } else {
        this.$closeBar.classList.remove('hidden');
      }

      this.hideEverythingButHeader();
    }
  }, {
    key: 'close',
    value: function close() {
      this.$closeBar.classList.add('hidden');
      this.$iframe.classList.add('hidden');
      this.showEverything();
      this.restoreScrollingPosition();
    }
  }, {
    key: 'saveScrollingPosition',
    value: function saveScrollingPosition() {
      this.currentYScrollPos = this.window.pageYOffset;
      this.window.scroll(0, 0);
    }
  }, {
    key: 'restoreScrollingPosition',
    value: function restoreScrollingPosition() {
      this.window.scroll(0, this.currentYScrollPos);
      this.currentYScrollPos = null;
    }
  }, {
    key: 'hideEverythingButHeader',
    value: function hideEverythingButHeader() {
      this.eachButHeader(function (element) {
        element.classList.add('hidden');
      });
    }
  }, {
    key: 'showEverything',
    value: function showEverything() {
      this.eachButHeader(function (element) {
        element.classList.remove('hidden');
      });
    }
  }, {
    key: 'createCloseBar',
    value: function createCloseBar() {
      var _this2 = this;

      var div = utils.buildElement('div', ['side-by-side-view__bar']);

      // other X options &#x00D7;&#x2a09;&#x2a2f;
      var btn = utils.buildElement('button', ['side-by-side-view__button-close'], '<span class="side-by-side-view__button-close-cross">&#x2715;</span>' + '<span class="side-by-side-view__button-close-text">Close side by side view</span>', div);
      btn.addEventListener('click', function () {
        _this2.close();
      });
      return div;
    }
  }], [{
    key: 'createIframe',
    value: function createIframe(src) {
      var iframe = utils.buildElement('iframe', ['side-by-side-view__iframe']);
      iframe.src = src;
      return iframe;
    }
  }]);

  return SideBySideView;
}();

},{"../libs/elife-utils":35}],30:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Overlay = require('./Overlay');
var utils = require('../libs/elife-utils')();

module.exports = function () {

  // Passing window and document separately allows for independent mocking of window in order
  // to test feature support fallbacks etc.
  function SiteHeader($elm) {
    var _window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;

    var doc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;

    _classCallCheck(this, SiteHeader);

    if (!$elm) {
      return;
    }

    this.$elm = $elm;
    this.window = _window;
    this.doc = doc;

    var SearchBox = require('./SearchBox');
    var $searchBoxEl = $elm.querySelector('[data-behaviour="SearchBox"]');
    this.searchBox = new SearchBox($searchBoxEl, this.window, doc);
    var searchToggle = $elm.querySelector('[rel="search"]');
    if (!!searchToggle) {
      this.searchToggle = searchToggle.parentNode;
      this.searchToggle.addEventListener('click', this.toggleSearchBox.bind(this));
    }

    var $overlayParent = this.doc.querySelector('.main');
    if (!$overlayParent) {
      return;
    }

    var $overlayFollowingSibling = $overlayParent.firstElementChild;
    this.pageOverlay = new Overlay($overlayParent, $overlayFollowingSibling, 'mainMenuOverlay', this.window, this.doc);
    this.pageOverlay.assignTop(96);

    // N.B. $mainMenu is not part of this component's HTML hierarchy.
    var mainMenu = doc.getElementById('mainMenu');
    if (!!mainMenu) {
      var MainMenu = require('./MainMenu');
      this.mainMenu = new MainMenu(mainMenu);

      this.$mainMenuToggle = this.$elm.querySelector('a[href="#mainMenu"]');
      if (!!this.$mainMenuToggle) {
        this.mainMenu.moveWithinDom();
        this.$mainMenuToggle.addEventListener('click', this.toggleMainMenu.bind(this));
      }
    }
  }

  /**
   * Toggles display of the main menu.
   */


  _createClass(SiteHeader, [{
    key: 'toggleMainMenu',
    value: function toggleMainMenu(e) {
      if (this.mainMenu.isOpen()) {
        this.mainMenu.close();
        this.window.removeEventListener('keyup', this.checkForMenuClose.bind(this));
        this.doc.querySelector('.global-inner').removeEventListener('click', this.checkForMenuClose.bind(this));
      } else {
        this.mainMenu.open();
        this.window.addEventListener('keyup', this.checkForMenuClose.bind(this));
        this.doc.querySelector('.global-inner').addEventListener('click', this.checkForMenuClose.bind(this));
      }

      e.preventDefault();
      e.stopPropagation();
    }
  }, {
    key: 'checkForMenuClose',
    value: function checkForMenuClose(e) {
      if (e.keyCode === 27 || e.type === 'click') {
        if (!e.target.classList.contains('main-menu__list_item')) {
          this.mainMenu.close();
        }
      }
    }

    /**
     * Toggles display of the search box.
     *
     * @param {Event} e The event causing the toggle to occur
     */

  }, {
    key: 'toggleSearchBox',
    value: function toggleSearchBox(e) {
      e.preventDefault();
      e.stopPropagation();
      if (this.searchBoxIsOpen()) {
        this.closeSearchBox();
      } else {
        this.openSearchBox();
      }
    }

    /**
     * Returns true if the search box is currently displayed.
     *
     * @returns {boolean} True if the search box is open
     */

  }, {
    key: 'searchBoxIsOpen',
    value: function searchBoxIsOpen() {
      return this.searchBox.$elm.classList.contains('search-box--shown');
    }

    /**
     * Closes the search box.
     */

  }, {
    key: 'closeSearchBox',
    value: function closeSearchBox() {
      this.searchBox.$elm.classList.remove('search-box--shown');
      utils.updateElementTranslate(this.searchBox.$elm, [0, '-40px']);
      if (this.searchBox.$output) {
        this.searchBox.$output.innerHTML = '';
      }

      this.searchBox.$input.blur();
      this.window.removeEventListener('keyup', this.checkForClose.bind(this));
      this.window.removeEventListener('click', this.checkForClose.bind(this));
      this.pageOverlay.hide();
    }

    /**
     * Decides whether to close the search box, based on the supplied event.
     *
     * @param e The KeyboardEvent provoking the check.
     */

  }, {
    key: 'checkForClose',
    value: function checkForClose(e) {
      if (e.keyCode && e.keyCode === 27 || e.type === 'click' && !utils.areElementsNested(this.searchBox.$elm, e.target)) {
        this.closeSearchBox();
      }
    }

    /**
     * Opens the search box.
     */

  }, {
    key: 'openSearchBox',
    value: function openSearchBox() {
      var _this = this;

      var myHeight = this.window.getComputedStyle(this.$elm).height;
      var adjustment = 20;
      var offsetY = utils.adjustPxString(myHeight, adjustment, 'add');

      // This is set in the site-header.scss.
      var transitionDurationInMs = 150;
      utils.updateElementTranslate(this.searchBox.$elm, [0, offsetY]);
      utils.invertPxString(this.window.getComputedStyle(this.searchBox.$container).height);
      this.searchBox.$elm.classList.add('search-box--shown');
      this.window.addEventListener('keyup', this.checkForClose.bind(this));
      this.window.addEventListener('click', this.checkForClose.bind(this));

      this.window.setTimeout(function () {

        // blur before focus forces the focus, a simple focus doesn't always behave as expected.
        _this.searchBox.$input.blur();
        _this.searchBox.$input.focus();
      }, transitionDurationInMs);
      this.pageOverlay.show();
    }
  }]);

  return SiteHeader;
}();

},{"../libs/elife-utils":35,"./MainMenu":19,"./Overlay":23,"./SearchBox":26}],31:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

module.exports = function () {
  function SpeechBubble($elm) {
    var _window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;

    var doc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;

    _classCallCheck(this, SpeechBubble);

    if (!$elm) {
      return;
    }

    this.$elm = $elm;
    this.window = _window;
    this.doc = doc;

    this.placeholder = '“';
  }

  _createClass(SpeechBubble, [{
    key: 'removePlaceholder',
    value: function removePlaceholder() {
      this.$elm.classList.remove('speech-bubble--has-placeholder');
      var re = new RegExp(this.placeholder, 'g');
      this.$elm.innerHTML = this.$elm.innerHTML.replace(re, '');
    }
  }, {
    key: 'showPlaceholder',
    value: function showPlaceholder(selector) {
      var $replacementTarget = this.$elm.querySelector(selector) || this.$elm;
      $replacementTarget.innerHTML = this.placeholder;
      this.$elm.classList.add('speech-bubble--has-placeholder');
    }
  }, {
    key: 'update',
    value: function update(content, selector) {
      this.removePlaceholder();
      var $target = this.$elm.querySelector(selector) || this.$elm;
      $target.innerHTML = content;
    }
  }, {
    key: 'showLoadingIndicator',
    value: function showLoadingIndicator() {
      this.$elm.classList.add('speech-bubble--loading');
    }
  }, {
    key: 'removeLoadingIndicator',
    value: function removeLoadingIndicator() {
      this.$elm.classList.remove('speech-bubble--loading');
    }
  }, {
    key: 'showFailureState',
    value: function showFailureState(applyToParent) {
      this.removeLoadingIndicator();
      this.$elm.setAttribute('disabled', 'disabled');
      this.$elm.style.cursor = 'not-allowed';

      if (applyToParent) {
        this.$elm.parentElement.style.cursor = 'not-allowed';
        this.$elm.parentElement.style.color = '#888'; // $color-text-secondary

        if (this.$elm.previousElementSibling) {
          this.$elm.previousElementSibling.style.cursor = 'not-allowed';
          this.$elm.previousElementSibling.style.color = '#888'; // $color-text-secondary
        }
      }
    }
  }]);

  return SpeechBubble;
}();

},{}],32:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var clipper = require('text-clipper');
var utils = require('../libs/elife-utils')();

module.exports = function () {
  function ToggleableCaption($elm) {
    var _this = this;

    var _window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;

    var doc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;

    _classCallCheck(this, ToggleableCaption);

    this.window = _window;
    this.doc = doc;
    this.thresholdWidth = $elm.dataset.thresholdWidth;

    this.$elm = $elm;
    if (!($elm instanceof HTMLElement)) {
      return;
    }

    this.$caption = this.$elm.querySelector(this.$elm.getAttribute('data-selector'));
    if (!(this.$caption instanceof HTMLElement)) {
      return;
    }

    this.setupToggle();

    if (!this.truncatedHtml) {
      return;
    }

    if (this.thresholdWidth !== null) {
      this.toggleToggle();
      this.window.addEventListener('resize', utils.debounce(function () {
        return _this.toggleToggle();
      }, 150));
    } else {
      this.toggleCaption();
    }
  }

  _createClass(ToggleableCaption, [{
    key: 'setupToggle',
    value: function setupToggle() {
      var seeMoreButton = '<button class="caption-text__toggle caption-text__toggle--see-more">see more</button>';
      var seeLessButton = '<button class="caption-text__toggle caption-text__toggle--see-less">see less</button>';

      var fullChildren = [];
      [].forEach.call(this.$caption.childNodes, function (child) {
        return fullChildren.push(child.outerHTML);
      });
      fullChildren = fullChildren.filter(function (child) {
        return child;
      });

      this.originalHtml = fullChildren.join(' ');

      fullChildren.push(seeLessButton);

      var truncatedChildren = fullChildren;
      if (this.$caption.firstElementChild.nodeName.toUpperCase() === 'P') {
        var truncatedChild = truncatedChildren[0];
        try {
          truncatedChild = clipper(truncatedChildren[0], 200, {
            html: true,
            maxLines: 1
          });
        } catch (e) {
          console.log(e);
        }

        if (truncatedChild !== truncatedChildren[0] || truncatedChildren.length > 3) {
          truncatedChildren = [truncatedChild.replace(/<\/p>/, ' ' + seeMoreButton + '</p>')];
        } else {
          return;
        }
      } else {
        truncatedChildren = [seeMoreButton];
      }

      this.fullHtml = fullChildren.join(' ');
      this.truncatedHtml = truncatedChildren.join(' ');
    }
  }, {
    key: 'toggleCaption',
    value: function toggleCaption(e) {
      var $toggle = this.$caption.querySelector('.caption-text__toggle');

      this.$caption.innerHTML = '';

      if (!$toggle || $toggle.classList.contains('caption-text__toggle--see-less')) {
        this.$caption.innerHTML = this.truncatedHtml;
        if (e && this.$caption.getBoundingClientRect().top < 0) {
          this.$caption.scrollIntoView();
        }
      } else {
        this.$caption.innerHTML = this.fullHtml;
      }

      if (!!this.window.MathJax && !!this.window.MathJax.Hub) {
        this.window.MathJax.Hub.Queue(['Typeset', this.window.MathJax.Hub, this.$caption]);
      }

      this.$caption.querySelector('.caption-text__toggle').addEventListener('click', this.toggleCaption.bind(this));
    }
  }, {
    key: 'toggleToggle',
    value: function toggleToggle() {
      if (this.window.matchMedia('(min-width: ' + this.thresholdWidth + 'px)').matches) {
        this.removeToggle();
      } else {
        this.restoreToggle();
      }
    }
  }, {
    key: 'removeToggle',
    value: function removeToggle() {
      var $toggle = this.$caption.querySelector('.caption-text__toggle');

      if ($toggle) {
        this.$caption.innerHTML = this.originalHtml;
      }
    }
  }, {
    key: 'restoreToggle',
    value: function restoreToggle() {
      var $toggle = this.$caption.querySelector('.caption-text__toggle');

      if (!$toggle) {
        this.toggleCaption();
      }
    }
  }]);

  return ToggleableCaption;
}();

},{"../libs/elife-utils":35,"text-clipper":129}],33:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SideBySideView = require('./SideBySideView');
var utils = require('../libs/elife-utils')();

module.exports = function () {
  function ViewSelector($elm) {
    var _this = this;

    var _window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;

    var doc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;

    _classCallCheck(this, ViewSelector);

    if (!$elm) {
      return;
    }

    this.window = _window;
    this.doc = doc;
    this.$elm = $elm;
    this.$jumpLinksList = this.$elm.querySelector('.view-selector__jump_links');
    this.jumpLinks = this.$elm.querySelectorAll('.view-selector__jump_link');
    this.$jumpLinksToggle = this.$elm.querySelector('.view-selector__jump_links_header');
    this.cssFixedClassName = 'view-selector--fixed';

    if (this.sideBySideViewAvailable()) {
      var $header = this.doc.getElementById('siteHeader');
      this.$global = this.doc.querySelector('.global-inner');
      this.sideBySideView = new SideBySideView(this.$global, this.$elm.dataset.sideBySideLink, $header, this.window, this.doc);

      this.insertSideBySideListItem();
    }

    this.mainTarget = this.doc.querySelector('.main');
    if (!this.mainTarget) {
      return;
    }

    // matches top padding in scss
    var topSpaceWhenFixed = 30;

    this.collapsibleSectionHeadings = ViewSelector.getAllCollapsibleSectionHeadings(this.doc);
    this.isScrollingHandled = false;

    var scrollingHandler = utils.throttle(function () {
      _this.handleScrolling();
    }, 50);

    if (this.isViewportWideEnoughForJumpMenu()) {
      this.startHandlingScrolling(scrollingHandler, this.handleScrolling);
    }

    this.window.addEventListener('resize', utils.throttle(function () {
      _this.handleResize(scrollingHandler, _this.handleScrolling);
    }, 200));

    this.elmYOffset = this.$elm.offsetTop - topSpaceWhenFixed;
    if (this.$jumpLinksToggle) {
      this.$jumpLinksToggle.addEventListener('click', this.toggleJumpLinks.bind(this));
      this.toggleJumpLinks();
    }
  }

  _createClass(ViewSelector, [{
    key: 'isViewportWideEnoughForJumpMenu',
    value: function isViewportWideEnoughForJumpMenu() {
      return this.window.matchMedia('(min-width: 1200px)').matches;
    }
  }, {
    key: 'handleResize',
    value: function handleResize(scrollingHandler, scrollingHandlerImmediate) {
      var isViewportWideEnoughForJumpMenu = this.isViewportWideEnoughForJumpMenu();
      if (!this.isScrollingHandled && isViewportWideEnoughForJumpMenu) {
        this.startHandlingScrolling(scrollingHandler, scrollingHandlerImmediate);
      } else if (this.isScrollingHandled && !isViewportWideEnoughForJumpMenu) {
        this.stopHandlingScrolling(scrollingHandler);
      }
    }
  }, {
    key: 'startHandlingScrolling',
    value: function startHandlingScrolling(scrollingHandler, scrollingHandlerImmediate) {
      this.window.addEventListener('scroll', scrollingHandler);
      this.isScrollingHandled = true;
      scrollingHandlerImmediate.call(this);
    }
  }, {
    key: 'stopHandlingScrolling',
    value: function stopHandlingScrolling(scrollingHandler) {
      this.window.removeEventListener('scroll', scrollingHandler);
      this.isScrollingHandled = false;
    }
  }, {
    key: 'handleScrolling',
    value: function handleScrolling() {
      if (this.$jumpLinksList) {
        this.handleHighlighting(utils.closest);
      }

      this.handlePositioning();
    }
  }, {
    key: 'handleHighlighting',
    value: function handleHighlighting(findClosest) {
      var $firstViewableHeading = this.findFirstInView(this.collapsibleSectionHeadings, this.doc, this.window);
      var firstLogicalHeadingText = this.collapsibleSectionHeadings[0] ? this.collapsibleSectionHeadings[0].innerHTML : '';
      var $section = ViewSelector.findSectionForLinkHighlight($firstViewableHeading, firstLogicalHeadingText, findClosest);

      if ($section && typeof $section.id === 'string') {
        var $target = ViewSelector.findLinkToHighlight(this.$jumpLinksList, '[href="#' + $section.id + '"]');
        if ($target) {
          ViewSelector.updateHighlighting($target, this.jumpLinks);
        }
      }
    }
  }, {
    key: 'findFirstInView',


    /**
     * Returns the first HTMLElement in the list that is in view
     * @param {NodeList|Array} elementList
     * @param {Document} doc
     * @param {Window} win
     * @returns {(HTMLElement|null)}
     */
    value: function findFirstInView(elementList, doc, win) {
      // Ensure elements is an array
      var elements = [].slice.call(elementList);
      var $found = null;
      elements.forEach(function ($el) {
        if (!$found) {
          if (utils.isTopInView($el, doc, win)) {
            $found = $el;
          }
        }
      });

      return $found;
    }
  }, {
    key: 'handlePositioning',
    value: function handlePositioning() {
      // If it's position is fixed
      if (this.$elm.classList.contains(this.cssFixedClassName)) {

        // Allow it to scroll again if it could keep its position & not scroll off top of screen
        if (this.window.pageYOffset < this.elmYOffset) {
          this.$elm.classList.remove(this.cssFixedClassName);
          return;
        }

        // Allow it to scroll again if it would otherwise over-/under-lay following element
        var bottomOfMain = this.mainTarget.getBoundingClientRect().bottom;
        if (bottomOfMain < this.$elm.offsetHeight) {
          var amountToNudgeUp = bottomOfMain - this.$elm.offsetHeight;
          this.$elm.style.top = amountToNudgeUp + 'px';
          return;
        }

        // Ensure top of component is not off top of screen once bottom of main is off screen bottom
        // Safety net: required because a fast scroll may prevent all code running as desired.
        if (bottomOfMain >= this.window.innerHeight) {
          this.$elm.style.top = '0px';
        }

        return;
      }

      // Otherwise fix its position if it would otherwise scroll off the top of the screen
      if (this.window.pageYOffset >= this.elmYOffset) {
        this.$elm.classList.add(this.cssFixedClassName);
        this.$elm.style.top = '0px';
      }
    }
  }, {
    key: 'toggleJumpLinks',
    value: function toggleJumpLinks() {
      this.$jumpLinksList.classList.toggle('visuallyhidden');
      this.$jumpLinksToggle.classList.toggle('view-selector__jump_links_header--closed');
    }
  }, {
    key: 'sideBySideViewAvailable',
    value: function sideBySideViewAvailable() {
      var _this2 = this;

      var link = this.$elm.dataset.sideBySideLink;
      var isLinkProvided = function isLinkProvided() {
        return !!(link && link.match(/^https:\/\/.*$/));
      };
      var isSideBySideViewLikelySupported = function isSideBySideViewLikelySupported() {
        try {
          if (!(_this2.window.CSS && _this2.window.CSS.supports)) {
            return false;
          }
        } catch (e) {
          return false;
        }

        // Proxy for IE/Edge, that Lens doesn't support. Dirty :-(
        return _this2.window.CSS.supports('text-orientation', 'sideways') || _this2.window.CSS.supports('-webkit-text-orientation', 'sideways');
      };

      return isLinkProvided() && isSideBySideViewLikelySupported();
    }
  }, {
    key: 'insertSideBySideListItem',
    value: function insertSideBySideListItem() {
      var _this3 = this;

      var $list = this.doc.querySelector('.view-selector__list');
      var $jumpList = this.doc.querySelector('.view-selector__list-item--jump');
      var $listItem = utils.buildElement('li', ['view-selector__list-item', 'view-selector__list-item--side-by-side'], '', $list, $jumpList);
      var $link = utils.buildElement('a', ['view-selector__link', 'view-selector__link--side-by-side'], '<span>Side by side</span>', $listItem);
      $link.setAttribute('href', this.$elm.dataset.sideBySideLink);
      $link.addEventListener('click', function (e) {
        e.preventDefault();
        _this3.sideBySideView.open();
      });
      return $listItem;
    }
  }], [{
    key: 'getAllCollapsibleSectionHeadings',
    value: function getAllCollapsibleSectionHeadings(doc) {
      return doc.querySelectorAll('[data-behaviour="ArticleSection"] > .article-section__header .article-section__header_text');
    }
  }, {
    key: 'updateHighlighting',
    value: function updateHighlighting($target, jumpLinksList) {
      ViewSelector.clearJumpLinkHighlight(jumpLinksList);
      ViewSelector.highlightJumpLink($target);
    }
  }, {
    key: 'findSectionForLinkHighlight',
    value: function findSectionForLinkHighlight($heading, firstHeadingText, findClosest) {
      if (!$heading) {
        return;
      }

      // If the heading is near or off the top of the window, use the section for that heading,
      // otherwise, use the section before the section for that heading
      if ($heading.innerHTML === firstHeadingText || $heading.getBoundingClientRect().top < 48) {
        return findClosest.call(null, $heading, '.article-section');
      }

      return findClosest.call(null, $heading, '.article-section').previousElementSibling;
    }
  }, {
    key: 'clearJumpLinkHighlight',
    value: function clearJumpLinkHighlight(jumpLinksList) {
      var linksList = [].slice.call(jumpLinksList);
      linksList.forEach(function ($link) {
        $link.classList.remove('view-selector__jump_link--active');
      });
    }
  }, {
    key: 'findLinkToHighlight',
    value: function findLinkToHighlight($linksList, selector) {
      return $linksList.querySelector(selector);
    }
  }, {
    key: 'highlightJumpLink',
    value: function highlightJumpLink($jumpLink) {
      $jumpLink.classList.add('view-selector__jump_link--active');
    }
  }]);

  return ViewSelector;
}();

},{"../libs/elife-utils":35,"./SideBySideView":29}],34:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

module.exports = function () {
  function ViewerModal($elm) {
    _classCallCheck(this, ViewerModal);

    this.$elm = $elm;
    this.$prev = document.createElement('div');
    this.$next = document.createElement('div');

    // build the modal
    this.build();

    // events
    this.$prev.addEventListener('click', this.prev);
    this.$next.addEventListener('click', this.next);
  }

  _createClass(ViewerModal, [{
    key: 'build',
    value: function build() {
      //
    }
  }, {
    key: 'prev',
    value: function prev(e) {
      e.preventDefault();
    }
  }, {
    key: 'next',
    value: function next(e) {
      e.preventDefault();
    }
  }, {
    key: 'close',
    value: function close() {
      //
    }
  }]);

  return ViewerModal;
}();

},{}],35:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

module.exports = function () {
  'use strict';

  /**
   * Builds and returns specified HTML element, optionally adding it to the DOM.
   *
   *
   *
   * @param {string} elName Name of the HTML element to build
   * @param {Array<string>} [cssClasses] CSS class name(s) to set on the element
   * @param {string} [textContent] Textual content of the element
   * @param {string|Element} [parent] Parent element to attach to
   * @param {string|Element|boolean} [attachBefore] The sibling before which to attach the element:
   *  true: following sibling is the parent's first element child
   *  HTMLElement: explicitly supplied following sibling
   *  string: CSS selector to use to find the following sibling
   *
   * @returns {Element}
   */

  function buildElement(elName, cssClasses, textContent, parent, attachBefore) {

    var $el = document.createElement(elName);
    var $parent = typeof parent === 'string' ? document.querySelector(parent) : parent;

    // Work out what the new element's following sibling will be, based on value of attachBefore.
    var $followingSibling = function () {

      if (!!attachBefore) {

        if (typeof attachBefore === 'boolean') {
          if ($parent.firstElementChild instanceof HTMLElement) {
            return $parent.firstElementChild;
          } else {
            return null;
          }
        } else if (typeof attachBefore === 'string') {
          return $parent.querySelector(attachBefore);
        } else if (attachBefore instanceof HTMLElement) {
          return attachBefore;
        }
      }
    }();

    if (Array.isArray(cssClasses)) {
      cssClasses.forEach(function (cssClass) {
        $el.classList.add(cssClass);
      });
    }

    if (textContent) {
      $el.innerHTML = textContent;
    }

    if ($parent) {
      if ($followingSibling) {
        if ($followingSibling.parentNode !== $parent) {
          throw new ReferenceError('Trying to attach an element with respect to an element sibling, but the two elements do not share a common parent.');
        }

        $parent.insertBefore($el, $followingSibling);
      } else {
        $parent.appendChild($el);
      }
    }

    return $el;
  }

  /**
   * uniqueIds.get()
   * uniqueIds.isValid()
   */
  var uniqueIds = function uniqueIds() {

    /** @class */
    var UniqueIdentifiers = function () {

      /** @constructor */
      function UniqueIdentifiers() {
        _classCallCheck(this, UniqueIdentifiers);

        this.used = [];
      }

      /**
       * Returns true if candidate is unique to this object, and also to any optional document supplied.
       * @param {string} candidate Candidate id string under evaluation
       * @param {HTMLDocument} [document]
       * @return {boolean}
       */


      _createClass(UniqueIdentifiers, [{
        key: 'isValid',
        value: function isValid(candidate, document) {
          // Compulsory check that id is unique to this object's knowledge.
          if (this.used.indexOf(candidate) > -1) {
            return false;
          }

          // Optional check to see if id is unique in the DOM.
          if (!!document) {
            if (!!document.getElementById && typeof document.getElementById === 'function' && document.getElementById(candidate)) {
              return false;
            }
          }

          return true;
        }

        /**
         * Gets a unique id with optional prefix.
         *
         * @param {string} [prefix] Prefix to use for the id
         * @param {HTMLDocument} [document] Enables checking for the id's uniqueness within the DOM
         * @returns {string}
         */

      }, {
        key: 'get',
        value: function get(prefix, document) {
          var _prefix = '' + prefix || 'default_';
          var random = ('' + Math.random()).replace(/\./, '');
          var candidate = _prefix + random;
          if (this.isValid(candidate, document)) {
            this.used.push(candidate);
            return candidate;
          }

          this.get(prefix, document);
        }
      }]);

      return UniqueIdentifiers;
    }();

    return new UniqueIdentifiers();
  }();

  /**
   * Simple XHR implementation for getting JSON data.
   *
   * @param url
   * @returns {Promise}
   */
  function loadData(url) {
    return new Promise(function resolver(resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.addEventListener('load', function () {
        resolve(xhr.responseText);
      });
      xhr.addEventListener('error', reject);
      xhr.open('GET', url);
      xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      xhr.send();
    });
  }

  /**
   * Updates the CSS transform's translate function on the element in a vendor-prefix-aware fashion.
   *
   * Because of the way CSS transformations are combined into a matrix, this may not work
   * as expected if other CSS transformations are also applied to the same element.
   *
   * @param {HTMLElement} $el The element to apply the transformation to.
   * @param {Array} offset The offset for both axes, expressed as [x, y], e.g. [0, '20px']
   */
  function updateElementTranslate($el, offset) {
    if (!($el instanceof HTMLElement && Array.isArray(offset))) {
      return false;
    }

    function calcOffset(value) {
      if (!value) {
        return '0px';
      }

      if (typeof value === 'number') {
        return value + 'px';
      }

      if (typeof value === 'string') {
        value += 'px';
        return value.replace(/((px)+)$/, 'px');
      }
    }

    var offsetX = calcOffset(offset[0]);
    var offsetY = calcOffset(offset[1]);

    var props = ['webkitTransform', 'mozTransform', 'msTransform', 'oTransform', 'transform'];
    props.forEach(function (prop) {
      // Only set the vendor prefixed properties where they are supported
      if ($el.style[prop] !== undefined) {
        $el.style[prop] = 'translate(' + offsetX + ', ' + offsetY + ')';
      }
    });
  }

  function _getValueFromPxString(pxString) {
    if (pxString === '0') {
      return 0;
    }

    var numberFromString = parseFloat(pxString);
    if (isNaN(numberFromString)) {
      throw new Error('Can\'t parse argument as a float: ' + pxString);
    }

    return Math.round(numberFromString);
  }

  function _getZeroAwarePxStringFromValue(value) {
    if (value === 0) {
      return '' + value;
    }

    return value + 'px';
  }

  /**
   * Return an '[n]px' string, adjusting a base value by the amount and operation supplied.
   *
   * Examples:
   *  - adjustPxString('97px', 8) returns '105px'
   *  - adjustPxString('97px', 8, `subtract') returns '89px'
   *  - adjustPxString('100px', 20, 'divide') returns '5px'
   *  - adjustPxString('50px', 3, 'multiply') returns '150px'
   *
   * @param {String} pxString The string representing the original quantity, e.g. '97px'
   * @param {Number} adjustment The numeric adjustment to make, e.g. 8
   * @param {('add'|'subtract'|'multiply'|'divide')} requestedOperation
   * @returns {string} The modified value, e.g.: '105px'
   */
  function adjustPxString(pxString, adjustment, requestedOperation) {
    var originalSize = _getValueFromPxString(pxString);
    var adjustedSize = originalSize;
    var operation = 'add';
    if (['subtract', 'multiply', 'divide'].indexOf(requestedOperation) > -1) {
      operation = requestedOperation;
    }

    switch (operation) {
      case 'add':
        adjustedSize = originalSize + adjustment;
        break;
      case 'subtract':
        adjustedSize = originalSize - adjustment;
        break;
      case 'multiply':
        adjustedSize = originalSize * adjustment;
        break;
      case 'divide':
        adjustedSize = originalSize / adjustment;
        break;
      default:
        break;
    }
    return _getZeroAwarePxStringFromValue(adjustedSize);
  }

  /**
   * Return the supplied value with the sign flipped, or '0' if supplied ` a zero px string
   *
   * For example: invertPxString('97px') returns '-97px'
   * For example: invertPxString('-97px') returns '97px'
   * For example: invertPxString('0px') returns '0'
   *
   * @param {String} pxString The string representing the original quantity, e.g. '97px'
   * @returns {string} The modified value, as a string, e.g.: '-97px'
   */
  function invertPxString(pxString) {
    var adjustedSize = _getValueFromPxString(pxString) * -1;
    return _getZeroAwarePxStringFromValue(adjustedSize);
  }

  /**
   * Returns true if $prospectiveDescendant is, or is a descendant of $prospectiveParent.
   *
   * @param {Node} $prospectiveParent el to test as a parent of the $prospectiveDescendant
   * @param {Node} $prospectiveDescendant el to test as descendant of the $prospectiveParent
   * @returns {boolean} Whether the $prospectiveDescendant is, or descends from $prospectiveParent
   */
  function areElementsNested($prospectiveParent, $prospectiveDescendant) {
    if (!($prospectiveParent instanceof Node && $prospectiveDescendant instanceof Node)) {
      return false;
    }

    var relationship = $prospectiveParent.compareDocumentPosition($prospectiveDescendant);
    return !!(relationship & $prospectiveParent.DOCUMENT_POSITION_CONTAINED_BY || relationship === 0);
  }

  /**
   * Indicates whether an HTML element with a given id is found as/within a specific chunk of html
   *
   * @param {String} id The id  of the HTML element to search for
   * @param {HTMLElement} $section The element to search/search within
   * @param {HTMLDocument} doc
   * @returns {boolean} true if element with id is $section, or is contained within $section
   */
  function isIdOfOrWithinSection(id, $section, doc) {
    if (id.search(/https?:\/\//) === 0) {
      return false;
    }

    if (id === $section.id) {
      return true;
    }

    var $fragWithId = doc.getElementById(id);
    return areElementsNested($section, $fragWithId);
  }

  /**
   * Debounce
   */
  function debounce(callback, wait) {
    var context = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this;
    // jshint ignore:line
    var timeout = null;
    var callbackArgs = null;

    var later = function later() {
      return callback.apply(context, callbackArgs);
    };

    return function () {
      callbackArgs = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  /**
   * Closest parent
   * Source: https://developer.mozilla.org/en-US/docs/Web/API/Element/closest
   * @param el
   * @param s
   * @returns {*}
   */
  function closest(el, s) {
    var matches = (el.document || el.ownerDocument).querySelectorAll(s);
    var i = void 0;
    do {
      i = matches.length;

      // jscs:disable disallowEmptyBlocks
      while (--i >= 0 && matches.item(i) !== el) {} // jshint ignore:line

      // jscs:enable disallowEmptyBlocks
    } while (i < 0 && (el = el.parentElement));

    return el;
  }

  /**
   * Returns the ordinal of an element's location within any siblings.
   * @param {HTMLElement} $el The element to assess the position of
   * @throws TypeError if the argument is not an HTMLElement
   * @returns {number}
   */
  function getOrdinalAmongstSiblingElements($el) {
    if ($el instanceof HTMLElement) {
      var position = 1;
      var previous = $el.previousElementSibling;
      while (previous) {
        position += 1;
        previous = previous.previousElementSibling;
      }

      return position;
    }

    throw new TypeError('Expected HTMLElement');
  }

  function loadJavaScript(uri) {
    var integrity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return new Promise(function (resolve, reject) {
      var script = document.createElement('script');

      script.src = uri;
      if (integrity) {
        script.integrity = integrity;
        script.crossOrigin = 'anonymous';
      }

      script.addEventListener('load', function () {
        resolve(script);
      }, false);

      script.addEventListener('error', function () {
        reject(script);
      }, false);

      document.body.appendChild(script);
    });
  }

  function loadStyleSheet(uri) {
    var integrity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return new Promise(function (resolve, reject) {
      var link = document.createElement('link');

      link.setAttribute('rel', 'stylesheet');
      link.href = uri;
      if (integrity) {
        link.integrity = integrity;
        link.crossOrigin = 'anonymous';
      }

      link.addEventListener('load', function () {
        resolve(link);
      }, false);

      link.addEventListener('error', function () {
        reject(link);
      }, false);

      document.head.appendChild(link);
    });
  }

  /**
   * Deferred promise
   */
  function defer() {
    var result = {};
    result.promise = new Promise(function (resolve, reject) {
      result.resolve = function (value) {
        resolve(value);
      };

      result.reject = function (value) {
        reject(value);
      };
    });

    return result;
  }

  /**
   * Flattens the upper most nested level of a nested array
   *
   * Examples:
   *  - flatten( [1,2,3,[4]] ) -> [1, 2, 3, 4]
   *  - flatten( [1,2,3,[4, [5]]] ) -> [1, 2, 3, 4, [5]]
   * @param {Array<*>} input
   * @returns {Array<*>} with one fewer level of nesting
   */
  function flatten(input) {
    var _ref;

    return (_ref = []).concat.apply(_ref, _toConsumableArray(input));
  }

  function remoteDoc(url, window) {
    var current = window.location.href.split('#')[0];
    url = url.split('#')[0];

    if (url === current) {
      return Promise.resolve(window.document);
    }

    if (window.remoteDocuments === undefined) {
      window.remoteDocuments = {};
    }

    if (!(url in window.remoteDocuments)) {
      window.remoteDocuments[url] = loadData(url).then(function (data) {
        var wrapper = window.document.createElement('div');
        wrapper.innerHTML = data;
        return wrapper;
      });
    }

    return window.remoteDocuments[url];
  }

  /**
   * Add CSS styling to DOM element.
   *
   * @param $el
   * @param styles
   * @returns {*}
   */
  function _addStylesToElement($el, styles) {
    for (var style in styles) {
      if (styles.hasOwnProperty(style)) {
        $el.style[style] = styles[style];
      }
    }

    return $el;
  }

  /**
   * Wrap elements in with various options.
   *
   * @param $el
   * @param tag
   * @param className
   * @param styles
   * @param fn
   * @returns {Element}
   */
  function wrapElements($el, tag, className, styles, fn) {
    var $children = Array.isArray($el) ? $el : [$el];
    var classNames = Array.isArray(className) ? className : [className];
    var $container = buildElement(tag, classNames);
    if (styles) {
      _addStylesToElement($container, styles);
    }

    $children.forEach(function (child) {
      return $container.appendChild(child);
    });
    return fn ? fn($container) : $container;
  }

  function eventCreator(name, detail) {
    var event = void 0;
    try {
      event = new CustomEvent(name, { detail: detail });
    } catch (e) {
      // CustomEvent not supported, do it the old fashioned way
      event = document.createEvent(name);
      event.initCustomEvent(name, true, true, { detail: detail });
    }

    return event;
  }

  /**
   * Jump to element on page.
   *
   * @param link
   */
  function jumpToAnchor(link) {
    if (history.replaceState) {
      window.location.href = link.href;
      history.replaceState(null, null, link.href);
    } else {
      var $el = document.getElementById(link.hash.slice(1));
      if ($el) {
        window.scrollTo(0, $el.offsetTop);
      }
    }
  }

  function create$pageOverlay($parent, $followingSibling, id) {
    // element already exists
    if (document.getElementById(id)) {
      return;
    }

    var $overlay = buildElement('div', ['overlay', 'hidden'], '', $parent, $followingSibling);
    if (id) {
      $overlay.id = id;
    }

    return $overlay;
  }

  /**
   *
   * Determines if the top of an element is within the viewport bounds
   *
   * @param {HTMLElement} $elm
   * @param {Document} doc
   * @param win
   * @returns {boolean} true if the top of the element is within the viewport bounds
   */
  function isTopInView($elm, doc, win) {
    var rect = $elm.getBoundingClientRect();
    var html = doc.documentElement;
    return rect.top >= 0 && rect.top <= (win.innerHeight || html.clientHeight) && rect.left >= 0 && rect.left <= (win.innerWidth || html.clientWidth);
  }

  /**
   * Throttle a function to run with specified interval
   *
   * The function should be an arrow function to ensure scope is correct
   * @param {Function} fn The arrow function to throttle
   * @param {Number} thresholdInMs The minimum interval between calls to the thottled function
   * @returns {Function}
   */
  function throttle(fn) {
    var thresholdInMs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;

    var last = void 0;
    var deferTimer = void 0;
    return function () {
      var now = +new Date();
      var args = arguments;
      if (last && now < last + thresholdInMs) {

        // hold on to it
        window.clearTimeout(deferTimer);
        deferTimer = window.setTimeout(function () {
          last = now;
          fn.apply(null, args);
        }, thresholdInMs);
      } else {
        last = now;
        fn.apply(null, args);
      }
    };
  }

  /**
   * Returns true if the viewport is wide enough to display multiple columns (>=900px)
   * @param {Window} window
   * @returns {boolean} true if the viewport is at least 900px wide
   */
  function isMultiColumnDisplay(window) {
    return window.matchMedia('(min-width: 900px)').matches;
  }

  /**
   * Returns true if the supplied element is a collapsible article section
   * @param {HTMLElement} $elm The element under test
   * @returns {boolean} true if the element under test is a collapisble article section
   */
  function isCollapsibleArticleSection($elm) {
    return $elm.dataset && $elm.dataset.behaviour && $elm.dataset.behaviour.indexOf('ArticleSection') > -1;
  }

  /**
   * Returns true if the supplied element is a collapsed article section
   * @param {HTMLElement} $elm THe element under test
   * @returns {boolean} true if the supplied element is a collapsed article section
   */
  function isCollapsedArticleSection($elm) {
    return $elm.classList.contains('article-section--collapsed');
  }

  /**
   * Returns the value of a data-item-type attribute on or within $elm
   * @param $elm {HTMLElement} An element expected to hold or wrap a data-item-type attribute
   * @return {String|null}
   */
  function getItemType($elm) {
    if ($elm.dataset.itemType) {
      return $elm.dataset.itemType;
    }

    var $target = $elm.querySelector('[data-item-type]');
    if ($target) {
      return $target.dataset.itemType;
    }

    return null;
  }

  function expandCollapsedSections(parent) {
    var collapsed = parent.querySelectorAll('.article-section--collapsed');
    [].slice.call(collapsed).forEach(function ($section) {
      $section.dispatchEvent(eventCreator('expandsection'));
    });
  }

  function calcScrollbarWidth() {
    var inner = document.createElement('p');
    inner.style.width = '100%';

    var outer = document.createElement('div');
    outer.style.position = 'absolute';
    outer.style.left = '0px';
    outer.style.visibility = 'hidden';
    outer.style.width = '100px';
    outer.style.overflow = 'hidden';
    outer.appendChild(inner);

    document.body.appendChild(outer);

    var widthWhenNoScrollBars = inner.offsetWidth;
    outer.style.overflow = 'scroll';
    var widthWhenScrollBars = inner.offsetWidth;
    if (widthWhenNoScrollBars === widthWhenScrollBars) {
      widthWhenScrollBars = outer.clientWidth;
    }

    document.body.removeChild(outer);

    return widthWhenNoScrollBars - widthWhenScrollBars;
  }

  function getCookieValue(cookieSought, cookies) {
    var found = '';
    cookies.split('; ').forEach(function (cookie) {
      if (cookie.indexOf(cookieSought) === 0) {
        var re = new RegExp(cookieSought + '=([^;]*)');
        var cookieMatch = cookie.match(re)[1];
        found = decodeURIComponent(cookieMatch);
      }
    });

    return found;
  }

  function logError(window, e, message) {
    window.console.error(message + ':' + e);
    if (_typeof(window.newrelic) === 'object') {
      window.newrelic.noticeError(e);
    }
  }

  return {
    adjustPxString: adjustPxString,
    areElementsNested: areElementsNested,
    isIdOfOrWithinSection: isIdOfOrWithinSection,
    buildElement: buildElement,
    calcScrollbarWidth: calcScrollbarWidth,
    closest: closest,
    create$pageOverlay: create$pageOverlay,
    debounce: debounce,
    eventCreator: eventCreator,
    expandCollapsedSections: expandCollapsedSections,
    getItemType: getItemType,
    loadJavaScript: loadJavaScript,
    loadStyleSheet: loadStyleSheet,
    defer: defer,
    flatten: flatten,
    getCookieValue: getCookieValue,
    invertPxString: invertPxString,
    isCollapsedArticleSection: isCollapsedArticleSection,
    isCollapsibleArticleSection: isCollapsibleArticleSection,
    isTopInView: isTopInView,
    isMultiColumnDisplay: isMultiColumnDisplay,
    jumpToAnchor: jumpToAnchor,
    loadData: loadData,
    getOrdinalAmongstSiblingElements: getOrdinalAmongstSiblingElements,
    remoteDoc: remoteDoc,
    throttle: throttle,
    uniqueIds: uniqueIds,
    updateElementTranslate: updateElementTranslate,
    wrapElements: wrapElements,
    logError: logError
  };
};

},{}],36:[function(require,module,exports){
'use strict';

require('core-js/es6/promise');
require('core-js/es6/set');
require('core-js/fn/object/assign');
require('core-js/fn/symbol');
require('core-js/fn/symbol/iterator');
require('element-closest');

module.exports = function polyfills() {

  (function () {

    if (typeof window.CustomEvent === "function") return false;

    function CustomEvent(event, params) {
      params = params || { bubbles: false, cancelable: false, detail: undefined };
      var evt = document.createEvent('CustomEvent');
      evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
      return evt;
    }

    CustomEvent.prototype = window.Event.prototype;

    window.CustomEvent = CustomEvent;
  })();
}();

},{"core-js/es6/promise":38,"core-js/es6/set":39,"core-js/fn/object/assign":40,"core-js/fn/symbol":41,"core-js/fn/symbol/iterator":42,"element-closest":127}],37:[function(require,module,exports){
'use strict';

require('./libs/polyfills');

document.querySelector('html').classList.add('js');

var Components = {};

// import modules into the list of Components.
Components.AboutProfiles = require('./components/AboutProfiles');
Components.AnnotationTeaser = require('./components/AnnotationTeaser');
Components.ArticleDownloadLinksList = require('./components/ArticleDownloadLinksList');
Components.ArticleSection = require('./components/ArticleSection');
Components.AssetNavigation = require('./components/AssetNavigation');
Components.AssetViewer = require('./components/AssetViewer');
Components.AudioPlayer = require('./components/AudioPlayer');
Components.Carousel = require('./components/Carousel');
Components.ContentHeader = require('./components/ContentHeader');
Components.CookieOverlay = require('./components/CookieOverlay');
Components.DelegateBehaviour = require('./components/DelegateBehaviour');
Components.FilterPanel = require('./components/FilterPanel');
Components.FragmentHandler = require('./components/FragmentHandler');
Components.Highlights = require('./components/Highlights');
Components.HypothesisLoader = require('./components/HypothesisLoader');
Components.HypothesisOpener = require('./components/HypothesisOpener');
Components.LoginControl = require('./components/LoginControl');
Components.MainMenu = require('./components/MainMenu');
Components.Math = require('./components/Math');
Components.MediaChapterListingItem = require('./components/MediaChapterListingItem');
Components.Metrics = require('./components/Metrics');
Components.Pager = require('./components/Pager');
Components.Popup = require('./components/Popup');
Components.SearchBox = require('./components/SearchBox');
Components.SectionListingLink = require('./components/SectionListingLink');
Components.SelectNav = require('./components/SelectNav');
Components.SideBySideView = require('./components/SideBySideView');
Components.SiteHeader = require('./components/SiteHeader');
Components.SpeechBubble = require('./components/SpeechBubble');
Components.ToggleableCaption = require('./components/ToggleableCaption');
Components.ViewerModal = require('./components/ViewerModal');
Components.ViewSelector = require('./components/ViewSelector');

// App
var Elife = function Elife() {

  var singletons = function () {
    var registered = [];

    function isRegistered(componentName) {
      return registered.indexOf(componentName) > -1;
    }

    function register(componentName) {
      registered.push(componentName);
    }

    return {
      isRegistered: isRegistered,
      register: register
    };
  }();

  function initialiseComponent($component) {
    var inputBehaviour = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    var behaviour = inputBehaviour ? inputBehaviour : $component.getAttribute('data-behaviour');

    // When present, data-behaviour contains a space-separated list of handlers for that component
    var handlers = behaviour.trim().split(' ');
    handlers.forEach(function (handler) {
      if (!singletons.isRegistered(handler)) {
        if (!!Components[handler] && typeof Components[handler] === 'function') {
          new Components[handler]($component, window, window.document);
          if (Components[handler].isSingleton) {
            singletons.register(handler);
          }
        }
      }
    });

    $component.dataset.behaviourInitialised = true;
  }

  Components.DelegateBehaviour.setInitialiseComponent(initialiseComponent);

  var components = document.querySelectorAll('[data-behaviour]');
  if (components) {
    [].forEach.call(components, function (el) {
      return initialiseComponent(el);
    });
  }

  if ('MutationObserver' in window) {
    var observer = new MutationObserver(function () {
      var components = document.querySelectorAll('[data-behaviour]:not([data-behaviour-initialised])');
      if (components) {
        [].forEach.call(components, function (el) {
          return initialiseComponent(el);
        });
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
};

new Elife();

},{"./components/AboutProfiles":1,"./components/AnnotationTeaser":2,"./components/ArticleDownloadLinksList":3,"./components/ArticleSection":4,"./components/AssetNavigation":5,"./components/AssetViewer":6,"./components/AudioPlayer":7,"./components/Carousel":9,"./components/ContentHeader":10,"./components/CookieOverlay":11,"./components/DelegateBehaviour":12,"./components/FilterPanel":13,"./components/FragmentHandler":14,"./components/Highlights":15,"./components/HypothesisLoader":16,"./components/HypothesisOpener":17,"./components/LoginControl":18,"./components/MainMenu":19,"./components/Math":20,"./components/MediaChapterListingItem":21,"./components/Metrics":22,"./components/Pager":24,"./components/Popup":25,"./components/SearchBox":26,"./components/SectionListingLink":27,"./components/SelectNav":28,"./components/SideBySideView":29,"./components/SiteHeader":30,"./components/SpeechBubble":31,"./components/ToggleableCaption":32,"./components/ViewSelector":33,"./components/ViewerModal":34,"./libs/polyfills":36}],38:[function(require,module,exports){
require('../modules/es6.object.to-string');
require('../modules/es6.string.iterator');
require('../modules/web.dom.iterable');
require('../modules/es6.promise');
module.exports = require('../modules/_core').Promise;
},{"../modules/_core":52,"../modules/es6.object.to-string":119,"../modules/es6.promise":120,"../modules/es6.string.iterator":122,"../modules/web.dom.iterable":126}],39:[function(require,module,exports){
require('../modules/es6.object.to-string');
require('../modules/es6.string.iterator');
require('../modules/web.dom.iterable');
require('../modules/es6.set');
module.exports = require('../modules/_core').Set;
},{"../modules/_core":52,"../modules/es6.object.to-string":119,"../modules/es6.set":121,"../modules/es6.string.iterator":122,"../modules/web.dom.iterable":126}],40:[function(require,module,exports){
require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;
},{"../../modules/_core":52,"../../modules/es6.object.assign":118}],41:[function(require,module,exports){
require('../../modules/es6.symbol');
require('../../modules/es6.object.to-string');
require('../../modules/es7.symbol.async-iterator');
require('../../modules/es7.symbol.observable');
module.exports = require('../../modules/_core').Symbol;
},{"../../modules/_core":52,"../../modules/es6.object.to-string":119,"../../modules/es6.symbol":123,"../../modules/es7.symbol.async-iterator":124,"../../modules/es7.symbol.observable":125}],42:[function(require,module,exports){
require('../../modules/es6.string.iterator');
require('../../modules/web.dom.iterable');
module.exports = require('../../modules/_wks-ext').f('iterator');
},{"../../modules/_wks-ext":114,"../../modules/es6.string.iterator":122,"../../modules/web.dom.iterable":126}],43:[function(require,module,exports){
module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};
},{}],44:[function(require,module,exports){
// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = require('./_wks')('unscopables')
  , ArrayProto  = Array.prototype;
if(ArrayProto[UNSCOPABLES] == undefined)require('./_hide')(ArrayProto, UNSCOPABLES, {});
module.exports = function(key){
  ArrayProto[UNSCOPABLES][key] = true;
};
},{"./_hide":64,"./_wks":115}],45:[function(require,module,exports){
module.exports = function(it, Constructor, name, forbiddenField){
  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};
},{}],46:[function(require,module,exports){
var isObject = require('./_is-object');
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};
},{"./_is-object":72}],47:[function(require,module,exports){
// false -> Array#indexOf
// true  -> Array#includes
var toIObject = require('./_to-iobject')
  , toLength  = require('./_to-length')
  , toIndex   = require('./_to-index');
module.exports = function(IS_INCLUDES){
  return function($this, el, fromIndex){
    var O      = toIObject($this)
      , length = toLength(O.length)
      , index  = toIndex(fromIndex, length)
      , value;
    // Array#includes uses SameValueZero equality algorithm
    if(IS_INCLUDES && el != el)while(length > index){
      value = O[index++];
      if(value != value)return true;
    // Array#toIndex ignores holes, Array#includes - not
    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
      if(O[index] === el)return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};
},{"./_to-index":106,"./_to-iobject":108,"./_to-length":109}],48:[function(require,module,exports){
// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = require('./_cof')
  , TAG = require('./_wks')('toStringTag')
  // ES3 wrong here
  , ARG = cof(function(){ return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function(it, key){
  try {
    return it[key];
  } catch(e){ /* empty */ }
};

module.exports = function(it){
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};
},{"./_cof":49,"./_wks":115}],49:[function(require,module,exports){
var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};
},{}],50:[function(require,module,exports){
'use strict';
var dP          = require('./_object-dp').f
  , create      = require('./_object-create')
  , redefineAll = require('./_redefine-all')
  , ctx         = require('./_ctx')
  , anInstance  = require('./_an-instance')
  , defined     = require('./_defined')
  , forOf       = require('./_for-of')
  , $iterDefine = require('./_iter-define')
  , step        = require('./_iter-step')
  , setSpecies  = require('./_set-species')
  , DESCRIPTORS = require('./_descriptors')
  , fastKey     = require('./_meta').fastKey
  , SIZE        = DESCRIPTORS ? '_s' : 'size';

var getEntry = function(that, key){
  // fast case
  var index = fastKey(key), entry;
  if(index !== 'F')return that._i[index];
  // frozen object case
  for(entry = that._f; entry; entry = entry.n){
    if(entry.k == key)return entry;
  }
};

module.exports = {
  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
    var C = wrapper(function(that, iterable){
      anInstance(that, C, NAME, '_i');
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear(){
        for(var that = this, data = that._i, entry = that._f; entry; entry = entry.n){
          entry.r = true;
          if(entry.p)entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function(key){
        var that  = this
          , entry = getEntry(that, key);
        if(entry){
          var next = entry.n
            , prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if(prev)prev.n = next;
          if(next)next.p = prev;
          if(that._f == entry)that._f = next;
          if(that._l == entry)that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /*, that = undefined */){
        anInstance(this, C, 'forEach');
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3)
          , entry;
        while(entry = entry ? entry.n : this._f){
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while(entry && entry.r)entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key){
        return !!getEntry(this, key);
      }
    });
    if(DESCRIPTORS)dP(C.prototype, 'size', {
      get: function(){
        return defined(this[SIZE]);
      }
    });
    return C;
  },
  def: function(that, key, value){
    var entry = getEntry(that, key)
      , prev, index;
    // change existing entry
    if(entry){
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if(!that._f)that._f = entry;
      if(prev)prev.n = entry;
      that[SIZE]++;
      // add to index
      if(index !== 'F')that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function(C, NAME, IS_MAP){
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function(iterated, kind){
      this._t = iterated;  // target
      this._k = kind;      // kind
      this._l = undefined; // previous
    }, function(){
      var that  = this
        , kind  = that._k
        , entry = that._l;
      // revert to the last existing entry
      while(entry && entry.r)entry = entry.p;
      // get next entry
      if(!that._t || !(that._l = entry = entry ? entry.n : that._t._f)){
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if(kind == 'keys'  )return step(0, entry.k);
      if(kind == 'values')return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};
},{"./_an-instance":45,"./_ctx":53,"./_defined":54,"./_descriptors":55,"./_for-of":61,"./_iter-define":75,"./_iter-step":77,"./_meta":81,"./_object-create":84,"./_object-dp":85,"./_redefine-all":96,"./_set-species":99}],51:[function(require,module,exports){
'use strict';
var global            = require('./_global')
  , $export           = require('./_export')
  , redefine          = require('./_redefine')
  , redefineAll       = require('./_redefine-all')
  , meta              = require('./_meta')
  , forOf             = require('./_for-of')
  , anInstance        = require('./_an-instance')
  , isObject          = require('./_is-object')
  , fails             = require('./_fails')
  , $iterDetect       = require('./_iter-detect')
  , setToStringTag    = require('./_set-to-string-tag')
  , inheritIfRequired = require('./_inherit-if-required');

module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
  var Base  = global[NAME]
    , C     = Base
    , ADDER = IS_MAP ? 'set' : 'add'
    , proto = C && C.prototype
    , O     = {};
  var fixMethod = function(KEY){
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function(a){
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a){
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a){
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a){ fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b){ fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if(typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){
    new C().entries().next();
  }))){
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance             = new C
      // early implementations not supports chaining
      , HASNT_CHAINING       = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance
      // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
      , THROWS_ON_PRIMITIVES = fails(function(){ instance.has(1); })
      // most early implementations doesn't supports iterables, most modern - not close it correctly
      , ACCEPT_ITERABLES     = $iterDetect(function(iter){ new C(iter); }) // eslint-disable-line no-new
      // for early implementations -0 and +0 not the same
      , BUGGY_ZERO = !IS_WEAK && fails(function(){
        // V8 ~ Chromium 42- fails only with 5+ elements
        var $instance = new C()
          , index     = 5;
        while(index--)$instance[ADDER](index, index);
        return !$instance.has(-0);
      });
    if(!ACCEPT_ITERABLES){ 
      C = wrapper(function(target, iterable){
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base, target, C);
        if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if(THROWS_ON_PRIMITIVES || BUGGY_ZERO){
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if(BUGGY_ZERO || HASNT_CHAINING)fixMethod(ADDER);
    // weak collections should not contains .clear method
    if(IS_WEAK && proto.clear)delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);

  return C;
};
},{"./_an-instance":45,"./_export":59,"./_fails":60,"./_for-of":61,"./_global":62,"./_inherit-if-required":67,"./_is-object":72,"./_iter-detect":76,"./_meta":81,"./_redefine":97,"./_redefine-all":96,"./_set-to-string-tag":100}],52:[function(require,module,exports){
var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef
},{}],53:[function(require,module,exports){
// optional / simple context binding
var aFunction = require('./_a-function');
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};
},{"./_a-function":43}],54:[function(require,module,exports){
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};
},{}],55:[function(require,module,exports){
// Thank's IE8 for his funny defineProperty
module.exports = !require('./_fails')(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});
},{"./_fails":60}],56:[function(require,module,exports){
var isObject = require('./_is-object')
  , document = require('./_global').document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};
},{"./_global":62,"./_is-object":72}],57:[function(require,module,exports){
// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');
},{}],58:[function(require,module,exports){
// all enumerable object keys, includes symbols
var getKeys = require('./_object-keys')
  , gOPS    = require('./_object-gops')
  , pIE     = require('./_object-pie');
module.exports = function(it){
  var result     = getKeys(it)
    , getSymbols = gOPS.f;
  if(getSymbols){
    var symbols = getSymbols(it)
      , isEnum  = pIE.f
      , i       = 0
      , key;
    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
  } return result;
};
},{"./_object-gops":90,"./_object-keys":93,"./_object-pie":94}],59:[function(require,module,exports){
var global    = require('./_global')
  , core      = require('./_core')
  , hide      = require('./_hide')
  , redefine  = require('./_redefine')
  , ctx       = require('./_ctx')
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE]
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , expProto  = exports[PROTOTYPE] || (exports[PROTOTYPE] = {})
    , key, own, out, exp;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if(target)redefine(target, key, out, type & $export.U);
    // export
    if(exports[key] != out)hide(exports, key, exp);
    if(IS_PROTO && expProto[key] != out)expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library` 
module.exports = $export;
},{"./_core":52,"./_ctx":53,"./_global":62,"./_hide":64,"./_redefine":97}],60:[function(require,module,exports){
module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};
},{}],61:[function(require,module,exports){
var ctx         = require('./_ctx')
  , call        = require('./_iter-call')
  , isArrayIter = require('./_is-array-iter')
  , anObject    = require('./_an-object')
  , toLength    = require('./_to-length')
  , getIterFn   = require('./core.get-iterator-method')
  , BREAK       = {}
  , RETURN      = {};
var exports = module.exports = function(iterable, entries, fn, that, ITERATOR){
  var iterFn = ITERATOR ? function(){ return iterable; } : getIterFn(iterable)
    , f      = ctx(fn, that, entries ? 2 : 1)
    , index  = 0
    , length, step, iterator, result;
  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if(result === BREAK || result === RETURN)return result;
  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
    result = call(iterator, f, step.value, entries);
    if(result === BREAK || result === RETURN)return result;
  }
};
exports.BREAK  = BREAK;
exports.RETURN = RETURN;
},{"./_an-object":46,"./_ctx":53,"./_is-array-iter":70,"./_iter-call":73,"./_to-length":109,"./core.get-iterator-method":116}],62:[function(require,module,exports){
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef
},{}],63:[function(require,module,exports){
var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};
},{}],64:[function(require,module,exports){
var dP         = require('./_object-dp')
  , createDesc = require('./_property-desc');
module.exports = require('./_descriptors') ? function(object, key, value){
  return dP.f(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};
},{"./_descriptors":55,"./_object-dp":85,"./_property-desc":95}],65:[function(require,module,exports){
module.exports = require('./_global').document && document.documentElement;
},{"./_global":62}],66:[function(require,module,exports){
module.exports = !require('./_descriptors') && !require('./_fails')(function(){
  return Object.defineProperty(require('./_dom-create')('div'), 'a', {get: function(){ return 7; }}).a != 7;
});
},{"./_descriptors":55,"./_dom-create":56,"./_fails":60}],67:[function(require,module,exports){
var isObject       = require('./_is-object')
  , setPrototypeOf = require('./_set-proto').set;
module.exports = function(that, target, C){
  var P, S = target.constructor;
  if(S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf){
    setPrototypeOf(that, P);
  } return that;
};
},{"./_is-object":72,"./_set-proto":98}],68:[function(require,module,exports){
// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function(fn, args, that){
  var un = that === undefined;
  switch(args.length){
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return              fn.apply(that, args);
};
},{}],69:[function(require,module,exports){
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = require('./_cof');
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
  return cof(it) == 'String' ? it.split('') : Object(it);
};
},{"./_cof":49}],70:[function(require,module,exports){
// check on default Array iterator
var Iterators  = require('./_iterators')
  , ITERATOR   = require('./_wks')('iterator')
  , ArrayProto = Array.prototype;

module.exports = function(it){
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};
},{"./_iterators":78,"./_wks":115}],71:[function(require,module,exports){
// 7.2.2 IsArray(argument)
var cof = require('./_cof');
module.exports = Array.isArray || function isArray(arg){
  return cof(arg) == 'Array';
};
},{"./_cof":49}],72:[function(require,module,exports){
module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};
},{}],73:[function(require,module,exports){
// call something on iterator step with safe closing on error
var anObject = require('./_an-object');
module.exports = function(iterator, fn, value, entries){
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch(e){
    var ret = iterator['return'];
    if(ret !== undefined)anObject(ret.call(iterator));
    throw e;
  }
};
},{"./_an-object":46}],74:[function(require,module,exports){
'use strict';
var create         = require('./_object-create')
  , descriptor     = require('./_property-desc')
  , setToStringTag = require('./_set-to-string-tag')
  , IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
require('./_hide')(IteratorPrototype, require('./_wks')('iterator'), function(){ return this; });

module.exports = function(Constructor, NAME, next){
  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
  setToStringTag(Constructor, NAME + ' Iterator');
};
},{"./_hide":64,"./_object-create":84,"./_property-desc":95,"./_set-to-string-tag":100,"./_wks":115}],75:[function(require,module,exports){
'use strict';
var LIBRARY        = require('./_library')
  , $export        = require('./_export')
  , redefine       = require('./_redefine')
  , hide           = require('./_hide')
  , has            = require('./_has')
  , Iterators      = require('./_iterators')
  , $iterCreate    = require('./_iter-create')
  , setToStringTag = require('./_set-to-string-tag')
  , getPrototypeOf = require('./_object-gpo')
  , ITERATOR       = require('./_wks')('iterator')
  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
  , FF_ITERATOR    = '@@iterator'
  , KEYS           = 'keys'
  , VALUES         = 'values';

var returnThis = function(){ return this; };

module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
  $iterCreate(Constructor, NAME, next);
  var getMethod = function(kind){
    if(!BUGGY && kind in proto)return proto[kind];
    switch(kind){
      case KEYS: return function keys(){ return new Constructor(this, kind); };
      case VALUES: return function values(){ return new Constructor(this, kind); };
    } return function entries(){ return new Constructor(this, kind); };
  };
  var TAG        = NAME + ' Iterator'
    , DEF_VALUES = DEFAULT == VALUES
    , VALUES_BUG = false
    , proto      = Base.prototype
    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
    , $default   = $native || getMethod(DEFAULT)
    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
    , methods, key, IteratorPrototype;
  // Fix native
  if($anyNative){
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
    if(IteratorPrototype !== Object.prototype){
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if(DEF_VALUES && $native && $native.name !== VALUES){
    VALUES_BUG = true;
    $default = function values(){ return $native.call(this); };
  }
  // Define iterator
  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG]  = returnThis;
  if(DEFAULT){
    methods = {
      values:  DEF_VALUES ? $default : getMethod(VALUES),
      keys:    IS_SET     ? $default : getMethod(KEYS),
      entries: $entries
    };
    if(FORCED)for(key in methods){
      if(!(key in proto))redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};
},{"./_export":59,"./_has":63,"./_hide":64,"./_iter-create":74,"./_iterators":78,"./_library":80,"./_object-gpo":91,"./_redefine":97,"./_set-to-string-tag":100,"./_wks":115}],76:[function(require,module,exports){
var ITERATOR     = require('./_wks')('iterator')
  , SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function(){ SAFE_CLOSING = true; };
  Array.from(riter, function(){ throw 2; });
} catch(e){ /* empty */ }

module.exports = function(exec, skipClosing){
  if(!skipClosing && !SAFE_CLOSING)return false;
  var safe = false;
  try {
    var arr  = [7]
      , iter = arr[ITERATOR]();
    iter.next = function(){ return {done: safe = true}; };
    arr[ITERATOR] = function(){ return iter; };
    exec(arr);
  } catch(e){ /* empty */ }
  return safe;
};
},{"./_wks":115}],77:[function(require,module,exports){
module.exports = function(done, value){
  return {value: value, done: !!done};
};
},{}],78:[function(require,module,exports){
module.exports = {};
},{}],79:[function(require,module,exports){
var getKeys   = require('./_object-keys')
  , toIObject = require('./_to-iobject');
module.exports = function(object, el){
  var O      = toIObject(object)
    , keys   = getKeys(O)
    , length = keys.length
    , index  = 0
    , key;
  while(length > index)if(O[key = keys[index++]] === el)return key;
};
},{"./_object-keys":93,"./_to-iobject":108}],80:[function(require,module,exports){
module.exports = false;
},{}],81:[function(require,module,exports){
var META     = require('./_uid')('meta')
  , isObject = require('./_is-object')
  , has      = require('./_has')
  , setDesc  = require('./_object-dp').f
  , id       = 0;
var isExtensible = Object.isExtensible || function(){
  return true;
};
var FREEZE = !require('./_fails')(function(){
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function(it){
  setDesc(it, META, {value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  }});
};
var fastKey = function(it, create){
  // return primitive with prefix
  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return 'F';
    // not necessary to add metadata
    if(!create)return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function(it, create){
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return true;
    // not necessary to add metadata
    if(!create)return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function(it){
  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY:      META,
  NEED:     false,
  fastKey:  fastKey,
  getWeak:  getWeak,
  onFreeze: onFreeze
};
},{"./_fails":60,"./_has":63,"./_is-object":72,"./_object-dp":85,"./_uid":112}],82:[function(require,module,exports){
var global    = require('./_global')
  , macrotask = require('./_task').set
  , Observer  = global.MutationObserver || global.WebKitMutationObserver
  , process   = global.process
  , Promise   = global.Promise
  , isNode    = require('./_cof')(process) == 'process';

module.exports = function(){
  var head, last, notify;

  var flush = function(){
    var parent, fn;
    if(isNode && (parent = process.domain))parent.exit();
    while(head){
      fn   = head.fn;
      head = head.next;
      try {
        fn();
      } catch(e){
        if(head)notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if(parent)parent.enter();
  };

  // Node.js
  if(isNode){
    notify = function(){
      process.nextTick(flush);
    };
  // browsers with MutationObserver
  } else if(Observer){
    var toggle = true
      , node   = document.createTextNode('');
    new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
    notify = function(){
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if(Promise && Promise.resolve){
    var promise = Promise.resolve();
    notify = function(){
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function(){
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function(fn){
    var task = {fn: fn, next: undefined};
    if(last)last.next = task;
    if(!head){
      head = task;
      notify();
    } last = task;
  };
};
},{"./_cof":49,"./_global":62,"./_task":105}],83:[function(require,module,exports){
'use strict';
// 19.1.2.1 Object.assign(target, source, ...)
var getKeys  = require('./_object-keys')
  , gOPS     = require('./_object-gops')
  , pIE      = require('./_object-pie')
  , toObject = require('./_to-object')
  , IObject  = require('./_iobject')
  , $assign  = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || require('./_fails')(function(){
  var A = {}
    , B = {}
    , S = Symbol()
    , K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function(k){ B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
  var T     = toObject(target)
    , aLen  = arguments.length
    , index = 1
    , getSymbols = gOPS.f
    , isEnum     = pIE.f;
  while(aLen > index){
    var S      = IObject(arguments[index++])
      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
      , length = keys.length
      , j      = 0
      , key;
    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
  } return T;
} : $assign;
},{"./_fails":60,"./_iobject":69,"./_object-gops":90,"./_object-keys":93,"./_object-pie":94,"./_to-object":110}],84:[function(require,module,exports){
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject    = require('./_an-object')
  , dPs         = require('./_object-dps')
  , enumBugKeys = require('./_enum-bug-keys')
  , IE_PROTO    = require('./_shared-key')('IE_PROTO')
  , Empty       = function(){ /* empty */ }
  , PROTOTYPE   = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function(){
  // Thrash, waste and sodomy: IE GC bug
  var iframe = require('./_dom-create')('iframe')
    , i      = enumBugKeys.length
    , lt     = '<'
    , gt     = '>'
    , iframeDocument;
  iframe.style.display = 'none';
  require('./_html').appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties){
  var result;
  if(O !== null){
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty;
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};

},{"./_an-object":46,"./_dom-create":56,"./_enum-bug-keys":57,"./_html":65,"./_object-dps":86,"./_shared-key":101}],85:[function(require,module,exports){
var anObject       = require('./_an-object')
  , IE8_DOM_DEFINE = require('./_ie8-dom-define')
  , toPrimitive    = require('./_to-primitive')
  , dP             = Object.defineProperty;

exports.f = require('./_descriptors') ? Object.defineProperty : function defineProperty(O, P, Attributes){
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if(IE8_DOM_DEFINE)try {
    return dP(O, P, Attributes);
  } catch(e){ /* empty */ }
  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
  if('value' in Attributes)O[P] = Attributes.value;
  return O;
};
},{"./_an-object":46,"./_descriptors":55,"./_ie8-dom-define":66,"./_to-primitive":111}],86:[function(require,module,exports){
var dP       = require('./_object-dp')
  , anObject = require('./_an-object')
  , getKeys  = require('./_object-keys');

module.exports = require('./_descriptors') ? Object.defineProperties : function defineProperties(O, Properties){
  anObject(O);
  var keys   = getKeys(Properties)
    , length = keys.length
    , i = 0
    , P;
  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
  return O;
};
},{"./_an-object":46,"./_descriptors":55,"./_object-dp":85,"./_object-keys":93}],87:[function(require,module,exports){
var pIE            = require('./_object-pie')
  , createDesc     = require('./_property-desc')
  , toIObject      = require('./_to-iobject')
  , toPrimitive    = require('./_to-primitive')
  , has            = require('./_has')
  , IE8_DOM_DEFINE = require('./_ie8-dom-define')
  , gOPD           = Object.getOwnPropertyDescriptor;

exports.f = require('./_descriptors') ? gOPD : function getOwnPropertyDescriptor(O, P){
  O = toIObject(O);
  P = toPrimitive(P, true);
  if(IE8_DOM_DEFINE)try {
    return gOPD(O, P);
  } catch(e){ /* empty */ }
  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
};
},{"./_descriptors":55,"./_has":63,"./_ie8-dom-define":66,"./_object-pie":94,"./_property-desc":95,"./_to-iobject":108,"./_to-primitive":111}],88:[function(require,module,exports){
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = require('./_to-iobject')
  , gOPN      = require('./_object-gopn').f
  , toString  = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function(it){
  try {
    return gOPN(it);
  } catch(e){
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it){
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};

},{"./_object-gopn":89,"./_to-iobject":108}],89:[function(require,module,exports){
// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys      = require('./_object-keys-internal')
  , hiddenKeys = require('./_enum-bug-keys').concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
  return $keys(O, hiddenKeys);
};
},{"./_enum-bug-keys":57,"./_object-keys-internal":92}],90:[function(require,module,exports){
exports.f = Object.getOwnPropertySymbols;
},{}],91:[function(require,module,exports){
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has         = require('./_has')
  , toObject    = require('./_to-object')
  , IE_PROTO    = require('./_shared-key')('IE_PROTO')
  , ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function(O){
  O = toObject(O);
  if(has(O, IE_PROTO))return O[IE_PROTO];
  if(typeof O.constructor == 'function' && O instanceof O.constructor){
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};
},{"./_has":63,"./_shared-key":101,"./_to-object":110}],92:[function(require,module,exports){
var has          = require('./_has')
  , toIObject    = require('./_to-iobject')
  , arrayIndexOf = require('./_array-includes')(false)
  , IE_PROTO     = require('./_shared-key')('IE_PROTO');

module.exports = function(object, names){
  var O      = toIObject(object)
    , i      = 0
    , result = []
    , key;
  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while(names.length > i)if(has(O, key = names[i++])){
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};
},{"./_array-includes":47,"./_has":63,"./_shared-key":101,"./_to-iobject":108}],93:[function(require,module,exports){
// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys       = require('./_object-keys-internal')
  , enumBugKeys = require('./_enum-bug-keys');

module.exports = Object.keys || function keys(O){
  return $keys(O, enumBugKeys);
};
},{"./_enum-bug-keys":57,"./_object-keys-internal":92}],94:[function(require,module,exports){
exports.f = {}.propertyIsEnumerable;
},{}],95:[function(require,module,exports){
module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};
},{}],96:[function(require,module,exports){
var redefine = require('./_redefine');
module.exports = function(target, src, safe){
  for(var key in src)redefine(target, key, src[key], safe);
  return target;
};
},{"./_redefine":97}],97:[function(require,module,exports){
var global    = require('./_global')
  , hide      = require('./_hide')
  , has       = require('./_has')
  , SRC       = require('./_uid')('src')
  , TO_STRING = 'toString'
  , $toString = Function[TO_STRING]
  , TPL       = ('' + $toString).split(TO_STRING);

require('./_core').inspectSource = function(it){
  return $toString.call(it);
};

(module.exports = function(O, key, val, safe){
  var isFunction = typeof val == 'function';
  if(isFunction)has(val, 'name') || hide(val, 'name', key);
  if(O[key] === val)return;
  if(isFunction)has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if(O === global){
    O[key] = val;
  } else {
    if(!safe){
      delete O[key];
      hide(O, key, val);
    } else {
      if(O[key])O[key] = val;
      else hide(O, key, val);
    }
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString(){
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});
},{"./_core":52,"./_global":62,"./_has":63,"./_hide":64,"./_uid":112}],98:[function(require,module,exports){
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = require('./_is-object')
  , anObject = require('./_an-object');
var check = function(O, proto){
  anObject(O);
  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function(test, buggy, set){
      try {
        set = require('./_ctx')(Function.call, require('./_object-gopd').f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch(e){ buggy = true; }
      return function setPrototypeOf(O, proto){
        check(O, proto);
        if(buggy)O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};
},{"./_an-object":46,"./_ctx":53,"./_is-object":72,"./_object-gopd":87}],99:[function(require,module,exports){
'use strict';
var global      = require('./_global')
  , dP          = require('./_object-dp')
  , DESCRIPTORS = require('./_descriptors')
  , SPECIES     = require('./_wks')('species');

module.exports = function(KEY){
  var C = global[KEY];
  if(DESCRIPTORS && C && !C[SPECIES])dP.f(C, SPECIES, {
    configurable: true,
    get: function(){ return this; }
  });
};
},{"./_descriptors":55,"./_global":62,"./_object-dp":85,"./_wks":115}],100:[function(require,module,exports){
var def = require('./_object-dp').f
  , has = require('./_has')
  , TAG = require('./_wks')('toStringTag');

module.exports = function(it, tag, stat){
  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
};
},{"./_has":63,"./_object-dp":85,"./_wks":115}],101:[function(require,module,exports){
var shared = require('./_shared')('keys')
  , uid    = require('./_uid');
module.exports = function(key){
  return shared[key] || (shared[key] = uid(key));
};
},{"./_shared":102,"./_uid":112}],102:[function(require,module,exports){
var global = require('./_global')
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};
},{"./_global":62}],103:[function(require,module,exports){
// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject  = require('./_an-object')
  , aFunction = require('./_a-function')
  , SPECIES   = require('./_wks')('species');
module.exports = function(O, D){
  var C = anObject(O).constructor, S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};
},{"./_a-function":43,"./_an-object":46,"./_wks":115}],104:[function(require,module,exports){
var toInteger = require('./_to-integer')
  , defined   = require('./_defined');
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING){
  return function(that, pos){
    var s = String(defined(that))
      , i = toInteger(pos)
      , l = s.length
      , a, b;
    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};
},{"./_defined":54,"./_to-integer":107}],105:[function(require,module,exports){
var ctx                = require('./_ctx')
  , invoke             = require('./_invoke')
  , html               = require('./_html')
  , cel                = require('./_dom-create')
  , global             = require('./_global')
  , process            = global.process
  , setTask            = global.setImmediate
  , clearTask          = global.clearImmediate
  , MessageChannel     = global.MessageChannel
  , counter            = 0
  , queue              = {}
  , ONREADYSTATECHANGE = 'onreadystatechange'
  , defer, channel, port;
var run = function(){
  var id = +this;
  if(queue.hasOwnProperty(id)){
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function(event){
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if(!setTask || !clearTask){
  setTask = function setImmediate(fn){
    var args = [], i = 1;
    while(arguments.length > i)args.push(arguments[i++]);
    queue[++counter] = function(){
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id){
    delete queue[id];
  };
  // Node.js 0.8-
  if(require('./_cof')(process) == 'process'){
    defer = function(id){
      process.nextTick(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if(MessageChannel){
    channel = new MessageChannel;
    port    = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
    defer = function(id){
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if(ONREADYSTATECHANGE in cel('script')){
    defer = function(id){
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function(id){
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set:   setTask,
  clear: clearTask
};
},{"./_cof":49,"./_ctx":53,"./_dom-create":56,"./_global":62,"./_html":65,"./_invoke":68}],106:[function(require,module,exports){
var toInteger = require('./_to-integer')
  , max       = Math.max
  , min       = Math.min;
module.exports = function(index, length){
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};
},{"./_to-integer":107}],107:[function(require,module,exports){
// 7.1.4 ToInteger
var ceil  = Math.ceil
  , floor = Math.floor;
module.exports = function(it){
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};
},{}],108:[function(require,module,exports){
// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = require('./_iobject')
  , defined = require('./_defined');
module.exports = function(it){
  return IObject(defined(it));
};
},{"./_defined":54,"./_iobject":69}],109:[function(require,module,exports){
// 7.1.15 ToLength
var toInteger = require('./_to-integer')
  , min       = Math.min;
module.exports = function(it){
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};
},{"./_to-integer":107}],110:[function(require,module,exports){
// 7.1.13 ToObject(argument)
var defined = require('./_defined');
module.exports = function(it){
  return Object(defined(it));
};
},{"./_defined":54}],111:[function(require,module,exports){
// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = require('./_is-object');
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S){
  if(!isObject(it))return it;
  var fn, val;
  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  throw TypeError("Can't convert object to primitive value");
};
},{"./_is-object":72}],112:[function(require,module,exports){
var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};
},{}],113:[function(require,module,exports){
var global         = require('./_global')
  , core           = require('./_core')
  , LIBRARY        = require('./_library')
  , wksExt         = require('./_wks-ext')
  , defineProperty = require('./_object-dp').f;
module.exports = function(name){
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
};
},{"./_core":52,"./_global":62,"./_library":80,"./_object-dp":85,"./_wks-ext":114}],114:[function(require,module,exports){
exports.f = require('./_wks');
},{"./_wks":115}],115:[function(require,module,exports){
var store      = require('./_shared')('wks')
  , uid        = require('./_uid')
  , Symbol     = require('./_global').Symbol
  , USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function(name){
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;
},{"./_global":62,"./_shared":102,"./_uid":112}],116:[function(require,module,exports){
var classof   = require('./_classof')
  , ITERATOR  = require('./_wks')('iterator')
  , Iterators = require('./_iterators');
module.exports = require('./_core').getIteratorMethod = function(it){
  if(it != undefined)return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};
},{"./_classof":48,"./_core":52,"./_iterators":78,"./_wks":115}],117:[function(require,module,exports){
'use strict';
var addToUnscopables = require('./_add-to-unscopables')
  , step             = require('./_iter-step')
  , Iterators        = require('./_iterators')
  , toIObject        = require('./_to-iobject');

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = require('./_iter-define')(Array, 'Array', function(iterated, kind){
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , kind  = this._k
    , index = this._i++;
  if(!O || index >= O.length){
    this._t = undefined;
    return step(1);
  }
  if(kind == 'keys'  )return step(0, index);
  if(kind == 'values')return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');
},{"./_add-to-unscopables":44,"./_iter-define":75,"./_iter-step":77,"./_iterators":78,"./_to-iobject":108}],118:[function(require,module,exports){
// 19.1.3.1 Object.assign(target, source)
var $export = require('./_export');

$export($export.S + $export.F, 'Object', {assign: require('./_object-assign')});
},{"./_export":59,"./_object-assign":83}],119:[function(require,module,exports){
'use strict';
// 19.1.3.6 Object.prototype.toString()
var classof = require('./_classof')
  , test    = {};
test[require('./_wks')('toStringTag')] = 'z';
if(test + '' != '[object z]'){
  require('./_redefine')(Object.prototype, 'toString', function toString(){
    return '[object ' + classof(this) + ']';
  }, true);
}
},{"./_classof":48,"./_redefine":97,"./_wks":115}],120:[function(require,module,exports){
'use strict';
var LIBRARY            = require('./_library')
  , global             = require('./_global')
  , ctx                = require('./_ctx')
  , classof            = require('./_classof')
  , $export            = require('./_export')
  , isObject           = require('./_is-object')
  , aFunction          = require('./_a-function')
  , anInstance         = require('./_an-instance')
  , forOf              = require('./_for-of')
  , speciesConstructor = require('./_species-constructor')
  , task               = require('./_task').set
  , microtask          = require('./_microtask')()
  , PROMISE            = 'Promise'
  , TypeError          = global.TypeError
  , process            = global.process
  , $Promise           = global[PROMISE]
  , process            = global.process
  , isNode             = classof(process) == 'process'
  , empty              = function(){ /* empty */ }
  , Internal, GenericPromiseCapability, Wrapper;

var USE_NATIVE = !!function(){
  try {
    // correct subclassing with @@species support
    var promise     = $Promise.resolve(1)
      , FakePromise = (promise.constructor = {})[require('./_wks')('species')] = function(exec){ exec(empty, empty); };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch(e){ /* empty */ }
}();

// helpers
var sameConstructor = function(a, b){
  // with library wrapper special case
  return a === b || a === $Promise && b === Wrapper;
};
var isThenable = function(it){
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var newPromiseCapability = function(C){
  return sameConstructor($Promise, C)
    ? new PromiseCapability(C)
    : new GenericPromiseCapability(C);
};
var PromiseCapability = GenericPromiseCapability = function(C){
  var resolve, reject;
  this.promise = new C(function($$resolve, $$reject){
    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject  = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject  = aFunction(reject);
};
var perform = function(exec){
  try {
    exec();
  } catch(e){
    return {error: e};
  }
};
var notify = function(promise, isReject){
  if(promise._n)return;
  promise._n = true;
  var chain = promise._c;
  microtask(function(){
    var value = promise._v
      , ok    = promise._s == 1
      , i     = 0;
    var run = function(reaction){
      var handler = ok ? reaction.ok : reaction.fail
        , resolve = reaction.resolve
        , reject  = reaction.reject
        , domain  = reaction.domain
        , result, then;
      try {
        if(handler){
          if(!ok){
            if(promise._h == 2)onHandleUnhandled(promise);
            promise._h = 1;
          }
          if(handler === true)result = value;
          else {
            if(domain)domain.enter();
            result = handler(value);
            if(domain)domain.exit();
          }
          if(result === reaction.promise){
            reject(TypeError('Promise-chain cycle'));
          } else if(then = isThenable(result)){
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch(e){
        reject(e);
      }
    };
    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if(isReject && !promise._h)onUnhandled(promise);
  });
};
var onUnhandled = function(promise){
  task.call(global, function(){
    var value = promise._v
      , abrupt, handler, console;
    if(isUnhandled(promise)){
      abrupt = perform(function(){
        if(isNode){
          process.emit('unhandledRejection', value, promise);
        } else if(handler = global.onunhandledrejection){
          handler({promise: promise, reason: value});
        } else if((console = global.console) && console.error){
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if(abrupt)throw abrupt.error;
  });
};
var isUnhandled = function(promise){
  if(promise._h == 1)return false;
  var chain = promise._a || promise._c
    , i     = 0
    , reaction;
  while(chain.length > i){
    reaction = chain[i++];
    if(reaction.fail || !isUnhandled(reaction.promise))return false;
  } return true;
};
var onHandleUnhandled = function(promise){
  task.call(global, function(){
    var handler;
    if(isNode){
      process.emit('rejectionHandled', promise);
    } else if(handler = global.onrejectionhandled){
      handler({promise: promise, reason: promise._v});
    }
  });
};
var $reject = function(value){
  var promise = this;
  if(promise._d)return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if(!promise._a)promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function(value){
  var promise = this
    , then;
  if(promise._d)return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if(promise === value)throw TypeError("Promise can't be resolved itself");
    if(then = isThenable(value)){
      microtask(function(){
        var wrapper = {_w: promise, _d: false}; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch(e){
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch(e){
    $reject.call({_w: promise, _d: false}, e); // wrap
  }
};

// constructor polyfill
if(!USE_NATIVE){
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor){
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch(err){
      $reject.call(this, err);
    }
  };
  Internal = function Promise(executor){
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = require('./_redefine-all')($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected){
      var reaction    = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok     = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail   = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if(this._a)this._a.push(reaction);
      if(this._s)notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function(onRejected){
      return this.then(undefined, onRejected);
    }
  });
  PromiseCapability = function(){
    var promise  = new Internal;
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject  = ctx($reject, promise, 1);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: $Promise});
require('./_set-to-string-tag')($Promise, PROMISE);
require('./_set-species')(PROMISE);
Wrapper = require('./_core')[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r){
    var capability = newPromiseCapability(this)
      , $$reject   = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x){
    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
    if(x instanceof $Promise && sameConstructor(x.constructor, this))return x;
    var capability = newPromiseCapability(this)
      , $$resolve  = capability.resolve;
    $$resolve(x);
    return capability.promise;
  }
});
$export($export.S + $export.F * !(USE_NATIVE && require('./_iter-detect')(function(iter){
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable){
    var C          = this
      , capability = newPromiseCapability(C)
      , resolve    = capability.resolve
      , reject     = capability.reject;
    var abrupt = perform(function(){
      var values    = []
        , index     = 0
        , remaining = 1;
      forOf(iterable, false, function(promise){
        var $index        = index++
          , alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function(value){
          if(alreadyCalled)return;
          alreadyCalled  = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable){
    var C          = this
      , capability = newPromiseCapability(C)
      , reject     = capability.reject;
    var abrupt = perform(function(){
      forOf(iterable, false, function(promise){
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  }
});
},{"./_a-function":43,"./_an-instance":45,"./_classof":48,"./_core":52,"./_ctx":53,"./_export":59,"./_for-of":61,"./_global":62,"./_is-object":72,"./_iter-detect":76,"./_library":80,"./_microtask":82,"./_redefine-all":96,"./_set-species":99,"./_set-to-string-tag":100,"./_species-constructor":103,"./_task":105,"./_wks":115}],121:[function(require,module,exports){
'use strict';
var strong = require('./_collection-strong');

// 23.2 Set Objects
module.exports = require('./_collection')('Set', function(get){
  return function Set(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value){
    return strong.def(this, value = value === 0 ? 0 : value, value);
  }
}, strong);
},{"./_collection":51,"./_collection-strong":50}],122:[function(require,module,exports){
'use strict';
var $at  = require('./_string-at')(true);

// 21.1.3.27 String.prototype[@@iterator]()
require('./_iter-define')(String, 'String', function(iterated){
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , index = this._i
    , point;
  if(index >= O.length)return {value: undefined, done: true};
  point = $at(O, index);
  this._i += point.length;
  return {value: point, done: false};
});
},{"./_iter-define":75,"./_string-at":104}],123:[function(require,module,exports){
'use strict';
// ECMAScript 6 symbols shim
var global         = require('./_global')
  , has            = require('./_has')
  , DESCRIPTORS    = require('./_descriptors')
  , $export        = require('./_export')
  , redefine       = require('./_redefine')
  , META           = require('./_meta').KEY
  , $fails         = require('./_fails')
  , shared         = require('./_shared')
  , setToStringTag = require('./_set-to-string-tag')
  , uid            = require('./_uid')
  , wks            = require('./_wks')
  , wksExt         = require('./_wks-ext')
  , wksDefine      = require('./_wks-define')
  , keyOf          = require('./_keyof')
  , enumKeys       = require('./_enum-keys')
  , isArray        = require('./_is-array')
  , anObject       = require('./_an-object')
  , toIObject      = require('./_to-iobject')
  , toPrimitive    = require('./_to-primitive')
  , createDesc     = require('./_property-desc')
  , _create        = require('./_object-create')
  , gOPNExt        = require('./_object-gopn-ext')
  , $GOPD          = require('./_object-gopd')
  , $DP            = require('./_object-dp')
  , $keys          = require('./_object-keys')
  , gOPD           = $GOPD.f
  , dP             = $DP.f
  , gOPN           = gOPNExt.f
  , $Symbol        = global.Symbol
  , $JSON          = global.JSON
  , _stringify     = $JSON && $JSON.stringify
  , PROTOTYPE      = 'prototype'
  , HIDDEN         = wks('_hidden')
  , TO_PRIMITIVE   = wks('toPrimitive')
  , isEnum         = {}.propertyIsEnumerable
  , SymbolRegistry = shared('symbol-registry')
  , AllSymbols     = shared('symbols')
  , OPSymbols      = shared('op-symbols')
  , ObjectProto    = Object[PROTOTYPE]
  , USE_NATIVE     = typeof $Symbol == 'function'
  , QObject        = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function(){
  return _create(dP({}, 'a', {
    get: function(){ return dP(this, 'a', {value: 7}).a; }
  })).a != 7;
}) ? function(it, key, D){
  var protoDesc = gOPD(ObjectProto, key);
  if(protoDesc)delete ObjectProto[key];
  dP(it, key, D);
  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function(tag){
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
  return typeof it == 'symbol';
} : function(it){
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D){
  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if(has(AllSymbols, key)){
    if(!D.enumerable){
      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
      D = _create(D, {enumerable: createDesc(0, false)});
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P){
  anObject(it);
  var keys = enumKeys(P = toIObject(P))
    , i    = 0
    , l = keys.length
    , key;
  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P){
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key){
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
  it  = toIObject(it);
  key = toPrimitive(key, true);
  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
  var D = gOPD(it, key);
  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it){
  var names  = gOPN(toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
  var IS_OP  = it === ObjectProto
    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if(!USE_NATIVE){
  $Symbol = function Symbol(){
    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function(value){
      if(this === ObjectProto)$set.call(OPSymbols, value);
      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f   = $defineProperty;
  require('./_object-gopn').f = gOPNExt.f = $getOwnPropertyNames;
  require('./_object-pie').f  = $propertyIsEnumerable;
  require('./_object-gops').f = $getOwnPropertySymbols;

  if(DESCRIPTORS && !require('./_library')){
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function(name){
    return wrap(wks(name));
  }
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});

for(var symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);

for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function(key){
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(key){
    if(isSymbol(key))return keyOf(SymbolRegistry, key);
    throw TypeError(key + ' is not a symbol!');
  },
  useSetter: function(){ setter = true; },
  useSimple: function(){ setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it){
    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
    var args = [it]
      , i    = 1
      , replacer, $replacer;
    while(arguments.length > i)args.push(arguments[i++]);
    replacer = args[1];
    if(typeof replacer == 'function')$replacer = replacer;
    if($replacer || !isArray(replacer))replacer = function(key, value){
      if($replacer)value = $replacer.call(this, key, value);
      if(!isSymbol(value))return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || require('./_hide')($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);
},{"./_an-object":46,"./_descriptors":55,"./_enum-keys":58,"./_export":59,"./_fails":60,"./_global":62,"./_has":63,"./_hide":64,"./_is-array":71,"./_keyof":79,"./_library":80,"./_meta":81,"./_object-create":84,"./_object-dp":85,"./_object-gopd":87,"./_object-gopn":89,"./_object-gopn-ext":88,"./_object-gops":90,"./_object-keys":93,"./_object-pie":94,"./_property-desc":95,"./_redefine":97,"./_set-to-string-tag":100,"./_shared":102,"./_to-iobject":108,"./_to-primitive":111,"./_uid":112,"./_wks":115,"./_wks-define":113,"./_wks-ext":114}],124:[function(require,module,exports){
require('./_wks-define')('asyncIterator');
},{"./_wks-define":113}],125:[function(require,module,exports){
require('./_wks-define')('observable');
},{"./_wks-define":113}],126:[function(require,module,exports){
var $iterators    = require('./es6.array.iterator')
  , redefine      = require('./_redefine')
  , global        = require('./_global')
  , hide          = require('./_hide')
  , Iterators     = require('./_iterators')
  , wks           = require('./_wks')
  , ITERATOR      = wks('iterator')
  , TO_STRING_TAG = wks('toStringTag')
  , ArrayValues   = Iterators.Array;

for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
  var NAME       = collections[i]
    , Collection = global[NAME]
    , proto      = Collection && Collection.prototype
    , key;
  if(proto){
    if(!proto[ITERATOR])hide(proto, ITERATOR, ArrayValues);
    if(!proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    for(key in $iterators)if(!proto[key])redefine(proto, key, $iterators[key], true);
  }
}
},{"./_global":62,"./_hide":64,"./_iterators":78,"./_redefine":97,"./_wks":115,"./es6.array.iterator":117}],127:[function(require,module,exports){
// element-closest | CC0-1.0 | github.com/jonathantneal/closest

(function (ElementProto) {
	if (typeof ElementProto.matches !== 'function') {
		ElementProto.matches = ElementProto.msMatchesSelector || ElementProto.mozMatchesSelector || ElementProto.webkitMatchesSelector || function matches(selector) {
			var element = this;
			var elements = (element.document || element.ownerDocument).querySelectorAll(selector);
			var index = 0;

			while (elements[index] && elements[index] !== element) {
				++index;
			}

			return Boolean(elements[index]);
		};
	}

	if (typeof ElementProto.closest !== 'function') {
		ElementProto.closest = function closest(selector) {
			var element = this;

			while (element && element.nodeType === 1) {
				if (element.matches(selector)) {
					return element;
				}

				element = element.parentNode;
			}

			return null;
		};
	}
})(window.Element.prototype);

},{}],128:[function(require,module,exports){
/*
 Highcharts JS v5.0.7 (2017-01-17)

 (c) 2009-2016 Torstein Honsi

 License: www.highcharts.com/license
*/
(function(L,a){"object"===typeof module&&module.exports?module.exports=L.document?a(L):a:L.Highcharts=a(L)})("undefined"!==typeof window?window:this,function(L){L=function(){var a=window,B=a.document,A=a.navigator&&a.navigator.userAgent||"",H=B&&B.createElementNS&&!!B.createElementNS("http://www.w3.org/2000/svg","svg").createSVGRect,G=/(edge|msie|trident)/i.test(A)&&!window.opera,r=!H,g=/Firefox/.test(A),f=g&&4>parseInt(A.split("Firefox/")[1],10);return a.Highcharts?a.Highcharts.error(16,!0):{product:"Highcharts",
version:"5.0.7",deg2rad:2*Math.PI/360,doc:B,hasBidiBug:f,hasTouch:B&&void 0!==B.documentElement.ontouchstart,isMS:G,isWebKit:/AppleWebKit/.test(A),isFirefox:g,isTouchDevice:/(Mobile|Android|Windows Phone)/.test(A),SVG_NS:"http://www.w3.org/2000/svg",chartCount:0,seriesTypes:{},symbolSizes:{},svg:H,vml:r,win:a,charts:[],marginNames:["plotTop","marginRight","marginBottom","plotLeft"],noop:function(){}}}();(function(a){var B=[],A=a.charts,H=a.doc,G=a.win;a.error=function(r,g){r=a.isNumber(r)?"Highcharts error #"+
r+": www.highcharts.com/errors/"+r:r;if(g)throw Error(r);G.console&&console.log(r)};a.Fx=function(a,g,f){this.options=g;this.elem=a;this.prop=f};a.Fx.prototype={dSetter:function(){var a=this.paths[0],g=this.paths[1],f=[],u=this.now,l=a.length,q;if(1===u)f=this.toD;else if(l===g.length&&1>u)for(;l--;)q=parseFloat(a[l]),f[l]=isNaN(q)?a[l]:u*parseFloat(g[l]-q)+q;else f=g;this.elem.attr("d",f,null,!0)},update:function(){var a=this.elem,g=this.prop,f=this.now,u=this.options.step;if(this[g+"Setter"])this[g+
"Setter"]();else a.attr?a.element&&a.attr(g,f,null,!0):a.style[g]=f+this.unit;u&&u.call(a,f,this)},run:function(a,g,f){var r=this,l=function(a){return l.stopped?!1:r.step(a)},q;this.startTime=+new Date;this.start=a;this.end=g;this.unit=f;this.now=this.start;this.pos=0;l.elem=this.elem;l.prop=this.prop;l()&&1===B.push(l)&&(l.timerId=setInterval(function(){for(q=0;q<B.length;q++)B[q]()||B.splice(q--,1);B.length||clearInterval(l.timerId)},13))},step:function(a){var r=+new Date,f,u=this.options;f=this.elem;
var l=u.complete,q=u.duration,d=u.curAnim,b;if(f.attr&&!f.element)f=!1;else if(a||r>=q+this.startTime){this.now=this.end;this.pos=1;this.update();a=d[this.prop]=!0;for(b in d)!0!==d[b]&&(a=!1);a&&l&&l.call(f);f=!1}else this.pos=u.easing((r-this.startTime)/q),this.now=this.start+(this.end-this.start)*this.pos,this.update(),f=!0;return f},initPath:function(r,g,f){function u(a){var e,b;for(n=a.length;n--;)e="M"===a[n]||"L"===a[n],b=/[a-zA-Z]/.test(a[n+3]),e&&b&&a.splice(n+1,0,a[n+1],a[n+2],a[n+1],a[n+
2])}function l(a,e){for(;a.length<m;){a[0]=e[m-a.length];var b=a.slice(0,t);[].splice.apply(a,[0,0].concat(b));E&&(b=a.slice(a.length-t),[].splice.apply(a,[a.length,0].concat(b)),n--)}a[0]="M"}function q(a,e){for(var b=(m-a.length)/t;0<b&&b--;)c=a.slice().splice(a.length/z-t,t*z),c[0]=e[m-t-b*t],C&&(c[t-6]=c[t-2],c[t-5]=c[t-1]),[].splice.apply(a,[a.length/z,0].concat(c)),E&&b--}g=g||"";var d,b=r.startX,p=r.endX,C=-1<g.indexOf("C"),t=C?7:3,m,c,n;g=g.split(" ");f=f.slice();var E=r.isArea,z=E?2:1,e;
C&&(u(g),u(f));if(b&&p){for(n=0;n<b.length;n++)if(b[n]===p[0]){d=n;break}else if(b[0]===p[p.length-b.length+n]){d=n;e=!0;break}void 0===d&&(g=[])}g.length&&a.isNumber(d)&&(m=f.length+d*z*t,e?(l(g,f),q(f,g)):(l(f,g),q(g,f)));return[g,f]}};a.extend=function(a,g){var f;a||(a={});for(f in g)a[f]=g[f];return a};a.merge=function(){var r,g=arguments,f,u={},l=function(q,d){var b,p;"object"!==typeof q&&(q={});for(p in d)d.hasOwnProperty(p)&&(b=d[p],a.isObject(b,!0)&&"renderTo"!==p&&"number"!==typeof b.nodeType?
q[p]=l(q[p]||{},b):q[p]=d[p]);return q};!0===g[0]&&(u=g[1],g=Array.prototype.slice.call(g,2));f=g.length;for(r=0;r<f;r++)u=l(u,g[r]);return u};a.pInt=function(a,g){return parseInt(a,g||10)};a.isString=function(a){return"string"===typeof a};a.isArray=function(a){a=Object.prototype.toString.call(a);return"[object Array]"===a||"[object Array Iterator]"===a};a.isObject=function(r,g){return r&&"object"===typeof r&&(!g||!a.isArray(r))};a.isNumber=function(a){return"number"===typeof a&&!isNaN(a)};a.erase=
function(a,g){for(var f=a.length;f--;)if(a[f]===g){a.splice(f,1);break}};a.defined=function(a){return void 0!==a&&null!==a};a.attr=function(r,g,f){var u,l;if(a.isString(g))a.defined(f)?r.setAttribute(g,f):r&&r.getAttribute&&(l=r.getAttribute(g));else if(a.defined(g)&&a.isObject(g))for(u in g)r.setAttribute(u,g[u]);return l};a.splat=function(r){return a.isArray(r)?r:[r]};a.syncTimeout=function(a,g,f){if(g)return setTimeout(a,g,f);a.call(0,f)};a.pick=function(){var a=arguments,g,f,u=a.length;for(g=
0;g<u;g++)if(f=a[g],void 0!==f&&null!==f)return f};a.css=function(r,g){a.isMS&&!a.svg&&g&&void 0!==g.opacity&&(g.filter="alpha(opacity\x3d"+100*g.opacity+")");a.extend(r.style,g)};a.createElement=function(r,g,f,u,l){r=H.createElement(r);var q=a.css;g&&a.extend(r,g);l&&q(r,{padding:0,border:"none",margin:0});f&&q(r,f);u&&u.appendChild(r);return r};a.extendClass=function(r,g){var f=function(){};f.prototype=new r;a.extend(f.prototype,g);return f};a.pad=function(a,g,f){return Array((g||2)+1-String(a).length).join(f||
0)+a};a.relativeLength=function(a,g){return/%$/.test(a)?g*parseFloat(a)/100:parseFloat(a)};a.wrap=function(a,g,f){var r=a[g];a[g]=function(){var a=Array.prototype.slice.call(arguments),q=arguments,d=this;d.proceed=function(){r.apply(d,arguments.length?arguments:q)};a.unshift(r);a=f.apply(this,a);d.proceed=null;return a}};a.getTZOffset=function(r){var g=a.Date;return 6E4*(g.hcGetTimezoneOffset&&g.hcGetTimezoneOffset(r)||g.hcTimezoneOffset||0)};a.dateFormat=function(r,g,f){if(!a.defined(g)||isNaN(g))return a.defaultOptions.lang.invalidDate||
"";r=a.pick(r,"%Y-%m-%d %H:%M:%S");var u=a.Date,l=new u(g-a.getTZOffset(g)),q,d=l[u.hcGetHours](),b=l[u.hcGetDay](),p=l[u.hcGetDate](),C=l[u.hcGetMonth](),t=l[u.hcGetFullYear](),m=a.defaultOptions.lang,c=m.weekdays,n=m.shortWeekdays,E=a.pad,u=a.extend({a:n?n[b]:c[b].substr(0,3),A:c[b],d:E(p),e:E(p,2," "),w:b,b:m.shortMonths[C],B:m.months[C],m:E(C+1),y:t.toString().substr(2,2),Y:t,H:E(d),k:d,I:E(d%12||12),l:d%12||12,M:E(l[u.hcGetMinutes]()),p:12>d?"AM":"PM",P:12>d?"am":"pm",S:E(l.getSeconds()),L:E(Math.round(g%
1E3),3)},a.dateFormats);for(q in u)for(;-1!==r.indexOf("%"+q);)r=r.replace("%"+q,"function"===typeof u[q]?u[q](g):u[q]);return f?r.substr(0,1).toUpperCase()+r.substr(1):r};a.formatSingle=function(r,g){var f=/\.([0-9])/,u=a.defaultOptions.lang;/f$/.test(r)?(f=(f=r.match(f))?f[1]:-1,null!==g&&(g=a.numberFormat(g,f,u.decimalPoint,-1<r.indexOf(",")?u.thousandsSep:""))):g=a.dateFormat(r,g);return g};a.format=function(r,g){for(var f="{",u=!1,l,q,d,b,p=[],C;r;){f=r.indexOf(f);if(-1===f)break;l=r.slice(0,
f);if(u){l=l.split(":");q=l.shift().split(".");b=q.length;C=g;for(d=0;d<b;d++)C=C[q[d]];l.length&&(C=a.formatSingle(l.join(":"),C));p.push(C)}else p.push(l);r=r.slice(f+1);f=(u=!u)?"}":"{"}p.push(r);return p.join("")};a.getMagnitude=function(a){return Math.pow(10,Math.floor(Math.log(a)/Math.LN10))};a.normalizeTickInterval=function(r,g,f,u,l){var q,d=r;f=a.pick(f,1);q=r/f;g||(g=l?[1,1.2,1.5,2,2.5,3,4,5,6,8,10]:[1,2,2.5,5,10],!1===u&&(1===f?g=a.grep(g,function(a){return 0===a%1}):.1>=f&&(g=[1/f])));
for(u=0;u<g.length&&!(d=g[u],l&&d*f>=r||!l&&q<=(g[u]+(g[u+1]||g[u]))/2);u++);return d=a.correctFloat(d*f,-Math.round(Math.log(.001)/Math.LN10))};a.stableSort=function(a,g){var f=a.length,r,l;for(l=0;l<f;l++)a[l].safeI=l;a.sort(function(a,d){r=g(a,d);return 0===r?a.safeI-d.safeI:r});for(l=0;l<f;l++)delete a[l].safeI};a.arrayMin=function(a){for(var g=a.length,f=a[0];g--;)a[g]<f&&(f=a[g]);return f};a.arrayMax=function(a){for(var g=a.length,f=a[0];g--;)a[g]>f&&(f=a[g]);return f};a.destroyObjectProperties=
function(a,g){for(var f in a)a[f]&&a[f]!==g&&a[f].destroy&&a[f].destroy(),delete a[f]};a.discardElement=function(r){var g=a.garbageBin;g||(g=a.createElement("div"));r&&g.appendChild(r);g.innerHTML=""};a.correctFloat=function(a,g){return parseFloat(a.toPrecision(g||14))};a.setAnimation=function(r,g){g.renderer.globalAnimation=a.pick(r,g.options.chart.animation,!0)};a.animObject=function(r){return a.isObject(r)?a.merge(r):{duration:r?500:0}};a.timeUnits={millisecond:1,second:1E3,minute:6E4,hour:36E5,
day:864E5,week:6048E5,month:24192E5,year:314496E5};a.numberFormat=function(r,g,f,u){r=+r||0;g=+g;var l=a.defaultOptions.lang,q=(r.toString().split(".")[1]||"").length,d,b;-1===g?g=Math.min(q,20):a.isNumber(g)||(g=2);b=(Math.abs(r)+Math.pow(10,-Math.max(g,q)-1)).toFixed(g);q=String(a.pInt(b));d=3<q.length?q.length%3:0;f=a.pick(f,l.decimalPoint);u=a.pick(u,l.thousandsSep);r=(0>r?"-":"")+(d?q.substr(0,d)+u:"");r+=q.substr(d).replace(/(\d{3})(?=\d)/g,"$1"+u);g&&(r+=f+b.slice(-g));return r};Math.easeInOutSine=
function(a){return-.5*(Math.cos(Math.PI*a)-1)};a.getStyle=function(r,g){return"width"===g?Math.min(r.offsetWidth,r.scrollWidth)-a.getStyle(r,"padding-left")-a.getStyle(r,"padding-right"):"height"===g?Math.min(r.offsetHeight,r.scrollHeight)-a.getStyle(r,"padding-top")-a.getStyle(r,"padding-bottom"):(r=G.getComputedStyle(r,void 0))&&a.pInt(r.getPropertyValue(g))};a.inArray=function(a,g){return g.indexOf?g.indexOf(a):[].indexOf.call(g,a)};a.grep=function(a,g){return[].filter.call(a,g)};a.find=function(a,
g){return[].find.call(a,g)};a.map=function(a,g){for(var f=[],u=0,l=a.length;u<l;u++)f[u]=g.call(a[u],a[u],u,a);return f};a.offset=function(a){var g=H.documentElement;a=a.getBoundingClientRect();return{top:a.top+(G.pageYOffset||g.scrollTop)-(g.clientTop||0),left:a.left+(G.pageXOffset||g.scrollLeft)-(g.clientLeft||0)}};a.stop=function(a,g){for(var f=B.length;f--;)B[f].elem!==a||g&&g!==B[f].prop||(B[f].stopped=!0)};a.each=function(a,g,f){return Array.prototype.forEach.call(a,g,f)};a.addEvent=function(r,
g,f){function u(a){a.target=a.srcElement||G;f.call(r,a)}var l=r.hcEvents=r.hcEvents||{};r.addEventListener?r.addEventListener(g,f,!1):r.attachEvent&&(r.hcEventsIE||(r.hcEventsIE={}),r.hcEventsIE[f.toString()]=u,r.attachEvent("on"+g,u));l[g]||(l[g]=[]);l[g].push(f);return function(){a.removeEvent(r,g,f)}};a.removeEvent=function(r,g,f){function u(a,b){r.removeEventListener?r.removeEventListener(a,b,!1):r.attachEvent&&(b=r.hcEventsIE[b.toString()],r.detachEvent("on"+a,b))}function l(){var a,b;if(r.nodeName)for(b in g?
(a={},a[g]=!0):a=d,a)if(d[b])for(a=d[b].length;a--;)u(b,d[b][a])}var q,d=r.hcEvents,b;d&&(g?(q=d[g]||[],f?(b=a.inArray(f,q),-1<b&&(q.splice(b,1),d[g]=q),u(g,f)):(l(),d[g]=[])):(l(),r.hcEvents={}))};a.fireEvent=function(r,g,f,u){var l;l=r.hcEvents;var q,d;f=f||{};if(H.createEvent&&(r.dispatchEvent||r.fireEvent))l=H.createEvent("Events"),l.initEvent(g,!0,!0),a.extend(l,f),r.dispatchEvent?r.dispatchEvent(l):r.fireEvent(g,l);else if(l)for(l=l[g]||[],q=l.length,f.target||a.extend(f,{preventDefault:function(){f.defaultPrevented=
!0},target:r,type:g}),g=0;g<q;g++)(d=l[g])&&!1===d.call(r,f)&&f.preventDefault();u&&!f.defaultPrevented&&u(f)};a.animate=function(r,g,f){var u,l="",q,d,b;a.isObject(f)||(u=arguments,f={duration:u[2],easing:u[3],complete:u[4]});a.isNumber(f.duration)||(f.duration=400);f.easing="function"===typeof f.easing?f.easing:Math[f.easing]||Math.easeInOutSine;f.curAnim=a.merge(g);for(b in g)a.stop(r,b),d=new a.Fx(r,f,b),q=null,"d"===b?(d.paths=d.initPath(r,r.d,g.d),d.toD=g.d,u=0,q=1):r.attr?u=r.attr(b):(u=parseFloat(a.getStyle(r,
b))||0,"opacity"!==b&&(l="px")),q||(q=g[b]),q.match&&q.match("px")&&(q=q.replace(/px/g,"")),d.run(u,q,l)};a.seriesType=function(r,g,f,u,l){var q=a.getOptions(),d=a.seriesTypes;q.plotOptions[r]=a.merge(q.plotOptions[g],f);d[r]=a.extendClass(d[g]||function(){},u);d[r].prototype.type=r;l&&(d[r].prototype.pointClass=a.extendClass(a.Point,l));return d[r]};a.uniqueKey=function(){var a=Math.random().toString(36).substring(2,9),g=0;return function(){return"highcharts-"+a+"-"+g++}}();G.jQuery&&(G.jQuery.fn.highcharts=
function(){var r=[].slice.call(arguments);if(this[0])return r[0]?(new (a[a.isString(r[0])?r.shift():"Chart"])(this[0],r[0],r[1]),this):A[a.attr(this[0],"data-highcharts-chart")]});H&&!H.defaultView&&(a.getStyle=function(r,g){var f={width:"clientWidth",height:"clientHeight"}[g];if(r.style[g])return a.pInt(r.style[g]);"opacity"===g&&(g="filter");if(f)return r.style.zoom=1,Math.max(r[f]-2*a.getStyle(r,"padding"),0);r=r.currentStyle[g.replace(/\-(\w)/g,function(a,l){return l.toUpperCase()})];"filter"===
g&&(r=r.replace(/alpha\(opacity=([0-9]+)\)/,function(a,l){return l/100}));return""===r?1:a.pInt(r)});Array.prototype.forEach||(a.each=function(a,g,f){for(var u=0,l=a.length;u<l;u++)if(!1===g.call(f,a[u],u,a))return u});Array.prototype.indexOf||(a.inArray=function(a,g){var f,u=0;if(g)for(f=g.length;u<f;u++)if(g[u]===a)return u;return-1});Array.prototype.filter||(a.grep=function(a,g){for(var f=[],u=0,l=a.length;u<l;u++)g(a[u],u)&&f.push(a[u]);return f});Array.prototype.find||(a.find=function(a,g){var f,
u=a.length;for(f=0;f<u;f++)if(g(a[f],f))return a[f]})})(L);(function(a){var B=a.each,A=a.isNumber,H=a.map,G=a.merge,r=a.pInt;a.Color=function(g){if(!(this instanceof a.Color))return new a.Color(g);this.init(g)};a.Color.prototype={parsers:[{regex:/rgba\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]?(?:\.[0-9]+)?)\s*\)/,parse:function(a){return[r(a[1]),r(a[2]),r(a[3]),parseFloat(a[4],10)]}},{regex:/#([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})/,parse:function(a){return[r(a[1],
16),r(a[2],16),r(a[3],16),1]}},{regex:/rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/,parse:function(a){return[r(a[1]),r(a[2]),r(a[3]),1]}}],names:{white:"#ffffff",black:"#000000"},init:function(g){var f,u,l,q;if((this.input=g=this.names[g]||g)&&g.stops)this.stops=H(g.stops,function(d){return new a.Color(d[1])});else for(l=this.parsers.length;l--&&!u;)q=this.parsers[l],(f=q.regex.exec(g))&&(u=q.parse(f));this.rgba=u||[]},get:function(a){var f=this.input,g=this.rgba,l;this.stops?
(l=G(f),l.stops=[].concat(l.stops),B(this.stops,function(f,d){l.stops[d]=[l.stops[d][0],f.get(a)]})):l=g&&A(g[0])?"rgb"===a||!a&&1===g[3]?"rgb("+g[0]+","+g[1]+","+g[2]+")":"a"===a?g[3]:"rgba("+g.join(",")+")":f;return l},brighten:function(a){var f,g=this.rgba;if(this.stops)B(this.stops,function(l){l.brighten(a)});else if(A(a)&&0!==a)for(f=0;3>f;f++)g[f]+=r(255*a),0>g[f]&&(g[f]=0),255<g[f]&&(g[f]=255);return this},setOpacity:function(a){this.rgba[3]=a;return this}};a.color=function(g){return new a.Color(g)}})(L);
(function(a){var B,A,H=a.addEvent,G=a.animate,r=a.attr,g=a.charts,f=a.color,u=a.css,l=a.createElement,q=a.defined,d=a.deg2rad,b=a.destroyObjectProperties,p=a.doc,C=a.each,t=a.extend,m=a.erase,c=a.grep,n=a.hasTouch,E=a.inArray,z=a.isArray,e=a.isFirefox,x=a.isMS,F=a.isObject,w=a.isString,h=a.isWebKit,y=a.merge,J=a.noop,K=a.pick,I=a.pInt,k=a.removeEvent,D=a.stop,P=a.svg,N=a.SVG_NS,S=a.symbolSizes,O=a.win;B=a.SVGElement=function(){return this};B.prototype={opacity:1,SVG_NS:N,textProps:"direction fontSize fontWeight fontFamily fontStyle color lineHeight width textDecoration textOverflow textOutline".split(" "),
init:function(a,k){this.element="span"===k?l(k):p.createElementNS(this.SVG_NS,k);this.renderer=a},animate:function(v,k,e){k=a.animObject(K(k,this.renderer.globalAnimation,!0));0!==k.duration?(e&&(k.complete=e),G(this,v,k)):this.attr(v,null,e);return this},colorGradient:function(v,k,e){var b=this.renderer,h,D,c,x,M,m,n,d,F,t,p,w=[],l;v.linearGradient?D="linearGradient":v.radialGradient&&(D="radialGradient");if(D){c=v[D];M=b.gradients;n=v.stops;t=e.radialReference;z(c)&&(v[D]=c={x1:c[0],y1:c[1],x2:c[2],
y2:c[3],gradientUnits:"userSpaceOnUse"});"radialGradient"===D&&t&&!q(c.gradientUnits)&&(x=c,c=y(c,b.getRadialAttr(t,x),{gradientUnits:"userSpaceOnUse"}));for(p in c)"id"!==p&&w.push(p,c[p]);for(p in n)w.push(n[p]);w=w.join(",");M[w]?t=M[w].attr("id"):(c.id=t=a.uniqueKey(),M[w]=m=b.createElement(D).attr(c).add(b.defs),m.radAttr=x,m.stops=[],C(n,function(v){0===v[1].indexOf("rgba")?(h=a.color(v[1]),d=h.get("rgb"),F=h.get("a")):(d=v[1],F=1);v=b.createElement("stop").attr({offset:v[0],"stop-color":d,
"stop-opacity":F}).add(m);m.stops.push(v)}));l="url("+b.url+"#"+t+")";e.setAttribute(k,l);e.gradient=w;v.toString=function(){return l}}},applyTextOutline:function(a){var v=this.element,k,e,b,c;-1!==a.indexOf("contrast")&&(a=a.replace(/contrast/g,this.renderer.getContrast(v.style.fill)));this.fakeTS=!0;this.ySetter=this.xSetter;k=[].slice.call(v.getElementsByTagName("tspan"));a=a.split(" ");e=a[a.length-1];(b=a[0])&&"none"!==b&&(b=b.replace(/(^[\d\.]+)(.*?)$/g,function(a,v,k){return 2*v+k}),C(k,function(a){"highcharts-text-outline"===
a.getAttribute("class")&&m(k,v.removeChild(a))}),c=v.firstChild,C(k,function(a,k){0===k&&(a.setAttribute("x",v.getAttribute("x")),k=v.getAttribute("y"),a.setAttribute("y",k||0),null===k&&v.setAttribute("y",0));a=a.cloneNode(1);r(a,{"class":"highcharts-text-outline",fill:e,stroke:e,"stroke-width":b,"stroke-linejoin":"round"});v.insertBefore(a,c)}))},attr:function(a,k,e,b){var v,c=this.element,h,x=this,M;"string"===typeof a&&void 0!==k&&(v=a,a={},a[v]=k);if("string"===typeof a)x=(this[a+"Getter"]||
this._defaultGetter).call(this,a,c);else{for(v in a)k=a[v],M=!1,b||D(this,v),this.symbolName&&/^(x|y|width|height|r|start|end|innerR|anchorX|anchorY)/.test(v)&&(h||(this.symbolAttr(a),h=!0),M=!0),!this.rotation||"x"!==v&&"y"!==v||(this.doTransform=!0),M||(M=this[v+"Setter"]||this._defaultSetter,M.call(this,k,v,c),this.shadows&&/^(width|height|visibility|x|y|d|transform|cx|cy|r)$/.test(v)&&this.updateShadows(v,k,M));this.doTransform&&(this.updateTransform(),this.doTransform=!1)}e&&e();return x},updateShadows:function(a,
k,e){for(var v=this.shadows,b=v.length;b--;)e.call(v[b],"height"===a?Math.max(k-(v[b].cutHeight||0),0):"d"===a?this.d:k,a,v[b])},addClass:function(a,k){var v=this.attr("class")||"";-1===v.indexOf(a)&&(k||(a=(v+(v?" ":"")+a).replace("  "," ")),this.attr("class",a));return this},hasClass:function(a){return-1!==r(this.element,"class").indexOf(a)},removeClass:function(a){r(this.element,"class",(r(this.element,"class")||"").replace(a,""));return this},symbolAttr:function(a){var v=this;C("x y r start end width height innerR anchorX anchorY".split(" "),
function(k){v[k]=K(a[k],v[k])});v.attr({d:v.renderer.symbols[v.symbolName](v.x,v.y,v.width,v.height,v)})},clip:function(a){return this.attr("clip-path",a?"url("+this.renderer.url+"#"+a.id+")":"none")},crisp:function(a,k){var v,e={},b;k=k||a.strokeWidth||0;b=Math.round(k)%2/2;a.x=Math.floor(a.x||this.x||0)+b;a.y=Math.floor(a.y||this.y||0)+b;a.width=Math.floor((a.width||this.width||0)-2*b);a.height=Math.floor((a.height||this.height||0)-2*b);q(a.strokeWidth)&&(a.strokeWidth=k);for(v in a)this[v]!==a[v]&&
(this[v]=e[v]=a[v]);return e},css:function(a){var v=this.styles,k={},e=this.element,b,c,h="";b=!v;var D=["textOverflow","width"];a&&a.color&&(a.fill=a.color);if(v)for(c in a)a[c]!==v[c]&&(k[c]=a[c],b=!0);if(b){b=this.textWidth=a&&a.width&&"text"===e.nodeName.toLowerCase()&&I(a.width)||this.textWidth;v&&(a=t(v,k));this.styles=a;b&&!P&&this.renderer.forExport&&delete a.width;if(x&&!P)u(this.element,a);else{v=function(a,v){return"-"+v.toLowerCase()};for(c in a)-1===E(c,D)&&(h+=c.replace(/([A-Z])/g,v)+
":"+a[c]+";");h&&r(e,"style",h)}this.added&&(b&&this.renderer.buildText(this),a&&a.textOutline&&this.applyTextOutline(a.textOutline))}return this},strokeWidth:function(){return this["stroke-width"]||0},on:function(a,k){var v=this,e=v.element;n&&"click"===a?(e.ontouchstart=function(a){v.touchEventFired=Date.now();a.preventDefault();k.call(e,a)},e.onclick=function(a){(-1===O.navigator.userAgent.indexOf("Android")||1100<Date.now()-(v.touchEventFired||0))&&k.call(e,a)}):e["on"+a]=k;return this},setRadialReference:function(a){var v=
this.renderer.gradients[this.element.gradient];this.element.radialReference=a;v&&v.radAttr&&v.animate(this.renderer.getRadialAttr(a,v.radAttr));return this},translate:function(a,k){return this.attr({translateX:a,translateY:k})},invert:function(a){this.inverted=a;this.updateTransform();return this},updateTransform:function(){var a=this.translateX||0,k=this.translateY||0,e=this.scaleX,b=this.scaleY,c=this.inverted,h=this.rotation,D=this.element;c&&(a+=this.width,k+=this.height);a=["translate("+a+","+
k+")"];c?a.push("rotate(90) scale(-1,1)"):h&&a.push("rotate("+h+" "+(D.getAttribute("x")||0)+" "+(D.getAttribute("y")||0)+")");(q(e)||q(b))&&a.push("scale("+K(e,1)+" "+K(b,1)+")");a.length&&D.setAttribute("transform",a.join(" "))},toFront:function(){var a=this.element;a.parentNode.appendChild(a);return this},align:function(a,k,e){var v,b,c,h,D={};b=this.renderer;c=b.alignedObjects;var x,y;if(a){if(this.alignOptions=a,this.alignByTranslate=k,!e||w(e))this.alignTo=v=e||"renderer",m(c,this),c.push(this),
e=null}else a=this.alignOptions,k=this.alignByTranslate,v=this.alignTo;e=K(e,b[v],b);v=a.align;b=a.verticalAlign;c=(e.x||0)+(a.x||0);h=(e.y||0)+(a.y||0);"right"===v?x=1:"center"===v&&(x=2);x&&(c+=(e.width-(a.width||0))/x);D[k?"translateX":"x"]=Math.round(c);"bottom"===b?y=1:"middle"===b&&(y=2);y&&(h+=(e.height-(a.height||0))/y);D[k?"translateY":"y"]=Math.round(h);this[this.placed?"animate":"attr"](D);this.placed=!0;this.alignAttr=D;return this},getBBox:function(a,k){var v,e=this.renderer,b,c=this.element,
h=this.styles,D,x=this.textStr,m,y=e.cache,n=e.cacheKeys,F;k=K(k,this.rotation);b=k*d;D=h&&h.fontSize;void 0!==x&&(F=x.toString(),-1===F.indexOf("\x3c")&&(F=F.replace(/[0-9]/g,"0")),F+=["",k||0,D,h&&h.width,h&&h.textOverflow].join());F&&!a&&(v=y[F]);if(!v){if(c.namespaceURI===this.SVG_NS||e.forExport){try{(m=this.fakeTS&&function(a){C(c.querySelectorAll(".highcharts-text-outline"),function(v){v.style.display=a})})&&m("none"),v=c.getBBox?t({},c.getBBox()):{width:c.offsetWidth,height:c.offsetHeight},
m&&m("")}catch(W){}if(!v||0>v.width)v={width:0,height:0}}else v=this.htmlGetBBox();e.isSVG&&(a=v.width,e=v.height,h&&"11px"===h.fontSize&&17===Math.round(e)&&(v.height=e=14),k&&(v.width=Math.abs(e*Math.sin(b))+Math.abs(a*Math.cos(b)),v.height=Math.abs(e*Math.cos(b))+Math.abs(a*Math.sin(b))));if(F&&0<v.height){for(;250<n.length;)delete y[n.shift()];y[F]||n.push(F);y[F]=v}}return v},show:function(a){return this.attr({visibility:a?"inherit":"visible"})},hide:function(){return this.attr({visibility:"hidden"})},
fadeOut:function(a){var v=this;v.animate({opacity:0},{duration:a||150,complete:function(){v.attr({y:-9999})}})},add:function(a){var v=this.renderer,k=this.element,e;a&&(this.parentGroup=a);this.parentInverted=a&&a.inverted;void 0!==this.textStr&&v.buildText(this);this.added=!0;if(!a||a.handleZ||this.zIndex)e=this.zIndexSetter();e||(a?a.element:v.box).appendChild(k);if(this.onAdd)this.onAdd();return this},safeRemoveChild:function(a){var v=a.parentNode;v&&v.removeChild(a)},destroy:function(){var a=
this.element||{},k=this.renderer.isSVG&&"SPAN"===a.nodeName&&this.parentGroup,e,b;a.onclick=a.onmouseout=a.onmouseover=a.onmousemove=a.point=null;D(this);this.clipPath&&(this.clipPath=this.clipPath.destroy());if(this.stops){for(b=0;b<this.stops.length;b++)this.stops[b]=this.stops[b].destroy();this.stops=null}this.safeRemoveChild(a);for(this.destroyShadows();k&&k.div&&0===k.div.childNodes.length;)a=k.parentGroup,this.safeRemoveChild(k.div),delete k.div,k=a;this.alignTo&&m(this.renderer.alignedObjects,
this);for(e in this)delete this[e];return null},shadow:function(a,k,e){var v=[],b,c,h=this.element,D,x,m,y;if(!a)this.destroyShadows();else if(!this.shadows){x=K(a.width,3);m=(a.opacity||.15)/x;y=this.parentInverted?"(-1,-1)":"("+K(a.offsetX,1)+", "+K(a.offsetY,1)+")";for(b=1;b<=x;b++)c=h.cloneNode(0),D=2*x+1-2*b,r(c,{isShadow:"true",stroke:a.color||"#000000","stroke-opacity":m*b,"stroke-width":D,transform:"translate"+y,fill:"none"}),e&&(r(c,"height",Math.max(r(c,"height")-D,0)),c.cutHeight=D),k?
k.element.appendChild(c):h.parentNode.insertBefore(c,h),v.push(c);this.shadows=v}return this},destroyShadows:function(){C(this.shadows||[],function(a){this.safeRemoveChild(a)},this);this.shadows=void 0},xGetter:function(a){"circle"===this.element.nodeName&&("x"===a?a="cx":"y"===a&&(a="cy"));return this._defaultGetter(a)},_defaultGetter:function(a){a=K(this[a],this.element?this.element.getAttribute(a):null,0);/^[\-0-9\.]+$/.test(a)&&(a=parseFloat(a));return a},dSetter:function(a,k,e){a&&a.join&&(a=
a.join(" "));/(NaN| {2}|^$)/.test(a)&&(a="M 0 0");e.setAttribute(k,a);this[k]=a},dashstyleSetter:function(a){var v,k=this["stroke-width"];"inherit"===k&&(k=1);if(a=a&&a.toLowerCase()){a=a.replace("shortdashdotdot","3,1,1,1,1,1,").replace("shortdashdot","3,1,1,1").replace("shortdot","1,1,").replace("shortdash","3,1,").replace("longdash","8,3,").replace(/dot/g,"1,3,").replace("dash","4,3,").replace(/,$/,"").split(",");for(v=a.length;v--;)a[v]=I(a[v])*k;a=a.join(",").replace(/NaN/g,"none");this.element.setAttribute("stroke-dasharray",
a)}},alignSetter:function(a){this.element.setAttribute("text-anchor",{left:"start",center:"middle",right:"end"}[a])},opacitySetter:function(a,k,e){this[k]=a;e.setAttribute(k,a)},titleSetter:function(a){var v=this.element.getElementsByTagName("title")[0];v||(v=p.createElementNS(this.SVG_NS,"title"),this.element.appendChild(v));v.firstChild&&v.removeChild(v.firstChild);v.appendChild(p.createTextNode(String(K(a),"").replace(/<[^>]*>/g,"")))},textSetter:function(a){a!==this.textStr&&(delete this.bBox,
this.textStr=a,this.added&&this.renderer.buildText(this))},fillSetter:function(a,k,e){"string"===typeof a?e.setAttribute(k,a):a&&this.colorGradient(a,k,e)},visibilitySetter:function(a,k,e){"inherit"===a?e.removeAttribute(k):e.setAttribute(k,a)},zIndexSetter:function(a,k){var v=this.renderer,e=this.parentGroup,b=(e||v).element||v.box,c,h=this.element,D;c=this.added;var x;q(a)&&(h.zIndex=a,a=+a,this[k]===a&&(c=!1),this[k]=a);if(c){(a=this.zIndex)&&e&&(e.handleZ=!0);k=b.childNodes;for(x=0;x<k.length&&
!D;x++)e=k[x],c=e.zIndex,e!==h&&(I(c)>a||!q(a)&&q(c)||0>a&&!q(c)&&b!==v.box)&&(b.insertBefore(h,e),D=!0);D||b.appendChild(h)}return D},_defaultSetter:function(a,k,e){e.setAttribute(k,a)}};B.prototype.yGetter=B.prototype.xGetter;B.prototype.translateXSetter=B.prototype.translateYSetter=B.prototype.rotationSetter=B.prototype.verticalAlignSetter=B.prototype.scaleXSetter=B.prototype.scaleYSetter=function(a,k){this[k]=a;this.doTransform=!0};B.prototype["stroke-widthSetter"]=B.prototype.strokeSetter=function(a,
k,e){this[k]=a;this.stroke&&this["stroke-width"]?(B.prototype.fillSetter.call(this,this.stroke,"stroke",e),e.setAttribute("stroke-width",this["stroke-width"]),this.hasStroke=!0):"stroke-width"===k&&0===a&&this.hasStroke&&(e.removeAttribute("stroke"),this.hasStroke=!1)};A=a.SVGRenderer=function(){this.init.apply(this,arguments)};A.prototype={Element:B,SVG_NS:N,init:function(a,k,b,c,D,x){var v;c=this.createElement("svg").attr({version:"1.1","class":"highcharts-root"}).css(this.getStyle(c));v=c.element;
a.appendChild(v);-1===a.innerHTML.indexOf("xmlns")&&r(v,"xmlns",this.SVG_NS);this.isSVG=!0;this.box=v;this.boxWrapper=c;this.alignedObjects=[];this.url=(e||h)&&p.getElementsByTagName("base").length?O.location.href.replace(/#.*?$/,"").replace(/<[^>]*>/g,"").replace(/([\('\)])/g,"\\$1").replace(/ /g,"%20"):"";this.createElement("desc").add().element.appendChild(p.createTextNode("Created with Highcharts 5.0.7"));this.defs=this.createElement("defs").add();this.allowHTML=x;this.forExport=D;this.gradients=
{};this.cache={};this.cacheKeys=[];this.imgCount=0;this.setSize(k,b,!1);var m;e&&a.getBoundingClientRect&&(k=function(){u(a,{left:0,top:0});m=a.getBoundingClientRect();u(a,{left:Math.ceil(m.left)-m.left+"px",top:Math.ceil(m.top)-m.top+"px"})},k(),this.unSubPixelFix=H(O,"resize",k))},getStyle:function(a){return this.style=t({fontFamily:'"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif',fontSize:"12px"},a)},setStyle:function(a){this.boxWrapper.css(this.getStyle(a))},isHidden:function(){return!this.boxWrapper.getBBox().width},
destroy:function(){var a=this.defs;this.box=null;this.boxWrapper=this.boxWrapper.destroy();b(this.gradients||{});this.gradients=null;a&&(this.defs=a.destroy());this.unSubPixelFix&&this.unSubPixelFix();return this.alignedObjects=null},createElement:function(a){var k=new this.Element;k.init(this,a);return k},draw:J,getRadialAttr:function(a,k){return{cx:a[0]-a[2]/2+k.cx*a[2],cy:a[1]-a[2]/2+k.cy*a[2],r:k.r*a[2]}},buildText:function(a){var k=a.element,v=this,e=v.forExport,b=K(a.textStr,"").toString(),
h=-1!==b.indexOf("\x3c"),D=k.childNodes,x,m,y,n,F=r(k,"x"),d=a.styles,t=a.textWidth,w=d&&d.lineHeight,l=d&&d.textOutline,z=d&&"ellipsis"===d.textOverflow,f=d&&"nowrap"===d.whiteSpace,E=d&&d.fontSize,q,g=D.length,d=t&&!a.added&&this.box,J=function(a){var e;e=/(px|em)$/.test(a&&a.style.fontSize)?a.style.fontSize:E||v.style.fontSize||12;return w?I(w):v.fontMetrics(e,a.getAttribute("style")?a:k).h};q=[b,z,f,w,l,E,t].join();if(q!==a.textCache){for(a.textCache=q;g--;)k.removeChild(D[g]);h||l||z||t||-1!==
b.indexOf(" ")?(x=/<.*class="([^"]+)".*>/,m=/<.*style="([^"]+)".*>/,y=/<.*href="(http[^"]+)".*>/,d&&d.appendChild(k),b=h?b.replace(/<(b|strong)>/g,'\x3cspan style\x3d"font-weight:bold"\x3e').replace(/<(i|em)>/g,'\x3cspan style\x3d"font-style:italic"\x3e').replace(/<a/g,"\x3cspan").replace(/<\/(b|strong|i|em|a)>/g,"\x3c/span\x3e").split(/<br.*?>/g):[b],b=c(b,function(a){return""!==a}),C(b,function(b,c){var h,D=0;b=b.replace(/^\s+|\s+$/g,"").replace(/<span/g,"|||\x3cspan").replace(/<\/span>/g,"\x3c/span\x3e|||");
h=b.split("|||");C(h,function(b){if(""!==b||1===h.length){var d={},w=p.createElementNS(v.SVG_NS,"tspan"),l,E;x.test(b)&&(l=b.match(x)[1],r(w,"class",l));m.test(b)&&(E=b.match(m)[1].replace(/(;| |^)color([ :])/,"$1fill$2"),r(w,"style",E));y.test(b)&&!e&&(r(w,"onclick",'location.href\x3d"'+b.match(y)[1]+'"'),u(w,{cursor:"pointer"}));b=(b.replace(/<(.|\n)*?>/g,"")||" ").replace(/&lt;/g,"\x3c").replace(/&gt;/g,"\x3e");if(" "!==b){w.appendChild(p.createTextNode(b));D?d.dx=0:c&&null!==F&&(d.x=F);r(w,d);
k.appendChild(w);!D&&c&&(!P&&e&&u(w,{display:"block"}),r(w,"dy",J(w)));if(t){d=b.replace(/([^\^])-/g,"$1- ").split(" ");l=1<h.length||c||1<d.length&&!f;for(var q,g,M=[],C=J(w),K=a.rotation,I=b,Q=I.length;(l||z)&&(d.length||M.length);)a.rotation=0,q=a.getBBox(!0),g=q.width,!P&&v.forExport&&(g=v.measureSpanWidth(w.firstChild.data,a.styles)),q=g>t,void 0===n&&(n=q),z&&n?(Q/=2,""===I||!q&&.5>Q?d=[]:(I=b.substring(0,I.length+(q?-1:1)*Math.ceil(Q)),d=[I+(3<t?"\u2026":"")],w.removeChild(w.firstChild))):
q&&1!==d.length?(w.removeChild(w.firstChild),M.unshift(d.pop())):(d=M,M=[],d.length&&!f&&(w=p.createElementNS(N,"tspan"),r(w,{dy:C,x:F}),E&&r(w,"style",E),k.appendChild(w)),g>t&&(t=g)),d.length&&w.appendChild(p.createTextNode(d.join(" ").replace(/- /g,"-")));a.rotation=K}D++}}})}),n&&a.attr("title",a.textStr),d&&d.removeChild(k),l&&a.applyTextOutline&&a.applyTextOutline(l)):k.appendChild(p.createTextNode(b.replace(/&lt;/g,"\x3c").replace(/&gt;/g,"\x3e")))}},getContrast:function(a){a=f(a).rgba;return 510<
a[0]+a[1]+a[2]?"#000000":"#FFFFFF"},button:function(a,k,e,b,c,h,D,m,d){var v=this.label(a,k,e,d,null,null,null,null,"button"),n=0;v.attr(y({padding:8,r:2},c));var F,w,p,l;c=y({fill:"#f7f7f7",stroke:"#cccccc","stroke-width":1,style:{color:"#333333",cursor:"pointer",fontWeight:"normal"}},c);F=c.style;delete c.style;h=y(c,{fill:"#e6e6e6"},h);w=h.style;delete h.style;D=y(c,{fill:"#e6ebf5",style:{color:"#000000",fontWeight:"bold"}},D);p=D.style;delete D.style;m=y(c,{style:{color:"#cccccc"}},m);l=m.style;
delete m.style;H(v.element,x?"mouseover":"mouseenter",function(){3!==n&&v.setState(1)});H(v.element,x?"mouseout":"mouseleave",function(){3!==n&&v.setState(n)});v.setState=function(a){1!==a&&(v.state=n=a);v.removeClass(/highcharts-button-(normal|hover|pressed|disabled)/).addClass("highcharts-button-"+["normal","hover","pressed","disabled"][a||0]);v.attr([c,h,D,m][a||0]).css([F,w,p,l][a||0])};v.attr(c).css(t({cursor:"default"},F));return v.on("click",function(a){3!==n&&b.call(v,a)})},crispLine:function(a,
k){a[1]===a[4]&&(a[1]=a[4]=Math.round(a[1])-k%2/2);a[2]===a[5]&&(a[2]=a[5]=Math.round(a[2])+k%2/2);return a},path:function(a){var k={fill:"none"};z(a)?k.d=a:F(a)&&t(k,a);return this.createElement("path").attr(k)},circle:function(a,k,e){a=F(a)?a:{x:a,y:k,r:e};k=this.createElement("circle");k.xSetter=k.ySetter=function(a,k,e){e.setAttribute("c"+k,a)};return k.attr(a)},arc:function(a,k,e,b,c,h){F(a)&&(k=a.y,e=a.r,b=a.innerR,c=a.start,h=a.end,a=a.x);a=this.symbol("arc",a||0,k||0,e||0,e||0,{innerR:b||
0,start:c||0,end:h||0});a.r=e;return a},rect:function(a,k,e,b,c,h){c=F(a)?a.r:c;var v=this.createElement("rect");a=F(a)?a:void 0===a?{}:{x:a,y:k,width:Math.max(e,0),height:Math.max(b,0)};void 0!==h&&(a.strokeWidth=h,a=v.crisp(a));a.fill="none";c&&(a.r=c);v.rSetter=function(a,k,e){r(e,{rx:a,ry:a})};return v.attr(a)},setSize:function(a,k,e){var b=this.alignedObjects,v=b.length;this.width=a;this.height=k;for(this.boxWrapper.animate({width:a,height:k},{step:function(){this.attr({viewBox:"0 0 "+this.attr("width")+
" "+this.attr("height")})},duration:K(e,!0)?void 0:0});v--;)b[v].align()},g:function(a){var k=this.createElement("g");return a?k.attr({"class":"highcharts-"+a}):k},image:function(a,k,e,b,c){var v={preserveAspectRatio:"none"};1<arguments.length&&t(v,{x:k,y:e,width:b,height:c});v=this.createElement("image").attr(v);v.element.setAttributeNS?v.element.setAttributeNS("http://www.w3.org/1999/xlink","href",a):v.element.setAttribute("hc-svg-href",a);return v},symbol:function(a,k,e,b,c,h){var v=this,D,x=this.symbols[a],
m=q(k)&&x&&this.symbols[a](Math.round(k),Math.round(e),b,c,h),y=/^url\((.*?)\)$/,d,n;x?(D=this.path(m),D.attr("fill","none"),t(D,{symbolName:a,x:k,y:e,width:b,height:c}),h&&t(D,h)):y.test(a)&&(d=a.match(y)[1],D=this.image(d),D.imgwidth=K(S[d]&&S[d].width,h&&h.width),D.imgheight=K(S[d]&&S[d].height,h&&h.height),n=function(){D.attr({width:D.width,height:D.height})},C(["width","height"],function(a){D[a+"Setter"]=function(a,k){var e={},b=this["img"+k],v="width"===k?"translateX":"translateY";this[k]=a;
q(b)&&(this.element&&this.element.setAttribute(k,b),this.alignByTranslate||(e[v]=((this[k]||0)-b)/2,this.attr(e)))}}),q(k)&&D.attr({x:k,y:e}),D.isImg=!0,q(D.imgwidth)&&q(D.imgheight)?n():(D.attr({width:0,height:0}),l("img",{onload:function(){var a=g[v.chartIndex];0===this.width&&(u(this,{position:"absolute",top:"-999em"}),p.body.appendChild(this));S[d]={width:this.width,height:this.height};D.imgwidth=this.width;D.imgheight=this.height;D.element&&n();this.parentNode&&this.parentNode.removeChild(this);
v.imgCount--;if(!v.imgCount&&a&&a.onload)a.onload()},src:d}),this.imgCount++));return D},symbols:{circle:function(a,k,e,b){return this.arc(a+e/2,k+b/2,e/2,b/2,{start:0,end:2*Math.PI,open:!1})},square:function(a,k,e,b){return["M",a,k,"L",a+e,k,a+e,k+b,a,k+b,"Z"]},triangle:function(a,k,e,b){return["M",a+e/2,k,"L",a+e,k+b,a,k+b,"Z"]},"triangle-down":function(a,k,e,b){return["M",a,k,"L",a+e,k,a+e/2,k+b,"Z"]},diamond:function(a,k,e,b){return["M",a+e/2,k,"L",a+e,k+b/2,a+e/2,k+b,a,k+b/2,"Z"]},arc:function(a,
k,e,b,c){var v=c.start,h=c.r||e,D=c.r||b||e,x=c.end-.001;e=c.innerR;b=c.open;var m=Math.cos(v),d=Math.sin(v),y=Math.cos(x),x=Math.sin(x);c=c.end-v<Math.PI?0:1;h=["M",a+h*m,k+D*d,"A",h,D,0,c,1,a+h*y,k+D*x];q(e)&&h.push(b?"M":"L",a+e*y,k+e*x,"A",e,e,0,c,0,a+e*m,k+e*d);h.push(b?"":"Z");return h},callout:function(a,k,e,b,c){var h=Math.min(c&&c.r||0,e,b),D=h+6,v=c&&c.anchorX;c=c&&c.anchorY;var x;x=["M",a+h,k,"L",a+e-h,k,"C",a+e,k,a+e,k,a+e,k+h,"L",a+e,k+b-h,"C",a+e,k+b,a+e,k+b,a+e-h,k+b,"L",a+h,k+b,"C",
a,k+b,a,k+b,a,k+b-h,"L",a,k+h,"C",a,k,a,k,a+h,k];v&&v>e?c>k+D&&c<k+b-D?x.splice(13,3,"L",a+e,c-6,a+e+6,c,a+e,c+6,a+e,k+b-h):x.splice(13,3,"L",a+e,b/2,v,c,a+e,b/2,a+e,k+b-h):v&&0>v?c>k+D&&c<k+b-D?x.splice(33,3,"L",a,c+6,a-6,c,a,c-6,a,k+h):x.splice(33,3,"L",a,b/2,v,c,a,b/2,a,k+h):c&&c>b&&v>a+D&&v<a+e-D?x.splice(23,3,"L",v+6,k+b,v,k+b+6,v-6,k+b,a+h,k+b):c&&0>c&&v>a+D&&v<a+e-D&&x.splice(3,3,"L",v-6,k,v,k-6,v+6,k,e-h,k);return x}},clipRect:function(k,e,b,c){var h=a.uniqueKey(),D=this.createElement("clipPath").attr({id:h}).add(this.defs);
k=this.rect(k,e,b,c,0).add(D);k.id=h;k.clipPath=D;k.count=0;return k},text:function(a,k,e,b){var c=!P&&this.forExport,h={};if(b&&(this.allowHTML||!this.forExport))return this.html(a,k,e);h.x=Math.round(k||0);e&&(h.y=Math.round(e));if(a||0===a)h.text=a;a=this.createElement("text").attr(h);c&&a.css({position:"absolute"});b||(a.xSetter=function(a,k,e){var b=e.getElementsByTagName("tspan"),c,h=e.getAttribute(k),D;for(D=0;D<b.length;D++)c=b[D],c.getAttribute(k)===h&&c.setAttribute(k,a);e.setAttribute(k,
a)});return a},fontMetrics:function(a,k){a=a||k&&k.style&&k.style.fontSize||this.style&&this.style.fontSize;a=/px/.test(a)?I(a):/em/.test(a)?parseFloat(a)*(k?this.fontMetrics(null,k.parentNode).f:16):12;k=24>a?a+3:Math.round(1.2*a);return{h:k,b:Math.round(.8*k),f:a}},rotCorr:function(a,k,e){var b=a;k&&e&&(b=Math.max(b*Math.cos(k*d),4));return{x:-a/3*Math.sin(k*d),y:b}},label:function(a,e,b,c,h,D,x,m,d){var v=this,n=v.g("button"!==d&&"label"),F=n.text=v.text("",0,0,x).attr({zIndex:1}),w,p,l=0,z=3,
E=0,f,g,J,K,P,N={},I,u,r=/^url\((.*?)\)$/.test(c),M=r,S,Q,R,O;d&&n.addClass("highcharts-"+d);M=r;S=function(){return(I||0)%2/2};Q=function(){var a=F.element.style,k={};p=(void 0===f||void 0===g||P)&&q(F.textStr)&&F.getBBox();n.width=(f||p.width||0)+2*z+E;n.height=(g||p.height||0)+2*z;u=z+v.fontMetrics(a&&a.fontSize,F).b;M&&(w||(n.box=w=v.symbols[c]||r?v.symbol(c):v.rect(),w.addClass(("button"===d?"":"highcharts-label-box")+(d?" highcharts-"+d+"-box":"")),w.add(n),a=S(),k.x=a,k.y=(m?-u:0)+a),k.width=
Math.round(n.width),k.height=Math.round(n.height),w.attr(t(k,N)),N={})};R=function(){var a=E+z,k;k=m?0:u;q(f)&&p&&("center"===P||"right"===P)&&(a+={center:.5,right:1}[P]*(f-p.width));if(a!==F.x||k!==F.y)F.attr("x",a),void 0!==k&&F.attr("y",k);F.x=a;F.y=k};O=function(a,k){w?w.attr(a,k):N[a]=k};n.onAdd=function(){F.add(n);n.attr({text:a||0===a?a:"",x:e,y:b});w&&q(h)&&n.attr({anchorX:h,anchorY:D})};n.widthSetter=function(a){f=a};n.heightSetter=function(a){g=a};n["text-alignSetter"]=function(a){P=a};
n.paddingSetter=function(a){q(a)&&a!==z&&(z=n.padding=a,R())};n.paddingLeftSetter=function(a){q(a)&&a!==E&&(E=a,R())};n.alignSetter=function(a){a={left:0,center:.5,right:1}[a];a!==l&&(l=a,p&&n.attr({x:J}))};n.textSetter=function(a){void 0!==a&&F.textSetter(a);Q();R()};n["stroke-widthSetter"]=function(a,k){a&&(M=!0);I=this["stroke-width"]=a;O(k,a)};n.strokeSetter=n.fillSetter=n.rSetter=function(a,k){"fill"===k&&a&&(M=!0);O(k,a)};n.anchorXSetter=function(a,k){h=a;O(k,Math.round(a)-S()-J)};n.anchorYSetter=
function(a,k){D=a;O(k,a-K)};n.xSetter=function(a){n.x=a;l&&(a-=l*((f||p.width)+2*z));J=Math.round(a);n.attr("translateX",J)};n.ySetter=function(a){K=n.y=Math.round(a);n.attr("translateY",K)};var V=n.css;return t(n,{css:function(a){if(a){var k={};a=y(a);C(n.textProps,function(e){void 0!==a[e]&&(k[e]=a[e],delete a[e])});F.css(k)}return V.call(n,a)},getBBox:function(){return{width:p.width+2*z,height:p.height+2*z,x:p.x-z,y:p.y-z}},shadow:function(a){a&&(Q(),w&&w.shadow(a));return n},destroy:function(){k(n.element,
"mouseenter");k(n.element,"mouseleave");F&&(F=F.destroy());w&&(w=w.destroy());B.prototype.destroy.call(n);n=v=Q=R=O=null}})}};a.Renderer=A})(L);(function(a){var B=a.attr,A=a.createElement,H=a.css,G=a.defined,r=a.each,g=a.extend,f=a.isFirefox,u=a.isMS,l=a.isWebKit,q=a.pInt,d=a.SVGRenderer,b=a.win,p=a.wrap;g(a.SVGElement.prototype,{htmlCss:function(a){var b=this.element;if(b=a&&"SPAN"===b.tagName&&a.width)delete a.width,this.textWidth=b,this.updateTransform();a&&"ellipsis"===a.textOverflow&&(a.whiteSpace=
"nowrap",a.overflow="hidden");this.styles=g(this.styles,a);H(this.element,a);return this},htmlGetBBox:function(){var a=this.element;"text"===a.nodeName&&(a.style.position="absolute");return{x:a.offsetLeft,y:a.offsetTop,width:a.offsetWidth,height:a.offsetHeight}},htmlUpdateTransform:function(){if(this.added){var a=this.renderer,b=this.element,m=this.translateX||0,c=this.translateY||0,n=this.x||0,d=this.y||0,p=this.textAlign||"left",e={left:0,center:.5,right:1}[p],x=this.styles;H(b,{marginLeft:m,marginTop:c});
this.shadows&&r(this.shadows,function(a){H(a,{marginLeft:m+1,marginTop:c+1})});this.inverted&&r(b.childNodes,function(e){a.invertChild(e,b)});if("SPAN"===b.tagName){var F=this.rotation,w=q(this.textWidth),h=x&&x.whiteSpace,y=[F,p,b.innerHTML,this.textWidth,this.textAlign].join();y!==this.cTT&&(x=a.fontMetrics(b.style.fontSize).b,G(F)&&this.setSpanRotation(F,e,x),H(b,{width:"",whiteSpace:h||"nowrap"}),b.offsetWidth>w&&/[ \-]/.test(b.textContent||b.innerText)&&H(b,{width:w+"px",display:"block",whiteSpace:h||
"normal"}),this.getSpanCorrection(b.offsetWidth,x,e,F,p));H(b,{left:n+(this.xCorr||0)+"px",top:d+(this.yCorr||0)+"px"});l&&(x=b.offsetHeight);this.cTT=y}}else this.alignOnAdd=!0},setSpanRotation:function(a,d,m){var c={},n=u?"-ms-transform":l?"-webkit-transform":f?"MozTransform":b.opera?"-o-transform":"";c[n]=c.transform="rotate("+a+"deg)";c[n+(f?"Origin":"-origin")]=c.transformOrigin=100*d+"% "+m+"px";H(this.element,c)},getSpanCorrection:function(a,b,m){this.xCorr=-a*m;this.yCorr=-b}});g(d.prototype,
{html:function(a,b,m){var c=this.createElement("span"),n=c.element,d=c.renderer,l=d.isSVG,e=function(a,e){r(["opacity","visibility"],function(b){p(a,b+"Setter",function(a,b,c,x){a.call(this,b,c,x);e[c]=b})})};c.textSetter=function(a){a!==n.innerHTML&&delete this.bBox;n.innerHTML=this.textStr=a;c.htmlUpdateTransform()};l&&e(c,c.element.style);c.xSetter=c.ySetter=c.alignSetter=c.rotationSetter=function(a,e){"align"===e&&(e="textAlign");c[e]=a;c.htmlUpdateTransform()};c.attr({text:a,x:Math.round(b),
y:Math.round(m)}).css({fontFamily:this.style.fontFamily,fontSize:this.style.fontSize,position:"absolute"});n.style.whiteSpace="nowrap";c.css=c.htmlCss;l&&(c.add=function(a){var b,x=d.box.parentNode,h=[];if(this.parentGroup=a){if(b=a.div,!b){for(;a;)h.push(a),a=a.parentGroup;r(h.reverse(),function(a){var n,m=B(a.element,"class");m&&(m={className:m});b=a.div=a.div||A("div",m,{position:"absolute",left:(a.translateX||0)+"px",top:(a.translateY||0)+"px",display:a.display,opacity:a.opacity,pointerEvents:a.styles&&
a.styles.pointerEvents},b||x);n=b.style;g(a,{on:function(){c.on.apply({element:h[0].div},arguments);return a},translateXSetter:function(e,k){n.left=e+"px";a[k]=e;a.doTransform=!0},translateYSetter:function(e,k){n.top=e+"px";a[k]=e;a.doTransform=!0}});e(a,n)})}}else b=x;b.appendChild(n);c.added=!0;c.alignOnAdd&&c.htmlUpdateTransform();return c});return c}})})(L);(function(a){var B,A,H=a.createElement,G=a.css,r=a.defined,g=a.deg2rad,f=a.discardElement,u=a.doc,l=a.each,q=a.erase,d=a.extend;B=a.extendClass;
var b=a.isArray,p=a.isNumber,C=a.isObject,t=a.merge;A=a.noop;var m=a.pick,c=a.pInt,n=a.SVGElement,E=a.SVGRenderer,z=a.win;a.svg||(A={docMode8:u&&8===u.documentMode,init:function(a,b){var e=["\x3c",b,' filled\x3d"f" stroked\x3d"f"'],c=["position: ","absolute",";"],h="div"===b;("shape"===b||h)&&c.push("left:0;top:0;width:1px;height:1px;");c.push("visibility: ",h?"hidden":"visible");e.push(' style\x3d"',c.join(""),'"/\x3e');b&&(e=h||"span"===b||"img"===b?e.join(""):a.prepVML(e),this.element=H(e));this.renderer=
a},add:function(a){var e=this.renderer,b=this.element,c=e.box,h=a&&a.inverted,c=a?a.element||a:c;a&&(this.parentGroup=a);h&&e.invertChild(b,c);c.appendChild(b);this.added=!0;this.alignOnAdd&&!this.deferUpdateTransform&&this.updateTransform();if(this.onAdd)this.onAdd();this.className&&this.attr("class",this.className);return this},updateTransform:n.prototype.htmlUpdateTransform,setSpanRotation:function(){var a=this.rotation,b=Math.cos(a*g),c=Math.sin(a*g);G(this.element,{filter:a?["progid:DXImageTransform.Microsoft.Matrix(M11\x3d",
b,", M12\x3d",-c,", M21\x3d",c,", M22\x3d",b,", sizingMethod\x3d'auto expand')"].join(""):"none"})},getSpanCorrection:function(a,b,c,n,h){var e=n?Math.cos(n*g):1,x=n?Math.sin(n*g):0,d=m(this.elemHeight,this.element.offsetHeight),F;this.xCorr=0>e&&-a;this.yCorr=0>x&&-d;F=0>e*x;this.xCorr+=x*b*(F?1-c:c);this.yCorr-=e*b*(n?F?c:1-c:1);h&&"left"!==h&&(this.xCorr-=a*c*(0>e?-1:1),n&&(this.yCorr-=d*c*(0>x?-1:1)),G(this.element,{textAlign:h}))},pathToVML:function(a){for(var b=a.length,e=[];b--;)p(a[b])?e[b]=
Math.round(10*a[b])-5:"Z"===a[b]?e[b]="x":(e[b]=a[b],!a.isArc||"wa"!==a[b]&&"at"!==a[b]||(e[b+5]===e[b+7]&&(e[b+7]+=a[b+7]>a[b+5]?1:-1),e[b+6]===e[b+8]&&(e[b+8]+=a[b+8]>a[b+6]?1:-1)));return e.join(" ")||"x"},clip:function(a){var b=this,e;a?(e=a.members,q(e,b),e.push(b),b.destroyClip=function(){q(e,b)},a=a.getCSS(b)):(b.destroyClip&&b.destroyClip(),a={clip:b.docMode8?"inherit":"rect(auto)"});return b.css(a)},css:n.prototype.htmlCss,safeRemoveChild:function(a){a.parentNode&&f(a)},destroy:function(){this.destroyClip&&
this.destroyClip();return n.prototype.destroy.apply(this)},on:function(a,b){this.element["on"+a]=function(){var a=z.event;a.target=a.srcElement;b(a)};return this},cutOffPath:function(a,b){var e;a=a.split(/[ ,]/);e=a.length;if(9===e||11===e)a[e-4]=a[e-2]=c(a[e-2])-10*b;return a.join(" ")},shadow:function(a,b,n){var e=[],h,d=this.element,x=this.renderer,p,F=d.style,k,D=d.path,l,t,z,f;D&&"string"!==typeof D.value&&(D="x");t=D;if(a){z=m(a.width,3);f=(a.opacity||.15)/z;for(h=1;3>=h;h++)l=2*z+1-2*h,n&&
(t=this.cutOffPath(D.value,l+.5)),k=['\x3cshape isShadow\x3d"true" strokeweight\x3d"',l,'" filled\x3d"false" path\x3d"',t,'" coordsize\x3d"10 10" style\x3d"',d.style.cssText,'" /\x3e'],p=H(x.prepVML(k),null,{left:c(F.left)+m(a.offsetX,1),top:c(F.top)+m(a.offsetY,1)}),n&&(p.cutOff=l+1),k=['\x3cstroke color\x3d"',a.color||"#000000",'" opacity\x3d"',f*h,'"/\x3e'],H(x.prepVML(k),null,null,p),b?b.element.appendChild(p):d.parentNode.insertBefore(p,d),e.push(p);this.shadows=e}return this},updateShadows:A,
setAttr:function(a,b){this.docMode8?this.element[a]=b:this.element.setAttribute(a,b)},classSetter:function(a){(this.added?this.element:this).className=a},dashstyleSetter:function(a,b,c){(c.getElementsByTagName("stroke")[0]||H(this.renderer.prepVML(["\x3cstroke/\x3e"]),null,null,c))[b]=a||"solid";this[b]=a},dSetter:function(a,b,c){var e=this.shadows;a=a||[];this.d=a.join&&a.join(" ");c.path=a=this.pathToVML(a);if(e)for(c=e.length;c--;)e[c].path=e[c].cutOff?this.cutOffPath(a,e[c].cutOff):a;this.setAttr(b,
a)},fillSetter:function(a,b,c){var e=c.nodeName;"SPAN"===e?c.style.color=a:"IMG"!==e&&(c.filled="none"!==a,this.setAttr("fillcolor",this.renderer.color(a,c,b,this)))},"fill-opacitySetter":function(a,b,c){H(this.renderer.prepVML(["\x3c",b.split("-")[0],' opacity\x3d"',a,'"/\x3e']),null,null,c)},opacitySetter:A,rotationSetter:function(a,b,c){c=c.style;this[b]=c[b]=a;c.left=-Math.round(Math.sin(a*g)+1)+"px";c.top=Math.round(Math.cos(a*g))+"px"},strokeSetter:function(a,b,c){this.setAttr("strokecolor",
this.renderer.color(a,c,b,this))},"stroke-widthSetter":function(a,b,c){c.stroked=!!a;this[b]=a;p(a)&&(a+="px");this.setAttr("strokeweight",a)},titleSetter:function(a,b){this.setAttr(b,a)},visibilitySetter:function(a,b,c){"inherit"===a&&(a="visible");this.shadows&&l(this.shadows,function(c){c.style[b]=a});"DIV"===c.nodeName&&(a="hidden"===a?"-999em":0,this.docMode8||(c.style[b]=a?"visible":"hidden"),b="top");c.style[b]=a},xSetter:function(a,b,c){this[b]=a;"x"===b?b="left":"y"===b&&(b="top");this.updateClipping?
(this[b]=a,this.updateClipping()):c.style[b]=a},zIndexSetter:function(a,b,c){c.style[b]=a}},A["stroke-opacitySetter"]=A["fill-opacitySetter"],a.VMLElement=A=B(n,A),A.prototype.ySetter=A.prototype.widthSetter=A.prototype.heightSetter=A.prototype.xSetter,A={Element:A,isIE8:-1<z.navigator.userAgent.indexOf("MSIE 8.0"),init:function(a,b,c){var e,h;this.alignedObjects=[];e=this.createElement("div").css({position:"relative"});h=e.element;a.appendChild(e.element);this.isVML=!0;this.box=h;this.boxWrapper=
e;this.gradients={};this.cache={};this.cacheKeys=[];this.imgCount=0;this.setSize(b,c,!1);if(!u.namespaces.hcv){u.namespaces.add("hcv","urn:schemas-microsoft-com:vml");try{u.createStyleSheet().cssText="hcv\\:fill, hcv\\:path, hcv\\:shape, hcv\\:stroke{ behavior:url(#default#VML); display: inline-block; } "}catch(y){u.styleSheets[0].cssText+="hcv\\:fill, hcv\\:path, hcv\\:shape, hcv\\:stroke{ behavior:url(#default#VML); display: inline-block; } "}}},isHidden:function(){return!this.box.offsetWidth},
clipRect:function(a,b,c,n){var e=this.createElement(),m=C(a);return d(e,{members:[],count:0,left:(m?a.x:a)+1,top:(m?a.y:b)+1,width:(m?a.width:c)-1,height:(m?a.height:n)-1,getCSS:function(a){var b=a.element,c=b.nodeName,k=a.inverted,e=this.top-("shape"===c?b.offsetTop:0),h=this.left,b=h+this.width,n=e+this.height,e={clip:"rect("+Math.round(k?h:e)+"px,"+Math.round(k?n:b)+"px,"+Math.round(k?b:n)+"px,"+Math.round(k?e:h)+"px)"};!k&&a.docMode8&&"DIV"===c&&d(e,{width:b+"px",height:n+"px"});return e},updateClipping:function(){l(e.members,
function(a){a.element&&a.css(e.getCSS(a))})}})},color:function(b,c,n,m){var e=this,d,x=/^rgba/,p,t,k="none";b&&b.linearGradient?t="gradient":b&&b.radialGradient&&(t="pattern");if(t){var D,w,z=b.linearGradient||b.radialGradient,f,E,v,q,g,F="";b=b.stops;var C,u=[],r=function(){p=['\x3cfill colors\x3d"'+u.join(",")+'" opacity\x3d"',v,'" o:opacity2\x3d"',E,'" type\x3d"',t,'" ',F,'focus\x3d"100%" method\x3d"any" /\x3e'];H(e.prepVML(p),null,null,c)};f=b[0];C=b[b.length-1];0<f[0]&&b.unshift([0,f[1]]);1>
C[0]&&b.push([1,C[1]]);l(b,function(k,b){x.test(k[1])?(d=a.color(k[1]),D=d.get("rgb"),w=d.get("a")):(D=k[1],w=1);u.push(100*k[0]+"% "+D);b?(v=w,q=D):(E=w,g=D)});if("fill"===n)if("gradient"===t)n=z.x1||z[0]||0,b=z.y1||z[1]||0,f=z.x2||z[2]||0,z=z.y2||z[3]||0,F='angle\x3d"'+(90-180*Math.atan((z-b)/(f-n))/Math.PI)+'"',r();else{var k=z.r,A=2*k,B=2*k,G=z.cx,U=z.cy,L=c.radialReference,T,k=function(){L&&(T=m.getBBox(),G+=(L[0]-T.x)/T.width-.5,U+=(L[1]-T.y)/T.height-.5,A*=L[2]/T.width,B*=L[2]/T.height);F=
'src\x3d"'+a.getOptions().global.VMLRadialGradientURL+'" size\x3d"'+A+","+B+'" origin\x3d"0.5,0.5" position\x3d"'+G+","+U+'" color2\x3d"'+g+'" ';r()};m.added?k():m.onAdd=k;k=q}else k=D}else x.test(b)&&"IMG"!==c.tagName?(d=a.color(b),m[n+"-opacitySetter"](d.get("a"),n,c),k=d.get("rgb")):(k=c.getElementsByTagName(n),k.length&&(k[0].opacity=1,k[0].type="solid"),k=b);return k},prepVML:function(a){var b=this.isIE8;a=a.join("");b?(a=a.replace("/\x3e",' xmlns\x3d"urn:schemas-microsoft-com:vml" /\x3e'),a=
-1===a.indexOf('style\x3d"')?a.replace("/\x3e",' style\x3d"display:inline-block;behavior:url(#default#VML);" /\x3e'):a.replace('style\x3d"','style\x3d"display:inline-block;behavior:url(#default#VML);')):a=a.replace("\x3c","\x3chcv:");return a},text:E.prototype.html,path:function(a){var c={coordsize:"10 10"};b(a)?c.d=a:C(a)&&d(c,a);return this.createElement("shape").attr(c)},circle:function(a,b,c){var e=this.symbol("circle");C(a)&&(c=a.r,b=a.y,a=a.x);e.isCircle=!0;e.r=c;return e.attr({x:a,y:b})},g:function(a){var b;
a&&(b={className:"highcharts-"+a,"class":"highcharts-"+a});return this.createElement("div").attr(b)},image:function(a,b,c,n,h){var e=this.createElement("img").attr({src:a});1<arguments.length&&e.attr({x:b,y:c,width:n,height:h});return e},createElement:function(a){return"rect"===a?this.symbol(a):E.prototype.createElement.call(this,a)},invertChild:function(a,b){var e=this;b=b.style;var n="IMG"===a.tagName&&a.style;G(a,{flip:"x",left:c(b.width)-(n?c(n.top):1),top:c(b.height)-(n?c(n.left):1),rotation:-90});
l(a.childNodes,function(b){e.invertChild(b,a)})},symbols:{arc:function(a,b,c,n,h){var e=h.start,m=h.end,d=h.r||c||n;c=h.innerR;n=Math.cos(e);var p=Math.sin(e),k=Math.cos(m),D=Math.sin(m);if(0===m-e)return["x"];e=["wa",a-d,b-d,a+d,b+d,a+d*n,b+d*p,a+d*k,b+d*D];h.open&&!c&&e.push("e","M",a,b);e.push("at",a-c,b-c,a+c,b+c,a+c*k,b+c*D,a+c*n,b+c*p,"x","e");e.isArc=!0;return e},circle:function(a,b,c,n,h){h&&r(h.r)&&(c=n=2*h.r);h&&h.isCircle&&(a-=c/2,b-=n/2);return["wa",a,b,a+c,b+n,a+c,b+n/2,a+c,b+n/2,"e"]},
rect:function(a,b,c,n,h){return E.prototype.symbols[r(h)&&h.r?"callout":"square"].call(0,a,b,c,n,h)}}},a.VMLRenderer=B=function(){this.init.apply(this,arguments)},B.prototype=t(E.prototype,A),a.Renderer=B);E.prototype.measureSpanWidth=function(a,b){var c=u.createElement("span");a=u.createTextNode(a);c.appendChild(a);G(c,b);this.box.appendChild(c);b=c.offsetWidth;f(c);return b}})(L);(function(a){function B(){var l=a.defaultOptions.global,f=u.moment;if(l.timezone){if(f)return function(a){return-f.tz(a,
l.timezone).utcOffset()};a.error(25)}return l.useUTC&&l.getTimezoneOffset}function A(){var l=a.defaultOptions.global,q,d=l.useUTC,b=d?"getUTC":"get",p=d?"setUTC":"set";a.Date=q=l.Date||u.Date;q.hcTimezoneOffset=d&&l.timezoneOffset;q.hcGetTimezoneOffset=B();q.hcMakeTime=function(a,b,m,c,n,p){var l;d?(l=q.UTC.apply(0,arguments),l+=r(l)):l=(new q(a,b,f(m,1),f(c,0),f(n,0),f(p,0))).getTime();return l};G("Minutes Hours Day Date Month FullYear".split(" "),function(a){q["hcGet"+a]=b+a});G("Milliseconds Seconds Minutes Hours Date Month FullYear".split(" "),
function(a){q["hcSet"+a]=p+a})}var H=a.color,G=a.each,r=a.getTZOffset,g=a.merge,f=a.pick,u=a.win;a.defaultOptions={colors:"#7cb5ec #434348 #90ed7d #f7a35c #8085e9 #f15c80 #e4d354 #2b908f #f45b5b #91e8e1".split(" "),symbols:["circle","diamond","square","triangle","triangle-down"],lang:{loading:"Loading...",months:"January February March April May June July August September October November December".split(" "),shortMonths:"Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" "),weekdays:"Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "),
decimalPoint:".",numericSymbols:"kMGTPE".split(""),resetZoom:"Reset zoom",resetZoomTitle:"Reset zoom level 1:1",thousandsSep:" "},global:{useUTC:!0,VMLRadialGradientURL:"http://code.highcharts.com/5.0.7/gfx/vml-radial-gradient.png"},chart:{borderRadius:0,defaultSeriesType:"line",ignoreHiddenSeries:!0,spacing:[10,10,15,10],resetZoomButton:{theme:{zIndex:20},position:{align:"right",x:-10,y:10}},width:null,height:null,borderColor:"#335cad",backgroundColor:"#ffffff",plotBorderColor:"#cccccc"},title:{text:"Chart title",
align:"center",margin:15,widthAdjust:-44},subtitle:{text:"",align:"center",widthAdjust:-44},plotOptions:{},labels:{style:{position:"absolute",color:"#333333"}},legend:{enabled:!0,align:"center",layout:"horizontal",labelFormatter:function(){return this.name},borderColor:"#999999",borderRadius:0,navigation:{activeColor:"#003399",inactiveColor:"#cccccc"},itemStyle:{color:"#333333",fontSize:"12px",fontWeight:"bold"},itemHoverStyle:{color:"#000000"},itemHiddenStyle:{color:"#cccccc"},shadow:!1,itemCheckboxStyle:{position:"absolute",
width:"13px",height:"13px"},squareSymbol:!0,symbolPadding:5,verticalAlign:"bottom",x:0,y:0,title:{style:{fontWeight:"bold"}}},loading:{labelStyle:{fontWeight:"bold",position:"relative",top:"45%"},style:{position:"absolute",backgroundColor:"#ffffff",opacity:.5,textAlign:"center"}},tooltip:{enabled:!0,animation:a.svg,borderRadius:3,dateTimeLabelFormats:{millisecond:"%A, %b %e, %H:%M:%S.%L",second:"%A, %b %e, %H:%M:%S",minute:"%A, %b %e, %H:%M",hour:"%A, %b %e, %H:%M",day:"%A, %b %e, %Y",week:"Week from %A, %b %e, %Y",
month:"%B %Y",year:"%Y"},footerFormat:"",padding:8,snap:a.isTouchDevice?25:10,backgroundColor:H("#f7f7f7").setOpacity(.85).get(),borderWidth:1,headerFormat:'\x3cspan style\x3d"font-size: 10px"\x3e{point.key}\x3c/span\x3e\x3cbr/\x3e',pointFormat:'\x3cspan style\x3d"color:{point.color}"\x3e\u25cf\x3c/span\x3e {series.name}: \x3cb\x3e{point.y}\x3c/b\x3e\x3cbr/\x3e',shadow:!0,style:{color:"#333333",cursor:"default",fontSize:"12px",pointerEvents:"none",whiteSpace:"nowrap"}},credits:{enabled:!0,href:"http://www.highcharts.com",
position:{align:"right",x:-10,verticalAlign:"bottom",y:-5},style:{cursor:"pointer",color:"#999999",fontSize:"9px"},text:"Highcharts.com"}};a.setOptions=function(l){a.defaultOptions=g(!0,a.defaultOptions,l);A();return a.defaultOptions};a.getOptions=function(){return a.defaultOptions};a.defaultPlotOptions=a.defaultOptions.plotOptions;A()})(L);(function(a){var B=a.arrayMax,A=a.arrayMin,H=a.defined,G=a.destroyObjectProperties,r=a.each,g=a.erase,f=a.merge,u=a.pick;a.PlotLineOrBand=function(a,f){this.axis=
a;f&&(this.options=f,this.id=f.id)};a.PlotLineOrBand.prototype={render:function(){var a=this,q=a.axis,d=q.horiz,b=a.options,p=b.label,g=a.label,t=b.to,m=b.from,c=b.value,n=H(m)&&H(t),E=H(c),z=a.svgElem,e=!z,x=[],F,w=b.color,h=u(b.zIndex,0),y=b.events,x={"class":"highcharts-plot-"+(n?"band ":"line ")+(b.className||"")},J={},K=q.chart.renderer,I=n?"bands":"lines",k=q.log2lin;q.isLog&&(m=k(m),t=k(t),c=k(c));E?(x={stroke:w,"stroke-width":b.width},b.dashStyle&&(x.dashstyle=b.dashStyle)):n&&(w&&(x.fill=
w),b.borderWidth&&(x.stroke=b.borderColor,x["stroke-width"]=b.borderWidth));J.zIndex=h;I+="-"+h;(w=q[I])||(q[I]=w=K.g("plot-"+I).attr(J).add());e&&(a.svgElem=z=K.path().attr(x).add(w));if(E)x=q.getPlotLinePath(c,z.strokeWidth());else if(n)x=q.getPlotBandPath(m,t,b);else return;if(e&&x&&x.length){if(z.attr({d:x}),y)for(F in b=function(b){z.on(b,function(k){y[b].apply(a,[k])})},y)b(F)}else z&&(x?(z.show(),z.animate({d:x})):(z.hide(),g&&(a.label=g=g.destroy())));p&&H(p.text)&&x&&x.length&&0<q.width&&
0<q.height&&!x.flat?(p=f({align:d&&n&&"center",x:d?!n&&4:10,verticalAlign:!d&&n&&"middle",y:d?n?16:10:n?6:-4,rotation:d&&!n&&90},p),this.renderLabel(p,x,n,h)):g&&g.hide();return a},renderLabel:function(a,f,d,b){var p=this.label,l=this.axis.chart.renderer;p||(p={align:a.textAlign||a.align,rotation:a.rotation,"class":"highcharts-plot-"+(d?"band":"line")+"-label "+(a.className||"")},p.zIndex=b,this.label=p=l.text(a.text,0,0,a.useHTML).attr(p).add(),p.css(a.style));b=[f[1],f[4],d?f[6]:f[1]];f=[f[2],f[5],
d?f[7]:f[2]];d=A(b);l=A(f);p.align(a,!1,{x:d,y:l,width:B(b)-d,height:B(f)-l});p.show()},destroy:function(){g(this.axis.plotLinesAndBands,this);delete this.axis;G(this)}};a.AxisPlotLineOrBandExtension={getPlotBandPath:function(a,f){f=this.getPlotLinePath(f,null,null,!0);(a=this.getPlotLinePath(a,null,null,!0))&&f?(a.flat=a.toString()===f.toString(),a.push(f[4],f[5],f[1],f[2],"z")):a=null;return a},addPlotBand:function(a){return this.addPlotBandOrLine(a,"plotBands")},addPlotLine:function(a){return this.addPlotBandOrLine(a,
"plotLines")},addPlotBandOrLine:function(f,g){var d=(new a.PlotLineOrBand(this,f)).render(),b=this.userOptions;d&&(g&&(b[g]=b[g]||[],b[g].push(f)),this.plotLinesAndBands.push(d));return d},removePlotBandOrLine:function(a){for(var f=this.plotLinesAndBands,d=this.options,b=this.userOptions,p=f.length;p--;)f[p].id===a&&f[p].destroy();r([d.plotLines||[],b.plotLines||[],d.plotBands||[],b.plotBands||[]],function(b){for(p=b.length;p--;)b[p].id===a&&g(b,b[p])})}}})(L);(function(a){var B=a.correctFloat,A=
a.defined,H=a.destroyObjectProperties,G=a.isNumber,r=a.merge,g=a.pick,f=a.deg2rad;a.Tick=function(a,f,g,d){this.axis=a;this.pos=f;this.type=g||"";this.isNew=!0;g||d||this.addLabel()};a.Tick.prototype={addLabel:function(){var a=this.axis,f=a.options,q=a.chart,d=a.categories,b=a.names,p=this.pos,C=f.labels,t=a.tickPositions,m=p===t[0],c=p===t[t.length-1],b=d?g(d[p],b[p],p):p,d=this.label,t=t.info,n;a.isDatetimeAxis&&t&&(n=f.dateTimeLabelFormats[t.higherRanks[p]||t.unitName]);this.isFirst=m;this.isLast=
c;f=a.labelFormatter.call({axis:a,chart:q,isFirst:m,isLast:c,dateTimeLabelFormat:n,value:a.isLog?B(a.lin2log(b)):b});A(d)?d&&d.attr({text:f}):(this.labelLength=(this.label=d=A(f)&&C.enabled?q.renderer.text(f,0,0,C.useHTML).css(r(C.style)).add(a.labelGroup):null)&&d.getBBox().width,this.rotation=0)},getLabelSize:function(){return this.label?this.label.getBBox()[this.axis.horiz?"height":"width"]:0},handleOverflow:function(a){var l=this.axis,q=a.x,d=l.chart.chartWidth,b=l.chart.spacing,p=g(l.labelLeft,
Math.min(l.pos,b[3])),b=g(l.labelRight,Math.max(l.pos+l.len,d-b[1])),C=this.label,t=this.rotation,m={left:0,center:.5,right:1}[l.labelAlign],c=C.getBBox().width,n=l.getSlotWidth(),E=n,z=1,e,x={};if(t)0>t&&q-m*c<p?e=Math.round(q/Math.cos(t*f)-p):0<t&&q+m*c>b&&(e=Math.round((d-q)/Math.cos(t*f)));else if(d=q+(1-m)*c,q-m*c<p?E=a.x+E*(1-m)-p:d>b&&(E=b-a.x+E*m,z=-1),E=Math.min(n,E),E<n&&"center"===l.labelAlign&&(a.x+=z*(n-E-m*(n-Math.min(c,E)))),c>E||l.autoRotation&&(C.styles||{}).width)e=E;e&&(x.width=
e,(l.options.labels.style||{}).textOverflow||(x.textOverflow="ellipsis"),C.css(x))},getPosition:function(a,f,g,d){var b=this.axis,p=b.chart,l=d&&p.oldChartHeight||p.chartHeight;return{x:a?b.translate(f+g,null,null,d)+b.transB:b.left+b.offset+(b.opposite?(d&&p.oldChartWidth||p.chartWidth)-b.right-b.left:0),y:a?l-b.bottom+b.offset-(b.opposite?b.height:0):l-b.translate(f+g,null,null,d)-b.transB}},getLabelPosition:function(a,g,q,d,b,p,C,t){var m=this.axis,c=m.transA,n=m.reversed,E=m.staggerLines,z=m.tickRotCorr||
{x:0,y:0},e=b.y;A(e)||(e=0===m.side?q.rotation?-8:-q.getBBox().height:2===m.side?z.y+8:Math.cos(q.rotation*f)*(z.y-q.getBBox(!1,0).height/2));a=a+b.x+z.x-(p&&d?p*c*(n?-1:1):0);g=g+e-(p&&!d?p*c*(n?1:-1):0);E&&(q=C/(t||1)%E,m.opposite&&(q=E-q-1),g+=m.labelOffset/E*q);return{x:a,y:Math.round(g)}},getMarkPath:function(a,f,g,d,b,p){return p.crispLine(["M",a,f,"L",a+(b?0:-g),f+(b?g:0)],d)},render:function(a,f,q){var d=this.axis,b=d.options,p=d.chart.renderer,l=d.horiz,t=this.type,m=this.label,c=this.pos,
n=b.labels,E=this.gridLine,z=t?t+"Tick":"tick",e=d.tickSize(z),x=this.mark,F=!x,w=n.step,h={},y=!0,J=d.tickmarkOffset,K=this.getPosition(l,c,J,f),I=K.x,K=K.y,k=l&&I===d.pos+d.len||!l&&K===d.pos?-1:1,D=t?t+"Grid":"grid",P=b[D+"LineWidth"],N=b[D+"LineColor"],r=b[D+"LineDashStyle"],D=g(b[z+"Width"],!t&&d.isXAxis?1:0),z=b[z+"Color"];q=g(q,1);this.isActive=!0;E||(h.stroke=N,h["stroke-width"]=P,r&&(h.dashstyle=r),t||(h.zIndex=1),f&&(h.opacity=0),this.gridLine=E=p.path().attr(h).addClass("highcharts-"+(t?
t+"-":"")+"grid-line").add(d.gridGroup));if(!f&&E&&(c=d.getPlotLinePath(c+J,E.strokeWidth()*k,f,!0)))E[this.isNew?"attr":"animate"]({d:c,opacity:q});e&&(d.opposite&&(e[0]=-e[0]),F&&(this.mark=x=p.path().addClass("highcharts-"+(t?t+"-":"")+"tick").add(d.axisGroup),x.attr({stroke:z,"stroke-width":D})),x[F?"attr":"animate"]({d:this.getMarkPath(I,K,e[0],x.strokeWidth()*k,l,p),opacity:q}));m&&G(I)&&(m.xy=K=this.getLabelPosition(I,K,m,l,n,J,a,w),this.isFirst&&!this.isLast&&!g(b.showFirstLabel,1)||this.isLast&&
!this.isFirst&&!g(b.showLastLabel,1)?y=!1:!l||d.isRadial||n.step||n.rotation||f||0===q||this.handleOverflow(K),w&&a%w&&(y=!1),y&&G(K.y)?(K.opacity=q,m[this.isNew?"attr":"animate"](K)):m.attr("y",-9999),this.isNew=!1)},destroy:function(){H(this,this.axis)}}})(L);(function(a){var B=a.addEvent,A=a.animObject,H=a.arrayMax,G=a.arrayMin,r=a.AxisPlotLineOrBandExtension,g=a.color,f=a.correctFloat,u=a.defaultOptions,l=a.defined,q=a.deg2rad,d=a.destroyObjectProperties,b=a.each,p=a.extend,C=a.fireEvent,t=a.format,
m=a.getMagnitude,c=a.grep,n=a.inArray,E=a.isArray,z=a.isNumber,e=a.isString,x=a.merge,F=a.normalizeTickInterval,w=a.pick,h=a.PlotLineOrBand,y=a.removeEvent,J=a.splat,K=a.syncTimeout,I=a.Tick;a.Axis=function(){this.init.apply(this,arguments)};a.Axis.prototype={defaultOptions:{dateTimeLabelFormats:{millisecond:"%H:%M:%S.%L",second:"%H:%M:%S",minute:"%H:%M",hour:"%H:%M",day:"%e. %b",week:"%e. %b",month:"%b '%y",year:"%Y"},endOnTick:!1,labels:{enabled:!0,style:{color:"#666666",cursor:"default",fontSize:"11px"},
x:0},minPadding:.01,maxPadding:.01,minorTickLength:2,minorTickPosition:"outside",startOfWeek:1,startOnTick:!1,tickLength:10,tickmarkPlacement:"between",tickPixelInterval:100,tickPosition:"outside",title:{align:"middle",style:{color:"#666666"}},type:"linear",minorGridLineColor:"#f2f2f2",minorGridLineWidth:1,minorTickColor:"#999999",lineColor:"#ccd6eb",lineWidth:1,gridLineColor:"#e6e6e6",tickColor:"#ccd6eb"},defaultYAxisOptions:{endOnTick:!0,tickPixelInterval:72,showLastLabel:!0,labels:{x:-8},maxPadding:.05,
minPadding:.05,startOnTick:!0,title:{rotation:270,text:"Values"},stackLabels:{enabled:!1,formatter:function(){return a.numberFormat(this.total,-1)},style:{fontSize:"11px",fontWeight:"bold",color:"#000000",textOutline:"1px contrast"}},gridLineWidth:1,lineWidth:0},defaultLeftAxisOptions:{labels:{x:-15},title:{rotation:270}},defaultRightAxisOptions:{labels:{x:15},title:{rotation:90}},defaultBottomAxisOptions:{labels:{autoRotation:[-45],x:0},title:{rotation:0}},defaultTopAxisOptions:{labels:{autoRotation:[-45],
x:0},title:{rotation:0}},init:function(a,b){var k=b.isX;this.chart=a;this.horiz=a.inverted?!k:k;this.isXAxis=k;this.coll=this.coll||(k?"xAxis":"yAxis");this.opposite=b.opposite;this.side=b.side||(this.horiz?this.opposite?0:2:this.opposite?1:3);this.setOptions(b);var c=this.options,e=c.type;this.labelFormatter=c.labels.formatter||this.defaultLabelFormatter;this.userOptions=b;this.minPixelPadding=0;this.reversed=c.reversed;this.visible=!1!==c.visible;this.zoomEnabled=!1!==c.zoomEnabled;this.hasNames=
"category"===e||!0===c.categories;this.categories=c.categories||this.hasNames;this.names=this.names||[];this.isLog="logarithmic"===e;this.isDatetimeAxis="datetime"===e;this.isLinked=l(c.linkedTo);this.ticks={};this.labelEdge=[];this.minorTicks={};this.plotLinesAndBands=[];this.alternateBands={};this.len=0;this.minRange=this.userMinRange=c.minRange||c.maxZoom;this.range=c.range;this.offset=c.offset||0;this.stacks={};this.oldStacks={};this.stacksTouched=0;this.min=this.max=null;this.crosshair=w(c.crosshair,
J(a.options.tooltip.crosshairs)[k?0:1],!1);var h;b=this.options.events;-1===n(this,a.axes)&&(k?a.axes.splice(a.xAxis.length,0,this):a.axes.push(this),a[this.coll].push(this));this.series=this.series||[];a.inverted&&k&&void 0===this.reversed&&(this.reversed=!0);this.removePlotLine=this.removePlotBand=this.removePlotBandOrLine;for(h in b)B(this,h,b[h]);this.isLog&&(this.val2lin=this.log2lin,this.lin2val=this.lin2log)},setOptions:function(a){this.options=x(this.defaultOptions,"yAxis"===this.coll&&this.defaultYAxisOptions,
[this.defaultTopAxisOptions,this.defaultRightAxisOptions,this.defaultBottomAxisOptions,this.defaultLeftAxisOptions][this.side],x(u[this.coll],a))},defaultLabelFormatter:function(){var b=this.axis,c=this.value,e=b.categories,h=this.dateTimeLabelFormat,n=u.lang,d=n.numericSymbols,n=n.numericSymbolMagnitude||1E3,v=d&&d.length,m,f=b.options.labels.format,b=b.isLog?c:b.tickInterval;if(f)m=t(f,this);else if(e)m=c;else if(h)m=a.dateFormat(h,c);else if(v&&1E3<=b)for(;v--&&void 0===m;)e=Math.pow(n,v+1),b>=
e&&0===10*c%e&&null!==d[v]&&0!==c&&(m=a.numberFormat(c/e,-1)+d[v]);void 0===m&&(m=1E4<=Math.abs(c)?a.numberFormat(c,-1):a.numberFormat(c,-1,void 0,""));return m},getSeriesExtremes:function(){var a=this,e=a.chart;a.hasVisibleSeries=!1;a.dataMin=a.dataMax=a.threshold=null;a.softThreshold=!a.isXAxis;a.buildStacks&&a.buildStacks();b(a.series,function(b){if(b.visible||!e.options.chart.ignoreHiddenSeries){var k=b.options,h=k.threshold,D;a.hasVisibleSeries=!0;a.isLog&&0>=h&&(h=null);if(a.isXAxis)k=b.xData,
k.length&&(b=G(k),z(b)||b instanceof Date||(k=c(k,function(a){return z(a)}),b=G(k)),a.dataMin=Math.min(w(a.dataMin,k[0]),b),a.dataMax=Math.max(w(a.dataMax,k[0]),H(k)));else if(b.getExtremes(),D=b.dataMax,b=b.dataMin,l(b)&&l(D)&&(a.dataMin=Math.min(w(a.dataMin,b),b),a.dataMax=Math.max(w(a.dataMax,D),D)),l(h)&&(a.threshold=h),!k.softThreshold||a.isLog)a.softThreshold=!1}})},translate:function(a,b,c,e,h,n){var k=this.linkedParent||this,D=1,m=0,d=e?k.oldTransA:k.transA;e=e?k.oldMin:k.min;var f=k.minPixelPadding;
h=(k.isOrdinal||k.isBroken||k.isLog&&h)&&k.lin2val;d||(d=k.transA);c&&(D*=-1,m=k.len);k.reversed&&(D*=-1,m-=D*(k.sector||k.len));b?(a=(a*D+m-f)/d+e,h&&(a=k.lin2val(a))):(h&&(a=k.val2lin(a)),a=D*(a-e)*d+m+D*f+(z(n)?d*n:0));return a},toPixels:function(a,b){return this.translate(a,!1,!this.horiz,null,!0)+(b?0:this.pos)},toValue:function(a,b){return this.translate(a-(b?0:this.pos),!0,!this.horiz,null,!0)},getPlotLinePath:function(a,b,c,e,h){var k=this.chart,D=this.left,n=this.top,m,d,f=c&&k.oldChartHeight||
k.chartHeight,p=c&&k.oldChartWidth||k.chartWidth,y;m=this.transB;var t=function(a,b,k){if(a<b||a>k)e?a=Math.min(Math.max(b,a),k):y=!0;return a};h=w(h,this.translate(a,null,null,c));a=c=Math.round(h+m);m=d=Math.round(f-h-m);z(h)?this.horiz?(m=n,d=f-this.bottom,a=c=t(a,D,D+this.width)):(a=D,c=p-this.right,m=d=t(m,n,n+this.height)):y=!0;return y&&!e?null:k.renderer.crispLine(["M",a,m,"L",c,d],b||1)},getLinearTickPositions:function(a,b,c){var k,e=f(Math.floor(b/a)*a),h=f(Math.ceil(c/a)*a),D=[];if(b===
c&&z(b))return[b];for(b=e;b<=h;){D.push(b);b=f(b+a);if(b===k)break;k=b}return D},getMinorTickPositions:function(){var a=this.options,b=this.tickPositions,c=this.minorTickInterval,e=[],h,n=this.pointRangePadding||0;h=this.min-n;var n=this.max+n,m=n-h;if(m&&m/c<this.len/3)if(this.isLog)for(n=b.length,h=1;h<n;h++)e=e.concat(this.getLogTickPositions(c,b[h-1],b[h],!0));else if(this.isDatetimeAxis&&"auto"===a.minorTickInterval)e=e.concat(this.getTimeTicks(this.normalizeTimeTickInterval(c),h,n,a.startOfWeek));
else for(b=h+(b[0]-h)%c;b<=n&&b!==e[0];b+=c)e.push(b);0!==e.length&&this.trimTicks(e,a.startOnTick,a.endOnTick);return e},adjustForMinRange:function(){var a=this.options,c=this.min,e=this.max,h,n=this.dataMax-this.dataMin>=this.minRange,m,v,d,f,p,y;this.isXAxis&&void 0===this.minRange&&!this.isLog&&(l(a.min)||l(a.max)?this.minRange=null:(b(this.series,function(a){f=a.xData;for(v=p=a.xIncrement?1:f.length-1;0<v;v--)if(d=f[v]-f[v-1],void 0===m||d<m)m=d}),this.minRange=Math.min(5*m,this.dataMax-this.dataMin)));
e-c<this.minRange&&(y=this.minRange,h=(y-e+c)/2,h=[c-h,w(a.min,c-h)],n&&(h[2]=this.isLog?this.log2lin(this.dataMin):this.dataMin),c=H(h),e=[c+y,w(a.max,c+y)],n&&(e[2]=this.isLog?this.log2lin(this.dataMax):this.dataMax),e=G(e),e-c<y&&(h[0]=e-y,h[1]=w(a.min,e-y),c=H(h)));this.min=c;this.max=e},getClosest:function(){var a;this.categories?a=1:b(this.series,function(b){var k=b.closestPointRange,c=b.visible||!b.chart.options.chart.ignoreHiddenSeries;!b.noSharedTooltip&&l(k)&&c&&(a=l(a)?Math.min(a,k):k)});
return a},nameToX:function(a){var b=E(this.categories),k=b?this.categories:this.names,c=a.options.x,e;a.series.requireSorting=!1;l(c)||(c=!1===this.options.uniqueNames?a.series.autoIncrement():n(a.name,k));-1===c?b||(e=k.length):e=c;this.names[e]=a.name;return e},updateNames:function(){var a=this;0<this.names.length&&(this.names.length=0,this.minRange=void 0,b(this.series||[],function(k){k.xIncrement=null;if(!k.points||k.isDirtyData)k.processData(),k.generatePoints();b(k.points,function(b,c){var e;
b.options&&(e=a.nameToX(b),e!==b.x&&(b.x=e,k.xData[c]=e))})}))},setAxisTranslation:function(a){var k=this,c=k.max-k.min,h=k.axisPointRange||0,n,m=0,d=0,f=k.linkedParent,y=!!k.categories,p=k.transA,t=k.isXAxis;if(t||y||h)n=k.getClosest(),f?(m=f.minPointOffset,d=f.pointRangePadding):b(k.series,function(a){var b=y?1:t?w(a.options.pointRange,n,0):k.axisPointRange||0;a=a.options.pointPlacement;h=Math.max(h,b);k.single||(m=Math.max(m,e(a)?0:b/2),d=Math.max(d,"on"===a?0:b))}),f=k.ordinalSlope&&n?k.ordinalSlope/
n:1,k.minPointOffset=m*=f,k.pointRangePadding=d*=f,k.pointRange=Math.min(h,c),t&&(k.closestPointRange=n);a&&(k.oldTransA=p);k.translationSlope=k.transA=p=k.len/(c+d||1);k.transB=k.horiz?k.left:k.bottom;k.minPixelPadding=p*m},minFromRange:function(){return this.max-this.range},setTickInterval:function(k){var c=this,e=c.chart,h=c.options,n=c.isLog,d=c.log2lin,v=c.isDatetimeAxis,y=c.isXAxis,p=c.isLinked,t=h.maxPadding,x=h.minPadding,g=h.tickInterval,E=h.tickPixelInterval,q=c.categories,J=c.threshold,
K=c.softThreshold,I,r,u,A;v||q||p||this.getTickAmount();u=w(c.userMin,h.min);A=w(c.userMax,h.max);p?(c.linkedParent=e[c.coll][h.linkedTo],e=c.linkedParent.getExtremes(),c.min=w(e.min,e.dataMin),c.max=w(e.max,e.dataMax),h.type!==c.linkedParent.options.type&&a.error(11,1)):(!K&&l(J)&&(c.dataMin>=J?(I=J,x=0):c.dataMax<=J&&(r=J,t=0)),c.min=w(u,I,c.dataMin),c.max=w(A,r,c.dataMax));n&&(!k&&0>=Math.min(c.min,w(c.dataMin,c.min))&&a.error(10,1),c.min=f(d(c.min),15),c.max=f(d(c.max),15));c.range&&l(c.max)&&
(c.userMin=c.min=u=Math.max(c.min,c.minFromRange()),c.userMax=A=c.max,c.range=null);C(c,"foundExtremes");c.beforePadding&&c.beforePadding();c.adjustForMinRange();!(q||c.axisPointRange||c.usePercentage||p)&&l(c.min)&&l(c.max)&&(d=c.max-c.min)&&(!l(u)&&x&&(c.min-=d*x),!l(A)&&t&&(c.max+=d*t));z(h.floor)?c.min=Math.max(c.min,h.floor):z(h.softMin)&&(c.min=Math.min(c.min,h.softMin));z(h.ceiling)?c.max=Math.min(c.max,h.ceiling):z(h.softMax)&&(c.max=Math.max(c.max,h.softMax));K&&l(c.dataMin)&&(J=J||0,!l(u)&&
c.min<J&&c.dataMin>=J?c.min=J:!l(A)&&c.max>J&&c.dataMax<=J&&(c.max=J));c.tickInterval=c.min===c.max||void 0===c.min||void 0===c.max?1:p&&!g&&E===c.linkedParent.options.tickPixelInterval?g=c.linkedParent.tickInterval:w(g,this.tickAmount?(c.max-c.min)/Math.max(this.tickAmount-1,1):void 0,q?1:(c.max-c.min)*E/Math.max(c.len,E));y&&!k&&b(c.series,function(a){a.processData(c.min!==c.oldMin||c.max!==c.oldMax)});c.setAxisTranslation(!0);c.beforeSetTickPositions&&c.beforeSetTickPositions();c.postProcessTickInterval&&
(c.tickInterval=c.postProcessTickInterval(c.tickInterval));c.pointRange&&!g&&(c.tickInterval=Math.max(c.pointRange,c.tickInterval));k=w(h.minTickInterval,c.isDatetimeAxis&&c.closestPointRange);!g&&c.tickInterval<k&&(c.tickInterval=k);v||n||g||(c.tickInterval=F(c.tickInterval,null,m(c.tickInterval),w(h.allowDecimals,!(.5<c.tickInterval&&5>c.tickInterval&&1E3<c.max&&9999>c.max)),!!this.tickAmount));this.tickAmount||(c.tickInterval=c.unsquish());this.setTickPositions()},setTickPositions:function(){var a=
this.options,b,c=a.tickPositions,e=a.tickPositioner,h=a.startOnTick,n=a.endOnTick,m;this.tickmarkOffset=this.categories&&"between"===a.tickmarkPlacement&&1===this.tickInterval?.5:0;this.minorTickInterval="auto"===a.minorTickInterval&&this.tickInterval?this.tickInterval/5:a.minorTickInterval;this.tickPositions=b=c&&c.slice();!b&&(b=this.isDatetimeAxis?this.getTimeTicks(this.normalizeTimeTickInterval(this.tickInterval,a.units),this.min,this.max,a.startOfWeek,this.ordinalPositions,this.closestPointRange,
!0):this.isLog?this.getLogTickPositions(this.tickInterval,this.min,this.max):this.getLinearTickPositions(this.tickInterval,this.min,this.max),b.length>this.len&&(b=[b[0],b.pop()]),this.tickPositions=b,e&&(e=e.apply(this,[this.min,this.max])))&&(this.tickPositions=b=e);this.trimTicks(b,h,n);this.isLinked||(this.min===this.max&&l(this.min)&&!this.tickAmount&&(m=!0,this.min-=.5,this.max+=.5),this.single=m,c||e||this.adjustTickAmount())},trimTicks:function(a,b,c){var k=a[0],e=a[a.length-1],h=this.minPointOffset||
0;if(!this.isLinked){if(b)this.min=k;else for(;this.min-h>a[0];)a.shift();if(c)this.max=e;else for(;this.max+h<a[a.length-1];)a.pop();0===a.length&&l(k)&&a.push((e+k)/2)}},alignToOthers:function(){var a={},c,e=this.options;!1===this.chart.options.chart.alignTicks||!1===e.alignTicks||this.isLog||b(this.chart[this.coll],function(b){var k=b.options,k=[b.horiz?k.left:k.top,k.width,k.height,k.pane].join();b.series.length&&(a[k]?c=!0:a[k]=1)});return c},getTickAmount:function(){var a=this.options,b=a.tickAmount,
c=a.tickPixelInterval;!l(a.tickInterval)&&this.len<c&&!this.isRadial&&!this.isLog&&a.startOnTick&&a.endOnTick&&(b=2);!b&&this.alignToOthers()&&(b=Math.ceil(this.len/c)+1);4>b&&(this.finalTickAmt=b,b=5);this.tickAmount=b},adjustTickAmount:function(){var a=this.tickInterval,b=this.tickPositions,c=this.tickAmount,e=this.finalTickAmt,h=b&&b.length;if(h<c){for(;b.length<c;)b.push(f(b[b.length-1]+a));this.transA*=(h-1)/(c-1);this.max=b[b.length-1]}else h>c&&(this.tickInterval*=2,this.setTickPositions());
if(l(e)){for(a=c=b.length;a--;)(3===e&&1===a%2||2>=e&&0<a&&a<c-1)&&b.splice(a,1);this.finalTickAmt=void 0}},setScale:function(){var a,c;this.oldMin=this.min;this.oldMax=this.max;this.oldAxisLength=this.len;this.setAxisSize();c=this.len!==this.oldAxisLength;b(this.series,function(b){if(b.isDirtyData||b.isDirty||b.xAxis.isDirty)a=!0});c||a||this.isLinked||this.forceRedraw||this.userMin!==this.oldUserMin||this.userMax!==this.oldUserMax||this.alignToOthers()?(this.resetStacks&&this.resetStacks(),this.forceRedraw=
!1,this.getSeriesExtremes(),this.setTickInterval(),this.oldUserMin=this.userMin,this.oldUserMax=this.userMax,this.isDirty||(this.isDirty=c||this.min!==this.oldMin||this.max!==this.oldMax)):this.cleanStacks&&this.cleanStacks()},setExtremes:function(a,c,e,h,n){var k=this,m=k.chart;e=w(e,!0);b(k.series,function(a){delete a.kdTree});n=p(n,{min:a,max:c});C(k,"setExtremes",n,function(){k.userMin=a;k.userMax=c;k.eventArgs=n;e&&m.redraw(h)})},zoom:function(a,b){var c=this.dataMin,k=this.dataMax,e=this.options,
h=Math.min(c,w(e.min,c)),e=Math.max(k,w(e.max,k));if(a!==this.min||b!==this.max)this.allowZoomOutside||(l(c)&&(a<h&&(a=h),a>e&&(a=e)),l(k)&&(b<h&&(b=h),b>e&&(b=e))),this.displayBtn=void 0!==a||void 0!==b,this.setExtremes(a,b,!1,void 0,{trigger:"zoom"});return!0},setAxisSize:function(){var a=this.chart,b=this.options,c=b.offsets||[0,0,0,0],e=this.horiz,h=w(b.width,a.plotWidth-c[3]+c[1]),n=w(b.height,a.plotHeight-c[0]+c[2]),m=w(b.top,a.plotTop+c[0]),b=w(b.left,a.plotLeft+c[3]),c=/%$/;c.test(n)&&(n=
Math.round(parseFloat(n)/100*a.plotHeight));c.test(m)&&(m=Math.round(parseFloat(m)/100*a.plotHeight+a.plotTop));this.left=b;this.top=m;this.width=h;this.height=n;this.bottom=a.chartHeight-n-m;this.right=a.chartWidth-h-b;this.len=Math.max(e?h:n,0);this.pos=e?b:m},getExtremes:function(){var a=this.isLog,b=this.lin2log;return{min:a?f(b(this.min)):this.min,max:a?f(b(this.max)):this.max,dataMin:this.dataMin,dataMax:this.dataMax,userMin:this.userMin,userMax:this.userMax}},getThreshold:function(a){var b=
this.isLog,c=this.lin2log,k=b?c(this.min):this.min,b=b?c(this.max):this.max;null===a?a=k:k>a?a=k:b<a&&(a=b);return this.translate(a,0,1,0,1)},autoLabelAlign:function(a){a=(w(a,0)-90*this.side+720)%360;return 15<a&&165>a?"right":195<a&&345>a?"left":"center"},tickSize:function(a){var b=this.options,c=b[a+"Length"],k=w(b[a+"Width"],"tick"===a&&this.isXAxis?1:0);if(k&&c)return"inside"===b[a+"Position"]&&(c=-c),[c,k]},labelMetrics:function(){return this.chart.renderer.fontMetrics(this.options.labels.style&&
this.options.labels.style.fontSize,this.ticks[0]&&this.ticks[0].label)},unsquish:function(){var a=this.options.labels,c=this.horiz,e=this.tickInterval,h=e,n=this.len/(((this.categories?1:0)+this.max-this.min)/e),m,d=a.rotation,f=this.labelMetrics(),p,y=Number.MAX_VALUE,t,x=function(a){a/=n||1;a=1<a?Math.ceil(a):1;return a*e};c?(t=!a.staggerLines&&!a.step&&(l(d)?[d]:n<w(a.autoRotationLimit,80)&&a.autoRotation))&&b(t,function(a){var b;if(a===d||a&&-90<=a&&90>=a)p=x(Math.abs(f.h/Math.sin(q*a))),b=p+
Math.abs(a/360),b<y&&(y=b,m=a,h=p)}):a.step||(h=x(f.h));this.autoRotation=t;this.labelRotation=w(m,d);return h},getSlotWidth:function(){var a=this.chart,b=this.horiz,c=this.options.labels,e=Math.max(this.tickPositions.length-(this.categories?0:1),1),h=a.margin[3];return b&&2>(c.step||0)&&!c.rotation&&(this.staggerLines||1)*this.len/e||!b&&(h&&h-a.spacing[3]||.33*a.chartWidth)},renderUnsquish:function(){var a=this.chart,c=a.renderer,h=this.tickPositions,n=this.ticks,m=this.options.labels,d=this.horiz,
v=this.getSlotWidth(),f=Math.max(1,Math.round(v-2*(m.padding||5))),p={},y=this.labelMetrics(),t=m.style&&m.style.textOverflow,g,z=0,E,w;e(m.rotation)||(p.rotation=m.rotation||0);b(h,function(a){(a=n[a])&&a.labelLength>z&&(z=a.labelLength)});this.maxLabelLength=z;if(this.autoRotation)z>f&&z>y.h?p.rotation=this.labelRotation:this.labelRotation=0;else if(v&&(g={width:f+"px"},!t))for(g.textOverflow="clip",E=h.length;!d&&E--;)if(w=h[E],f=n[w].label)f.styles&&"ellipsis"===f.styles.textOverflow?f.css({textOverflow:"clip"}):
n[w].labelLength>v&&f.css({width:v+"px"}),f.getBBox().height>this.len/h.length-(y.h-y.f)&&(f.specCss={textOverflow:"ellipsis"});p.rotation&&(g={width:(z>.5*a.chartHeight?.33*a.chartHeight:a.chartHeight)+"px"},t||(g.textOverflow="ellipsis"));if(this.labelAlign=m.align||this.autoLabelAlign(this.labelRotation))p.align=this.labelAlign;b(h,function(a){var b=(a=n[a])&&a.label;b&&(b.attr(p),g&&b.css(x(g,b.specCss)),delete b.specCss,a.rotation=p.rotation)});this.tickRotCorr=c.rotCorr(y.b,this.labelRotation||
0,0!==this.side)},hasData:function(){return this.hasVisibleSeries||l(this.min)&&l(this.max)&&!!this.tickPositions},addTitle:function(a){var b=this.chart.renderer,c=this.horiz,k=this.opposite,e=this.options.title,h;this.axisTitle||((h=e.textAlign)||(h=(c?{low:"left",middle:"center",high:"right"}:{low:k?"right":"left",middle:"center",high:k?"left":"right"})[e.align]),this.axisTitle=b.text(e.text,0,0,e.useHTML).attr({zIndex:7,rotation:e.rotation||0,align:h}).addClass("highcharts-axis-title").css(e.style).add(this.axisGroup),
this.axisTitle.isNew=!0);this.axisTitle[a?"show":"hide"](!0)},generateTick:function(a){var b=this.ticks;b[a]?b[a].addLabel():b[a]=new I(this,a)},getOffset:function(){var a=this,c=a.chart,e=c.renderer,h=a.options,n=a.tickPositions,m=a.ticks,d=a.horiz,f=a.side,p=c.inverted?[1,0,3,2][f]:f,y,t,x=0,g,z=0,E=h.title,q=h.labels,F=0,J=c.axisOffset,c=c.clipOffset,K=[-1,1,1,-1][f],C,I=h.className,r=a.axisParent,u=this.tickSize("tick");y=a.hasData();a.showAxis=t=y||w(h.showEmpty,!0);a.staggerLines=a.horiz&&q.staggerLines;
a.axisGroup||(a.gridGroup=e.g("grid").attr({zIndex:h.gridZIndex||1}).addClass("highcharts-"+this.coll.toLowerCase()+"-grid "+(I||"")).add(r),a.axisGroup=e.g("axis").attr({zIndex:h.zIndex||2}).addClass("highcharts-"+this.coll.toLowerCase()+" "+(I||"")).add(r),a.labelGroup=e.g("axis-labels").attr({zIndex:q.zIndex||7}).addClass("highcharts-"+a.coll.toLowerCase()+"-labels "+(I||"")).add(r));if(y||a.isLinked)b(n,function(b,c){a.generateTick(b,c)}),a.renderUnsquish(),!1===q.reserveSpace||0!==f&&2!==f&&
{1:"left",3:"right"}[f]!==a.labelAlign&&"center"!==a.labelAlign||b(n,function(a){F=Math.max(m[a].getLabelSize(),F)}),a.staggerLines&&(F*=a.staggerLines,a.labelOffset=F*(a.opposite?-1:1));else for(C in m)m[C].destroy(),delete m[C];E&&E.text&&!1!==E.enabled&&(a.addTitle(t),t&&(x=a.axisTitle.getBBox()[d?"height":"width"],g=E.offset,z=l(g)?0:w(E.margin,d?5:10)));a.renderLine();a.offset=K*w(h.offset,J[f]);a.tickRotCorr=a.tickRotCorr||{x:0,y:0};e=0===f?-a.labelMetrics().h:2===f?a.tickRotCorr.y:0;z=Math.abs(F)+
z;F&&(z=z-e+K*(d?w(q.y,a.tickRotCorr.y+8*K):q.x));a.axisTitleMargin=w(g,z);J[f]=Math.max(J[f],a.axisTitleMargin+x+K*a.offset,z,y&&n.length&&u?u[0]:0);h=h.offset?0:2*Math.floor(a.axisLine.strokeWidth()/2);c[p]=Math.max(c[p],h)},getLinePath:function(a){var b=this.chart,c=this.opposite,k=this.offset,e=this.horiz,h=this.left+(c?this.width:0)+k,k=b.chartHeight-this.bottom-(c?this.height:0)+k;c&&(a*=-1);return b.renderer.crispLine(["M",e?this.left:h,e?k:this.top,"L",e?b.chartWidth-this.right:h,e?k:b.chartHeight-
this.bottom],a)},renderLine:function(){this.axisLine||(this.axisLine=this.chart.renderer.path().addClass("highcharts-axis-line").add(this.axisGroup),this.axisLine.attr({stroke:this.options.lineColor,"stroke-width":this.options.lineWidth,zIndex:7}))},getTitlePosition:function(){var a=this.horiz,b=this.left,c=this.top,e=this.len,h=this.options.title,n=a?b:c,m=this.opposite,d=this.offset,f=h.x||0,p=h.y||0,y=this.chart.renderer.fontMetrics(h.style&&h.style.fontSize,this.axisTitle).f,e={low:n+(a?0:e),
middle:n+e/2,high:n+(a?e:0)}[h.align],b=(a?c+this.height:b)+(a?1:-1)*(m?-1:1)*this.axisTitleMargin+(2===this.side?y:0);return{x:a?e+f:b+(m?this.width:0)+d+f,y:a?b+p-(m?this.height:0)+d:e+p}},renderMinorTick:function(a){var b=this.chart.hasRendered&&z(this.oldMin),c=this.minorTicks;c[a]||(c[a]=new I(this,a,"minor"));b&&c[a].isNew&&c[a].render(null,!0);c[a].render(null,!1,1)},renderTick:function(a,b){var c=this.isLinked,e=this.ticks,k=this.chart.hasRendered&&z(this.oldMin);if(!c||a>=this.min&&a<=this.max)e[a]||
(e[a]=new I(this,a)),k&&e[a].isNew&&e[a].render(b,!0,.1),e[a].render(b)},render:function(){var a=this,c=a.chart,e=a.options,n=a.isLog,m=a.lin2log,d=a.isLinked,v=a.tickPositions,f=a.axisTitle,p=a.ticks,y=a.minorTicks,t=a.alternateBands,x=e.stackLabels,z=e.alternateGridColor,g=a.tickmarkOffset,E=a.axisLine,w=a.showAxis,l=A(c.renderer.globalAnimation),q,F;a.labelEdge.length=0;a.overlap=!1;b([p,y,t],function(a){for(var b in a)a[b].isActive=!1});if(a.hasData()||d)a.minorTickInterval&&!a.categories&&b(a.getMinorTickPositions(),
function(b){a.renderMinorTick(b)}),v.length&&(b(v,function(b,c){a.renderTick(b,c)}),g&&(0===a.min||a.single)&&(p[-1]||(p[-1]=new I(a,-1,null,!0)),p[-1].render(-1))),z&&b(v,function(b,e){F=void 0!==v[e+1]?v[e+1]+g:a.max-g;0===e%2&&b<a.max&&F<=a.max+(c.polar?-g:g)&&(t[b]||(t[b]=new h(a)),q=b+g,t[b].options={from:n?m(q):q,to:n?m(F):F,color:z},t[b].render(),t[b].isActive=!0)}),a._addedPlotLB||(b((e.plotLines||[]).concat(e.plotBands||[]),function(b){a.addPlotBandOrLine(b)}),a._addedPlotLB=!0);b([p,y,t],
function(a){var b,e,h=[],k=l.duration;for(b in a)a[b].isActive||(a[b].render(b,!1,0),a[b].isActive=!1,h.push(b));K(function(){for(e=h.length;e--;)a[h[e]]&&!a[h[e]].isActive&&(a[h[e]].destroy(),delete a[h[e]])},a!==t&&c.hasRendered&&k?k:0)});E&&(E[E.isPlaced?"animate":"attr"]({d:this.getLinePath(E.strokeWidth())}),E.isPlaced=!0,E[w?"show":"hide"](!0));f&&w&&(f[f.isNew?"attr":"animate"](a.getTitlePosition()),f.isNew=!1);x&&x.enabled&&a.renderStackTotals();a.isDirty=!1},redraw:function(){this.visible&&
(this.render(),b(this.plotLinesAndBands,function(a){a.render()}));b(this.series,function(a){a.isDirty=!0})},keepProps:"extKey hcEvents names series userMax userMin".split(" "),destroy:function(a){var c=this,e=c.stacks,h,k=c.plotLinesAndBands,m;a||y(c);for(h in e)d(e[h]),e[h]=null;b([c.ticks,c.minorTicks,c.alternateBands],function(a){d(a)});if(k)for(a=k.length;a--;)k[a].destroy();b("stackTotalGroup axisLine axisTitle axisGroup gridGroup labelGroup cross".split(" "),function(a){c[a]&&(c[a]=c[a].destroy())});
for(m in c)c.hasOwnProperty(m)&&-1===n(m,c.keepProps)&&delete c[m]},drawCrosshair:function(a,b){var c,e=this.crosshair,h=w(e.snap,!0),k,n=this.cross;a||(a=this.cross&&this.cross.e);this.crosshair&&!1!==(l(b)||!h)?(h?l(b)&&(k=this.isXAxis?b.plotX:this.len-b.plotY):k=a&&(this.horiz?a.chartX-this.pos:this.len-a.chartY+this.pos),l(k)&&(c=this.getPlotLinePath(b&&(this.isXAxis?b.x:w(b.stackY,b.y)),null,null,null,k)||null),l(c)?(b=this.categories&&!this.isRadial,n||(this.cross=n=this.chart.renderer.path().addClass("highcharts-crosshair highcharts-crosshair-"+
(b?"category ":"thin ")+e.className).attr({zIndex:w(e.zIndex,2)}).add(),n.attr({stroke:e.color||(b?g("#ccd6eb").setOpacity(.25).get():"#cccccc"),"stroke-width":w(e.width,1)}),e.dashStyle&&n.attr({dashstyle:e.dashStyle})),n.show().attr({d:c}),b&&!e.width&&n.attr({"stroke-width":this.transA}),this.cross.e=a):this.hideCrosshair()):this.hideCrosshair()},hideCrosshair:function(){this.cross&&this.cross.hide()}};p(a.Axis.prototype,r)})(L);(function(a){var B=a.Axis,A=a.Date,H=a.dateFormat,G=a.defaultOptions,
r=a.defined,g=a.each,f=a.extend,u=a.getMagnitude,l=a.getTZOffset,q=a.normalizeTickInterval,d=a.pick,b=a.timeUnits;B.prototype.getTimeTicks=function(a,q,t,m){var c=[],n={},p=G.global.useUTC,z,e=new A(q-l(q)),x=A.hcMakeTime,F=a.unitRange,w=a.count,h;if(r(q)){e[A.hcSetMilliseconds](F>=b.second?0:w*Math.floor(e.getMilliseconds()/w));if(F>=b.second)e[A.hcSetSeconds](F>=b.minute?0:w*Math.floor(e.getSeconds()/w));if(F>=b.minute)e[A.hcSetMinutes](F>=b.hour?0:w*Math.floor(e[A.hcGetMinutes]()/w));if(F>=b.hour)e[A.hcSetHours](F>=
b.day?0:w*Math.floor(e[A.hcGetHours]()/w));if(F>=b.day)e[A.hcSetDate](F>=b.month?1:w*Math.floor(e[A.hcGetDate]()/w));F>=b.month&&(e[A.hcSetMonth](F>=b.year?0:w*Math.floor(e[A.hcGetMonth]()/w)),z=e[A.hcGetFullYear]());if(F>=b.year)e[A.hcSetFullYear](z-z%w);if(F===b.week)e[A.hcSetDate](e[A.hcGetDate]()-e[A.hcGetDay]()+d(m,1));z=e[A.hcGetFullYear]();m=e[A.hcGetMonth]();var y=e[A.hcGetDate](),J=e[A.hcGetHours]();if(A.hcTimezoneOffset||A.hcGetTimezoneOffset)h=(!p||!!A.hcGetTimezoneOffset)&&(t-q>4*b.month||
l(q)!==l(t)),e=e.getTime(),e=new A(e+l(e));p=e.getTime();for(q=1;p<t;)c.push(p),p=F===b.year?x(z+q*w,0):F===b.month?x(z,m+q*w):!h||F!==b.day&&F!==b.week?h&&F===b.hour?x(z,m,y,J+q*w):p+F*w:x(z,m,y+q*w*(F===b.day?1:7)),q++;c.push(p);F<=b.hour&&1E4>c.length&&g(c,function(a){0===a%18E5&&"000000000"===H("%H%M%S%L",a)&&(n[a]="day")})}c.info=f(a,{higherRanks:n,totalRange:F*w});return c};B.prototype.normalizeTimeTickInterval=function(a,d){var f=d||[["millisecond",[1,2,5,10,20,25,50,100,200,500]],["second",
[1,2,5,10,15,30]],["minute",[1,2,5,10,15,30]],["hour",[1,2,3,4,6,8,12]],["day",[1,2]],["week",[1,2]],["month",[1,2,3,4,6]],["year",null]];d=f[f.length-1];var m=b[d[0]],c=d[1],n;for(n=0;n<f.length&&!(d=f[n],m=b[d[0]],c=d[1],f[n+1]&&a<=(m*c[c.length-1]+b[f[n+1][0]])/2);n++);m===b.year&&a<5*m&&(c=[1,2,5]);a=q(a/m,c,"year"===d[0]?Math.max(u(a/m),1):1);return{unitRange:m,count:a,unitName:d[0]}}})(L);(function(a){var B=a.Axis,A=a.getMagnitude,H=a.map,G=a.normalizeTickInterval,r=a.pick;B.prototype.getLogTickPositions=
function(a,f,u,l){var g=this.options,d=this.len,b=this.lin2log,p=this.log2lin,C=[];l||(this._minorAutoInterval=null);if(.5<=a)a=Math.round(a),C=this.getLinearTickPositions(a,f,u);else if(.08<=a)for(var d=Math.floor(f),t,m,c,n,E,g=.3<a?[1,2,4]:.15<a?[1,2,4,6,8]:[1,2,3,4,5,6,7,8,9];d<u+1&&!E;d++)for(m=g.length,t=0;t<m&&!E;t++)c=p(b(d)*g[t]),c>f&&(!l||n<=u)&&void 0!==n&&C.push(n),n>u&&(E=!0),n=c;else f=b(f),u=b(u),a=g[l?"minorTickInterval":"tickInterval"],a=r("auto"===a?null:a,this._minorAutoInterval,
g.tickPixelInterval/(l?5:1)*(u-f)/((l?d/this.tickPositions.length:d)||1)),a=G(a,null,A(a)),C=H(this.getLinearTickPositions(a,f,u),p),l||(this._minorAutoInterval=a/5);l||(this.tickInterval=a);return C};B.prototype.log2lin=function(a){return Math.log(a)/Math.LN10};B.prototype.lin2log=function(a){return Math.pow(10,a)}})(L);(function(a){var B=a.dateFormat,A=a.each,H=a.extend,G=a.format,r=a.isNumber,g=a.map,f=a.merge,u=a.pick,l=a.splat,q=a.syncTimeout,d=a.timeUnits;a.Tooltip=function(){this.init.apply(this,
arguments)};a.Tooltip.prototype={init:function(a,d){this.chart=a;this.options=d;this.crosshairs=[];this.now={x:0,y:0};this.isHidden=!0;this.split=d.split&&!a.inverted;this.shared=d.shared||this.split},cleanSplit:function(a){A(this.chart.series,function(b){var d=b&&b.tt;d&&(!d.isActive||a?b.tt=d.destroy():d.isActive=!1)})},getLabel:function(){var a=this.chart.renderer,d=this.options;this.label||(this.split?this.label=a.g("tooltip"):(this.label=a.label("",0,0,d.shape||"callout",null,null,d.useHTML,
null,"tooltip").attr({padding:d.padding,r:d.borderRadius}),this.label.attr({fill:d.backgroundColor,"stroke-width":d.borderWidth}).css(d.style).shadow(d.shadow)),this.label.attr({zIndex:8}).add());return this.label},update:function(a){this.destroy();this.init(this.chart,f(!0,this.options,a))},destroy:function(){this.label&&(this.label=this.label.destroy());this.split&&this.tt&&(this.cleanSplit(this.chart,!0),this.tt=this.tt.destroy());clearTimeout(this.hideTimer);clearTimeout(this.tooltipTimeout)},
move:function(a,d,f,t){var b=this,c=b.now,n=!1!==b.options.animation&&!b.isHidden&&(1<Math.abs(a-c.x)||1<Math.abs(d-c.y)),p=b.followPointer||1<b.len;H(c,{x:n?(2*c.x+a)/3:a,y:n?(c.y+d)/2:d,anchorX:p?void 0:n?(2*c.anchorX+f)/3:f,anchorY:p?void 0:n?(c.anchorY+t)/2:t});b.getLabel().attr(c);n&&(clearTimeout(this.tooltipTimeout),this.tooltipTimeout=setTimeout(function(){b&&b.move(a,d,f,t)},32))},hide:function(a){var b=this;clearTimeout(this.hideTimer);a=u(a,this.options.hideDelay,500);this.isHidden||(this.hideTimer=
q(function(){b.getLabel()[a?"fadeOut":"hide"]();b.isHidden=!0},a))},getAnchor:function(a,d){var b,f=this.chart,m=f.inverted,c=f.plotTop,n=f.plotLeft,p=0,z=0,e,x;a=l(a);b=a[0].tooltipPos;this.followPointer&&d&&(void 0===d.chartX&&(d=f.pointer.normalize(d)),b=[d.chartX-f.plotLeft,d.chartY-c]);b||(A(a,function(a){e=a.series.yAxis;x=a.series.xAxis;p+=a.plotX+(!m&&x?x.left-n:0);z+=(a.plotLow?(a.plotLow+a.plotHigh)/2:a.plotY)+(!m&&e?e.top-c:0)}),p/=a.length,z/=a.length,b=[m?f.plotWidth-z:p,this.shared&&
!m&&1<a.length&&d?d.chartY-c:m?f.plotHeight-p:z]);return g(b,Math.round)},getPosition:function(a,d,f){var b=this.chart,m=this.distance,c={},n=f.h||0,p,z=["y",b.chartHeight,d,f.plotY+b.plotTop,b.plotTop,b.plotTop+b.plotHeight],e=["x",b.chartWidth,a,f.plotX+b.plotLeft,b.plotLeft,b.plotLeft+b.plotWidth],x=!this.followPointer&&u(f.ttBelow,!b.inverted===!!f.negative),g=function(a,b,e,h,d,f){var k=e<h-m,y=h+m+e<b,p=h-m-e;h+=m;if(x&&y)c[a]=h;else if(!x&&k)c[a]=p;else if(k)c[a]=Math.min(f-e,0>p-n?p:p-n);
else if(y)c[a]=Math.max(d,h+n+e>b?h:h+n);else return!1},w=function(a,b,e,h){var k;h<m||h>b-m?k=!1:c[a]=h<e/2?1:h>b-e/2?b-e-2:h-e/2;return k},h=function(a){var b=z;z=e;e=b;p=a},y=function(){!1!==g.apply(0,z)?!1!==w.apply(0,e)||p||(h(!0),y()):p?c.x=c.y=0:(h(!0),y())};(b.inverted||1<this.len)&&h();y();return c},defaultFormatter:function(a){var b=this.points||l(this),d;d=[a.tooltipFooterHeaderFormatter(b[0])];d=d.concat(a.bodyFormatter(b));d.push(a.tooltipFooterHeaderFormatter(b[0],!0));return d},refresh:function(a,
d){var b=this.chart,f,m=this.options,c,n,p={},z=[];f=m.formatter||this.defaultFormatter;var p=b.hoverPoints,e=this.shared;clearTimeout(this.hideTimer);this.followPointer=l(a)[0].series.tooltipOptions.followPointer;n=this.getAnchor(a,d);d=n[0];c=n[1];!e||a.series&&a.series.noSharedTooltip?p=a.getLabelConfig():(b.hoverPoints=a,p&&A(p,function(a){a.setState()}),A(a,function(a){a.setState("hover");z.push(a.getLabelConfig())}),p={x:a[0].category,y:a[0].y},p.points=z,a=a[0]);this.len=z.length;p=f.call(p,
this);e=a.series;this.distance=u(e.tooltipOptions.distance,16);!1===p?this.hide():(f=this.getLabel(),this.isHidden&&f.attr({opacity:1}).show(),this.split?this.renderSplit(p,b.hoverPoints):(f.attr({text:p&&p.join?p.join(""):p}),f.removeClass(/highcharts-color-[\d]+/g).addClass("highcharts-color-"+u(a.colorIndex,e.colorIndex)),f.attr({stroke:m.borderColor||a.color||e.color||"#666666"}),this.updatePosition({plotX:d,plotY:c,negative:a.negative,ttBelow:a.ttBelow,h:n[2]||0})),this.isHidden=!1)},renderSplit:function(b,
d){var f=this,p=[],m=this.chart,c=m.renderer,n=!0,g=this.options,z,e=this.getLabel();A(b.slice(0,d.length+1),function(a,b){b=d[b-1]||{isHeader:!0,plotX:d[0].plotX};var x=b.series||f,h=x.tt,y=b.series||{},t="highcharts-color-"+u(b.colorIndex,y.colorIndex,"none");h||(x.tt=h=c.label(null,null,null,"callout").addClass("highcharts-tooltip-box "+t).attr({padding:g.padding,r:g.borderRadius,fill:g.backgroundColor,stroke:b.color||y.color||"#333333","stroke-width":g.borderWidth}).add(e));h.isActive=!0;h.attr({text:a});
h.css(g.style);a=h.getBBox();y=a.width+h.strokeWidth();b.isHeader?(z=a.height,y=Math.max(0,Math.min(b.plotX+m.plotLeft-y/2,m.chartWidth-y))):y=b.plotX+m.plotLeft-u(g.distance,16)-y;0>y&&(n=!1);a=(b.series&&b.series.yAxis&&b.series.yAxis.pos)+(b.plotY||0);a-=m.plotTop;p.push({target:b.isHeader?m.plotHeight+z:a,rank:b.isHeader?1:0,size:x.tt.getBBox().height+1,point:b,x:y,tt:h})});this.cleanSplit();a.distribute(p,m.plotHeight+z);A(p,function(a){var b=a.point,c=b.series;a.tt.attr({visibility:void 0===
a.pos?"hidden":"inherit",x:n||b.isHeader?a.x:b.plotX+m.plotLeft+u(g.distance,16),y:a.pos+m.plotTop,anchorX:b.isHeader?b.plotX+m.plotLeft:b.plotX+c.xAxis.pos,anchorY:b.isHeader?a.pos+m.plotTop-15:b.plotY+c.yAxis.pos})})},updatePosition:function(a){var b=this.chart,d=this.getLabel(),d=(this.options.positioner||this.getPosition).call(this,d.width,d.height,a);this.move(Math.round(d.x),Math.round(d.y||0),a.plotX+b.plotLeft,a.plotY+b.plotTop)},getDateFormat:function(a,f,g,t){var b=B("%m-%d %H:%M:%S.%L",
f),c,n,p={millisecond:15,second:12,minute:9,hour:6,day:3},z="millisecond";for(n in d){if(a===d.week&&+B("%w",f)===g&&"00:00:00.000"===b.substr(6)){n="week";break}if(d[n]>a){n=z;break}if(p[n]&&b.substr(p[n])!=="01-01 00:00:00.000".substr(p[n]))break;"week"!==n&&(z=n)}n&&(c=t[n]);return c},getXDateFormat:function(a,d,f){d=d.dateTimeLabelFormats;var b=f&&f.closestPointRange;return(b?this.getDateFormat(b,a.x,f.options.startOfWeek,d):d.day)||d.year},tooltipFooterHeaderFormatter:function(a,d){var b=d?"footer":
"header";d=a.series;var f=d.tooltipOptions,m=f.xDateFormat,c=d.xAxis,n=c&&"datetime"===c.options.type&&r(a.key),b=f[b+"Format"];n&&!m&&(m=this.getXDateFormat(a,f,c));n&&m&&(b=b.replace("{point.key}","{point.key:"+m+"}"));return G(b,{point:a,series:d})},bodyFormatter:function(a){return g(a,function(a){var b=a.series.tooltipOptions;return(b.pointFormatter||a.point.tooltipFormatter).call(a.point,b.pointFormat)})}}})(L);(function(a){var B=a.addEvent,A=a.attr,H=a.charts,G=a.color,r=a.css,g=a.defined,f=
a.doc,u=a.each,l=a.extend,q=a.fireEvent,d=a.offset,b=a.pick,p=a.removeEvent,C=a.splat,t=a.Tooltip,m=a.win;a.Pointer=function(a,b){this.init(a,b)};a.Pointer.prototype={init:function(a,d){this.options=d;this.chart=a;this.runChartClick=d.chart.events&&!!d.chart.events.click;this.pinchDown=[];this.lastValidTouch={};t&&d.tooltip.enabled&&(a.tooltip=new t(a,d.tooltip),this.followTouchMove=b(d.tooltip.followTouchMove,!0));this.setDOMEvents()},zoomOption:function(a){var c=this.chart,d=c.options.chart,m=d.zoomType||
"",c=c.inverted;/touch/.test(a.type)&&(m=b(d.pinchType,m));this.zoomX=a=/x/.test(m);this.zoomY=m=/y/.test(m);this.zoomHor=a&&!c||m&&c;this.zoomVert=m&&!c||a&&c;this.hasZoom=a||m},normalize:function(a,b){var c,n;a=a||m.event;a.target||(a.target=a.srcElement);n=a.touches?a.touches.length?a.touches.item(0):a.changedTouches[0]:a;b||(this.chartPosition=b=d(this.chart.container));void 0===n.pageX?(c=Math.max(a.x,a.clientX-b.left),b=a.y):(c=n.pageX-b.left,b=n.pageY-b.top);return l(a,{chartX:Math.round(c),
chartY:Math.round(b)})},getCoordinates:function(a){var b={xAxis:[],yAxis:[]};u(this.chart.axes,function(c){b[c.isXAxis?"xAxis":"yAxis"].push({axis:c,value:c.toValue(a[c.horiz?"chartX":"chartY"])})});return b},runPointActions:function(c){var d=this.chart,m=d.series,p=d.tooltip,e=p?p.shared:!1,g=!0,t=d.hoverPoint,w=d.hoverSeries,h,y,l,q=[],r;if(!e&&!w)for(h=0;h<m.length;h++)if(m[h].directTouch||!m[h].options.stickyTracking)m=[];w&&(e?w.noSharedTooltip:w.directTouch)&&t?q=[t]:(e||!w||w.options.stickyTracking||
(m=[w]),u(m,function(a){y=a.noSharedTooltip&&e;l=!e&&a.directTouch;a.visible&&!y&&!l&&b(a.options.enableMouseTracking,!0)&&(r=a.searchPoint(c,!y&&1===a.kdDimensions))&&r.series&&q.push(r)}),q.sort(function(a,b){var c=a.distX-b.distX,h=a.dist-b.dist,k=(b.series.group&&b.series.group.zIndex)-(a.series.group&&a.series.group.zIndex);return 0!==c&&e?c:0!==h?h:0!==k?k:a.series.index>b.series.index?-1:1}));if(e)for(h=q.length;h--;)(q[h].x!==q[0].x||q[h].series.noSharedTooltip)&&q.splice(h,1);if(q[0]&&(q[0]!==
this.prevKDPoint||p&&p.isHidden)){if(e&&!q[0].series.noSharedTooltip){for(h=0;h<q.length;h++)q[h].onMouseOver(c,q[h]!==(w&&w.directTouch&&t||q[0]));q.length&&p&&p.refresh(q.sort(function(a,b){return a.series.index-b.series.index}),c)}else if(p&&p.refresh(q[0],c),!w||!w.directTouch)q[0].onMouseOver(c);this.prevKDPoint=q[0];g=!1}g&&(m=w&&w.tooltipOptions.followPointer,p&&m&&!p.isHidden&&(m=p.getAnchor([{}],c),p.updatePosition({plotX:m[0],plotY:m[1]})));this.unDocMouseMove||(this.unDocMouseMove=B(f,
"mousemove",function(b){if(H[a.hoverChartIndex])H[a.hoverChartIndex].pointer.onDocumentMouseMove(b)}));u(e?q:[b(t,q[0])],function(a){u(d.axes,function(b){(!a||a.series&&a.series[b.coll]===b)&&b.drawCrosshair(c,a)})})},reset:function(a,b){var c=this.chart,d=c.hoverSeries,e=c.hoverPoint,n=c.hoverPoints,m=c.tooltip,f=m&&m.shared?n:e;a&&f&&u(C(f),function(b){b.series.isCartesian&&void 0===b.plotX&&(a=!1)});if(a)m&&f&&(m.refresh(f),e&&(e.setState(e.state,!0),u(c.axes,function(a){a.crosshair&&a.drawCrosshair(null,
e)})));else{if(e)e.onMouseOut();n&&u(n,function(a){a.setState()});if(d)d.onMouseOut();m&&m.hide(b);this.unDocMouseMove&&(this.unDocMouseMove=this.unDocMouseMove());u(c.axes,function(a){a.hideCrosshair()});this.hoverX=this.prevKDPoint=c.hoverPoints=c.hoverPoint=null}},scaleGroups:function(a,b){var c=this.chart,d;u(c.series,function(e){d=a||e.getPlotBox();e.xAxis&&e.xAxis.zoomEnabled&&e.group&&(e.group.attr(d),e.markerGroup&&(e.markerGroup.attr(d),e.markerGroup.clip(b?c.clipRect:null)),e.dataLabelsGroup&&
e.dataLabelsGroup.attr(d))});c.clipRect.attr(b||c.clipBox)},dragStart:function(a){var b=this.chart;b.mouseIsDown=a.type;b.cancelClick=!1;b.mouseDownX=this.mouseDownX=a.chartX;b.mouseDownY=this.mouseDownY=a.chartY},drag:function(a){var b=this.chart,c=b.options.chart,d=a.chartX,e=a.chartY,m=this.zoomHor,f=this.zoomVert,p=b.plotLeft,h=b.plotTop,y=b.plotWidth,g=b.plotHeight,t,q=this.selectionMarker,k=this.mouseDownX,l=this.mouseDownY,r=c.panKey&&a[c.panKey+"Key"];q&&q.touch||(d<p?d=p:d>p+y&&(d=p+y),e<
h?e=h:e>h+g&&(e=h+g),this.hasDragged=Math.sqrt(Math.pow(k-d,2)+Math.pow(l-e,2)),10<this.hasDragged&&(t=b.isInsidePlot(k-p,l-h),b.hasCartesianSeries&&(this.zoomX||this.zoomY)&&t&&!r&&!q&&(this.selectionMarker=q=b.renderer.rect(p,h,m?1:y,f?1:g,0).attr({fill:c.selectionMarkerFill||G("#335cad").setOpacity(.25).get(),"class":"highcharts-selection-marker",zIndex:7}).add()),q&&m&&(d-=k,q.attr({width:Math.abs(d),x:(0<d?0:d)+k})),q&&f&&(d=e-l,q.attr({height:Math.abs(d),y:(0<d?0:d)+l})),t&&!q&&c.panning&&b.pan(a,
c.panning)))},drop:function(a){var b=this,c=this.chart,d=this.hasPinched;if(this.selectionMarker){var e={originalEvent:a,xAxis:[],yAxis:[]},m=this.selectionMarker,f=m.attr?m.attr("x"):m.x,p=m.attr?m.attr("y"):m.y,h=m.attr?m.attr("width"):m.width,y=m.attr?m.attr("height"):m.height,t;if(this.hasDragged||d)u(c.axes,function(c){if(c.zoomEnabled&&g(c.min)&&(d||b[{xAxis:"zoomX",yAxis:"zoomY"}[c.coll]])){var m=c.horiz,k="touchend"===a.type?c.minPixelPadding:0,n=c.toValue((m?f:p)+k),m=c.toValue((m?f+h:p+
y)-k);e[c.coll].push({axis:c,min:Math.min(n,m),max:Math.max(n,m)});t=!0}}),t&&q(c,"selection",e,function(a){c.zoom(l(a,d?{animation:!1}:null))});this.selectionMarker=this.selectionMarker.destroy();d&&this.scaleGroups()}c&&(r(c.container,{cursor:c._cursor}),c.cancelClick=10<this.hasDragged,c.mouseIsDown=this.hasDragged=this.hasPinched=!1,this.pinchDown=[])},onContainerMouseDown:function(a){a=this.normalize(a);this.zoomOption(a);a.preventDefault&&a.preventDefault();this.dragStart(a)},onDocumentMouseUp:function(b){H[a.hoverChartIndex]&&
H[a.hoverChartIndex].pointer.drop(b)},onDocumentMouseMove:function(a){var b=this.chart,c=this.chartPosition;a=this.normalize(a,c);!c||this.inClass(a.target,"highcharts-tracker")||b.isInsidePlot(a.chartX-b.plotLeft,a.chartY-b.plotTop)||this.reset()},onContainerMouseLeave:function(b){var c=H[a.hoverChartIndex];c&&(b.relatedTarget||b.toElement)&&(c.pointer.reset(),c.pointer.chartPosition=null)},onContainerMouseMove:function(b){var c=this.chart;g(a.hoverChartIndex)&&H[a.hoverChartIndex]&&H[a.hoverChartIndex].mouseIsDown||
(a.hoverChartIndex=c.index);b=this.normalize(b);b.returnValue=!1;"mousedown"===c.mouseIsDown&&this.drag(b);!this.inClass(b.target,"highcharts-tracker")&&!c.isInsidePlot(b.chartX-c.plotLeft,b.chartY-c.plotTop)||c.openMenu||this.runPointActions(b)},inClass:function(a,b){for(var c;a;){if(c=A(a,"class")){if(-1!==c.indexOf(b))return!0;if(-1!==c.indexOf("highcharts-container"))return!1}a=a.parentNode}},onTrackerMouseOut:function(a){var b=this.chart.hoverSeries;a=a.relatedTarget||a.toElement;if(!(!b||!a||
b.options.stickyTracking||this.inClass(a,"highcharts-tooltip")||this.inClass(a,"highcharts-series-"+b.index)&&this.inClass(a,"highcharts-tracker")))b.onMouseOut()},onContainerClick:function(a){var b=this.chart,c=b.hoverPoint,d=b.plotLeft,e=b.plotTop;a=this.normalize(a);b.cancelClick||(c&&this.inClass(a.target,"highcharts-tracker")?(q(c.series,"click",l(a,{point:c})),b.hoverPoint&&c.firePointEvent("click",a)):(l(a,this.getCoordinates(a)),b.isInsidePlot(a.chartX-d,a.chartY-e)&&q(b,"click",a)))},setDOMEvents:function(){var b=
this,d=b.chart.container;d.onmousedown=function(a){b.onContainerMouseDown(a)};d.onmousemove=function(a){b.onContainerMouseMove(a)};d.onclick=function(a){b.onContainerClick(a)};B(d,"mouseleave",b.onContainerMouseLeave);1===a.chartCount&&B(f,"mouseup",b.onDocumentMouseUp);a.hasTouch&&(d.ontouchstart=function(a){b.onContainerTouchStart(a)},d.ontouchmove=function(a){b.onContainerTouchMove(a)},1===a.chartCount&&B(f,"touchend",b.onDocumentTouchEnd))},destroy:function(){var b;p(this.chart.container,"mouseleave",
this.onContainerMouseLeave);a.chartCount||(p(f,"mouseup",this.onDocumentMouseUp),p(f,"touchend",this.onDocumentTouchEnd));clearInterval(this.tooltipTimeout);for(b in this)this[b]=null}}})(L);(function(a){var B=a.charts,A=a.each,H=a.extend,G=a.map,r=a.noop,g=a.pick;H(a.Pointer.prototype,{pinchTranslate:function(a,g,l,q,d,b){this.zoomHor&&this.pinchTranslateDirection(!0,a,g,l,q,d,b);this.zoomVert&&this.pinchTranslateDirection(!1,a,g,l,q,d,b)},pinchTranslateDirection:function(a,g,l,q,d,b,p,r){var f=
this.chart,m=a?"x":"y",c=a?"X":"Y",n="chart"+c,E=a?"width":"height",z=f["plot"+(a?"Left":"Top")],e,x,F=r||1,w=f.inverted,h=f.bounds[a?"h":"v"],y=1===g.length,J=g[0][n],u=l[0][n],I=!y&&g[1][n],k=!y&&l[1][n],D;l=function(){!y&&20<Math.abs(J-I)&&(F=r||Math.abs(u-k)/Math.abs(J-I));x=(z-u)/F+J;e=f["plot"+(a?"Width":"Height")]/F};l();g=x;g<h.min?(g=h.min,D=!0):g+e>h.max&&(g=h.max-e,D=!0);D?(u-=.8*(u-p[m][0]),y||(k-=.8*(k-p[m][1])),l()):p[m]=[u,k];w||(b[m]=x-z,b[E]=e);b=w?1/F:F;d[E]=e;d[m]=g;q[w?a?"scaleY":
"scaleX":"scale"+c]=F;q["translate"+c]=b*z+(u-b*J)},pinch:function(a){var f=this,l=f.chart,q=f.pinchDown,d=a.touches,b=d.length,p=f.lastValidTouch,C=f.hasZoom,t=f.selectionMarker,m={},c=1===b&&(f.inClass(a.target,"highcharts-tracker")&&l.runTrackerClick||f.runChartClick),n={};1<b&&(f.initiated=!0);C&&f.initiated&&!c&&a.preventDefault();G(d,function(a){return f.normalize(a)});"touchstart"===a.type?(A(d,function(a,b){q[b]={chartX:a.chartX,chartY:a.chartY}}),p.x=[q[0].chartX,q[1]&&q[1].chartX],p.y=[q[0].chartY,
q[1]&&q[1].chartY],A(l.axes,function(a){if(a.zoomEnabled){var b=l.bounds[a.horiz?"h":"v"],c=a.minPixelPadding,d=a.toPixels(g(a.options.min,a.dataMin)),m=a.toPixels(g(a.options.max,a.dataMax)),f=Math.max(d,m);b.min=Math.min(a.pos,Math.min(d,m)-c);b.max=Math.max(a.pos+a.len,f+c)}}),f.res=!0):f.followTouchMove&&1===b?this.runPointActions(f.normalize(a)):q.length&&(t||(f.selectionMarker=t=H({destroy:r,touch:!0},l.plotBox)),f.pinchTranslate(q,d,m,t,n,p),f.hasPinched=C,f.scaleGroups(m,n),f.res&&(f.res=
!1,this.reset(!1,0)))},touch:function(f,r){var l=this.chart,q,d;if(l.index!==a.hoverChartIndex)this.onContainerMouseLeave({relatedTarget:!0});a.hoverChartIndex=l.index;1===f.touches.length?(f=this.normalize(f),(d=l.isInsidePlot(f.chartX-l.plotLeft,f.chartY-l.plotTop))&&!l.openMenu?(r&&this.runPointActions(f),"touchmove"===f.type&&(r=this.pinchDown,q=r[0]?4<=Math.sqrt(Math.pow(r[0].chartX-f.chartX,2)+Math.pow(r[0].chartY-f.chartY,2)):!1),g(q,!0)&&this.pinch(f)):r&&this.reset()):2===f.touches.length&&
this.pinch(f)},onContainerTouchStart:function(a){this.zoomOption(a);this.touch(a,!0)},onContainerTouchMove:function(a){this.touch(a)},onDocumentTouchEnd:function(f){B[a.hoverChartIndex]&&B[a.hoverChartIndex].pointer.drop(f)}})})(L);(function(a){var B=a.addEvent,A=a.charts,H=a.css,G=a.doc,r=a.extend,g=a.noop,f=a.Pointer,u=a.removeEvent,l=a.win,q=a.wrap;if(l.PointerEvent||l.MSPointerEvent){var d={},b=!!l.PointerEvent,p=function(){var a,b=[];b.item=function(a){return this[a]};for(a in d)d.hasOwnProperty(a)&&
b.push({pageX:d[a].pageX,pageY:d[a].pageY,target:d[a].target});return b},C=function(b,d,c,f){"touch"!==b.pointerType&&b.pointerType!==b.MSPOINTER_TYPE_TOUCH||!A[a.hoverChartIndex]||(f(b),f=A[a.hoverChartIndex].pointer,f[d]({type:c,target:b.currentTarget,preventDefault:g,touches:p()}))};r(f.prototype,{onContainerPointerDown:function(a){C(a,"onContainerTouchStart","touchstart",function(a){d[a.pointerId]={pageX:a.pageX,pageY:a.pageY,target:a.currentTarget}})},onContainerPointerMove:function(a){C(a,"onContainerTouchMove",
"touchmove",function(a){d[a.pointerId]={pageX:a.pageX,pageY:a.pageY};d[a.pointerId].target||(d[a.pointerId].target=a.currentTarget)})},onDocumentPointerUp:function(a){C(a,"onDocumentTouchEnd","touchend",function(a){delete d[a.pointerId]})},batchMSEvents:function(a){a(this.chart.container,b?"pointerdown":"MSPointerDown",this.onContainerPointerDown);a(this.chart.container,b?"pointermove":"MSPointerMove",this.onContainerPointerMove);a(G,b?"pointerup":"MSPointerUp",this.onDocumentPointerUp)}});q(f.prototype,
"init",function(a,b,c){a.call(this,b,c);this.hasZoom&&H(b.container,{"-ms-touch-action":"none","touch-action":"none"})});q(f.prototype,"setDOMEvents",function(a){a.apply(this);(this.hasZoom||this.followTouchMove)&&this.batchMSEvents(B)});q(f.prototype,"destroy",function(a){this.batchMSEvents(u);a.call(this)})}})(L);(function(a){var B,A=a.addEvent,H=a.css,G=a.discardElement,r=a.defined,g=a.each,f=a.extend,u=a.isFirefox,l=a.marginNames,q=a.merge,d=a.pick,b=a.setAnimation,p=a.stableSort,C=a.win,t=a.wrap;
B=a.Legend=function(a,b){this.init(a,b)};B.prototype={init:function(a,b){this.chart=a;this.setOptions(b);b.enabled&&(this.render(),A(this.chart,"endResize",function(){this.legend.positionCheckboxes()}))},setOptions:function(a){var b=d(a.padding,8);this.options=a;this.itemStyle=a.itemStyle;this.itemHiddenStyle=q(this.itemStyle,a.itemHiddenStyle);this.itemMarginTop=a.itemMarginTop||0;this.initialItemX=this.padding=b;this.initialItemY=b-5;this.itemHeight=this.maxItemWidth=0;this.symbolWidth=d(a.symbolWidth,
16);this.pages=[]},update:function(a,b){var c=this.chart;this.setOptions(q(!0,this.options,a));this.destroy();c.isDirtyLegend=c.isDirtyBox=!0;d(b,!0)&&c.redraw()},colorizeItem:function(a,b){a.legendGroup[b?"removeClass":"addClass"]("highcharts-legend-item-hidden");var c=this.options,d=a.legendItem,m=a.legendLine,e=a.legendSymbol,f=this.itemHiddenStyle.color,c=b?c.itemStyle.color:f,p=b?a.color||f:f,g=a.options&&a.options.marker,h={fill:p},y;d&&d.css({fill:c,color:c});m&&m.attr({stroke:p});if(e){if(g&&
e.isMarker&&(h=a.pointAttribs(),!b))for(y in h)h[y]=f;e.attr(h)}},positionItem:function(a){var b=this.options,d=b.symbolPadding,b=!b.rtl,m=a._legendItemPos,f=m[0],m=m[1],e=a.checkbox;(a=a.legendGroup)&&a.element&&a.translate(b?f:this.legendWidth-f-2*d-4,m);e&&(e.x=f,e.y=m)},destroyItem:function(a){var b=a.checkbox;g(["legendItem","legendLine","legendSymbol","legendGroup"],function(b){a[b]&&(a[b]=a[b].destroy())});b&&G(a.checkbox)},destroy:function(){function a(a){this[a]&&(this[a]=this[a].destroy())}
g(this.getAllItems(),function(b){g(["legendItem","legendGroup"],a,b)});g(["box","title","group"],a,this);this.display=null},positionCheckboxes:function(a){var b=this.group&&this.group.alignAttr,d,m=this.clipHeight||this.legendHeight,f=this.titleHeight;b&&(d=b.translateY,g(this.allItems,function(c){var e=c.checkbox,n;e&&(n=d+f+e.y+(a||0)+3,H(e,{left:b.translateX+c.checkboxOffset+e.x-20+"px",top:n+"px",display:n>d-6&&n<d+m-6?"":"none"}))}))},renderTitle:function(){var a=this.padding,b=this.options.title,
d=0;b.text&&(this.title||(this.title=this.chart.renderer.label(b.text,a-3,a-4,null,null,null,null,null,"legend-title").attr({zIndex:1}).css(b.style).add(this.group)),a=this.title.getBBox(),d=a.height,this.offsetWidth=a.width,this.contentGroup.attr({translateY:d}));this.titleHeight=d},setText:function(b){var c=this.options;b.legendItem.attr({text:c.labelFormat?a.format(c.labelFormat,b):c.labelFormatter.call(b)})},renderItem:function(a){var b=this.chart,f=b.renderer,m=this.options,p="horizontal"===
m.layout,e=this.symbolWidth,g=m.symbolPadding,l=this.itemStyle,t=this.itemHiddenStyle,h=this.padding,y=p?d(m.itemDistance,20):0,J=!m.rtl,r=m.width,I=m.itemMarginBottom||0,k=this.itemMarginTop,u=this.initialItemX,C=a.legendItem,N=!a.series,A=!N&&a.series.drawLegendSymbol?a.series:a,B=A.options,B=this.createCheckboxForItem&&B&&B.showCheckbox,v=m.useHTML;C||(a.legendGroup=f.g("legend-item").addClass("highcharts-"+A.type+"-series highcharts-color-"+a.colorIndex+(a.options.className?" "+a.options.className:
"")+(N?" highcharts-series-"+a.index:"")).attr({zIndex:1}).add(this.scrollGroup),a.legendItem=C=f.text("",J?e+g:-g,this.baseline||0,v).css(q(a.visible?l:t)).attr({align:J?"left":"right",zIndex:2}).add(a.legendGroup),this.baseline||(l=l.fontSize,this.fontMetrics=f.fontMetrics(l,C),this.baseline=this.fontMetrics.f+3+k,C.attr("y",this.baseline)),this.symbolHeight=m.symbolHeight||this.fontMetrics.f,A.drawLegendSymbol(this,a),this.setItemEvents&&this.setItemEvents(a,C,v),B&&this.createCheckboxForItem(a));
this.colorizeItem(a,a.visible);this.setText(a);f=C.getBBox();e=a.checkboxOffset=m.itemWidth||a.legendItemWidth||e+g+f.width+y+(B?20:0);this.itemHeight=g=Math.round(a.legendItemHeight||f.height);p&&this.itemX-u+e>(r||b.chartWidth-2*h-u-m.x)&&(this.itemX=u,this.itemY+=k+this.lastLineHeight+I,this.lastLineHeight=0);this.maxItemWidth=Math.max(this.maxItemWidth,e);this.lastItemY=k+this.itemY+I;this.lastLineHeight=Math.max(g,this.lastLineHeight);a._legendItemPos=[this.itemX,this.itemY];p?this.itemX+=e:
(this.itemY+=k+g+I,this.lastLineHeight=g);this.offsetWidth=r||Math.max((p?this.itemX-u-y:e)+h,this.offsetWidth)},getAllItems:function(){var a=[];g(this.chart.series,function(b){var c=b&&b.options;b&&d(c.showInLegend,r(c.linkedTo)?!1:void 0,!0)&&(a=a.concat(b.legendItems||("point"===c.legendType?b.data:b)))});return a},adjustMargins:function(a,b){var c=this.chart,f=this.options,m=f.align.charAt(0)+f.verticalAlign.charAt(0)+f.layout.charAt(0);f.floating||g([/(lth|ct|rth)/,/(rtv|rm|rbv)/,/(rbh|cb|lbh)/,
/(lbv|lm|ltv)/],function(e,n){e.test(m)&&!r(a[n])&&(c[l[n]]=Math.max(c[l[n]],c.legend[(n+1)%2?"legendHeight":"legendWidth"]+[1,-1,-1,1][n]*f[n%2?"x":"y"]+d(f.margin,12)+b[n]))})},render:function(){var a=this,b=a.chart,d=b.renderer,q=a.group,l,e,t,r,w=a.box,h=a.options,y=a.padding;a.itemX=a.initialItemX;a.itemY=a.initialItemY;a.offsetWidth=0;a.lastItemY=0;q||(a.group=q=d.g("legend").attr({zIndex:7}).add(),a.contentGroup=d.g().attr({zIndex:1}).add(q),a.scrollGroup=d.g().add(a.contentGroup));a.renderTitle();
l=a.getAllItems();p(l,function(a,b){return(a.options&&a.options.legendIndex||0)-(b.options&&b.options.legendIndex||0)});h.reversed&&l.reverse();a.allItems=l;a.display=e=!!l.length;a.lastLineHeight=0;g(l,function(b){a.renderItem(b)});t=(h.width||a.offsetWidth)+y;r=a.lastItemY+a.lastLineHeight+a.titleHeight;r=a.handleOverflow(r);r+=y;w||(a.box=w=d.rect().addClass("highcharts-legend-box").attr({r:h.borderRadius}).add(q),w.isNew=!0);w.attr({stroke:h.borderColor,"stroke-width":h.borderWidth||0,fill:h.backgroundColor||
"none"}).shadow(h.shadow);0<t&&0<r&&(w[w.isNew?"attr":"animate"](w.crisp({x:0,y:0,width:t,height:r},w.strokeWidth())),w.isNew=!1);w[e?"show":"hide"]();a.legendWidth=t;a.legendHeight=r;g(l,function(b){a.positionItem(b)});e&&q.align(f({width:t,height:r},h),!0,"spacingBox");b.isResizing||this.positionCheckboxes()},handleOverflow:function(a){var b=this,f=this.chart,m=f.renderer,p=this.options,e=p.y,f=f.spacingBox.height+("top"===p.verticalAlign?-e:e)-this.padding,e=p.maxHeight,q,l=this.clipRect,t=p.navigation,
h=d(t.animation,!0),y=t.arrowSize||12,r=this.nav,u=this.pages,I=this.padding,k,D=this.allItems,C=function(a){a?l.attr({height:a}):l&&(b.clipRect=l.destroy(),b.contentGroup.clip());b.contentGroup.div&&(b.contentGroup.div.style.clip=a?"rect("+I+"px,9999px,"+(I+a)+"px,0)":"auto")};"horizontal"!==p.layout||"middle"===p.verticalAlign||p.floating||(f/=2);e&&(f=Math.min(f,e));u.length=0;a>f&&!1!==t.enabled?(this.clipHeight=q=Math.max(f-20-this.titleHeight-I,0),this.currentPage=d(this.currentPage,1),this.fullHeight=
a,g(D,function(a,b){var c=a._legendItemPos[1];a=Math.round(a.legendItem.getBBox().height);var e=u.length;if(!e||c-u[e-1]>q&&(k||c)!==u[e-1])u.push(k||c),e++;b===D.length-1&&c+a-u[e-1]>q&&u.push(c);c!==k&&(k=c)}),l||(l=b.clipRect=m.clipRect(0,I,9999,0),b.contentGroup.clip(l)),C(q),r||(this.nav=r=m.g().attr({zIndex:1}).add(this.group),this.up=m.symbol("triangle",0,0,y,y).on("click",function(){b.scroll(-1,h)}).add(r),this.pager=m.text("",15,10).addClass("highcharts-legend-navigation").css(t.style).add(r),
this.down=m.symbol("triangle-down",0,0,y,y).on("click",function(){b.scroll(1,h)}).add(r)),b.scroll(0),a=f):r&&(C(),r.hide(),this.scrollGroup.attr({translateY:1}),this.clipHeight=0);return a},scroll:function(a,c){var d=this.pages,f=d.length;a=this.currentPage+a;var m=this.clipHeight,e=this.options.navigation,p=this.pager,g=this.padding;a>f&&(a=f);0<a&&(void 0!==c&&b(c,this.chart),this.nav.attr({translateX:g,translateY:m+this.padding+7+this.titleHeight,visibility:"visible"}),this.up.attr({"class":1===
a?"highcharts-legend-nav-inactive":"highcharts-legend-nav-active"}),p.attr({text:a+"/"+f}),this.down.attr({x:18+this.pager.getBBox().width,"class":a===f?"highcharts-legend-nav-inactive":"highcharts-legend-nav-active"}),this.up.attr({fill:1===a?e.inactiveColor:e.activeColor}).css({cursor:1===a?"default":"pointer"}),this.down.attr({fill:a===f?e.inactiveColor:e.activeColor}).css({cursor:a===f?"default":"pointer"}),c=-d[a-1]+this.initialItemY,this.scrollGroup.animate({translateY:c}),this.currentPage=
a,this.positionCheckboxes(c))}};a.LegendSymbolMixin={drawRectangle:function(a,b){var c=a.symbolHeight,f=a.options.squareSymbol;b.legendSymbol=this.chart.renderer.rect(f?(a.symbolWidth-c)/2:0,a.baseline-c+1,f?c:a.symbolWidth,c,d(a.options.symbolRadius,c/2)).addClass("highcharts-point").attr({zIndex:3}).add(b.legendGroup)},drawLineMarker:function(a){var b=this.options,f=b.marker,m=a.symbolWidth,p=a.symbolHeight,e=p/2,g=this.chart.renderer,l=this.legendGroup;a=a.baseline-Math.round(.3*a.fontMetrics.b);
var t;t={"stroke-width":b.lineWidth||0};b.dashStyle&&(t.dashstyle=b.dashStyle);this.legendLine=g.path(["M",0,a,"L",m,a]).addClass("highcharts-graph").attr(t).add(l);f&&!1!==f.enabled&&(b=Math.min(d(f.radius,e),e),0===this.symbol.indexOf("url")&&(f=q(f,{width:p,height:p}),b=0),this.legendSymbol=f=g.symbol(this.symbol,m/2-b,a-b,2*b,2*b,f).addClass("highcharts-point").add(l),f.isMarker=!0)}};(/Trident\/7\.0/.test(C.navigator.userAgent)||u)&&t(B.prototype,"positionItem",function(a,b){var c=this,d=function(){b._legendItemPos&&
a.call(c,b)};d();setTimeout(d)})})(L);(function(a){var B=a.addEvent,A=a.animate,H=a.animObject,G=a.attr,r=a.doc,g=a.Axis,f=a.createElement,u=a.defaultOptions,l=a.discardElement,q=a.charts,d=a.css,b=a.defined,p=a.each,C=a.extend,t=a.find,m=a.fireEvent,c=a.getStyle,n=a.grep,E=a.isNumber,z=a.isObject,e=a.isString,x=a.Legend,F=a.marginNames,w=a.merge,h=a.Pointer,y=a.pick,J=a.pInt,K=a.removeEvent,I=a.seriesTypes,k=a.splat,D=a.svg,P=a.syncTimeout,N=a.win,S=a.Renderer,O=a.Chart=function(){this.getArgs.apply(this,
arguments)};a.chart=function(a,b,c){return new O(a,b,c)};O.prototype={callbacks:[],getArgs:function(){var a=[].slice.call(arguments);if(e(a[0])||a[0].nodeName)this.renderTo=a.shift();this.init(a[0],a[1])},init:function(b,c){var e,h=b.series;b.series=null;e=w(u,b);e.series=b.series=h;this.userOptions=b;this.respRules=[];b=e.chart;h=b.events;this.margin=[];this.spacing=[];this.bounds={h:{},v:{}};this.callback=c;this.isResizing=0;this.options=e;this.axes=[];this.series=[];this.hasCartesianSeries=b.showAxes;
var d;this.index=q.length;q.push(this);a.chartCount++;if(h)for(d in h)B(this,d,h[d]);this.xAxis=[];this.yAxis=[];this.pointCount=this.colorCounter=this.symbolCounter=0;this.firstRender()},initSeries:function(b){var c=this.options.chart;(c=I[b.type||c.type||c.defaultSeriesType])||a.error(17,!0);c=new c;c.init(this,b);return c},orderSeries:function(a){var b=this.series;for(a=a||0;a<b.length;a++)b[a]&&(b[a].index=a,b[a].name=b[a].name||"Series "+(b[a].index+1))},isInsidePlot:function(a,b,c){var e=c?
b:a;a=c?a:b;return 0<=e&&e<=this.plotWidth&&0<=a&&a<=this.plotHeight},redraw:function(b){var c=this.axes,e=this.series,h=this.pointer,d=this.legend,k=this.isDirtyLegend,f,n,y=this.hasCartesianSeries,g=this.isDirtyBox,v=e.length,l=v,q=this.renderer,t=q.isHidden(),w=[];this.setResponsive&&this.setResponsive(!1);a.setAnimation(b,this);t&&this.cloneRenderTo();for(this.layOutTitles();l--;)if(b=e[l],b.options.stacking&&(f=!0,b.isDirty)){n=!0;break}if(n)for(l=v;l--;)b=e[l],b.options.stacking&&(b.isDirty=
!0);p(e,function(a){a.isDirty&&"point"===a.options.legendType&&(a.updateTotals&&a.updateTotals(),k=!0);a.isDirtyData&&m(a,"updatedData")});k&&d.options.enabled&&(d.render(),this.isDirtyLegend=!1);f&&this.getStacks();y&&p(c,function(a){a.updateNames();a.setScale()});this.getMargins();y&&(p(c,function(a){a.isDirty&&(g=!0)}),p(c,function(a){var b=a.min+","+a.max;a.extKey!==b&&(a.extKey=b,w.push(function(){m(a,"afterSetExtremes",C(a.eventArgs,a.getExtremes()));delete a.eventArgs}));(g||f)&&a.redraw()}));
g&&this.drawChartBox();m(this,"predraw");p(e,function(a){(g||a.isDirty)&&a.visible&&a.redraw();a.isDirtyData=!1});h&&h.reset(!0);q.draw();m(this,"redraw");m(this,"render");t&&this.cloneRenderTo(!0);p(w,function(a){a.call()})},get:function(a){function b(b){return b.id===a||b.options&&b.options.id===a}var c,e=this.series,h;c=t(this.axes,b)||t(this.series,b);for(h=0;!c&&h<e.length;h++)c=t(e[h].points||[],b);return c},getAxes:function(){var a=this,b=this.options,c=b.xAxis=k(b.xAxis||{}),b=b.yAxis=k(b.yAxis||
{});p(c,function(a,b){a.index=b;a.isX=!0});p(b,function(a,b){a.index=b});c=c.concat(b);p(c,function(b){new g(a,b)})},getSelectedPoints:function(){var a=[];p(this.series,function(b){a=a.concat(n(b.points||[],function(a){return a.selected}))});return a},getSelectedSeries:function(){return n(this.series,function(a){return a.selected})},setTitle:function(a,b,c){var e=this,h=e.options,d;d=h.title=w({style:{color:"#333333",fontSize:h.isStock?"16px":"18px"}},h.title,a);h=h.subtitle=w({style:{color:"#666666"}},
h.subtitle,b);p([["title",a,d],["subtitle",b,h]],function(a,b){var c=a[0],h=e[c],d=a[1];a=a[2];h&&d&&(e[c]=h=h.destroy());a&&a.text&&!h&&(e[c]=e.renderer.text(a.text,0,0,a.useHTML).attr({align:a.align,"class":"highcharts-"+c,zIndex:a.zIndex||4}).add(),e[c].update=function(a){e.setTitle(!b&&a,b&&a)},e[c].css(a.style))});e.layOutTitles(c)},layOutTitles:function(a){var b=0,c,e=this.renderer,h=this.spacingBox;p(["title","subtitle"],function(a){var c=this[a],d=this.options[a],k;c&&(k=d.style.fontSize,
k=e.fontMetrics(k,c).b,c.css({width:(d.width||h.width+d.widthAdjust)+"px"}).align(C({y:b+k+("title"===a?-3:2)},d),!1,"spacingBox"),d.floating||d.verticalAlign||(b=Math.ceil(b+c.getBBox().height)))},this);c=this.titleOffset!==b;this.titleOffset=b;!this.isDirtyBox&&c&&(this.isDirtyBox=c,this.hasRendered&&y(a,!0)&&this.isDirtyBox&&this.redraw())},getChartSize:function(){var a=this.options.chart,e=a.width,a=a.height,h=this.renderToClone||this.renderTo;b(e)||(this.containerWidth=c(h,"width"));b(a)||(this.containerHeight=
c(h,"height"));this.chartWidth=Math.max(0,e||this.containerWidth||600);this.chartHeight=Math.max(0,a||this.containerHeight||400)},cloneRenderTo:function(a){var b=this.renderToClone,c=this.container;if(a){if(b){for(;b.childNodes.length;)this.renderTo.appendChild(b.firstChild);l(b);delete this.renderToClone}}else c&&c.parentNode===this.renderTo&&this.renderTo.removeChild(c),this.renderToClone=b=this.renderTo.cloneNode(0),d(b,{position:"absolute",top:"-9999px",display:"block"}),b.style.setProperty&&
b.style.setProperty("display","block","important"),r.body.appendChild(b),c&&b.appendChild(c)},setClassName:function(a){this.container.className="highcharts-container "+(a||"")},getContainer:function(){var b,c=this.options,h=c.chart,d,k;b=this.renderTo;var m=a.uniqueKey(),n;b||(this.renderTo=b=h.renderTo);e(b)&&(this.renderTo=b=r.getElementById(b));b||a.error(13,!0);d=J(G(b,"data-highcharts-chart"));E(d)&&q[d]&&q[d].hasRendered&&q[d].destroy();G(b,"data-highcharts-chart",this.index);b.innerHTML="";
h.skipClone||b.offsetWidth||this.cloneRenderTo();this.getChartSize();d=this.chartWidth;k=this.chartHeight;n=C({position:"relative",overflow:"hidden",width:d+"px",height:k+"px",textAlign:"left",lineHeight:"normal",zIndex:0,"-webkit-tap-highlight-color":"rgba(0,0,0,0)"},h.style);this.container=b=f("div",{id:m},n,this.renderToClone||b);this._cursor=b.style.cursor;this.renderer=new (a[h.renderer]||S)(b,d,k,null,h.forExport,c.exporting&&c.exporting.allowHTML);this.setClassName(h.className);this.renderer.setStyle(h.style);
this.renderer.chartIndex=this.index},getMargins:function(a){var c=this.spacing,e=this.margin,h=this.titleOffset;this.resetMargins();h&&!b(e[0])&&(this.plotTop=Math.max(this.plotTop,h+this.options.title.margin+c[0]));this.legend.display&&this.legend.adjustMargins(e,c);this.extraMargin&&(this[this.extraMargin.type]=(this[this.extraMargin.type]||0)+this.extraMargin.value);this.extraTopMargin&&(this.plotTop+=this.extraTopMargin);a||this.getAxisMargins()},getAxisMargins:function(){var a=this,c=a.axisOffset=
[0,0,0,0],e=a.margin;a.hasCartesianSeries&&p(a.axes,function(a){a.visible&&a.getOffset()});p(F,function(h,d){b(e[d])||(a[h]+=c[d])});a.setChartSize()},reflow:function(a){var e=this,h=e.options.chart,d=e.renderTo,k=b(h.width),f=h.width||c(d,"width"),h=h.height||c(d,"height"),d=a?a.target:N;if(!k&&!e.isPrinting&&f&&h&&(d===N||d===r)){if(f!==e.containerWidth||h!==e.containerHeight)clearTimeout(e.reflowTimeout),e.reflowTimeout=P(function(){e.container&&e.setSize(void 0,void 0,!1)},a?100:0);e.containerWidth=
f;e.containerHeight=h}},initReflow:function(){var a=this,b;b=B(N,"resize",function(b){a.reflow(b)});B(a,"destroy",b)},setSize:function(b,c,e){var h=this,k=h.renderer;h.isResizing+=1;a.setAnimation(e,h);h.oldChartHeight=h.chartHeight;h.oldChartWidth=h.chartWidth;void 0!==b&&(h.options.chart.width=b);void 0!==c&&(h.options.chart.height=c);h.getChartSize();b=k.globalAnimation;(b?A:d)(h.container,{width:h.chartWidth+"px",height:h.chartHeight+"px"},b);h.setChartSize(!0);k.setSize(h.chartWidth,h.chartHeight,
e);p(h.axes,function(a){a.isDirty=!0;a.setScale()});h.isDirtyLegend=!0;h.isDirtyBox=!0;h.layOutTitles();h.getMargins();h.redraw(e);h.oldChartHeight=null;m(h,"resize");P(function(){h&&m(h,"endResize",null,function(){--h.isResizing})},H(b).duration)},setChartSize:function(a){var b=this.inverted,c=this.renderer,e=this.chartWidth,h=this.chartHeight,d=this.options.chart,k=this.spacing,f=this.clipOffset,m,n,y,g;this.plotLeft=m=Math.round(this.plotLeft);this.plotTop=n=Math.round(this.plotTop);this.plotWidth=
y=Math.max(0,Math.round(e-m-this.marginRight));this.plotHeight=g=Math.max(0,Math.round(h-n-this.marginBottom));this.plotSizeX=b?g:y;this.plotSizeY=b?y:g;this.plotBorderWidth=d.plotBorderWidth||0;this.spacingBox=c.spacingBox={x:k[3],y:k[0],width:e-k[3]-k[1],height:h-k[0]-k[2]};this.plotBox=c.plotBox={x:m,y:n,width:y,height:g};e=2*Math.floor(this.plotBorderWidth/2);b=Math.ceil(Math.max(e,f[3])/2);c=Math.ceil(Math.max(e,f[0])/2);this.clipBox={x:b,y:c,width:Math.floor(this.plotSizeX-Math.max(e,f[1])/
2-b),height:Math.max(0,Math.floor(this.plotSizeY-Math.max(e,f[2])/2-c))};a||p(this.axes,function(a){a.setAxisSize();a.setAxisTranslation()})},resetMargins:function(){var a=this,b=a.options.chart;p(["margin","spacing"],function(c){var e=b[c],h=z(e)?e:[e,e,e,e];p(["Top","Right","Bottom","Left"],function(e,d){a[c][d]=y(b[c+e],h[d])})});p(F,function(b,c){a[b]=y(a.margin[c],a.spacing[c])});a.axisOffset=[0,0,0,0];a.clipOffset=[0,0,0,0]},drawChartBox:function(){var a=this.options.chart,b=this.renderer,c=
this.chartWidth,e=this.chartHeight,h=this.chartBackground,d=this.plotBackground,k=this.plotBorder,f,m=this.plotBGImage,n=a.backgroundColor,p=a.plotBackgroundColor,y=a.plotBackgroundImage,g,l=this.plotLeft,q=this.plotTop,t=this.plotWidth,w=this.plotHeight,x=this.plotBox,r=this.clipRect,z=this.clipBox,J="animate";h||(this.chartBackground=h=b.rect().addClass("highcharts-background").add(),J="attr");f=a.borderWidth||0;g=f+(a.shadow?8:0);n={fill:n||"none"};if(f||h["stroke-width"])n.stroke=a.borderColor,
n["stroke-width"]=f;h.attr(n).shadow(a.shadow);h[J]({x:g/2,y:g/2,width:c-g-f%2,height:e-g-f%2,r:a.borderRadius});J="animate";d||(J="attr",this.plotBackground=d=b.rect().addClass("highcharts-plot-background").add());d[J](x);d.attr({fill:p||"none"}).shadow(a.plotShadow);y&&(m?m.animate(x):this.plotBGImage=b.image(y,l,q,t,w).add());r?r.animate({width:z.width,height:z.height}):this.clipRect=b.clipRect(z);J="animate";k||(J="attr",this.plotBorder=k=b.rect().addClass("highcharts-plot-border").attr({zIndex:1}).add());
k.attr({stroke:a.plotBorderColor,"stroke-width":a.plotBorderWidth||0,fill:"none"});k[J](k.crisp({x:l,y:q,width:t,height:w},-k.strokeWidth()));this.isDirtyBox=!1},propFromSeries:function(){var a=this,b=a.options.chart,c,e=a.options.series,h,d;p(["inverted","angular","polar"],function(k){c=I[b.type||b.defaultSeriesType];d=b[k]||c&&c.prototype[k];for(h=e&&e.length;!d&&h--;)(c=I[e[h].type])&&c.prototype[k]&&(d=!0);a[k]=d})},linkSeries:function(){var a=this,b=a.series;p(b,function(a){a.linkedSeries.length=
0});p(b,function(b){var c=b.options.linkedTo;e(c)&&(c=":previous"===c?a.series[b.index-1]:a.get(c))&&c.linkedParent!==b&&(c.linkedSeries.push(b),b.linkedParent=c,b.visible=y(b.options.visible,c.options.visible,b.visible))})},renderSeries:function(){p(this.series,function(a){a.translate();a.render()})},renderLabels:function(){var a=this,b=a.options.labels;b.items&&p(b.items,function(c){var e=C(b.style,c.style),h=J(e.left)+a.plotLeft,d=J(e.top)+a.plotTop+12;delete e.left;delete e.top;a.renderer.text(c.html,
h,d).attr({zIndex:2}).css(e).add()})},render:function(){var a=this.axes,b=this.renderer,c=this.options,e,h,d;this.setTitle();this.legend=new x(this,c.legend);this.getStacks&&this.getStacks();this.getMargins(!0);this.setChartSize();c=this.plotWidth;e=this.plotHeight-=21;p(a,function(a){a.setScale()});this.getAxisMargins();h=1.1<c/this.plotWidth;d=1.05<e/this.plotHeight;if(h||d)p(a,function(a){(a.horiz&&h||!a.horiz&&d)&&a.setTickInterval(!0)}),this.getMargins();this.drawChartBox();this.hasCartesianSeries&&
p(a,function(a){a.visible&&a.render()});this.seriesGroup||(this.seriesGroup=b.g("series-group").attr({zIndex:3}).add());this.renderSeries();this.renderLabels();this.addCredits();this.setResponsive&&this.setResponsive();this.hasRendered=!0},addCredits:function(a){var b=this;a=w(!0,this.options.credits,a);a.enabled&&!this.credits&&(this.credits=this.renderer.text(a.text+(this.mapCredits||""),0,0).addClass("highcharts-credits").on("click",function(){a.href&&(N.location.href=a.href)}).attr({align:a.position.align,
zIndex:8}).css(a.style).add().align(a.position),this.credits.update=function(a){b.credits=b.credits.destroy();b.addCredits(a)})},destroy:function(){var b=this,c=b.axes,e=b.series,h=b.container,d,k=h&&h.parentNode;m(b,"destroy");q[b.index]=void 0;a.chartCount--;b.renderTo.removeAttribute("data-highcharts-chart");K(b);for(d=c.length;d--;)c[d]=c[d].destroy();this.scroller&&this.scroller.destroy&&this.scroller.destroy();for(d=e.length;d--;)e[d]=e[d].destroy();p("title subtitle chartBackground plotBackground plotBGImage plotBorder seriesGroup clipRect credits pointer rangeSelector legend resetZoomButton tooltip renderer".split(" "),
function(a){var c=b[a];c&&c.destroy&&(b[a]=c.destroy())});h&&(h.innerHTML="",K(h),k&&l(h));for(d in b)delete b[d]},isReadyToRender:function(){var a=this;return D||N!=N.top||"complete"===r.readyState?!0:(r.attachEvent("onreadystatechange",function(){r.detachEvent("onreadystatechange",a.firstRender);"complete"===r.readyState&&a.firstRender()}),!1)},firstRender:function(){var a=this,b=a.options;if(a.isReadyToRender()){a.getContainer();m(a,"init");a.resetMargins();a.setChartSize();a.propFromSeries();
a.getAxes();p(b.series||[],function(b){a.initSeries(b)});a.linkSeries();m(a,"beforeRender");h&&(a.pointer=new h(a,b));a.render();if(!a.renderer.imgCount&&a.onload)a.onload();a.cloneRenderTo(!0)}},onload:function(){p([this.callback].concat(this.callbacks),function(a){a&&void 0!==this.index&&a.apply(this,[this])},this);m(this,"load");m(this,"render");b(this.index)&&!1!==this.options.chart.reflow&&this.initReflow();this.onload=null}}})(L);(function(a){var B,A=a.each,H=a.extend,G=a.erase,r=a.fireEvent,
g=a.format,f=a.isArray,u=a.isNumber,l=a.pick,q=a.removeEvent;B=a.Point=function(){};B.prototype={init:function(a,b,f){this.series=a;this.color=a.color;this.applyOptions(b,f);a.options.colorByPoint?(b=a.options.colors||a.chart.options.colors,this.color=this.color||b[a.colorCounter],b=b.length,f=a.colorCounter,a.colorCounter++,a.colorCounter===b&&(a.colorCounter=0)):f=a.colorIndex;this.colorIndex=l(this.colorIndex,f);a.chart.pointCount++;return this},applyOptions:function(a,b){var d=this.series,f=d.options.pointValKey||
d.pointValKey;a=B.prototype.optionsToObject.call(this,a);H(this,a);this.options=this.options?H(this.options,a):a;a.group&&delete this.group;f&&(this.y=this[f]);this.isNull=l(this.isValid&&!this.isValid(),null===this.x||!u(this.y,!0));this.selected&&(this.state="select");"name"in this&&void 0===b&&d.xAxis&&d.xAxis.hasNames&&(this.x=d.xAxis.nameToX(this));void 0===this.x&&d&&(this.x=void 0===b?d.autoIncrement(this):b);return this},optionsToObject:function(a){var b={},d=this.series,g=d.options.keys,
l=g||d.pointArrayMap||["y"],m=l.length,c=0,n=0;if(u(a)||null===a)b[l[0]]=a;else if(f(a))for(!g&&a.length>m&&(d=typeof a[0],"string"===d?b.name=a[0]:"number"===d&&(b.x=a[0]),c++);n<m;)g&&void 0===a[c]||(b[l[n]]=a[c]),c++,n++;else"object"===typeof a&&(b=a,a.dataLabels&&(d._hasPointLabels=!0),a.marker&&(d._hasPointMarkers=!0));return b},getClassName:function(){return"highcharts-point"+(this.selected?" highcharts-point-select":"")+(this.negative?" highcharts-negative":"")+(this.isNull?" highcharts-null-point":
"")+(void 0!==this.colorIndex?" highcharts-color-"+this.colorIndex:"")+(this.options.className?" "+this.options.className:"")+(this.zone&&this.zone.className?" "+this.zone.className.replace("highcharts-negative",""):"")},getZone:function(){var a=this.series,b=a.zones,a=a.zoneAxis||"y",f=0,g;for(g=b[f];this[a]>=g.value;)g=b[++f];g&&g.color&&!this.options.color&&(this.color=g.color);return g},destroy:function(){var a=this.series.chart,b=a.hoverPoints,f;a.pointCount--;b&&(this.setState(),G(b,this),b.length||
(a.hoverPoints=null));if(this===a.hoverPoint)this.onMouseOut();if(this.graphic||this.dataLabel)q(this),this.destroyElements();this.legendItem&&a.legend.destroyItem(this);for(f in this)this[f]=null},destroyElements:function(){for(var a=["graphic","dataLabel","dataLabelUpper","connector","shadowGroup"],b,f=6;f--;)b=a[f],this[b]&&(this[b]=this[b].destroy())},getLabelConfig:function(){return{x:this.category,y:this.y,color:this.color,colorIndex:this.colorIndex,key:this.name||this.category,series:this.series,
point:this,percentage:this.percentage,total:this.total||this.stackTotal}},tooltipFormatter:function(a){var b=this.series,d=b.tooltipOptions,f=l(d.valueDecimals,""),q=d.valuePrefix||"",m=d.valueSuffix||"";A(b.pointArrayMap||["y"],function(b){b="{point."+b;if(q||m)a=a.replace(b+"}",q+b+"}"+m);a=a.replace(b+"}",b+":,."+f+"f}")});return g(a,{point:this,series:this.series})},firePointEvent:function(a,b,f){var d=this,g=this.series.options;(g.point.events[a]||d.options&&d.options.events&&d.options.events[a])&&
this.importEvents();"click"===a&&g.allowPointSelect&&(f=function(a){d.select&&d.select(null,a.ctrlKey||a.metaKey||a.shiftKey)});r(this,a,b,f)},visible:!0}})(L);(function(a){var B=a.addEvent,A=a.animObject,H=a.arrayMax,G=a.arrayMin,r=a.correctFloat,g=a.Date,f=a.defaultOptions,u=a.defaultPlotOptions,l=a.defined,q=a.each,d=a.erase,b=a.extend,p=a.fireEvent,C=a.grep,t=a.isArray,m=a.isNumber,c=a.isString,n=a.merge,E=a.pick,z=a.removeEvent,e=a.splat,x=a.SVGElement,F=a.syncTimeout,w=a.win;a.Series=a.seriesType("line",
null,{lineWidth:2,allowPointSelect:!1,showCheckbox:!1,animation:{duration:1E3},events:{},marker:{lineWidth:0,lineColor:"#ffffff",radius:4,states:{hover:{animation:{duration:50},enabled:!0,radiusPlus:2,lineWidthPlus:1},select:{fillColor:"#cccccc",lineColor:"#000000",lineWidth:2}}},point:{events:{}},dataLabels:{align:"center",formatter:function(){return null===this.y?"":a.numberFormat(this.y,-1)},style:{fontSize:"11px",fontWeight:"bold",color:"contrast",textOutline:"1px contrast"},verticalAlign:"bottom",
x:0,y:0,padding:5},cropThreshold:300,pointRange:0,softThreshold:!0,states:{hover:{lineWidthPlus:1,marker:{},halo:{size:10,opacity:.25}},select:{marker:{}}},stickyTracking:!0,turboThreshold:1E3},{isCartesian:!0,pointClass:a.Point,sorted:!0,requireSorting:!0,directTouch:!1,axisTypes:["xAxis","yAxis"],colorCounter:0,parallelArrays:["x","y"],coll:"series",init:function(a,c){var e=this,h,d,k=a.series,f;e.chart=a;e.options=c=e.setOptions(c);e.linkedSeries=[];e.bindAxes();b(e,{name:c.name,state:"",visible:!1!==
c.visible,selected:!0===c.selected});d=c.events;for(h in d)B(e,h,d[h]);if(d&&d.click||c.point&&c.point.events&&c.point.events.click||c.allowPointSelect)a.runTrackerClick=!0;e.getColor();e.getSymbol();q(e.parallelArrays,function(a){e[a+"Data"]=[]});e.setData(c.data,!1);e.isCartesian&&(a.hasCartesianSeries=!0);k.length&&(f=k[k.length-1]);e._i=E(f&&f._i,-1)+1;a.orderSeries(this.insert(k))},insert:function(a){var b=this.options.index,c;if(m(b)){for(c=a.length;c--;)if(b>=E(a[c].options.index,a[c]._i)){a.splice(c+
1,0,this);break}-1===c&&a.unshift(this);c+=1}else a.push(this);return E(c,a.length-1)},bindAxes:function(){var b=this,c=b.options,e=b.chart,d;q(b.axisTypes||[],function(h){q(e[h],function(a){d=a.options;if(c[h]===d.index||void 0!==c[h]&&c[h]===d.id||void 0===c[h]&&0===d.index)b.insert(a.series),b[h]=a,a.isDirty=!0});b[h]||b.optionalAxis===h||a.error(18,!0)})},updateParallelArrays:function(a,b){var c=a.series,e=arguments,h=m(b)?function(e){var h="y"===e&&c.toYData?c.toYData(a):a[e];c[e+"Data"][b]=
h}:function(a){Array.prototype[b].apply(c[a+"Data"],Array.prototype.slice.call(e,2))};q(c.parallelArrays,h)},autoIncrement:function(){var a=this.options,b=this.xIncrement,c,e=a.pointIntervalUnit,b=E(b,a.pointStart,0);this.pointInterval=c=E(this.pointInterval,a.pointInterval,1);e&&(a=new g(b),"day"===e?a=+a[g.hcSetDate](a[g.hcGetDate]()+c):"month"===e?a=+a[g.hcSetMonth](a[g.hcGetMonth]()+c):"year"===e&&(a=+a[g.hcSetFullYear](a[g.hcGetFullYear]()+c)),c=a-b);this.xIncrement=b+c;return b},setOptions:function(a){var b=
this.chart,c=b.options.plotOptions,b=b.userOptions||{},e=b.plotOptions||{},h=c[this.type];this.userOptions=a;c=n(h,c.series,a);this.tooltipOptions=n(f.tooltip,f.plotOptions[this.type].tooltip,b.tooltip,e.series&&e.series.tooltip,e[this.type]&&e[this.type].tooltip,a.tooltip);null===h.marker&&delete c.marker;this.zoneAxis=c.zoneAxis;a=this.zones=(c.zones||[]).slice();!c.negativeColor&&!c.negativeFillColor||c.zones||a.push({value:c[this.zoneAxis+"Threshold"]||c.threshold||0,className:"highcharts-negative",
color:c.negativeColor,fillColor:c.negativeFillColor});a.length&&l(a[a.length-1].value)&&a.push({color:this.color,fillColor:this.fillColor});return c},getCyclic:function(a,b,c){var e,h=this.chart,d=this.userOptions,f=a+"Index",n=a+"Counter",m=c?c.length:E(h.options.chart[a+"Count"],h[a+"Count"]);b||(e=E(d[f],d["_"+f]),l(e)||(h.series.length||(h[n]=0),d["_"+f]=e=h[n]%m,h[n]+=1),c&&(b=c[e]));void 0!==e&&(this[f]=e);this[a]=b},getColor:function(){this.options.colorByPoint?this.options.color=null:this.getCyclic("color",
this.options.color||u[this.type].color,this.chart.options.colors)},getSymbol:function(){this.getCyclic("symbol",this.options.marker.symbol,this.chart.options.symbols)},drawLegendSymbol:a.LegendSymbolMixin.drawLineMarker,setData:function(b,e,d,f){var h=this,k=h.points,n=k&&k.length||0,g,p=h.options,y=h.chart,l=null,w=h.xAxis,x=p.turboThreshold,r=this.xData,z=this.yData,F=(g=h.pointArrayMap)&&g.length;b=b||[];g=b.length;e=E(e,!0);if(!1!==f&&g&&n===g&&!h.cropped&&!h.hasGroupedData&&h.visible)q(b,function(a,
b){k[b].update&&a!==p.data[b]&&k[b].update(a,!1,null,!1)});else{h.xIncrement=null;h.colorCounter=0;q(this.parallelArrays,function(a){h[a+"Data"].length=0});if(x&&g>x){for(d=0;null===l&&d<g;)l=b[d],d++;if(m(l))for(d=0;d<g;d++)r[d]=this.autoIncrement(),z[d]=b[d];else if(t(l))if(F)for(d=0;d<g;d++)l=b[d],r[d]=l[0],z[d]=l.slice(1,F+1);else for(d=0;d<g;d++)l=b[d],r[d]=l[0],z[d]=l[1];else a.error(12)}else for(d=0;d<g;d++)void 0!==b[d]&&(l={series:h},h.pointClass.prototype.applyOptions.apply(l,[b[d]]),h.updateParallelArrays(l,
d));c(z[0])&&a.error(14,!0);h.data=[];h.options.data=h.userOptions.data=b;for(d=n;d--;)k[d]&&k[d].destroy&&k[d].destroy();w&&(w.minRange=w.userMinRange);h.isDirty=y.isDirtyBox=!0;h.isDirtyData=!!k;d=!1}"point"===p.legendType&&(this.processData(),this.generatePoints());e&&y.redraw(d)},processData:function(b){var c=this.xData,e=this.yData,h=c.length,d;d=0;var k,f,n=this.xAxis,m,g=this.options;m=g.cropThreshold;var p=this.getExtremesFromAll||g.getExtremesFromAll,l=this.isCartesian,g=n&&n.val2lin,q=n&&
n.isLog,t,w;if(l&&!this.isDirty&&!n.isDirty&&!this.yAxis.isDirty&&!b)return!1;n&&(b=n.getExtremes(),t=b.min,w=b.max);if(l&&this.sorted&&!p&&(!m||h>m||this.forceCrop))if(c[h-1]<t||c[0]>w)c=[],e=[];else if(c[0]<t||c[h-1]>w)d=this.cropData(this.xData,this.yData,t,w),c=d.xData,e=d.yData,d=d.start,k=!0;for(m=c.length||1;--m;)h=q?g(c[m])-g(c[m-1]):c[m]-c[m-1],0<h&&(void 0===f||h<f)?f=h:0>h&&this.requireSorting&&a.error(15);this.cropped=k;this.cropStart=d;this.processedXData=c;this.processedYData=e;this.closestPointRange=
f},cropData:function(a,b,c,e){var h=a.length,d=0,f=h,n=E(this.cropShoulder,1),m;for(m=0;m<h;m++)if(a[m]>=c){d=Math.max(0,m-n);break}for(c=m;c<h;c++)if(a[c]>e){f=c+n;break}return{xData:a.slice(d,f),yData:b.slice(d,f),start:d,end:f}},generatePoints:function(){var a=this.options.data,b=this.data,c,d=this.processedXData,f=this.processedYData,k=this.pointClass,n=d.length,m=this.cropStart||0,g,p=this.hasGroupedData,l,q=[],t;b||p||(b=[],b.length=a.length,b=this.data=b);for(t=0;t<n;t++)g=m+t,p?(l=(new k).init(this,
[d[t]].concat(e(f[t]))),l.dataGroup=this.groupMap[t]):(l=b[g])||void 0===a[g]||(b[g]=l=(new k).init(this,a[g],d[t])),l.index=g,q[t]=l;if(b&&(n!==(c=b.length)||p))for(t=0;t<c;t++)t!==m||p||(t+=n),b[t]&&(b[t].destroyElements(),b[t].plotX=void 0);this.data=b;this.points=q},getExtremes:function(a){var b=this.yAxis,c=this.processedXData,e,h=[],d=0;e=this.xAxis.getExtremes();var f=e.min,n=e.max,g,p,l,q;a=a||this.stackedYData||this.processedYData||[];e=a.length;for(q=0;q<e;q++)if(p=c[q],l=a[q],g=(m(l,!0)||
t(l))&&(!b.isLog||l.length||0<l),p=this.getExtremesFromAll||this.options.getExtremesFromAll||this.cropped||(c[q+1]||p)>=f&&(c[q-1]||p)<=n,g&&p)if(g=l.length)for(;g--;)null!==l[g]&&(h[d++]=l[g]);else h[d++]=l;this.dataMin=G(h);this.dataMax=H(h)},translate:function(){this.processedXData||this.processData();this.generatePoints();var a=this.options,b=a.stacking,c=this.xAxis,e=c.categories,d=this.yAxis,k=this.points,f=k.length,n=!!this.modifyValue,g=a.pointPlacement,p="between"===g||m(g),q=a.threshold,
t=a.startFromThreshold?q:0,w,x,z,F,u=Number.MAX_VALUE;"between"===g&&(g=.5);m(g)&&(g*=E(a.pointRange||c.pointRange));for(a=0;a<f;a++){var C=k[a],A=C.x,B=C.y;x=C.low;var H=b&&d.stacks[(this.negStacks&&B<(t?0:q)?"-":"")+this.stackKey],G;d.isLog&&null!==B&&0>=B&&(C.isNull=!0);C.plotX=w=r(Math.min(Math.max(-1E5,c.translate(A,0,0,0,1,g,"flags"===this.type)),1E5));b&&this.visible&&!C.isNull&&H&&H[A]&&(F=this.getStackIndicator(F,A,this.index),G=H[A],B=G.points[F.key],x=B[0],B=B[1],x===t&&F.key===H[A].base&&
(x=E(q,d.min)),d.isLog&&0>=x&&(x=null),C.total=C.stackTotal=G.total,C.percentage=G.total&&C.y/G.total*100,C.stackY=B,G.setOffset(this.pointXOffset||0,this.barW||0));C.yBottom=l(x)?d.translate(x,0,1,0,1):null;n&&(B=this.modifyValue(B,C));C.plotY=x="number"===typeof B&&Infinity!==B?Math.min(Math.max(-1E5,d.translate(B,0,1,0,1)),1E5):void 0;C.isInside=void 0!==x&&0<=x&&x<=d.len&&0<=w&&w<=c.len;C.clientX=p?r(c.translate(A,0,0,0,1,g)):w;C.negative=C.y<(q||0);C.category=e&&void 0!==e[C.x]?e[C.x]:C.x;C.isNull||
(void 0!==z&&(u=Math.min(u,Math.abs(w-z))),z=w);C.zone=this.zones.length&&C.getZone()}this.closestPointRangePx=u},getValidPoints:function(a,b){var c=this.chart;return C(a||this.points||[],function(a){return b&&!c.isInsidePlot(a.plotX,a.plotY,c.inverted)?!1:!a.isNull})},setClip:function(a){var b=this.chart,c=this.options,e=b.renderer,d=b.inverted,h=this.clipBox,f=h||b.clipBox,n=this.sharedClipKey||["_sharedClip",a&&a.duration,a&&a.easing,f.height,c.xAxis,c.yAxis].join(),m=b[n],g=b[n+"m"];m||(a&&(f.width=
0,b[n+"m"]=g=e.clipRect(-99,d?-b.plotLeft:-b.plotTop,99,d?b.chartWidth:b.chartHeight)),b[n]=m=e.clipRect(f),m.count={length:0});a&&!m.count[this.index]&&(m.count[this.index]=!0,m.count.length+=1);!1!==c.clip&&(this.group.clip(a||h?m:b.clipRect),this.markerGroup.clip(g),this.sharedClipKey=n);a||(m.count[this.index]&&(delete m.count[this.index],--m.count.length),0===m.count.length&&n&&b[n]&&(h||(b[n]=b[n].destroy()),b[n+"m"]&&(this.markerGroup.clip(),b[n+"m"]=b[n+"m"].destroy())))},animate:function(a){var b=
this.chart,c=A(this.options.animation),e;a?this.setClip(c):(e=this.sharedClipKey,(a=b[e])&&a.animate({width:b.plotSizeX},c),b[e+"m"]&&b[e+"m"].animate({width:b.plotSizeX+99},c),this.animate=null)},afterAnimate:function(){this.setClip();p(this,"afterAnimate")},drawPoints:function(){var a=this.points,b=this.chart,c,e,d,k,f=this.options.marker,n,g,p,l,q=this.markerGroup,t=E(f.enabled,this.xAxis.isRadial?!0:null,this.closestPointRangePx>2*f.radius);if(!1!==f.enabled||this._hasPointMarkers)for(e=0;e<a.length;e++)d=
a[e],c=d.plotY,k=d.graphic,n=d.marker||{},g=!!d.marker,p=t&&void 0===n.enabled||n.enabled,l=d.isInside,p&&m(c)&&null!==d.y?(c=E(n.symbol,this.symbol),d.hasImage=0===c.indexOf("url"),p=this.markerAttribs(d,d.selected&&"select"),k?k[l?"show":"hide"](!0).animate(p):l&&(0<p.width||d.hasImage)&&(d.graphic=k=b.renderer.symbol(c,p.x,p.y,p.width,p.height,g?n:f).add(q)),k&&k.attr(this.pointAttribs(d,d.selected&&"select")),k&&k.addClass(d.getClassName(),!0)):k&&(d.graphic=k.destroy())},markerAttribs:function(a,
b){var c=this.options.marker,e=a.marker||{},d=E(e.radius,c.radius);b&&(c=c.states[b],b=e.states&&e.states[b],d=E(b&&b.radius,c&&c.radius,d+(c&&c.radiusPlus||0)));a.hasImage&&(d=0);a={x:Math.floor(a.plotX)-d,y:a.plotY-d};d&&(a.width=a.height=2*d);return a},pointAttribs:function(a,b){var c=this.options.marker,e=a&&a.options,d=e&&e.marker||{},h=this.color,f=e&&e.color,n=a&&a.color,e=E(d.lineWidth,c.lineWidth);a=a&&a.zone&&a.zone.color;h=f||a||n||h;a=d.fillColor||c.fillColor||h;h=d.lineColor||c.lineColor||
h;b&&(c=c.states[b],b=d.states&&d.states[b]||{},e=E(b.lineWidth,c.lineWidth,e+E(b.lineWidthPlus,c.lineWidthPlus,0)),a=b.fillColor||c.fillColor||a,h=b.lineColor||c.lineColor||h);return{stroke:h,"stroke-width":e,fill:a}},destroy:function(){var a=this,b=a.chart,c=/AppleWebKit\/533/.test(w.navigator.userAgent),e,f=a.data||[],k,n,m;p(a,"destroy");z(a);q(a.axisTypes||[],function(b){(m=a[b])&&m.series&&(d(m.series,a),m.isDirty=m.forceRedraw=!0)});a.legendItem&&a.chart.legend.destroyItem(a);for(e=f.length;e--;)(k=
f[e])&&k.destroy&&k.destroy();a.points=null;clearTimeout(a.animationTimeout);for(n in a)a[n]instanceof x&&!a[n].survive&&(e=c&&"group"===n?"hide":"destroy",a[n][e]());b.hoverSeries===a&&(b.hoverSeries=null);d(b.series,a);b.orderSeries();for(n in a)delete a[n]},getGraphPath:function(a,b,c){var e=this,d=e.options,h=d.step,f,n=[],m=[],g;a=a||e.points;(f=a.reversed)&&a.reverse();(h={right:1,center:2}[h]||h&&3)&&f&&(h=4-h);!d.connectNulls||b||c||(a=this.getValidPoints(a));q(a,function(f,k){var p=f.plotX,
q=f.plotY,t=a[k-1];(f.leftCliff||t&&t.rightCliff)&&!c&&(g=!0);f.isNull&&!l(b)&&0<k?g=!d.connectNulls:f.isNull&&!b?g=!0:(0===k||g?k=["M",f.plotX,f.plotY]:e.getPointSpline?k=e.getPointSpline(a,f,k):h?(k=1===h?["L",t.plotX,q]:2===h?["L",(t.plotX+p)/2,t.plotY,"L",(t.plotX+p)/2,q]:["L",p,t.plotY],k.push("L",p,q)):k=["L",p,q],m.push(f.x),h&&m.push(f.x),n.push.apply(n,k),g=!1)});n.xMap=m;return e.graphPath=n},drawGraph:function(){var a=this,b=this.options,c=(this.gappedPath||this.getGraphPath).call(this),
e=[["graph","highcharts-graph",b.lineColor||this.color,b.dashStyle]];q(this.zones,function(c,d){e.push(["zone-graph-"+d,"highcharts-graph highcharts-zone-graph-"+d+" "+(c.className||""),c.color||a.color,c.dashStyle||b.dashStyle])});q(e,function(e,d){var h=e[0],f=a[h];f?(f.endX=c.xMap,f.animate({d:c})):c.length&&(a[h]=a.chart.renderer.path(c).addClass(e[1]).attr({zIndex:1}).add(a.group),f={stroke:e[2],"stroke-width":b.lineWidth,fill:a.fillGraph&&a.color||"none"},e[3]?f.dashstyle=e[3]:"square"!==b.linecap&&
(f["stroke-linecap"]=f["stroke-linejoin"]="round"),f=a[h].attr(f).shadow(2>d&&b.shadow));f&&(f.startX=c.xMap,f.isArea=c.isArea)})},applyZones:function(){var a=this,b=this.chart,c=b.renderer,e=this.zones,d,f,n=this.clips||[],m,g=this.graph,p=this.area,l=Math.max(b.chartWidth,b.chartHeight),t=this[(this.zoneAxis||"y")+"Axis"],w,x,r=b.inverted,z,F,u,C,A=!1;e.length&&(g||p)&&t&&void 0!==t.min&&(x=t.reversed,z=t.horiz,g&&g.hide(),p&&p.hide(),w=t.getExtremes(),q(e,function(e,h){d=x?z?b.plotWidth:0:z?0:
t.toPixels(w.min);d=Math.min(Math.max(E(f,d),0),l);f=Math.min(Math.max(Math.round(t.toPixels(E(e.value,w.max),!0)),0),l);A&&(d=f=t.toPixels(w.max));F=Math.abs(d-f);u=Math.min(d,f);C=Math.max(d,f);t.isXAxis?(m={x:r?C:u,y:0,width:F,height:l},z||(m.x=b.plotHeight-m.x)):(m={x:0,y:r?C:u,width:l,height:F},z&&(m.y=b.plotWidth-m.y));r&&c.isVML&&(m=t.isXAxis?{x:0,y:x?u:C,height:m.width,width:b.chartWidth}:{x:m.y-b.plotLeft-b.spacingBox.x,y:0,width:m.height,height:b.chartHeight});n[h]?n[h].animate(m):(n[h]=
c.clipRect(m),g&&a["zone-graph-"+h].clip(n[h]),p&&a["zone-area-"+h].clip(n[h]));A=e.value>w.max}),this.clips=n)},invertGroups:function(a){function b(){q(["group","markerGroup"],function(b){c[b]&&(c[b].width=c.yAxis.len,c[b].height=c.xAxis.len,c[b].invert(a))})}var c=this,e;c.xAxis&&(e=B(c.chart,"resize",b),B(c,"destroy",e),b(a),c.invertGroups=b)},plotGroup:function(a,b,c,e,d){var h=this[a],f=!h;f&&(this[a]=h=this.chart.renderer.g(b).attr({zIndex:e||.1}).add(d),h.addClass("highcharts-series-"+this.index+
" highcharts-"+this.type+"-series highcharts-color-"+this.colorIndex+" "+(this.options.className||"")));h.attr({visibility:c})[f?"attr":"animate"](this.getPlotBox());return h},getPlotBox:function(){var a=this.chart,b=this.xAxis,c=this.yAxis;a.inverted&&(b=c,c=this.xAxis);return{translateX:b?b.left:a.plotLeft,translateY:c?c.top:a.plotTop,scaleX:1,scaleY:1}},render:function(){var a=this,b=a.chart,c,e=a.options,d=!!a.animate&&b.renderer.isSVG&&A(e.animation).duration,f=a.visible?"inherit":"hidden",n=
e.zIndex,m=a.hasRendered,g=b.seriesGroup,p=b.inverted;c=a.plotGroup("group","series",f,n,g);a.markerGroup=a.plotGroup("markerGroup","markers",f,n,g);d&&a.animate(!0);c.inverted=a.isCartesian?p:!1;a.drawGraph&&(a.drawGraph(),a.applyZones());a.drawDataLabels&&a.drawDataLabels();a.visible&&a.drawPoints();a.drawTracker&&!1!==a.options.enableMouseTracking&&a.drawTracker();a.invertGroups(p);!1===e.clip||a.sharedClipKey||m||c.clip(b.clipRect);d&&a.animate();m||(a.animationTimeout=F(function(){a.afterAnimate()},
d));a.isDirty=!1;a.hasRendered=!0},redraw:function(){var a=this.chart,b=this.isDirty||this.isDirtyData,c=this.group,e=this.xAxis,d=this.yAxis;c&&(a.inverted&&c.attr({width:a.plotWidth,height:a.plotHeight}),c.animate({translateX:E(e&&e.left,a.plotLeft),translateY:E(d&&d.top,a.plotTop)}));this.translate();this.render();b&&delete this.kdTree},kdDimensions:1,kdAxisArray:["clientX","plotY"],searchPoint:function(a,b){var c=this.xAxis,e=this.yAxis,d=this.chart.inverted;return this.searchKDTree({clientX:d?
c.len-a.chartY+c.pos:a.chartX-c.pos,plotY:d?e.len-a.chartX+e.pos:a.chartY-e.pos},b)},buildKDTree:function(){function a(c,e,d){var h,f;if(f=c&&c.length)return h=b.kdAxisArray[e%d],c.sort(function(a,b){return a[h]-b[h]}),f=Math.floor(f/2),{point:c[f],left:a(c.slice(0,f),e+1,d),right:a(c.slice(f+1),e+1,d)}}this.buildingKdTree=!0;var b=this,c=b.kdDimensions;delete b.kdTree;F(function(){b.kdTree=a(b.getValidPoints(null,!b.directTouch),c,c);b.buildingKdTree=!1},b.options.kdNow?0:1)},searchKDTree:function(a,
b){function c(a,b,k,n){var m=b.point,g=e.kdAxisArray[k%n],p,t,q=m;t=l(a[d])&&l(m[d])?Math.pow(a[d]-m[d],2):null;p=l(a[h])&&l(m[h])?Math.pow(a[h]-m[h],2):null;p=(t||0)+(p||0);m.dist=l(p)?Math.sqrt(p):Number.MAX_VALUE;m.distX=l(t)?Math.sqrt(t):Number.MAX_VALUE;g=a[g]-m[g];p=0>g?"left":"right";t=0>g?"right":"left";b[p]&&(p=c(a,b[p],k+1,n),q=p[f]<q[f]?p:m);b[t]&&Math.sqrt(g*g)<q[f]&&(a=c(a,b[t],k+1,n),q=a[f]<q[f]?a:q);return q}var e=this,d=this.kdAxisArray[0],h=this.kdAxisArray[1],f=b?"distX":"dist";
this.kdTree||this.buildingKdTree||this.buildKDTree();if(this.kdTree)return c(a,this.kdTree,this.kdDimensions,this.kdDimensions)}})})(L);(function(a){function B(a,d,b,f,g){var p=a.chart.inverted;this.axis=a;this.isNegative=b;this.options=d;this.x=f;this.total=null;this.points={};this.stack=g;this.rightCliff=this.leftCliff=0;this.alignOptions={align:d.align||(p?b?"left":"right":"center"),verticalAlign:d.verticalAlign||(p?"middle":b?"bottom":"top"),y:l(d.y,p?4:b?14:-6),x:l(d.x,p?b?-6:6:0)};this.textAlign=
d.textAlign||(p?b?"right":"left":"center")}var A=a.Axis,H=a.Chart,G=a.correctFloat,r=a.defined,g=a.destroyObjectProperties,f=a.each,u=a.format,l=a.pick;a=a.Series;B.prototype={destroy:function(){g(this,this.axis)},render:function(a){var d=this.options,b=d.format,b=b?u(b,this):d.formatter.call(this);this.label?this.label.attr({text:b,visibility:"hidden"}):this.label=this.axis.chart.renderer.text(b,null,null,d.useHTML).css(d.style).attr({align:this.textAlign,rotation:d.rotation,visibility:"hidden"}).add(a)},
setOffset:function(a,d){var b=this.axis,f=b.chart,g=f.inverted,l=b.reversed,l=this.isNegative&&!l||!this.isNegative&&l,m=b.translate(b.usePercentage?100:this.total,0,0,0,1),b=b.translate(0),b=Math.abs(m-b);a=f.xAxis[0].translate(this.x)+a;var c=f.plotHeight,g={x:g?l?m:m-b:a,y:g?c-a-d:l?c-m-b:c-m,width:g?b:d,height:g?d:b};if(d=this.label)d.align(this.alignOptions,null,g),g=d.alignAttr,d[!1===this.options.crop||f.isInsidePlot(g.x,g.y)?"show":"hide"](!0)}};H.prototype.getStacks=function(){var a=this;
f(a.yAxis,function(a){a.stacks&&a.hasVisibleSeries&&(a.oldStacks=a.stacks)});f(a.series,function(d){!d.options.stacking||!0!==d.visible&&!1!==a.options.chart.ignoreHiddenSeries||(d.stackKey=d.type+l(d.options.stack,""))})};A.prototype.buildStacks=function(){var a=this.series,d,b=l(this.options.reversedStacks,!0),f=a.length,g;if(!this.isXAxis){this.usePercentage=!1;for(g=f;g--;)a[b?g:f-g-1].setStackedPoints();for(g=f;g--;)d=a[b?g:f-g-1],d.setStackCliffs&&d.setStackCliffs();if(this.usePercentage)for(g=
0;g<f;g++)a[g].setPercentStacks()}};A.prototype.renderStackTotals=function(){var a=this.chart,d=a.renderer,b=this.stacks,f,g,l=this.stackTotalGroup;l||(this.stackTotalGroup=l=d.g("stack-labels").attr({visibility:"visible",zIndex:6}).add());l.translate(a.plotLeft,a.plotTop);for(f in b)for(g in a=b[f],a)a[g].render(l)};A.prototype.resetStacks=function(){var a=this.stacks,d,b;if(!this.isXAxis)for(d in a)for(b in a[d])a[d][b].touched<this.stacksTouched?(a[d][b].destroy(),delete a[d][b]):(a[d][b].total=
null,a[d][b].cum=null)};A.prototype.cleanStacks=function(){var a,d,b;if(!this.isXAxis)for(d in this.oldStacks&&(a=this.stacks=this.oldStacks),a)for(b in a[d])a[d][b].cum=a[d][b].total};a.prototype.setStackedPoints=function(){if(this.options.stacking&&(!0===this.visible||!1===this.chart.options.chart.ignoreHiddenSeries)){var a=this.processedXData,d=this.processedYData,b=[],f=d.length,g=this.options,t=g.threshold,m=g.startFromThreshold?t:0,c=g.stack,g=g.stacking,n=this.stackKey,u="-"+n,z=this.negStacks,
e=this.yAxis,x=e.stacks,F=e.oldStacks,w,h,y,A,K,I,k;e.stacksTouched+=1;for(K=0;K<f;K++)I=a[K],k=d[K],w=this.getStackIndicator(w,I,this.index),A=w.key,y=(h=z&&k<(m?0:t))?u:n,x[y]||(x[y]={}),x[y][I]||(F[y]&&F[y][I]?(x[y][I]=F[y][I],x[y][I].total=null):x[y][I]=new B(e,e.options.stackLabels,h,I,c)),y=x[y][I],null!==k&&(y.points[A]=y.points[this.index]=[l(y.cum,m)],r(y.cum)||(y.base=A),y.touched=e.stacksTouched,0<w.index&&!1===this.singleStacks&&(y.points[A][0]=y.points[this.index+","+I+",0"][0])),"percent"===
g?(h=h?n:u,z&&x[h]&&x[h][I]?(h=x[h][I],y.total=h.total=Math.max(h.total,y.total)+Math.abs(k)||0):y.total=G(y.total+(Math.abs(k)||0))):y.total=G(y.total+(k||0)),y.cum=l(y.cum,m)+(k||0),null!==k&&(y.points[A].push(y.cum),b[K]=y.cum);"percent"===g&&(e.usePercentage=!0);this.stackedYData=b;e.oldStacks={}}};a.prototype.setPercentStacks=function(){var a=this,d=a.stackKey,b=a.yAxis.stacks,g=a.processedXData,l;f([d,"-"+d],function(d){for(var f=g.length,c,n;f--;)if(c=g[f],l=a.getStackIndicator(l,c,a.index,
d),c=(n=b[d]&&b[d][c])&&n.points[l.key])n=n.total?100/n.total:0,c[0]=G(c[0]*n),c[1]=G(c[1]*n),a.stackedYData[f]=c[1]})};a.prototype.getStackIndicator=function(a,d,b,f){!r(a)||a.x!==d||f&&a.key!==f?a={x:d,index:0,key:f}:a.index++;a.key=[b,d,a.index].join();return a}})(L);(function(a){var B=a.addEvent,A=a.animate,H=a.Axis,G=a.createElement,r=a.css,g=a.defined,f=a.each,u=a.erase,l=a.extend,q=a.fireEvent,d=a.inArray,b=a.isNumber,p=a.isObject,C=a.merge,t=a.pick,m=a.Point,c=a.Series,n=a.seriesTypes,E=a.setAnimation,
z=a.splat;l(a.Chart.prototype,{addSeries:function(a,b,c){var e,d=this;a&&(b=t(b,!0),q(d,"addSeries",{options:a},function(){e=d.initSeries(a);d.isDirtyLegend=!0;d.linkSeries();b&&d.redraw(c)}));return e},addAxis:function(a,b,c,d){var e=b?"xAxis":"yAxis",f=this.options;a=C(a,{index:this[e].length,isX:b});new H(this,a);f[e]=z(f[e]||{});f[e].push(a);t(c,!0)&&this.redraw(d)},showLoading:function(a){var b=this,c=b.options,e=b.loadingDiv,d=c.loading,f=function(){e&&r(e,{left:b.plotLeft+"px",top:b.plotTop+
"px",width:b.plotWidth+"px",height:b.plotHeight+"px"})};e||(b.loadingDiv=e=G("div",{className:"highcharts-loading highcharts-loading-hidden"},null,b.container),b.loadingSpan=G("span",{className:"highcharts-loading-inner"},null,e),B(b,"redraw",f));e.className="highcharts-loading";b.loadingSpan.innerHTML=a||c.lang.loading;r(e,l(d.style,{zIndex:10}));r(b.loadingSpan,d.labelStyle);b.loadingShown||(r(e,{opacity:0,display:""}),A(e,{opacity:d.style.opacity||.5},{duration:d.showDuration||0}));b.loadingShown=
!0;f()},hideLoading:function(){var a=this.options,b=this.loadingDiv;b&&(b.className="highcharts-loading highcharts-loading-hidden",A(b,{opacity:0},{duration:a.loading.hideDuration||100,complete:function(){r(b,{display:"none"})}}));this.loadingShown=!1},propsRequireDirtyBox:"backgroundColor borderColor borderWidth margin marginTop marginRight marginBottom marginLeft spacing spacingTop spacingRight spacingBottom spacingLeft borderRadius plotBackgroundColor plotBackgroundImage plotBorderColor plotBorderWidth plotShadow shadow".split(" "),
propsRequireUpdateSeries:"chart.inverted chart.polar chart.ignoreHiddenSeries chart.type colors plotOptions".split(" "),update:function(a,c){var e,n={credits:"addCredits",title:"setTitle",subtitle:"setSubtitle"},h=a.chart,m,p;if(h){C(!0,this.options.chart,h);"className"in h&&this.setClassName(h.className);if("inverted"in h||"polar"in h)this.propFromSeries(),m=!0;for(e in h)h.hasOwnProperty(e)&&(-1!==d("chart."+e,this.propsRequireUpdateSeries)&&(p=!0),-1!==d(e,this.propsRequireDirtyBox)&&(this.isDirtyBox=
!0));"style"in h&&this.renderer.setStyle(h.style)}for(e in a){if(this[e]&&"function"===typeof this[e].update)this[e].update(a[e],!1);else if("function"===typeof this[n[e]])this[n[e]](a[e]);"chart"!==e&&-1!==d(e,this.propsRequireUpdateSeries)&&(p=!0)}a.colors&&(this.options.colors=a.colors);a.plotOptions&&C(!0,this.options.plotOptions,a.plotOptions);f(["xAxis","yAxis","series"],function(b){a[b]&&f(z(a[b]),function(a,c){(c=g(a.id)&&this.get(a.id)||this[b][c])&&c.coll===b&&c.update(a,!1)},this)},this);
m&&f(this.axes,function(a){a.update({},!1)});p&&f(this.series,function(a){a.update({},!1)});a.loading&&C(!0,this.options.loading,a.loading);e=h&&h.width;h=h&&h.height;b(e)&&e!==this.chartWidth||b(h)&&h!==this.chartHeight?this.setSize(e,h):t(c,!0)&&this.redraw()},setSubtitle:function(a){this.setTitle(void 0,a)}});l(m.prototype,{update:function(a,b,c,d){function e(){f.applyOptions(a);null===f.y&&n&&(f.graphic=n.destroy());p(a,!0)&&(n&&n.element&&a&&a.marker&&a.marker.symbol&&(f.graphic=n.destroy()),
a&&a.dataLabels&&f.dataLabel&&(f.dataLabel=f.dataLabel.destroy()));m=f.index;g.updateParallelArrays(f,m);l.data[m]=p(l.data[m],!0)?f.options:a;g.isDirty=g.isDirtyData=!0;!g.fixedBox&&g.hasCartesianSeries&&(k.isDirtyBox=!0);"point"===l.legendType&&(k.isDirtyLegend=!0);b&&k.redraw(c)}var f=this,g=f.series,n=f.graphic,m,k=g.chart,l=g.options;b=t(b,!0);!1===d?e():f.firePointEvent("update",{options:a},e)},remove:function(a,b){this.series.removePoint(d(this,this.series.data),a,b)}});l(c.prototype,{addPoint:function(a,
b,c,d){var e=this.options,f=this.data,g=this.chart,n=this.xAxis,n=n&&n.hasNames&&n.names,m=e.data,k,p,l=this.xData,q,w;b=t(b,!0);k={series:this};this.pointClass.prototype.applyOptions.apply(k,[a]);w=k.x;q=l.length;if(this.requireSorting&&w<l[q-1])for(p=!0;q&&l[q-1]>w;)q--;this.updateParallelArrays(k,"splice",q,0,0);this.updateParallelArrays(k,q);n&&k.name&&(n[w]=k.name);m.splice(q,0,a);p&&(this.data.splice(q,0,null),this.processData());"point"===e.legendType&&this.generatePoints();c&&(f[0]&&f[0].remove?
f[0].remove(!1):(f.shift(),this.updateParallelArrays(k,"shift"),m.shift()));this.isDirtyData=this.isDirty=!0;b&&g.redraw(d)},removePoint:function(a,b,c){var e=this,d=e.data,f=d[a],g=e.points,n=e.chart,m=function(){g&&g.length===d.length&&g.splice(a,1);d.splice(a,1);e.options.data.splice(a,1);e.updateParallelArrays(f||{series:e},"splice",a,1);f&&f.destroy();e.isDirty=!0;e.isDirtyData=!0;b&&n.redraw()};E(c,n);b=t(b,!0);f?f.firePointEvent("remove",null,m):m()},remove:function(a,b,c){function e(){d.destroy();
f.isDirtyLegend=f.isDirtyBox=!0;f.linkSeries();t(a,!0)&&f.redraw(b)}var d=this,f=d.chart;!1!==c?q(d,"remove",null,e):e()},update:function(a,b){var c=this,e=this.chart,d=this.userOptions,g=this.type,m=a.type||d.type||e.options.chart.type,p=n[g].prototype,q=["group","markerGroup","dataLabelsGroup"],k;if(m&&m!==g||void 0!==a.zIndex)q.length=0;f(q,function(a){q[a]=c[a];delete c[a]});a=C(d,{animation:!1,index:this.index,pointStart:this.xData[0]},{data:this.options.data},a);this.remove(!1,null,!1);for(k in p)this[k]=
void 0;l(this,n[m||g].prototype);f(q,function(a){c[a]=q[a]});this.init(e,a);e.linkSeries();t(b,!0)&&e.redraw(!1)}});l(H.prototype,{update:function(a,b){var c=this.chart;a=c.options[this.coll][this.options.index]=C(this.userOptions,a);this.destroy(!0);this.init(c,l(a,{events:void 0}));c.isDirtyBox=!0;t(b,!0)&&c.redraw()},remove:function(a){for(var b=this.chart,c=this.coll,e=this.series,d=e.length;d--;)e[d]&&e[d].remove(!1);u(b.axes,this);u(b[c],this);b.options[c].splice(this.options.index,1);f(b[c],
function(a,b){a.options.index=b});this.destroy();b.isDirtyBox=!0;t(a,!0)&&b.redraw()},setTitle:function(a,b){this.update({title:a},b)},setCategories:function(a,b){this.update({categories:a},b)}})})(L);(function(a){var B=a.color,A=a.each,H=a.map,G=a.pick,r=a.Series,g=a.seriesType;g("area","line",{softThreshold:!1,threshold:0},{singleStacks:!1,getStackPoints:function(){var a=[],g=[],l=this.xAxis,q=this.yAxis,d=q.stacks[this.stackKey],b={},p=this.points,r=this.index,t=q.series,m=t.length,c,n=G(q.options.reversedStacks,
!0)?1:-1,E,z;if(this.options.stacking){for(E=0;E<p.length;E++)b[p[E].x]=p[E];for(z in d)null!==d[z].total&&g.push(z);g.sort(function(a,b){return a-b});c=H(t,function(){return this.visible});A(g,function(e,f){var p=0,t,h;if(b[e]&&!b[e].isNull)a.push(b[e]),A([-1,1],function(a){var p=1===a?"rightNull":"leftNull",l=0,q=d[g[f+a]];if(q)for(E=r;0<=E&&E<m;)t=q.points[E],t||(E===r?b[e][p]=!0:c[E]&&(h=d[e].points[E])&&(l-=h[1]-h[0])),E+=n;b[e][1===a?"rightCliff":"leftCliff"]=l});else{for(E=r;0<=E&&E<m;){if(t=
d[e].points[E]){p=t[1];break}E+=n}p=q.toPixels(p,!0);a.push({isNull:!0,plotX:l.toPixels(e,!0),plotY:p,yBottom:p})}})}return a},getGraphPath:function(a){var f=r.prototype.getGraphPath,g=this.options,q=g.stacking,d=this.yAxis,b,p,C=[],t=[],m=this.index,c,n=d.stacks[this.stackKey],E=g.threshold,z=d.getThreshold(g.threshold),e,g=g.connectNulls||"percent"===q,x=function(b,e,f){var h=a[b];b=q&&n[h.x].points[m];var g=h[f+"Null"]||0;f=h[f+"Cliff"]||0;var p,l,h=!0;f||g?(p=(g?b[0]:b[1])+f,l=b[0]+f,h=!!g):!q&&
a[e]&&a[e].isNull&&(p=l=E);void 0!==p&&(t.push({plotX:c,plotY:null===p?z:d.getThreshold(p),isNull:h}),C.push({plotX:c,plotY:null===l?z:d.getThreshold(l),doCurve:!1}))};a=a||this.points;q&&(a=this.getStackPoints());for(b=0;b<a.length;b++)if(p=a[b].isNull,c=G(a[b].rectPlotX,a[b].plotX),e=G(a[b].yBottom,z),!p||g)g||x(b,b-1,"left"),p&&!q&&g||(t.push(a[b]),C.push({x:b,plotX:c,plotY:e})),g||x(b,b+1,"right");b=f.call(this,t,!0,!0);C.reversed=!0;p=f.call(this,C,!0,!0);p.length&&(p[0]="L");p=b.concat(p);f=
f.call(this,t,!1,g);p.xMap=b.xMap;this.areaPath=p;return f},drawGraph:function(){this.areaPath=[];r.prototype.drawGraph.apply(this);var a=this,g=this.areaPath,l=this.options,q=[["area","highcharts-area",this.color,l.fillColor]];A(this.zones,function(d,b){q.push(["zone-area-"+b,"highcharts-area highcharts-zone-area-"+b+" "+d.className,d.color||a.color,d.fillColor||l.fillColor])});A(q,function(d){var b=d[0],f=a[b];f?(f.endX=g.xMap,f.animate({d:g})):(f=a[b]=a.chart.renderer.path(g).addClass(d[1]).attr({fill:G(d[3],
B(d[2]).setOpacity(G(l.fillOpacity,.75)).get()),zIndex:0}).add(a.group),f.isArea=!0);f.startX=g.xMap;f.shiftUnit=l.step?2:1})},drawLegendSymbol:a.LegendSymbolMixin.drawRectangle})})(L);(function(a){var B=a.pick;a=a.seriesType;a("spline","line",{},{getPointSpline:function(a,H,G){var r=H.plotX,g=H.plotY,f=a[G-1];G=a[G+1];var u,l,q,d;if(f&&!f.isNull&&!1!==f.doCurve&&G&&!G.isNull&&!1!==G.doCurve){a=f.plotY;q=G.plotX;G=G.plotY;var b=0;u=(1.5*r+f.plotX)/2.5;l=(1.5*g+a)/2.5;q=(1.5*r+q)/2.5;d=(1.5*g+G)/2.5;
q!==u&&(b=(d-l)*(q-r)/(q-u)+g-d);l+=b;d+=b;l>a&&l>g?(l=Math.max(a,g),d=2*g-l):l<a&&l<g&&(l=Math.min(a,g),d=2*g-l);d>G&&d>g?(d=Math.max(G,g),l=2*g-d):d<G&&d<g&&(d=Math.min(G,g),l=2*g-d);H.rightContX=q;H.rightContY=d}H=["C",B(f.rightContX,f.plotX),B(f.rightContY,f.plotY),B(u,r),B(l,g),r,g];f.rightContX=f.rightContY=null;return H}})})(L);(function(a){var B=a.seriesTypes.area.prototype,A=a.seriesType;A("areaspline","spline",a.defaultPlotOptions.area,{getStackPoints:B.getStackPoints,getGraphPath:B.getGraphPath,
setStackCliffs:B.setStackCliffs,drawGraph:B.drawGraph,drawLegendSymbol:a.LegendSymbolMixin.drawRectangle})})(L);(function(a){var B=a.animObject,A=a.color,H=a.each,G=a.extend,r=a.isNumber,g=a.merge,f=a.pick,u=a.Series,l=a.seriesType,q=a.svg;l("column","line",{borderRadius:0,groupPadding:.2,marker:null,pointPadding:.1,minPointLength:0,cropThreshold:50,pointRange:null,states:{hover:{halo:!1,brightness:.1,shadow:!1},select:{color:"#cccccc",borderColor:"#000000",shadow:!1}},dataLabels:{align:null,verticalAlign:null,
y:null},softThreshold:!1,startFromThreshold:!0,stickyTracking:!1,tooltip:{distance:6},threshold:0,borderColor:"#ffffff"},{cropShoulder:0,directTouch:!0,trackerGroups:["group","dataLabelsGroup"],negStacks:!0,init:function(){u.prototype.init.apply(this,arguments);var a=this,b=a.chart;b.hasRendered&&H(b.series,function(b){b.type===a.type&&(b.isDirty=!0)})},getColumnMetrics:function(){var a=this,b=a.options,g=a.xAxis,l=a.yAxis,t=g.reversed,m,c={},n=0;!1===b.grouping?n=1:H(a.chart.series,function(b){var e=
b.options,d=b.yAxis,f;b.type===a.type&&b.visible&&l.len===d.len&&l.pos===d.pos&&(e.stacking?(m=b.stackKey,void 0===c[m]&&(c[m]=n++),f=c[m]):!1!==e.grouping&&(f=n++),b.columnIndex=f)});var q=Math.min(Math.abs(g.transA)*(g.ordinalSlope||b.pointRange||g.closestPointRange||g.tickInterval||1),g.len),r=q*b.groupPadding,e=(q-2*r)/(n||1),b=Math.min(b.maxPointWidth||g.len,f(b.pointWidth,e*(1-2*b.pointPadding)));a.columnMetrics={width:b,offset:(e-b)/2+(r+((a.columnIndex||0)+(t?1:0))*e-q/2)*(t?-1:1)};return a.columnMetrics},
crispCol:function(a,b,f,g){var d=this.chart,m=this.borderWidth,c=-(m%2?.5:0),m=m%2?.5:1;d.inverted&&d.renderer.isVML&&(m+=1);f=Math.round(a+f)+c;a=Math.round(a)+c;g=Math.round(b+g)+m;c=.5>=Math.abs(b)&&.5<g;b=Math.round(b)+m;g-=b;c&&g&&(--b,g+=1);return{x:a,y:b,width:f-a,height:g}},translate:function(){var a=this,b=a.chart,g=a.options,l=a.dense=2>a.closestPointRange*a.xAxis.transA,l=a.borderWidth=f(g.borderWidth,l?0:1),t=a.yAxis,m=a.translatedThreshold=t.getThreshold(g.threshold),c=f(g.minPointLength,
5),n=a.getColumnMetrics(),q=n.width,r=a.barW=Math.max(q,1+2*l),e=a.pointXOffset=n.offset;b.inverted&&(m-=.5);g.pointPadding&&(r=Math.ceil(r));u.prototype.translate.apply(a);H(a.points,function(d){var g=f(d.yBottom,m),n=999+Math.abs(g),n=Math.min(Math.max(-n,d.plotY),t.len+n),h=d.plotX+e,l=r,p=Math.min(n,g),z,x=Math.max(n,g)-p;Math.abs(x)<c&&c&&(x=c,z=!t.reversed&&!d.negative||t.reversed&&d.negative,p=Math.abs(p-m)>c?g-c:m-(z?c:0));d.barX=h;d.pointWidth=q;d.tooltipPos=b.inverted?[t.len+t.pos-b.plotLeft-
n,a.xAxis.len-h-l/2,x]:[h+l/2,n+t.pos-b.plotTop,x];d.shapeType="rect";d.shapeArgs=a.crispCol.apply(a,d.isNull?[d.plotX,t.len/2,0,0]:[h,p,l,x])})},getSymbol:a.noop,drawLegendSymbol:a.LegendSymbolMixin.drawRectangle,drawGraph:function(){this.group[this.dense?"addClass":"removeClass"]("highcharts-dense-data")},pointAttribs:function(a,b){var d=this.options,f,g=this.pointAttrToOptions||{};f=g.stroke||"borderColor";var m=g["stroke-width"]||"borderWidth",c=a&&a.color||this.color,n=a[f]||d[f]||this.color||
c,l=a[m]||d[m]||this[m]||0,g=d.dashStyle;a&&this.zones.length&&(c=(c=a.getZone())&&c.color||a.options.color||this.color);b&&(a=d.states[b],b=a.brightness,c=a.color||void 0!==b&&A(c).brighten(a.brightness).get()||c,n=a[f]||n,l=a[m]||l,g=a.dashStyle||g);f={fill:c,stroke:n,"stroke-width":l};d.borderRadius&&(f.r=d.borderRadius);g&&(f.dashstyle=g);return f},drawPoints:function(){var a=this,b=this.chart,f=a.options,l=b.renderer,t=f.animationLimit||250,m;H(a.points,function(c){var d=c.graphic;if(r(c.plotY)&&
null!==c.y){m=c.shapeArgs;if(d)d[b.pointCount<t?"animate":"attr"](g(m));else c.graphic=d=l[c.shapeType](m).attr({"class":c.getClassName()}).add(c.group||a.group);d.attr(a.pointAttribs(c,c.selected&&"select")).shadow(f.shadow,null,f.stacking&&!f.borderRadius)}else d&&(c.graphic=d.destroy())})},animate:function(a){var b=this,d=this.yAxis,f=b.options,g=this.chart.inverted,m={};q&&(a?(m.scaleY=.001,a=Math.min(d.pos+d.len,Math.max(d.pos,d.toPixels(f.threshold))),g?m.translateX=a-d.len:m.translateY=a,b.group.attr(m)):
(m[g?"translateX":"translateY"]=d.pos,b.group.animate(m,G(B(b.options.animation),{step:function(a,d){b.group.attr({scaleY:Math.max(.001,d.pos)})}})),b.animate=null))},remove:function(){var a=this,b=a.chart;b.hasRendered&&H(b.series,function(b){b.type===a.type&&(b.isDirty=!0)});u.prototype.remove.apply(a,arguments)}})})(L);(function(a){a=a.seriesType;a("bar","column",null,{inverted:!0})})(L);(function(a){var B=a.Series;a=a.seriesType;a("scatter","line",{lineWidth:0,marker:{enabled:!0},tooltip:{headerFormat:'\x3cspan style\x3d"color:{point.color}"\x3e\u25cf\x3c/span\x3e \x3cspan style\x3d"font-size: 0.85em"\x3e {series.name}\x3c/span\x3e\x3cbr/\x3e',
pointFormat:"x: \x3cb\x3e{point.x}\x3c/b\x3e\x3cbr/\x3ey: \x3cb\x3e{point.y}\x3c/b\x3e\x3cbr/\x3e"}},{sorted:!1,requireSorting:!1,noSharedTooltip:!0,trackerGroups:["group","markerGroup","dataLabelsGroup"],takeOrdinalPosition:!1,kdDimensions:2,drawGraph:function(){this.options.lineWidth&&B.prototype.drawGraph.call(this)}})})(L);(function(a){var B=a.pick,A=a.relativeLength;a.CenteredSeriesMixin={getCenter:function(){var a=this.options,G=this.chart,r=2*(a.slicedOffset||0),g=G.plotWidth-2*r,G=G.plotHeight-
2*r,f=a.center,f=[B(f[0],"50%"),B(f[1],"50%"),a.size||"100%",a.innerSize||0],u=Math.min(g,G),l,q;for(l=0;4>l;++l)q=f[l],a=2>l||2===l&&/%$/.test(q),f[l]=A(q,[g,G,u,f[2]][l])+(a?r:0);f[3]>f[2]&&(f[3]=f[2]);return f}}})(L);(function(a){var B=a.addEvent,A=a.defined,H=a.each,G=a.extend,r=a.inArray,g=a.noop,f=a.pick,u=a.Point,l=a.Series,q=a.seriesType,d=a.setAnimation;q("pie","line",{center:[null,null],clip:!1,colorByPoint:!0,dataLabels:{distance:30,enabled:!0,formatter:function(){return null===this.y?
void 0:this.point.name},x:0},ignoreHiddenPoint:!0,legendType:"point",marker:null,size:null,showInLegend:!1,slicedOffset:10,stickyTracking:!1,tooltip:{followPointer:!0},borderColor:"#ffffff",borderWidth:1,states:{hover:{brightness:.1,shadow:!1}}},{isCartesian:!1,requireSorting:!1,directTouch:!0,noSharedTooltip:!0,trackerGroups:["group","dataLabelsGroup"],axisTypes:[],pointAttribs:a.seriesTypes.column.prototype.pointAttribs,animate:function(a){var b=this,d=b.points,f=b.startAngleRad;a||(H(d,function(a){var c=
a.graphic,d=a.shapeArgs;c&&(c.attr({r:a.startR||b.center[3]/2,start:f,end:f}),c.animate({r:d.r,start:d.start,end:d.end},b.options.animation))}),b.animate=null)},updateTotals:function(){var a,d=0,f=this.points,g=f.length,m,c=this.options.ignoreHiddenPoint;for(a=0;a<g;a++)m=f[a],0>m.y&&(m.y=null),d+=c&&!m.visible?0:m.y;this.total=d;for(a=0;a<g;a++)m=f[a],m.percentage=0<d&&(m.visible||!c)?m.y/d*100:0,m.total=d},generatePoints:function(){l.prototype.generatePoints.call(this);this.updateTotals()},translate:function(a){this.generatePoints();
var b=0,d=this.options,g=d.slicedOffset,m=g+(d.borderWidth||0),c,n,l,q=d.startAngle||0,e=this.startAngleRad=Math.PI/180*(q-90),q=(this.endAngleRad=Math.PI/180*(f(d.endAngle,q+360)-90))-e,r=this.points,u=d.dataLabels.distance,d=d.ignoreHiddenPoint,w,h=r.length,y;a||(this.center=a=this.getCenter());this.getX=function(b,c){l=Math.asin(Math.min((b-a[1])/(a[2]/2+u),1));return a[0]+(c?-1:1)*Math.cos(l)*(a[2]/2+u)};for(w=0;w<h;w++){y=r[w];c=e+b*q;if(!d||y.visible)b+=y.percentage/100;n=e+b*q;y.shapeType=
"arc";y.shapeArgs={x:a[0],y:a[1],r:a[2]/2,innerR:a[3]/2,start:Math.round(1E3*c)/1E3,end:Math.round(1E3*n)/1E3};l=(n+c)/2;l>1.5*Math.PI?l-=2*Math.PI:l<-Math.PI/2&&(l+=2*Math.PI);y.slicedTranslation={translateX:Math.round(Math.cos(l)*g),translateY:Math.round(Math.sin(l)*g)};c=Math.cos(l)*a[2]/2;n=Math.sin(l)*a[2]/2;y.tooltipPos=[a[0]+.7*c,a[1]+.7*n];y.half=l<-Math.PI/2||l>Math.PI/2?1:0;y.angle=l;m=Math.min(m,u/5);y.labelPos=[a[0]+c+Math.cos(l)*u,a[1]+n+Math.sin(l)*u,a[0]+c+Math.cos(l)*m,a[1]+n+Math.sin(l)*
m,a[0]+c,a[1]+n,0>u?"center":y.half?"right":"left",l]}},drawGraph:null,drawPoints:function(){var a=this,d=a.chart.renderer,f,g,m,c,n=a.options.shadow;n&&!a.shadowGroup&&(a.shadowGroup=d.g("shadow").add(a.group));H(a.points,function(b){if(null!==b.y){g=b.graphic;c=b.shapeArgs;f=b.sliced?b.slicedTranslation:{};var l=b.shadowGroup;n&&!l&&(l=b.shadowGroup=d.g("shadow").add(a.shadowGroup));l&&l.attr(f);m=a.pointAttribs(b,b.selected&&"select");g?g.setRadialReference(a.center).attr(m).animate(G(c,f)):(b.graphic=
g=d[b.shapeType](c).addClass(b.getClassName()).setRadialReference(a.center).attr(f).add(a.group),b.visible||g.attr({visibility:"hidden"}),g.attr(m).attr({"stroke-linejoin":"round"}).shadow(n,l))}})},searchPoint:g,sortByAngle:function(a,d){a.sort(function(a,b){return void 0!==a.angle&&(b.angle-a.angle)*d})},drawLegendSymbol:a.LegendSymbolMixin.drawRectangle,getCenter:a.CenteredSeriesMixin.getCenter,getSymbol:g},{init:function(){u.prototype.init.apply(this,arguments);var a=this,d;a.name=f(a.name,"Slice");
d=function(b){a.slice("select"===b.type)};B(a,"select",d);B(a,"unselect",d);return a},setVisible:function(a,d){var b=this,g=b.series,m=g.chart,c=g.options.ignoreHiddenPoint;d=f(d,c);a!==b.visible&&(b.visible=b.options.visible=a=void 0===a?!b.visible:a,g.options.data[r(b,g.data)]=b.options,H(["graphic","dataLabel","connector","shadowGroup"],function(c){if(b[c])b[c][a?"show":"hide"](!0)}),b.legendItem&&m.legend.colorizeItem(b,a),a||"hover"!==b.state||b.setState(""),c&&(g.isDirty=!0),d&&m.redraw())},
slice:function(a,g,l){var b=this.series;d(l,b.chart);f(g,!0);this.sliced=this.options.sliced=a=A(a)?a:!this.sliced;b.options.data[r(this,b.data)]=this.options;a=a?this.slicedTranslation:{translateX:0,translateY:0};this.graphic.animate(a);this.shadowGroup&&this.shadowGroup.animate(a)},haloPath:function(a){var b=this.shapeArgs;return this.sliced||!this.visible?[]:this.series.chart.renderer.symbols.arc(b.x,b.y,b.r+a,b.r+a,{innerR:this.shapeArgs.r,start:b.start,end:b.end})}})})(L);(function(a){var B=
a.addEvent,A=a.arrayMax,H=a.defined,G=a.each,r=a.extend,g=a.format,f=a.map,u=a.merge,l=a.noop,q=a.pick,d=a.relativeLength,b=a.Series,p=a.seriesTypes,C=a.stableSort;a.distribute=function(a,b){function c(a,b){return a.target-b.target}var d,g=!0,m=a,e=[],l;l=0;for(d=a.length;d--;)l+=a[d].size;if(l>b){C(a,function(a,b){return(b.rank||0)-(a.rank||0)});for(l=d=0;l<=b;)l+=a[d].size,d++;e=a.splice(d-1,a.length)}C(a,c);for(a=f(a,function(a){return{size:a.size,targets:[a.target]}});g;){for(d=a.length;d--;)g=
a[d],l=(Math.min.apply(0,g.targets)+Math.max.apply(0,g.targets))/2,g.pos=Math.min(Math.max(0,l-g.size/2),b-g.size);d=a.length;for(g=!1;d--;)0<d&&a[d-1].pos+a[d-1].size>a[d].pos&&(a[d-1].size+=a[d].size,a[d-1].targets=a[d-1].targets.concat(a[d].targets),a[d-1].pos+a[d-1].size>b&&(a[d-1].pos=b-a[d-1].size),a.splice(d,1),g=!0)}d=0;G(a,function(a){var b=0;G(a.targets,function(){m[d].pos=a.pos+b;b+=m[d].size;d++})});m.push.apply(m,e);C(m,c)};b.prototype.drawDataLabels=function(){var a=this,b=a.options,
c=b.dataLabels,d=a.points,f,l,e=a.hasRendered||0,p,r,w=q(c.defer,!0),h=a.chart.renderer;if(c.enabled||a._hasPointLabels)a.dlProcessOptions&&a.dlProcessOptions(c),r=a.plotGroup("dataLabelsGroup","data-labels",w&&!e?"hidden":"visible",c.zIndex||6),w&&(r.attr({opacity:+e}),e||B(a,"afterAnimate",function(){a.visible&&r.show(!0);r[b.animation?"animate":"attr"]({opacity:1},{duration:200})})),l=c,G(d,function(e){var d,m=e.dataLabel,n,k,t,z=e.connector,w=!m,x;f=e.dlOptions||e.options&&e.options.dataLabels;
if(d=q(f&&f.enabled,l.enabled)&&null!==e.y)for(k in c=u(l,f),n=e.getLabelConfig(),p=c.format?g(c.format,n):c.formatter.call(n,c),x=c.style,t=c.rotation,x.color=q(c.color,x.color,a.color,"#000000"),"contrast"===x.color&&(x.color=c.inside||0>c.distance||b.stacking?h.getContrast(e.color||a.color):"#000000"),b.cursor&&(x.cursor=b.cursor),n={fill:c.backgroundColor,stroke:c.borderColor,"stroke-width":c.borderWidth,r:c.borderRadius||0,rotation:t,padding:c.padding,zIndex:1},n)void 0===n[k]&&delete n[k];!m||
d&&H(p)?d&&H(p)&&(m?n.text=p:(m=e.dataLabel=h[t?"text":"label"](p,0,-9999,c.shape,null,null,c.useHTML,null,"data-label"),m.addClass("highcharts-data-label-color-"+e.colorIndex+" "+(c.className||"")+(c.useHTML?"highcharts-tracker":""))),m.attr(n),m.css(x).shadow(c.shadow),m.added||m.add(r),a.alignDataLabel(e,m,c,null,w)):(e.dataLabel=m.destroy(),z&&(e.connector=z.destroy()))})};b.prototype.alignDataLabel=function(a,b,c,d,f){var g=this.chart,e=g.inverted,m=q(a.plotX,-9999),n=q(a.plotY,-9999),l=b.getBBox(),
h,p=c.rotation,t=c.align,u=this.visible&&(a.series.forceDL||g.isInsidePlot(m,Math.round(n),e)||d&&g.isInsidePlot(m,e?d.x+1:d.y+d.height-1,e)),E="justify"===q(c.overflow,"justify");u&&(h=c.style.fontSize,h=g.renderer.fontMetrics(h,b).b,d=r({x:e?g.plotWidth-n:m,y:Math.round(e?g.plotHeight-m:n),width:0,height:0},d),r(c,{width:l.width,height:l.height}),p?(E=!1,e=g.renderer.rotCorr(h,p),e={x:d.x+c.x+d.width/2+e.x,y:d.y+c.y+{top:0,middle:.5,bottom:1}[c.verticalAlign]*d.height},b[f?"attr":"animate"](e).attr({align:t}),
m=(p+720)%360,m=180<m&&360>m,"left"===t?e.y-=m?l.height:0:"center"===t?(e.x-=l.width/2,e.y-=l.height/2):"right"===t&&(e.x-=l.width,e.y-=m?0:l.height)):(b.align(c,null,d),e=b.alignAttr),E?this.justifyDataLabel(b,c,e,l,d,f):q(c.crop,!0)&&(u=g.isInsidePlot(e.x,e.y)&&g.isInsidePlot(e.x+l.width,e.y+l.height)),c.shape&&!p&&b.attr({anchorX:a.plotX,anchorY:a.plotY}));u||(b.attr({y:-9999}),b.placed=!1)};b.prototype.justifyDataLabel=function(a,b,c,d,f,g){var e=this.chart,m=b.align,n=b.verticalAlign,l,h,p=a.box?
0:a.padding||0;l=c.x+p;0>l&&("right"===m?b.align="left":b.x=-l,h=!0);l=c.x+d.width-p;l>e.plotWidth&&("left"===m?b.align="right":b.x=e.plotWidth-l,h=!0);l=c.y+p;0>l&&("bottom"===n?b.verticalAlign="top":b.y=-l,h=!0);l=c.y+d.height-p;l>e.plotHeight&&("top"===n?b.verticalAlign="bottom":b.y=e.plotHeight-l,h=!0);h&&(a.placed=!g,a.align(b,null,f))};p.pie&&(p.pie.prototype.drawDataLabels=function(){var d=this,g=d.data,c,l=d.chart,p=d.options.dataLabels,r=q(p.connectorPadding,10),e=q(p.connectorWidth,1),u=
l.plotWidth,F=l.plotHeight,w,h=p.distance,y=d.center,C=y[2]/2,B=y[1],H=0<h,k,D,L,N,S=[[],[]],O,v,M,Q,R=[0,0,0,0];d.visible&&(p.enabled||d._hasPointLabels)&&(b.prototype.drawDataLabels.apply(d),G(g,function(a){a.dataLabel&&a.visible&&(S[a.half].push(a),a.dataLabel._pos=null)}),G(S,function(b,e){var g,m,n=b.length,q,t,z;if(n)for(d.sortByAngle(b,e-.5),0<h&&(g=Math.max(0,B-C-h),m=Math.min(B+C+h,l.plotHeight),q=f(b,function(a){if(a.dataLabel)return z=a.dataLabel.getBBox().height||21,{target:a.labelPos[1]-
g+z/2,size:z,rank:a.y}}),a.distribute(q,m+z-g)),Q=0;Q<n;Q++)c=b[Q],L=c.labelPos,k=c.dataLabel,M=!1===c.visible?"hidden":"inherit",t=L[1],q?void 0===q[Q].pos?M="hidden":(N=q[Q].size,v=g+q[Q].pos):v=t,O=p.justify?y[0]+(e?-1:1)*(C+h):d.getX(v<g+2||v>m-2?t:v,e),k._attr={visibility:M,align:L[6]},k._pos={x:O+p.x+({left:r,right:-r}[L[6]]||0),y:v+p.y-10},L.x=O,L.y=v,null===d.options.size&&(D=k.width,O-D<r?R[3]=Math.max(Math.round(D-O+r),R[3]):O+D>u-r&&(R[1]=Math.max(Math.round(O+D-u+r),R[1])),0>v-N/2?R[0]=
Math.max(Math.round(-v+N/2),R[0]):v+N/2>F&&(R[2]=Math.max(Math.round(v+N/2-F),R[2])))}),0===A(R)||this.verifyDataLabelOverflow(R))&&(this.placeDataLabels(),H&&e&&G(this.points,function(a){var b;w=a.connector;if((k=a.dataLabel)&&k._pos&&a.visible){M=k._attr.visibility;if(b=!w)a.connector=w=l.renderer.path().addClass("highcharts-data-label-connector highcharts-color-"+a.colorIndex).add(d.dataLabelsGroup),w.attr({"stroke-width":e,stroke:p.connectorColor||a.color||"#666666"});w[b?"attr":"animate"]({d:d.connectorPath(a.labelPos)});
w.attr("visibility",M)}else w&&(a.connector=w.destroy())}))},p.pie.prototype.connectorPath=function(a){var b=a.x,c=a.y;return q(this.options.dataLabels.softConnector,!0)?["M",b+("left"===a[6]?5:-5),c,"C",b,c,2*a[2]-a[4],2*a[3]-a[5],a[2],a[3],"L",a[4],a[5]]:["M",b+("left"===a[6]?5:-5),c,"L",a[2],a[3],"L",a[4],a[5]]},p.pie.prototype.placeDataLabels=function(){G(this.points,function(a){var b=a.dataLabel;b&&a.visible&&((a=b._pos)?(b.attr(b._attr),b[b.moved?"animate":"attr"](a),b.moved=!0):b&&b.attr({y:-9999}))})},
p.pie.prototype.alignDataLabel=l,p.pie.prototype.verifyDataLabelOverflow=function(a){var b=this.center,c=this.options,f=c.center,g=c.minSize||80,l,e;null!==f[0]?l=Math.max(b[2]-Math.max(a[1],a[3]),g):(l=Math.max(b[2]-a[1]-a[3],g),b[0]+=(a[3]-a[1])/2);null!==f[1]?l=Math.max(Math.min(l,b[2]-Math.max(a[0],a[2])),g):(l=Math.max(Math.min(l,b[2]-a[0]-a[2]),g),b[1]+=(a[0]-a[2])/2);l<b[2]?(b[2]=l,b[3]=Math.min(d(c.innerSize||0,l),l),this.translate(b),this.drawDataLabels&&this.drawDataLabels()):e=!0;return e});
p.column&&(p.column.prototype.alignDataLabel=function(a,d,c,f,g){var l=this.chart.inverted,e=a.series,m=a.dlBox||a.shapeArgs,n=q(a.below,a.plotY>q(this.translatedThreshold,e.yAxis.len)),p=q(c.inside,!!this.options.stacking);m&&(f=u(m),0>f.y&&(f.height+=f.y,f.y=0),m=f.y+f.height-e.yAxis.len,0<m&&(f.height-=m),l&&(f={x:e.yAxis.len-f.y-f.height,y:e.xAxis.len-f.x-f.width,width:f.height,height:f.width}),p||(l?(f.x+=n?0:f.width,f.width=0):(f.y+=n?f.height:0,f.height=0)));c.align=q(c.align,!l||p?"center":
n?"right":"left");c.verticalAlign=q(c.verticalAlign,l||p?"middle":n?"top":"bottom");b.prototype.alignDataLabel.call(this,a,d,c,f,g)})})(L);(function(a){var B=a.Chart,A=a.each,H=a.pick,G=a.addEvent;B.prototype.callbacks.push(function(a){function g(){var f=[];A(a.series,function(a){var g=a.options.dataLabels,q=a.dataLabelCollections||["dataLabel"];(g.enabled||a._hasPointLabels)&&!g.allowOverlap&&a.visible&&A(q,function(d){A(a.points,function(a){a[d]&&(a[d].labelrank=H(a.labelrank,a.shapeArgs&&a.shapeArgs.height),
f.push(a[d]))})})});a.hideOverlappingLabels(f)}g();G(a,"redraw",g)});B.prototype.hideOverlappingLabels=function(a){var g=a.length,f,r,l,q,d,b,p,C,t,m=function(a,b,d,f,e,g,l,m){return!(e>a+d||e+l<a||g>b+f||g+m<b)};for(r=0;r<g;r++)if(f=a[r])f.oldOpacity=f.opacity,f.newOpacity=1;a.sort(function(a,b){return(b.labelrank||0)-(a.labelrank||0)});for(r=0;r<g;r++)for(l=a[r],f=r+1;f<g;++f)if(q=a[f],l&&q&&l.placed&&q.placed&&0!==l.newOpacity&&0!==q.newOpacity&&(d=l.alignAttr,b=q.alignAttr,p=l.parentGroup,C=q.parentGroup,
t=2*(l.box?0:l.padding),d=m(d.x+p.translateX,d.y+p.translateY,l.width-t,l.height-t,b.x+C.translateX,b.y+C.translateY,q.width-t,q.height-t)))(l.labelrank<q.labelrank?l:q).newOpacity=0;A(a,function(a){var b,c;a&&(c=a.newOpacity,a.oldOpacity!==c&&a.placed&&(c?a.show(!0):b=function(){a.hide()},a.alignAttr.opacity=c,a[a.isOld?"animate":"attr"](a.alignAttr,null,b)),a.isOld=!0)})}})(L);(function(a){var B=a.addEvent,A=a.Chart,H=a.createElement,G=a.css,r=a.defaultOptions,g=a.defaultPlotOptions,f=a.each,u=
a.extend,l=a.fireEvent,q=a.hasTouch,d=a.inArray,b=a.isObject,p=a.Legend,C=a.merge,t=a.pick,m=a.Point,c=a.Series,n=a.seriesTypes,E=a.svg;a=a.TrackerMixin={drawTrackerPoint:function(){var a=this,b=a.chart,c=b.pointer,d=function(a){for(var c=a.target,e;c&&!e;)e=c.point,c=c.parentNode;if(void 0!==e&&e!==b.hoverPoint)e.onMouseOver(a)};f(a.points,function(a){a.graphic&&(a.graphic.element.point=a);a.dataLabel&&(a.dataLabel.div?a.dataLabel.div.point=a:a.dataLabel.element.point=a)});a._hasTracking||(f(a.trackerGroups,
function(b){if(a[b]){a[b].addClass("highcharts-tracker").on("mouseover",d).on("mouseout",function(a){c.onTrackerMouseOut(a)});if(q)a[b].on("touchstart",d);a.options.cursor&&a[b].css(G).css({cursor:a.options.cursor})}}),a._hasTracking=!0)},drawTrackerGraph:function(){var a=this,b=a.options,c=b.trackByArea,d=[].concat(c?a.areaPath:a.graphPath),g=d.length,h=a.chart,l=h.pointer,m=h.renderer,n=h.options.tooltip.snap,p=a.tracker,k,r=function(){if(h.hoverSeries!==a)a.onMouseOver()},t="rgba(192,192,192,"+
(E?.0001:.002)+")";if(g&&!c)for(k=g+1;k--;)"M"===d[k]&&d.splice(k+1,0,d[k+1]-n,d[k+2],"L"),(k&&"M"===d[k]||k===g)&&d.splice(k,0,"L",d[k-2]+n,d[k-1]);p?p.attr({d:d}):a.graph&&(a.tracker=m.path(d).attr({"stroke-linejoin":"round",visibility:a.visible?"visible":"hidden",stroke:t,fill:c?t:"none","stroke-width":a.graph.strokeWidth()+(c?0:2*n),zIndex:2}).add(a.group),f([a.tracker,a.markerGroup],function(a){a.addClass("highcharts-tracker").on("mouseover",r).on("mouseout",function(a){l.onTrackerMouseOut(a)});
b.cursor&&a.css({cursor:b.cursor});if(q)a.on("touchstart",r)}))}};n.column&&(n.column.prototype.drawTracker=a.drawTrackerPoint);n.pie&&(n.pie.prototype.drawTracker=a.drawTrackerPoint);n.scatter&&(n.scatter.prototype.drawTracker=a.drawTrackerPoint);u(p.prototype,{setItemEvents:function(a,b,c){var e=this,d=e.chart,f="highcharts-legend-"+(a.series?"point":"series")+"-active";(c?b:a.legendGroup).on("mouseover",function(){a.setState("hover");d.seriesGroup.addClass(f);b.css(e.options.itemHoverStyle)}).on("mouseout",
function(){b.css(a.visible?e.itemStyle:e.itemHiddenStyle);d.seriesGroup.removeClass(f);a.setState()}).on("click",function(b){var c=function(){a.setVisible&&a.setVisible()};b={browserEvent:b};a.firePointEvent?a.firePointEvent("legendItemClick",b,c):l(a,"legendItemClick",b,c)})},createCheckboxForItem:function(a){a.checkbox=H("input",{type:"checkbox",checked:a.selected,defaultChecked:a.selected},this.options.itemCheckboxStyle,this.chart.container);B(a.checkbox,"click",function(b){l(a.series||a,"checkboxClick",
{checked:b.target.checked,item:a},function(){a.select()})})}});r.legend.itemStyle.cursor="pointer";u(A.prototype,{showResetZoom:function(){var a=this,b=r.lang,c=a.options.chart.resetZoomButton,d=c.theme,f=d.states,g="chart"===c.relativeTo?null:"plotBox";this.resetZoomButton=a.renderer.button(b.resetZoom,null,null,function(){a.zoomOut()},d,f&&f.hover).attr({align:c.position.align,title:b.resetZoomTitle}).addClass("highcharts-reset-zoom").add().align(c.position,!1,g)},zoomOut:function(){var a=this;
l(a,"selection",{resetSelection:!0},function(){a.zoom()})},zoom:function(a){var c,d=this.pointer,g=!1,l;!a||a.resetSelection?f(this.axes,function(a){c=a.zoom()}):f(a.xAxis.concat(a.yAxis),function(a){var b=a.axis;d[b.isXAxis?"zoomX":"zoomY"]&&(c=b.zoom(a.min,a.max),b.displayBtn&&(g=!0))});l=this.resetZoomButton;g&&!l?this.showResetZoom():!g&&b(l)&&(this.resetZoomButton=l.destroy());c&&this.redraw(t(this.options.chart.animation,a&&a.animation,100>this.pointCount))},pan:function(a,b){var c=this,d=c.hoverPoints,
e;d&&f(d,function(a){a.setState()});f("xy"===b?[1,0]:[1],function(b){b=c[b?"xAxis":"yAxis"][0];var d=b.horiz,f=a[d?"chartX":"chartY"],d=d?"mouseDownX":"mouseDownY",g=c[d],h=(b.pointRange||0)/2,k=b.getExtremes(),l=b.toValue(g-f,!0)+h,h=b.toValue(g+b.len-f,!0)-h,m=h<l,g=m?h:l,l=m?l:h,h=Math.min(k.dataMin,k.min)-g,k=l-Math.max(k.dataMax,k.max);b.series.length&&0>h&&0>k&&(b.setExtremes(g,l,!1,!1,{trigger:"pan"}),e=!0);c[d]=f});e&&c.redraw(!1);G(c.container,{cursor:"move"})}});u(m.prototype,{select:function(a,
b){var c=this,e=c.series,g=e.chart;a=t(a,!c.selected);c.firePointEvent(a?"select":"unselect",{accumulate:b},function(){c.selected=c.options.selected=a;e.options.data[d(c,e.data)]=c.options;c.setState(a&&"select");b||f(g.getSelectedPoints(),function(a){a.selected&&a!==c&&(a.selected=a.options.selected=!1,e.options.data[d(a,e.data)]=a.options,a.setState(""),a.firePointEvent("unselect"))})})},onMouseOver:function(a,b){var c=this.series,d=c.chart,e=d.tooltip,f=d.hoverPoint;if(this.series){if(!b){if(f&&
f!==this)f.onMouseOut();if(d.hoverSeries!==c)c.onMouseOver();d.hoverPoint=this}!e||e.shared&&!c.noSharedTooltip?e||this.setState("hover"):(this.setState("hover"),e.refresh(this,a));this.firePointEvent("mouseOver")}},onMouseOut:function(){var a=this.series.chart,b=a.hoverPoints;this.firePointEvent("mouseOut");b&&-1!==d(this,b)||(this.setState(),a.hoverPoint=null)},importEvents:function(){if(!this.hasImportedEvents){var a=C(this.series.options.point,this.options).events,b;this.events=a;for(b in a)B(this,
b,a[b]);this.hasImportedEvents=!0}},setState:function(a,b){var c=Math.floor(this.plotX),d=this.plotY,e=this.series,f=e.options.states[a]||{},l=g[e.type].marker&&e.options.marker,m=l&&!1===l.enabled,n=l&&l.states&&l.states[a]||{},p=!1===n.enabled,k=e.stateMarkerGraphic,q=this.marker||{},r=e.chart,z=e.halo,C,A=l&&e.markerAttribs;a=a||"";if(!(a===this.state&&!b||this.selected&&"select"!==a||!1===f.enabled||a&&(p||m&&!1===n.enabled)||a&&q.states&&q.states[a]&&!1===q.states[a].enabled)){A&&(C=e.markerAttribs(this,
a));if(this.graphic)this.state&&this.graphic.removeClass("highcharts-point-"+this.state),a&&this.graphic.addClass("highcharts-point-"+a),this.graphic.attr(e.pointAttribs(this,a)),C&&this.graphic.animate(C,t(r.options.chart.animation,n.animation,l.animation)),k&&k.hide();else{if(a&&n){l=q.symbol||e.symbol;k&&k.currentSymbol!==l&&(k=k.destroy());if(k)k[b?"animate":"attr"]({x:C.x,y:C.y});else l&&(e.stateMarkerGraphic=k=r.renderer.symbol(l,C.x,C.y,C.width,C.height).add(e.markerGroup),k.currentSymbol=
l);k&&k.attr(e.pointAttribs(this,a))}k&&(k[a&&r.isInsidePlot(c,d,r.inverted)?"show":"hide"](),k.element.point=this)}(c=f.halo)&&c.size?(z||(e.halo=z=r.renderer.path().add(A?e.markerGroup:e.group)),z[b?"animate":"attr"]({d:this.haloPath(c.size)}),z.attr({"class":"highcharts-halo highcharts-color-"+t(this.colorIndex,e.colorIndex)}),z.point=this,z.attr(u({fill:this.color||e.color,"fill-opacity":c.opacity,zIndex:-1},c.attributes))):z&&z.point&&z.point.haloPath&&z.animate({d:z.point.haloPath(0)});this.state=
a}},haloPath:function(a){return this.series.chart.renderer.symbols.circle(Math.floor(this.plotX)-a,this.plotY-a,2*a,2*a)}});u(c.prototype,{onMouseOver:function(){var a=this.chart,b=a.hoverSeries;if(b&&b!==this)b.onMouseOut();this.options.events.mouseOver&&l(this,"mouseOver");this.setState("hover");a.hoverSeries=this},onMouseOut:function(){var a=this.options,b=this.chart,c=b.tooltip,d=b.hoverPoint;b.hoverSeries=null;if(d)d.onMouseOut();this&&a.events.mouseOut&&l(this,"mouseOut");!c||a.stickyTracking||
c.shared&&!this.noSharedTooltip||c.hide();this.setState()},setState:function(a){var b=this,c=b.options,d=b.graph,g=c.states,h=c.lineWidth,c=0;a=a||"";if(b.state!==a&&(f([b.group,b.markerGroup],function(c){c&&(b.state&&c.removeClass("highcharts-series-"+b.state),a&&c.addClass("highcharts-series-"+a))}),b.state=a,!g[a]||!1!==g[a].enabled)&&(a&&(h=g[a].lineWidth||h+(g[a].lineWidthPlus||0)),d&&!d.dashstyle))for(g={"stroke-width":h},d.attr(g);b["zone-graph-"+c];)b["zone-graph-"+c].attr(g),c+=1},setVisible:function(a,
b){var c=this,d=c.chart,e=c.legendItem,g,m=d.options.chart.ignoreHiddenSeries,n=c.visible;g=(c.visible=a=c.options.visible=c.userOptions.visible=void 0===a?!n:a)?"show":"hide";f(["group","dataLabelsGroup","markerGroup","tracker","tt"],function(a){if(c[a])c[a][g]()});if(d.hoverSeries===c||(d.hoverPoint&&d.hoverPoint.series)===c)c.onMouseOut();e&&d.legend.colorizeItem(c,a);c.isDirty=!0;c.options.stacking&&f(d.series,function(a){a.options.stacking&&a.visible&&(a.isDirty=!0)});f(c.linkedSeries,function(b){b.setVisible(a,
!1)});m&&(d.isDirtyBox=!0);!1!==b&&d.redraw();l(c,g)},show:function(){this.setVisible(!0)},hide:function(){this.setVisible(!1)},select:function(a){this.selected=a=void 0===a?!this.selected:a;this.checkbox&&(this.checkbox.checked=a);l(this,a?"select":"unselect")},drawTracker:a.drawTrackerGraph})})(L);(function(a){var B=a.Chart,A=a.each,H=a.inArray,G=a.isObject,r=a.pick,g=a.splat;B.prototype.setResponsive=function(a){var f=this.options.responsive;f&&f.rules&&A(f.rules,function(f){this.matchResponsiveRule(f,
a)},this)};B.prototype.matchResponsiveRule=function(f,g){var l=this.respRules,q=f.condition,d;d=q.callback||function(){return this.chartWidth<=r(q.maxWidth,Number.MAX_VALUE)&&this.chartHeight<=r(q.maxHeight,Number.MAX_VALUE)&&this.chartWidth>=r(q.minWidth,0)&&this.chartHeight>=r(q.minHeight,0)};void 0===f._id&&(f._id=a.uniqueKey());d=d.call(this);!l[f._id]&&d?f.chartOptions&&(l[f._id]=this.currentOptions(f.chartOptions),this.update(f.chartOptions,g)):l[f._id]&&!d&&(this.update(l[f._id],g),delete l[f._id])};
B.prototype.currentOptions=function(a){function f(a,d,b,l){var p,q;for(p in a)if(!l&&-1<H(p,["series","xAxis","yAxis"]))for(a[p]=g(a[p]),b[p]=[],q=0;q<a[p].length;q++)b[p][q]={},f(a[p][q],d[p][q],b[p][q],l+1);else G(a[p])?(b[p]={},f(a[p],d[p]||{},b[p],l+1)):b[p]=d[p]||null}var l={};f(a,this.options,l,0);return l}})(L);return L});

},{}],129:[function(require,module,exports){
'use strict';

var VOID_ELEMENTS = ['area', 'base', 'br', 'col', 'command', 'embed', 'hr', 'img', 'input', 'keygen', 'link', 'meta', 'param', 'source', 'track', 'wbr'];

var NEWLINE_CHAR_CODE = 10; // '\n'
var DOUBLE_QUOTE_CHAR_CODE = 34; // '"'
var AMPERSAND_CHAR_CODE = 38; // '&'
var SINGLE_QUOTE_CHAR_CODE = 39; // '\''
var FORWARD_SLASH_CHAR_CODE = 47; // '/'
var SEMICOLON_CHAR_CODE = 59; // ';'
var TAG_OPEN_CHAR_CODE = 60; // '<'
var EQUAL_SIGN_CHAR_CODE = 61; // '='
var TAG_CLOSE_CHAR_CODE = 62; // '>'

var CHAR_OF_INTEREST_REGEX = /[<&\n\ud800-\udbff]/;

var TRIM_END_REGEX = /\s+$/;

/**
 * Clips a string to a maximum length. If the string exceeds the length, it is truncated and an
 * indicator (an ellipsis, by default) is appended.
 *
 * In detail, the clipping rules are as follows:
 * - The resulting clipped string may never contain more than maxLength characters. Examples:
 *   - clip("foo", 3) => "foo"
 *   - clip("foo", 2) => "f…"
 * - The indicator is inserted if and only if the string is clipped at any place other than a
 *   newline. Examples:
 *   - clip("foo bar", 5) => "foo …"
 *   - clip("foo\nbar", 5) => "foo"
 * - If the html option is true and valid HTML is inserted, the clipped output *must* also be valid
 *   HTML. If the input is not valid HTML, the result is undefined (not to be confused with JS'
 *   "undefined" type; some errors might be detected and result in an exception, but this is not
 *   guaranteed).
 *
 * @param string The string to clip.
 * @param maxLength The maximum length of the clipped string in number of characters.
 * @param options Optional options object. May contain the following property:
 *                breakWords - By default, we try to break only at word boundaries. Set to true if
 *                             this is undesired.
 *                html - Set to true if the string is HTML-encoded. If so, this method will take
 *                       extra care to make sure the HTML-encoding is correctly maintained.
 *                imageWeight - The amount of characters to assume for images. This is used
 *                              whenever an image is encountered, but also for SVG and MathML
 *                              content. Default: 2.
 *                indicator - The string to insert to indicate clipping. Default: "…".
 *                maxLines - Maximum amount of lines allowed. If given, the string will be
 *                           clipped either at the moment the maximum amount of characters is
 *                           exceeded or the moment maxLines newlines are discovered, whichever
 *                           comes first.
 *
 * @return The clipped string.
 */
module.exports = function clip(string, maxLength) {
    var options = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];


    if (!string) {
        return '';
    }

    string = string.toString();

    if (options.indicator === undefined) {
        options.indicator = '…';
    }

    return options.html ? clipHtml(string, maxLength, options) : clipPlainText(string, maxLength, options);
};

function clipHtml(string, maxLength, options) {
    var _options$imageWeight = options.imageWeight;
    var imageWeight = _options$imageWeight === undefined ? 2 : _options$imageWeight;
    var maxLines = options.maxLines;


    var numChars = 1;
    var numLines = 1;

    var i = 0;
    var isUnbreakableContent = false;
    var tagStack = [];
    var length = string.length;

    for (; i < length; i++) {
        var rest = i ? string.slice(i) : string;
        var nextIndex = rest.search(CHAR_OF_INTEREST_REGEX);
        var nextBlockSize = nextIndex > -1 ? nextIndex : rest.length;
        i += nextBlockSize;

        if (!isUnbreakableContent) {
            numChars += nextBlockSize;
            if (numChars > maxLength) {
                i -= numChars - maxLength;
                break;
            }
        }

        if (nextIndex === -1) {
            break;
        }

        var charCode = string.charCodeAt(i);
        if (charCode === TAG_OPEN_CHAR_CODE) {
            if (string.substr(i + 1, 3) === '!--') {
                var commentEndIndex = string.indexOf('-->', i + 4) + 3;
                i = commentEndIndex - 1; // - 1 because the outer for loop will increment it
            } else if (string.substr(i + 1, 8) === '![CDATA[') {
                var cdataEndIndex = string.indexOf(']]>', i + 9) + 3;
                i = cdataEndIndex - 1; // - 1 because the outer for loop will increment it

                // note we don't count CDATA text for our character limit because it is only
                // allowed within SVG and MathML content, both of which we don't clip
            } else {
                // don't open new tags if we are currently at the limit
                if (numChars === maxLength && string.charCodeAt(i + 1) !== FORWARD_SLASH_CHAR_CODE) {
                    numChars++;
                    break;
                }

                var attributeQuoteCharCode = 0;
                var endIndex = i;
                var isAttributeValue = false;
                while (true) {
                    // eslint-disable-line
                    endIndex++;
                    if (endIndex >= length) {
                        throw new Error('Invalid HTML: ' + string);
                    }

                    var _charCode = string.charCodeAt(endIndex);
                    if (isAttributeValue) {
                        if (attributeQuoteCharCode) {
                            if (_charCode === attributeQuoteCharCode) {
                                isAttributeValue = false;
                            }
                        } else {
                            if (isWhiteSpace(_charCode)) {
                                isAttributeValue = false;
                            } else if (_charCode === TAG_CLOSE_CHAR_CODE) {
                                isAttributeValue = false;
                                endIndex--; // re-evaluate this character
                            }
                        }
                    } else if (_charCode === EQUAL_SIGN_CHAR_CODE) {
                        while (isWhiteSpace(string.charCodeAt(endIndex + 1))) {
                            endIndex++; // skip whitespace
                        }
                        isAttributeValue = true;

                        var firstAttributeCharCode = string.charCodeAt(endIndex + 1);
                        if (firstAttributeCharCode === DOUBLE_QUOTE_CHAR_CODE || firstAttributeCharCode === SINGLE_QUOTE_CHAR_CODE) {
                            attributeQuoteCharCode = firstAttributeCharCode;
                            endIndex++;
                        } else {
                            attributeQuoteCharCode = 0;
                        }
                    } else if (_charCode === TAG_CLOSE_CHAR_CODE) {
                        var isEndTag = string.charCodeAt(i + 1) === FORWARD_SLASH_CHAR_CODE;
                        var tagNameStartIndex = i + (isEndTag ? 2 : 1);
                        var tagNameEndIndex = Math.min(indexOfWhiteSpace(string, tagNameStartIndex), endIndex);
                        var tagName = string.slice(tagNameStartIndex, tagNameEndIndex).toLowerCase();

                        if (isEndTag) {
                            var currentTagName = tagStack.pop();
                            if (currentTagName !== tagName) {
                                throw new Error('Invalid HTML: ' + string);
                            }

                            if (tagName === 'math' || tagName === 'svg') {
                                isUnbreakableContent = tagStack.indexOf('math') !== -1 || tagStack.indexOf('svg') !== -1;
                                if (!isUnbreakableContent) {
                                    numChars += imageWeight;
                                    if (numChars > maxLength) {
                                        break;
                                    }
                                }
                            }
                        } else if (VOID_ELEMENTS.indexOf(tagName) !== -1 || string.charCodeAt(endIndex - 1) === FORWARD_SLASH_CHAR_CODE) {
                            if (tagName === 'br') {
                                numLines++;
                                if (numLines > maxLines) {
                                    break;
                                }
                            } else if (tagName === 'img') {
                                numChars += imageWeight;
                                if (numChars > maxLength) {
                                    break;
                                }
                            }
                        } else {
                            tagStack.push(tagName);
                            if (tagName === 'math' || tagName === 'svg') {
                                isUnbreakableContent = true;
                            }
                        }

                        i = endIndex;
                        break;
                    }
                }
                if (numChars > maxLength || numLines > maxLines) {
                    break;
                }
            }
        } else if (charCode === AMPERSAND_CHAR_CODE) {
            var _endIndex = i + 1;
            while (string.charCodeAt(_endIndex) !== SEMICOLON_CHAR_CODE) {
                _endIndex++;
                if (_endIndex >= length) {
                    throw new Error('Invalid HTML: ' + string);
                }
            }

            if (!isUnbreakableContent) {
                numChars++;
                if (numChars > maxLength) {
                    break;
                }
            }

            i = _endIndex;
        } else if (charCode === NEWLINE_CHAR_CODE) {
            if (!isUnbreakableContent) {
                numChars++;
                if (numChars > maxLength) {
                    break;
                }

                numLines++;
                if (numLines > maxLines) {
                    break;
                }
            }
        } else {
            if (!isUnbreakableContent) {
                numChars++;
                if (numChars > maxLength) {
                    break;
                }
            }

            // high Unicode surrogate should never be separated from its matching low surrogate
            var nextCharCode = string.charCodeAt(i + 1);
            if ((nextCharCode & 0xfc00) === 0xdc00) {
                i++;
            }
        }
    }

    if (numChars > maxLength) {
        var nextChar = takeCharAt(string, i);
        var peekIndex = i + nextChar.length;
        while (string.charCodeAt(peekIndex) === TAG_OPEN_CHAR_CODE && string.charCodeAt(peekIndex + 1) === FORWARD_SLASH_CHAR_CODE) {
            var nextPeekIndex = string.indexOf('>', peekIndex + 2) + 1;
            if (nextPeekIndex) {
                peekIndex = nextPeekIndex;
            } else {
                break;
            }
        }

        if (peekIndex && (peekIndex === string.length || isLineBreak(string, peekIndex))) {
            // if there's only a single character remaining in the input string, or the next
            // character is followed by a line-break, we can include it instead of the clipping
            // indicator (provided it's not a special HTML character)
            if (nextChar === '<' || nextChar === '&') {
                throw new Error('Invalid HTML: ' + string);
            }

            i += nextChar.length;
            nextChar = string.charAt(i);
        }

        // include closing tags before adding the clipping indicator if that's where they
        // are in the input string
        while (nextChar === '<' && string.charCodeAt(i + 1) === FORWARD_SLASH_CHAR_CODE) {
            var _tagName = tagStack.pop();
            var tagEndIndex = _tagName ? string.indexOf('>', i + 2) : -1;
            if (tagEndIndex === -1 || string.replace(TRIM_END_REGEX, '').slice(i + 2, tagEndIndex) !== _tagName) {
                throw new Error('Invalid HTML: ' + string);
            }

            i = tagEndIndex + 1;
            nextChar = string.charAt(i);
        }

        if (i < string.length) {
            if (!options.breakWords) {
                // try to clip at word boundaries, if desired
                for (var j = i - 1; j >= 0; j--) {
                    var _charCode2 = string.charCodeAt(j);
                    if (_charCode2 === TAG_CLOSE_CHAR_CODE || _charCode2 === SEMICOLON_CHAR_CODE) {
                        // these characters could be just regular characters, so if they occur in
                        // the middle of a word, they would "break" our attempt to prevent breaking
                        // of words, but given this seems highly unlikely and the alternative is
                        // doing another full parsing of the preceding text, this seems acceptable.
                        break;
                    } else if (_charCode2 === NEWLINE_CHAR_CODE) {
                        i = j;
                        break;
                    } else if (isWhiteSpace(_charCode2)) {
                        i = j + 1;
                        break;
                    }
                }
            }

            var result = string.slice(0, i) + (isLineBreak(string, i) ? '' : options.indicator);
            while (tagStack.length) {
                var _tagName2 = tagStack.pop();
                result += '</' + _tagName2 + '>';
            }
            return result;
        }
    } else if (numLines > maxLines) {
        var _result = string.slice(0, i);
        while (tagStack.length) {
            var _tagName3 = tagStack.pop();
            _result += '</' + _tagName3 + '>';
        }
        return _result;
    }

    return string;
}

function clipPlainText(string, maxLength, options) {
    var maxLines = options.maxLines;


    var numChars = 1;
    var numLines = 1;

    var i = 0;
    var length = string.length;

    for (; i < length; i++) {
        numChars++;
        if (numChars > maxLength) {
            break;
        }

        var charCode = string.charCodeAt(i);
        if (charCode === NEWLINE_CHAR_CODE) {
            numLines++;
            if (numLines > maxLines) {
                break;
            }
        } else if ((charCode & 0xfc00) === 0xd800) {
            // high Unicode surrogate should never be separated from its matching low surrogate
            var nextCharCode = string.charCodeAt(i + 1);
            if ((nextCharCode & 0xfc00) === 0xdc00) {
                i++;
            }
        }
    }

    if (numChars > maxLength) {
        var nextChar = takeCharAt(string, i);
        var peekIndex = i + nextChar.length;
        if (peekIndex === string.length) {
            return string;
        } else if (string.charCodeAt(peekIndex) === NEWLINE_CHAR_CODE) {
            return string.slice(0, i + nextChar.length);
        } else {
            if (!options.breakWords) {
                // try to clip at word boundaries, if desired
                for (var j = i - 1; j >= 0; j--) {
                    var _charCode3 = string.charCodeAt(j);
                    if (_charCode3 === NEWLINE_CHAR_CODE) {
                        i = j;
                        nextChar = '\n';
                        break;
                    } else if (isWhiteSpace(_charCode3)) {
                        i = j + 1;
                        break;
                    }
                }
            }

            return string.slice(0, i) + (nextChar === '\n' ? '' : options.indicator);
        }
    } else if (numLines > maxLines) {
        return string.slice(0, i);
    }

    return string;
}

function indexOfWhiteSpace(string, fromIndex) {
    var length = string.length;

    for (var i = fromIndex; i < length; i++) {
        if (isWhiteSpace(string.charCodeAt(i))) {
            return i;
        }
    }
    // rather than -1, this function returns the length of the string if no match is found,
    // so it works well with the Math.min() usage below
    return length;
}

function isLineBreak(string, index) {

    var firstCharCode = string.charCodeAt(index);
    if (firstCharCode === NEWLINE_CHAR_CODE) {
        return true;
    } else if (firstCharCode === TAG_OPEN_CHAR_CODE) {
        return (/<br[\t\n\f\r ]*\/?>/i.test(string.slice(index))
        );
    } else {
        return false;
    }
}

function isWhiteSpace(charCode) {

    return charCode === 9 || charCode === 10 || charCode === 12 || charCode === 13 || charCode === 32;
}

function takeCharAt(string, index) {

    var charCode = string.charCodeAt(index);
    if ((charCode & 0xfc00) === 0xd800) {
        // high Unicode surrogate should never be separated from its matching low surrogate
        var nextCharCode = string.charCodeAt(index + 1);
        if ((nextCharCode & 0xfc00) === 0xdc00) {
            return String.fromCharCode(charCode, nextCharCode);
        }
    }
    return String.fromCharCode(charCode);
}
},{}]},{},[37])

